/*
 * speech-workspace/engine.js — общий движок расшифровки для двух РАЗНЫХ тулов:
 * `/speech-to-text` (диктовка в микрофон) и `/audio-to-text` (расшифровка
 * записи). До 08.09.2026 это были 8073 строки ИНЛАЙНОВОГО скрипта в ОДНОМ
 * блейде, который рендерили оба слага, — то есть один инструмент за двумя
 * дверями (разбор — Tests\Support\TwinAudit).
 *
 * Что перенесено и что НЕТ. Логика движка перенесена дословно: здесь живут годы
 * измеренных починок (HE-AAC через часы контейнера, чекпойнты длинных
 * расшифровок, переживание сетевого разрыва, фильтр несловесных пометок
 * Whisper). Переписывать их «заодно» значило бы разменять реальное качество на
 * красоту диффа. Изменились только границы: страницы теперь разные, а общий
 * движок — один файл, который кэшируется между ними.
 *
 * Всё, что зависит от Laravel (переводы, маршруты, тарифные лестницы, список
 * языков), приезжает из блейда через `window.__sttCfg`; в этом файле НЕТ ни
 * одной Blade-конструкции, поэтому он отдаётся как обычная versioned-статика.
 *
 * ⚠️ Элементы, которых нет на странице, — норма, а не ошибка: у страницы
 * микрофона нет файловой панели, у страницы файла нет осциллографа записи.
 * Ссылки берутся через `_$()` (getElementById), то есть могут быть null, и
 * каждая ветка обязана это переживать. `CFG.mode` говорит, какая половина
 * активна.
 */
(function() {
    var CFG = (window.__sttCfg || {});
    'use strict';

    /* =====================================================
       Section 1: Translated strings & constants
       ===================================================== */
    var STR = CFG.str;

    /* Server-side transcription (Pro) bootstrap. URLs are emitted ONLY when the
       master flag is on (routes don't exist otherwise). isPro drives whether the
       "On server" option runs or shows the upgrade offer (variant A). */
    var __serverAsr = CFG.serverAsr;
    var __transcriptAi = CFG.transcriptAi;

    /* =====================================================
       Section 2: Language list for Web Speech API
       ===================================================== */
    var LANGUAGES = CFG.languages;

    /* =====================================================
       Section 3: DOM references
       ===================================================== */
    /* ═══ Элементы, которых на ЭТОЙ странице нет ПО ЗАМЫСЛУ ═══════════════
       Движок один, а страницы две: у диктовки нет файловой панели, у
       расшифровки — осциллографа записи и плеера дубля. Код второй половины
       на этой странице не выполняется, но ПРИВЯЗКА обработчиков при загрузке
       выполняется вся — и падала на первом же отсутствующем элементе
       («Cannot read properties of null (reading 'addEventListener')»),
       унося за собой весь остаток инициализации.

       Поэтому для перечисленных ниже id `_$` отдаёт ОТКРЕПЛЁННЫЙ элемент того
       же типа: настоящий DOM-узел с настоящим поведением, просто вне
       документа. Обработчик привязывается в пустоту, класс переключается на
       ничём, `.play()` существует и молчит.

       ⚠️ Список закрытый, и это главное. Опечатка в id сюда не попадает —
       `_$('sttRecordBtnn')` по-прежнему вернёт null и упадёт, как раньше.
       Список сверяется с живыми страницами сторожем
       tests/playwright/speech-workspace-dom-contract.mjs: он открывает оба
       тула и требует, чтобы КАЖДЫЙ отсутствующий id был объявлен здесь. */
    var ABSENT_BY_DESIGN = {
        sttRecordBtn: 'button',
        sttPauseBtn: 'button',
        sttStopBtn: 'button',
        sttTimer: 'div',
        sttWaveform: 'canvas',
        sttStatus: 'div',
        sttContinuous: 'input',
        sttShowSpeakers: 'input',
        sttSettingsBtn: 'button',
        sttAdvancedSettings: 'div',
        sttAutoPunctuation: 'input',
        sttAutoScroll: 'input',
        sttMicPanel: 'div',
        sttFilePanel: 'div',
        sttFileRecovery: 'div',
        sttProc: 'div',
        sttServerQuality: 'div',
        sttQualityOpts: 'div',
        sttProcServer: 'button',
        sttProcLock: 'span',
        sttProcActiveBadge: 'div',
        sttUpsell: 'div',
        sttUpsellBody: 'span',
        sttUpsellTitle: 'strong',
        sttUpsellCta: 'a',
        sttDemo: 'div',
        sttDemoBtn: 'button',
        sttDemoResult: 'div',
        sttDemoBrowser: 'div',
        sttDemoServer: 'div',
        sttDropzone: 'div',
        sttFileInfo: 'div',
        sttFileName: 'div',
        sttFileMeta: 'div',
        sttFileRemove: 'button',
        sttAudioPlayer: 'audio',
        sttTranscribeBtn: 'button',
        sttGlossary: 'textarea',
        sttPeople: 'input',
        sttDiarize: 'input',
        sttDiarizeRow: 'label',
        sttSpeakersRow: 'div',
        sttSpeakers: 'input',
        sttDiarizeHint: 'span',
        sttBrowserWarning: 'div',
        sttBrowserWarningText: 'span',
        /* Меню реплики, «Отменить» и вопрос о говорящих, запись к тексту, судебный
           режим (07.10.2026) — разметка только у /audio-to-text; контракт
           (speech-workspace-dom-contract.mjs) краснел на /speech-to-text с тех пор. */
        sttParaMenu: 'div',
        sttSpkUndo: 'button',
        sttSpkAsk: 'div',
        sttAttach: 'div',
        sttAttachBtn: 'button',
        sttCourtOffer: 'div',
        sttCourt: 'div',
        sttCourtDoc: 'div',
        sttWarnRetryBtn: 'button',
        sttWarnFileLink: 'a',
        sttVoiceCommands: 'input',
        sttAutoParagraphs: 'input',
        sttBookmarkBtn: 'button',
        sttPlayback: 'div',
        sttPlaybackWave: 'canvas',
        sttPlaybackWaveWrap: 'div',
        sttPlaybackCursor: 'div',
        sttPlaybackTimeOverlay: 'div',
        sttPlayBtn: 'button',
        sttPlayIcon: 'svg',
        sttStopIcon: 'svg',
        sttPlaybackLabel: 'span',
        sttRecordAgainBtn: 'button',
        sttWhisperRefineBtn: 'button',
        sttAudioDl: 'div',
        sttAudioDlBtn: 'button',
        sttAudioDlMenu: 'div',
        sttTranslate: 'input',
        sttGenCloud: 'button',
        sttWordCloud: 'canvas',
        sttWordCloudEmpty: 'div',
        sttBookmarksList: 'div',
        sttMicQuality: 'select'
    };
    var _spare = {};
    var _$ = function(id) {
        var el = document.getElementById(id);
        if (el) return el;
        var tag = ABSENT_BY_DESIGN[id];
        if (!tag) return null;
        if (!_spare[id]) _spare[id] = document.createElement(tag);
        return _spare[id];
    };

    var $recordBtn     = _$('sttRecordBtn'),
        $pauseBtn      = _$('sttPauseBtn'),
        $stopBtn       = _$('sttStopBtn'),
        $timer         = _$('sttTimer'),
        $waveform      = _$('sttWaveform'),
        $status        = _$('sttStatus'),
        $lang          = _$('sttLang'),
        $continuous    = _$('sttContinuous'),
        $timestamps    = _$('sttTimestamps'),
        $showSpeakers  = _$('sttShowSpeakers'),      /* file-mode toolbar toggle; null on the mic page */
        $settingsBtn   = _$('sttSettingsBtn'),
        $advSettings   = _$('sttAdvancedSettings'),
        $autoPunct     = _$('sttAutoPunctuation'),
        $autoScroll    = _$('sttAutoScroll'),
        $micPanel      = _$('sttMicPanel'),
        $filePanel     = _$('sttFilePanel'),
        $fileRecovery  = _$('sttFileRecovery'),
        $proc          = _$('sttProc'),
        $serverQuality = _$('sttServerQuality'),
        $qualityOpts   = _$('sttQualityOpts'),
        $procServer    = _$('sttProcServer'),
        $procLock      = _$('sttProcLock'),
        $procActiveBadge = _$('sttProcActiveBadge'),
        $upsell        = _$('sttUpsell'),
        $upsellBody    = _$('sttUpsellBody'),
        $upsellTitle   = _$('sttUpsellTitle'),
        $upsellCta     = _$('sttUpsellCta'),
        $demo          = _$('sttDemo'),
        $demoBtn       = _$('sttDemoBtn'),
        $demoResult    = _$('sttDemoResult'),
        $demoBrowser   = _$('sttDemoBrowser'),
        $demoServer    = _$('sttDemoServer'),
        $dropzone      = _$('sttDropzone'),
        $fileInfo      = _$('sttFileInfo'),
        $fileName      = _$('sttFileName'),
        $fileMeta      = _$('sttFileMeta'),
        $fileRemove    = _$('sttFileRemove'),
        $audioPlayer   = _$('sttAudioPlayer'),
        $model         = _$('sttModel'),
        $progress      = _$('sttProgress'),
        $progressFill  = _$('sttProgressFill'),
        $progressText  = _$('sttProgressText'),
        $progressTime  = _$('sttProgressTime'),
        $cancelBtn     = _$('sttCancelBtn'),
        $transcribeBtn = _$('sttTranscribeBtn'),
        $glossary      = _$('sttGlossary'),
        $people        = _$('sttPeople'),
        // id библиотечной копии — куда сохранять имена говорящих, чтобы они
        // пережили закрытие вкладки (иначе правка живёт только на экране).
        libraryTranscriptId = null,
        $diarize       = _$('sttDiarize'),
        $diarizeRow    = _$('sttDiarizeRow'),
        $speakersRow   = _$('sttSpeakersRow'),
        $speakers      = _$('sttSpeakers'),
        $diarizeHint   = _$('sttDiarizeHint'),
        $aiSummaryBtn  = _$('sttAiSummary'),
        $aiTransWrap   = _$('sttAiTranslateWrap'),
        $aiTransLang   = _$('sttAiTransLang'),
        $aiTransBtn    = _$('sttAiTranslate'),
        $aiResult      = _$('sttAiResult'),
        $aiResultTitle = _$('sttAiResultTitle'),
        $aiDownload    = _$('sttAiDownload'),
        $aiDocx        = _$('sttAiDocx'),
        $aiResultBody  = _$('sttAiResultBody'),
        $aiCopy        = _$('sttAiCopy'),
        $aiClose       = _$('sttAiClose'),
        $detectedLang  = _$('sttDetectedLang'),
        $transcript    = _$('sttTranscript'),
        $copyBtn       = _$('sttCopyBtn'),
        $exportBtn     = _$('sttExportBtn'),
        $exportMenu    = _$('sttExportMenu'),
        $findBtn       = _$('sttFindBtn'),
        $clearBtn      = _$('sttClearBtn'),
        $findPanel     = _$('sttFindPanel'),
        $findInput     = _$('sttFindInput'),
        $replaceInput  = _$('sttReplaceInput'),
        $matchCount    = _$('sttMatchCount'),
        $findPrev      = _$('sttFindPrev'),
        $findNext      = _$('sttFindNext'),
        $findClose     = _$('sttFindClose'),
        $replaceBtn    = _$('sttReplaceBtn'),
        $replaceAllBtn = _$('sttReplaceAllBtn'),
        $historyList   = _$('sttHistoryList'),
        $historyEmpty  = _$('sttHistoryEmpty'),
        $historyFooter = _$('sttHistoryFooter'),
        $historyClear  = _$('sttHistoryClear'),
        $toast         = _$('sttToast'),
        $warning       = _$('sttBrowserWarning'),
        $warningText   = _$('sttBrowserWarningText'),
        $warnRetryBtn  = _$('sttWarnRetryBtn'),
        $warnFileLink  = _$('sttWarnFileLink'),
        $voiceCommands = _$('sttVoiceCommands'),
        $autoParagraphs = _$('sttAutoParagraphs'),
        $bookmarkBtn   = _$('sttBookmarkBtn'),
        $playback      = _$('sttPlayback'),
        $playbackWave  = _$('sttPlaybackWave'),
        $playbackWrap  = _$('sttPlaybackWaveWrap'),
        $playbackCursor = _$('sttPlaybackCursor'),
        $playbackTimeOv = _$('sttPlaybackTimeOverlay'),
        $playBtn       = _$('sttPlayBtn'),
        $playIcon      = _$('sttPlayIcon'),
        $stopIcon      = _$('sttStopIcon'),
        $playbackLabel = _$('sttPlaybackLabel'),
        $recordAgainBtn = _$('sttRecordAgainBtn'),
        $whisperRefineBtn = _$('sttWhisperRefineBtn'),
        $audioDl       = _$('sttAudioDl'),
        $audioDlBtn    = _$('sttAudioDlBtn'),
        $audioDlMenu   = _$('sttAudioDlMenu'),
        $translateChk  = _$('sttTranslate'),
        $dictation     = _$('sttDictation'),
        $dictationText = _$('sttDictationText'),
        $dictationTimer = _$('sttDictationTimer'),
        $dictationStatus = _$('sttDictationStatus'),
        $dictationRecordBtn = _$('sttDictationRecordBtn'),
        $exitDictation = _$('sttExitDictation'),
        $dictationBtn  = _$('sttDictationBtn'),
        $genCloud      = _$('sttGenCloud'),
        $wordCloudCanvas = _$('sttWordCloud'),
        $wordCloudEmpty = _$('sttWordCloudEmpty'),
        $bookmarksList = _$('sttBookmarksList'),
        $micQuality    = _$('sttMicQuality'),
        $backendBadge  = _$('sttBackendBadge');

    /* =====================================================
       Section 3b: Mic quality presets
       ===================================================== */
    var MIC_PRESETS = {
        best:     { sr: 96000, ch: 2, bps: 320000 },
        standard: { sr: 48000, ch: 2, bps: 192000 },
        medium:   { sr: 44100, ch: 2, bps: 128000 },
        low:      { sr: 22050, ch: 1, bps: 64000 },
    };
    function getMicPreset() { return MIC_PRESETS[$micQuality.value] || MIC_PRESETS.standard; }
    var savedMicQ = localStorage.getItem('timbrica_mic_quality');
    if (savedMicQ && MIC_PRESETS[savedMicQ]) $micQuality.value = savedMicQ;
    $micQuality.addEventListener('change', function(){ localStorage.setItem('timbrica_mic_quality', this.value); });

    /* =====================================================
       Section 4: State
       ===================================================== */
    var mode           = CFG.mode;
    var TOOL_SLUG      = CFG.slug;
    /* Калибровка скорости лейна — свойство МАШИНЫ, а не страницы: замерив
       real-time factor на разборе файла, глупо переучиваться заново на
       диктовке того же устройства. Поэтому у неё ОДНО ведро на оба тула, а имя
       ведра историческое — переименование выбросило бы накопленные замеры у
       живых пользователей и вернуло бы оценку «18 минут» вместо измеренной.
       Всё остальное (телеметрия, настройки интерфейса) идёт под TOOL_SLUG:
       событие обязано называть ТУ страницу, где произошло, иначе разведённые
       тулы снова становятся неразличимы — в данных. */
    var PERF_NS        = 'speech-to-text';
    var diarPcm        = null;   /* mono PCM kept for opt-in speaker diarization */
    var isRecording    = false;
    var isPaused       = false;

    /* ── Soft daily-run limit (client-side counter → Pro funnel; window.__toolLimit).
       Pro users, and free users on locales where Pro isn't sold, have an unlimited
       cap so this never fires for them. File (audio-to-text) and mic (speech-to-text)
       are DIFFERENT slugs → separate counters. Recorded ONLY on a completed
       transcription (never on preview / checkpoint-restore / failed read). The
       real-cost Pro server path also has a hard Redis backstop server-side.

       UI is the shared tool-limit component mount: the proactive ":remaining of
       :cap" hint (warning-before-wall) and the note — including the paid-plan variant
       (a PAYING user must never see "get Pro", bug report 2026-07-06 tembrica/de;
       the module's paintNote handles it) — all live in tool-usage-limit.js.
       begin() reveals the note, fires daily_limit_hit and announces on block;
       the returned token is aborted right away because BILLING here stays on
       record()-at-completion: the Pro server path survives page reloads via
       SERVER_JOB_LS_KEY polling, and a begin()-token cannot outlive a reload. */
    function sttLimitBlocked(fileForKey) {
        if (!window.__toolLimit) return false;
        var tok = window.__toolLimit.begin(TOOL_SLUG, (fileForKey && window.__toolLimit.fileKey) ? window.__toolLimit.fileKey(fileForKey) : null);
        if (!tok) return true;              // cap spent — note (Pro-aware) already shown
        tok.abort();                        // gate only; completion bills via record()
        return false;
    }
    function sttLimitRecord(fileForKey) {
        try {
            if (window.__toolLimit) {
                window.__toolLimit.record(TOOL_SLUG, (fileForKey && window.__toolLimit.fileKey) ? window.__toolLimit.fileKey(fileForKey) : null);
                window.__toolLimit.refresh(TOOL_SLUG);   // keep the "N left" hint live
            }
        } catch (_) {}
    }
    var voiceSession   = null;
    var audioContext    = null;
    var analyser       = null;
    var mediaStream    = null;
    var waveTimer      = null;
    var timerInterval  = null;
    var timerSeconds   = 0;
    var transcriptSegments = [];
    var finalTranscript    = '';
    var whisperWorker      = null;
    var currentFile        = null;
    /* Материал, из которого собирается ИМЯ выдаваемого файла и заголовок
       ВНУТРИ документа. Обычно это имя загруженной записи; при возврате из
       «Моих генераций» — имя, сохранённое в библиотеке; в микрофонном
       режиме пусто, и тогда имя строится из даты (см. __transcriptFile). */
    var exportSourceName   = '';
    var exportDurationSec  = 0;
    /* Запись истории, которой ЯВЛЯЕТСЯ текст на экране, и имя файла в плеере. */
    var docEntryId         = null;
    var docSize            = 0;      /* байты файла записи — опознать её при повторном выборе */
    var playerSrcName      = '';
    var isTranscribing     = false;
    var transcribeCanceled = false;  /* preflight/mid-process cancel flag */
    var cancelGen = 0;               /* bumped by Cancel only — a DETACHED job (new recording) is not cancelled */
    var userChangedModel   = false;  /* respect user's manual model pick over auto-default */
    /* WASM-SIMD probe. onnxruntime-web (the engine behind transformers.js)
       ships ONLY a SIMD+threaded wasm — there is NO non-SIMD build — so an
       environment without WASM-SIMD cannot run browser Whisper at all: ort
       throws "no available backend found. ERR: [wasm] WebAssembly SIMD is not
       supported". Telemetry (analytics.sqlite, 2026-06-22) pinned 5/8 explicit
       transcription failures to exactly this — sab:0, wasm:1, no SIMD — on
       iOS Safari 16.2 (SIMD landed in 16.4) and Chrome on Windows 7. The
       31-byte module below is the canonical wasm-feature-detect SIMD test
       (i8x16.splat + i8x16.popcnt over a v128); WebAssembly.validate returns
       true iff the engine accepts a v128 instruction. We gate on it up front
       so no-SIMD devices get an honest, actionable message instead of a
       cryptic worker crash after a 30 MB model download. */
    function __wasmSimdSupported() {
        try {
            return WebAssembly.validate(new Uint8Array([
                0,97,115,109,1,0,0,0, 1,5,1,96,0,1,123, 3,2,1,0,
                10,10,1,8,0,65,0,253,15,253,98,11
            ]));
        } catch (_) { return false; }
    }
    /* The other half of the same gate (2026-10-08). Every browser lane here
       loads its model through import() INSIDE a worker: Whisper through
       transformers.js (ESM), GigaAM through ORT 1.24, whose wasm glue is an
       .mjs too. An engine without module workers (Firefox < 114, Safari < 15)
       has no import() in workers either — measured on an emulation of it: the
       worker starts, every library source is tried twice and fails «dynamic
       module import is not implemented», and the person reads «the model did
       not load, try again», which no retry fixes. Same verdict as no SIMD, so
       the same exits (server for those who have it, «update the browser» for
       the rest); the layout's probe is silent, the sentence is ours.
       → 'simd' | 'module_worker' | null. */
    function browserLaneBlocker() {
        if (!caps.simd) return 'simd';
        if (window.__moduleWorkerOk && !window.__moduleWorkerOk()) return 'module_worker';
        return null;
    }

    var caps = {                     /* device capabilities — filled async at init */
        webgpu: false,               /* navigator.gpu adapter reachable */
        sab: (typeof SharedArrayBuffer !== 'undefined'), /* multi-thread WASM ok */
        simd: __wasmSimdSupported(),  /* WASM-SIMD — REQUIRED by onnxruntime-web (no non-SIMD build) */
        /* GB — ёмкость спрашивается у ВЛАДЕЛЬЦА бюджета (`window.__memBudget`, layout):
           он знает, что у WebKit `deviceMemory` нет вовсе, и отдаёт iOS бюджет
           ВКЛАДКИ (2), а не «8, раз десктоп». Своё «|| 8» здесь делало iPhone
           восьмигигабайтным десктопом и выключало для него `isWeakDevice()`.
           Литерал ниже — последний рубеж, если layout-скрипта нет. */
        mem: (window.__memBudget && window.__memBudget.gb) ? window.__memBudget.gb() : (navigator.deviceMemory || 8),
        ready: false,                /* true once async detection finished */
    };
    var activeBackend = null;        /* reported by worker after model load */
    var currentFontSize    = 'medium';
    var currentFindIndex   = -1;
    var findMatches        = [];
    var toastTimer         = null;
    var mediaRecorder      = null;
    var recordedChunks     = [];
    var bookmarks          = [];
    var isDictationMode    = false;
    var lastSpeechTimestamp = 0;
    var playbackAudio      = null;
    var playbackAnimFrame  = null;
    var playbackWaveData   = null;
    var userHasEdited      = false;
    /* Правка говорящих и меню реплики (07.10.2026). Объявлено здесь, а не рядом
       с кодом ниже: отрисовка текста зовётся уже при запуске страницы. */
    var SPK                = window.__transcriptSpeakers || null;
    var spkUndo            = [];     /* снимки меток — для «Отменить» */
    var lastParas          = [];     /* абзацы последней отрисовки */
    var lastColour         = {};     /* говорящий → номер цвета, как в тексте */
    var paraMenuIdx        = -1;
    var paraMenuPick       = null;   /* выделенный текст на момент открытия меню */
    var attachOnly         = false;  /* следующий выбранный файл — только запись к тексту */
    var playerHome         = null;   /* откуда плеер был перенесён к тексту */
    var courtState         = { sig: '', seen: false, hearing: false, skipLen: -1 };
    var audioDlBtnOrigHTML = $audioDlBtn.innerHTML;
    var noSpeechCount      = 0;
    var hasGotResult       = false;
    var noResultTimer      = null;
    var statusClearTimer   = null;
    /* Auto-fallback flag — when Web Speech is unrecoverable (restart cap /
       start failure), we transcribe the captured audio via Whisper
       (offline, no timeout). Flag is consumed by `showPlayback` so the
       transcribe fires AFTER recordedChunks is finalized
       (mediaRecorder.onstop deterministic chain). */
    var pendingAutoTranscribe = false;
    /* ── Who owns the transcript surface right now ──────────────────────────
       `transcriptSegments` / `finalTranscript` / #sttTranscript are ONE
       surface with TWO asynchronous producers: the live Web Speech dictation
       and a background Whisper job over recorded audio. Until 2026-09-18
       neither knew about the other, so whichever finished last wrote over the
       top of the other.

       Bug-report 2026-09-18 (Edge 153, /de/speech-to-text, sid cfdf1759):
       "ich habe noch diktierfunktion aufgemacht dann hat er Maschiene von
       selbst das ganze aus skripfunktion nochmal wiederholt". Reconstructed
       from that session's own telemetry: Web Speech died `network` ×4 →
       whisper_takeover → he stopped → the rescue started on 294 s of audio →
       30 s later he pressed record and dictated again → 90 s later the
       rescue's 219 words were APPENDED to his live dictation. Measured across
       both shards, 60 d: 402 sessions started a recording while a Whisper job
       was in flight (322 auto-rescue + 80 manual refine) — a recurring class,
       not one unlucky user.

       The fix is ownership, not a special case: a producer takes a token when
       it claims the surface, and a producer holding a stale token never
       writes to it. A stale job is NOT cancelled — its audio exists nowhere
       else — it finishes into history instead and says so. Same identity-guard
       idiom already used for `playbackAudio` further down this file. */
    var transcriptRun = 0;          /* bumped on every claim of the surface   */
    var jobRun        = -1;         /* token held by the running transcribe   */
    /* Web Speech died mid-session (network error / backend rejected). The
       MediaRecorder stream is INDEPENDENT of Web Speech and keeps capturing
       — so instead of killing the whole recording we set this flag, stop
       trying to restart recognition, and let the user keep dictating;
       Whisper transcribes the full audio when they stop. Bug-report
       2026-05-16 sid 24d8087b (Edge 148, Bolivia): recording died at 1 s,
       `network` error in onerror → stopRecording, zero telemetry trace.
       Continuous-mode auto-restart, the ~14 s Yandex cutoff fix, network
       retry-once and the restart cap all now live in the shared
       WebSpeechSession module (public/js/web-speech-session.js). */
    var webSpeechFailed = false;
    /* IndexedDB-backed recovery: persist MediaRecorder chunks once
       whisperTakeover engages so a closed tab doesn't lose the audio.
       18% of takeover sessions abandoned before stopping in 14d telemetry
       (29 sessions) — this closes that path. */
    var recoverySessionId = null;
    var recordingStartedAt = 0;
    var RECOVERY_MAX_AGE_MS = 24 * 60 * 60 * 1000;   /* 24 h auto-purge */

    /* ── File-mode long-transcription resilience (bug-report 38fdd911) ──
       A 2 h file on single-thread WASM runs for hours; if anything interrupts
       it (tab discard, OOM, reload, sleep) the transcript was previously lost
       with no trace because the blade only consumed the worker's final
       `result` and ignored every streamed `partial_text` / `chunk_done`.
       These drive: live transcript painting, an IndexedDB checkpoint persisted
       per finalized chunk (so the work survives a crash), a no-progress
       watchdog, a Wake Lock, and a recovery banner on return. */
    var ckptKey            = null;   /* fingerprint of the file being transcribed */
    var ckptStreamSegs     = [];     /* finalized per-chunk texts (live preview + persisted) */
    var ckptPartial        = '';     /* in-progress chunk's streamed text */
    var ckptMeta           = null;   /* {lang, model, task, audioDuration, totalChunks, startedAt} */
    var ckptSaveTimer      = null;   /* throttle: coalesce IDB writes */
    var ckptLastSaveMs     = 0;
    var deadChunkCount     = 0;      /* degenerate windows dropped this run */
    var degenerateFinal    = false;  /* worker judged the finished run degenerate */

    /* "Is this streamed window a dead decode?" — delegated to the shared guard
       so the page and the worker judge by one definition. Fails OPEN: if the
       guard did not load, a chunk is kept rather than silently swallowed. */
    function sttChunkIsDead(text) {
        try {
            var g = window.__asrQualityGuard;
            return !!(g && typeof g.chunkLooksDead === 'function' && g.chunkLooksDead(text));
        } catch (_) { return false; }
    }
    var transcribeWatchdog = null;   /* fires if no worker progress for a while */
    var lastProgressMs     = 0;      /* timestamp of last heartbeat/chunk/partial */
    var stallNotified      = false;  /* one-shot stall notice per run */
    var wakeLockSentinel   = null;   /* screen Wake Lock held during transcription */
    var resumeFromSec      = 0;      /* >0 → re-transcribe only the tail from this audio offset */
    var extractFailReason  = '';     /* 'truncated' → file looked complete but moov was missing */
    /* Server-side transcription (Pro). procMode: 'browser' | 'server'.
       Default is Pro-aware: paying users get their paid server perk on first
       visit; saved preference overrides. Comment #652 root cause — the prior
       hardcoded 'browser' default silently routed all 82 active Pro users to
       the free path (zero `server_transcribe_start` events in 14d
       telemetry). */
    const STT_PROC_MODE_KEY = 'stt_proc_mode_v1';
    /* May THIS account use the server lane at all? Since 2026-08-01 the answer is
       "any logged-in account" — the lane is metered in minutes, not sold as a
       membership. Whether a PARTICULAR file is affordable is a separate question,
       answered per-file with an honest quote (asrQuote) and, authoritatively, by
       the server's 402. Keeping the two apart is what stops us relocking the door
       we just opened: a verified user with 30 free minutes and a broke user with
       a top-up link are both "allowed", they just see different quotes. */
    function asrServerAllowed() {
        return !!(__serverAsr.enabled && __serverAsr.loggedIn);
    }
    /* Free minutes left this month — the only thing that should DEFAULT someone
       into the server lane. Routing a user with zero free minutes there by default
       would put a price tag in front of their first click. */
    function asrHasFreeMinutes() {
        return asrServerAllowed() && (__serverAsr.freeLeft | 0) > 0;
    }
    var procMode = (function () {
        /* __serverAsr is declared earlier in this same IIFE (line ~1480), so
           it is always defined here — no `typeof` guard needed. */
        var isPro = asrHasFreeMinutes();
        var saved = null;
        try { saved = localStorage.getItem(STT_PROC_MODE_KEY); } catch (_) {}
        /* Expired-Pro safety (Wave 2 hardening): if the saved value is 'server'
           but the user is no longer Pro (subscription lapsed, signed out, …),
           downgrade to 'browser' so the UI doesn't bait them with a pill that
           clicks through to the upsell. Protects against ANY future code path
           that writes 'server' — defense-in-depth for the comment-#652
           perception gap, just in the opposite direction. */
        /* Downgrade a saved 'server' only when the lane is CLOSED to this account
           (signed out) — not merely when the free minutes ran out. A Premium user
           who spent their 30 h still chose the server lane deliberately and can
           pay for it; bouncing them to the browser would silently downgrade the
           thing they picked. */
        if (saved === 'server' && !asrServerAllowed()) return 'browser';
        if (saved === 'server' || saved === 'browser') return saved;
        return isPro ? 'server' : 'browser';
    })();
    var serverPollTimer    = null;
    /* The running watch's own tick — the visibility handler asks the server
       through it the moment the tab is back. */
    var serverPollNow      = null;
    var serverJobId        = null;
    /* Server lane: when this page first saw the job standing in the queue, and
       the most jobs it was told were ahead — for the `server_queue_wait` event. */
    var serverQueuedSince  = 0;
    var serverAheadMax     = 0;
    var serverModel        = null;   /* selected server quality model key (null = decide from language) */
    var userChangedServerModel = false; /* an explicit pick outranks the language default */
    var serverDefaultReported  = null; /* report each resolved default once, not per repaint */
    var serverAudioDur     = 0;      /* current file duration (sec), for the honest ETA */
    var SERVER_JOB_LS_KEY  = 'stt_server_job';   /* survive reload so a closed tab resumes polling */
    var pendingCkpt        = null;   /* recovered checkpoint awaiting same-file re-pick */
    var CKPT_MAX_AGE_MS    = 24 * 60 * 60 * 1000;   /* 24 h auto-purge */
    var CKPT_SAVE_THROTTLE_MS = 3000;               /* min gap between IDB writes */
    /* No-progress watchdog window. Single-thread WASM can spend minutes on one
       29 s chunk of a long file, so this is generous — it only fires when the
       worker has almost certainly died, never on a merely-slow-but-alive run. */
    var WATCHDOG_IDLE_MS   = 5 * 60 * 1000;

    /* ── Tunables for the recording state machine ──
       Centralised so behaviour is auditable in one place rather than
       scattered as magic numbers across the recording lifecycle. */
    var STATUS_CLEAR_MS       = 4000;  /* "Recording saved!" banner before status clears */
    var NO_RESULT_HINT_MS     = 10000; /* show speech_not_working warning after this idle window */
    var NO_SPEECH_HINT_THRESH = 3;     /* 'no-speech' events in a row before showing the same warning */

    /* =====================================================
       Section 5: Preferences (localStorage)
       ===================================================== */
    var PREFS_KEY = 'stt_prefs';

    function loadPrefs() {
        try { return JSON.parse(localStorage.getItem(PREFS_KEY) || '{}'); }
        catch(e) { return {}; }
    }

    function savePrefs() {
        try {
            localStorage.setItem(PREFS_KEY, JSON.stringify({
                lang: $lang.value,
                continuous: $continuous.checked,
                timestamps: $timestamps.checked,
                fontSize: currentFontSize,
                model: $model.value,
                autoScroll: $autoScroll.checked,
                autoPunct: $autoPunct.checked,
                voiceCommands: $voiceCommands.checked,
                autoParagraphs: $autoParagraphs.checked,
                glossary: ($glossary ? $glossary.value : ''),
                diarize: ($diarize ? $diarize.checked : false),
            }));
        } catch(e) {}
    }

    function restorePrefs() {
        var prefs = loadPrefs();
        if (prefs.lang) {
            var opt = $lang.querySelector('option[value="' + prefs.lang + '"]');
            if (opt) $lang.value = prefs.lang;
        }
        if (prefs.continuous !== undefined) $continuous.checked = prefs.continuous;
        if (prefs.timestamps !== undefined) $timestamps.checked = prefs.timestamps;
        /* File mode: paragraph timecodes on by default (one per paragraph, not
           per phrase) — that is the shape every transcription service ships and
           the one a Premium user asked for; a saved preference still wins. */
        else if (mode === 'file') $timestamps.checked = true;
        if ($showSpeakers && window.__toolSettings) {
            try { $showSpeakers.checked = String(window.__toolSettings.load(TOOL_SLUG, 'show_speakers', 1)) !== '0'; } catch (_) {}
        }
        if (prefs.model) {
            $model.value = prefs.model;
            userChangedModel = true;   /* saved pref counts as explicit choice */
        }
        if (prefs.autoScroll !== undefined) $autoScroll.checked = prefs.autoScroll;
        if (prefs.autoPunct !== undefined) $autoPunct.checked = prefs.autoPunct;
        if (prefs.voiceCommands !== undefined) $voiceCommands.checked = prefs.voiceCommands;
        if (prefs.autoParagraphs !== undefined) $autoParagraphs.checked = prefs.autoParagraphs;
        if (prefs.glossary && $glossary) $glossary.value = prefs.glossary;
        if (prefs.diarize !== undefined && $diarize) $diarize.checked = prefs.diarize;
        if (prefs.fontSize) setFontSize(prefs.fontSize);
    }

    /* =====================================================
       Section 5b: Voice Commands & Auto-punctuation
       ===================================================== */
    var VOICE_COMMANDS = {
        'period':'.','full stop':'.','dot':'.','comma':',','question mark':'?',
        'exclamation mark':'!','exclamation point':'!','new line':'\n','new paragraph':'\n\n',
        'colon':':','semicolon':';','dash':' — ','hyphen':'-',
        'open quote':'\u201c','close quote':'\u201d','open parenthesis':'(','close parenthesis':')',
        /* Russian */
        '\u0442\u043e\u0447\u043a\u0430':'.', '\u0437\u0430\u043f\u044f\u0442\u0430\u044f':',',
        '\u0432\u043e\u043f\u0440\u043e\u0441\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0439 \u0437\u043d\u0430\u043a':'?',
        '\u0432\u043e\u0441\u043a\u043b\u0438\u0446\u0430\u0442\u0435\u043b\u044c\u043d\u044b\u0439 \u0437\u043d\u0430\u043a':'!',
        '\u043d\u043e\u0432\u0430\u044f \u0441\u0442\u0440\u043e\u043a\u0430':'\n',
        '\u043d\u043e\u0432\u044b\u0439 \u0430\u0431\u0437\u0430\u0446':'\n\n',
        '\u0434\u0432\u043e\u0435\u0442\u043e\u0447\u0438\u0435':':',
        '\u0442\u043e\u0447\u043a\u0430 \u0441 \u0437\u0430\u043f\u044f\u0442\u043e\u0439':';',
        '\u0442\u0438\u0440\u0435':' \u2014 ',
        '\u043e\u0442\u043a\u0440\u044b\u0442\u044c \u043a\u0430\u0432\u044b\u0447\u043a\u0438':'\u00ab',
        '\u0437\u0430\u043a\u0440\u044b\u0442\u044c \u043a\u0430\u0432\u044b\u0447\u043a\u0438':'\u00bb',
        /* Korean */
        '\ub9c8\uce68\ud45c':'.', '\uc274\ud45c':',', '\ubb3c\uc74c\ud45c':'?', '\ub290\ub08c\ud45c':'!', '\uc904 \ubc14\uafb8':'\n',
        /* Arabic */
        '\u0646\u0642\u0637\u0629':'.', '\u0641\u0627\u0635\u0644\u0629':'\u060c',
        '\u0639\u0644\u0627\u0645\u0629 \u0627\u0633\u062a\u0641\u0647\u0627\u0645':'\u061f',
        '\u0639\u0644\u0627\u0645\u0629 \u062a\u0639\u062c\u0628':'!',
        '\u0633\u0637\u0631 \u062c\u062f\u064a\u062f':'\n',
        /* Indonesian */
        'titik':'.','koma':',','tanda tanya':'?','tanda seru':'!','baris baru':'\n'
    };

    /* ═══ Правка голосом ══════════════════════════════════════════════════
       Знаки препинания голосом умеют все. А вот ПОПРАВИТЬ уже сказанное, не
       трогая клавиатуру, — почти никто, и это главная жалоба на диктовку.

       Замер рынка 08.09.2026. Полная правка голосом есть у Dragon (меню
       альтернатив, «Correct that», «Spell that») — но потребительский канал
       закрыт: Dragon Home снят с продажи, Dragon Anywhere перестал продаваться
       1 июля 2026, остаток линейки продаётся только по запросу. У Windows
       Voice Access правка есть и работает на 15 локалях. У Apple Dictation
       правки голосом нет вовсе — только клик мышью по подчёркнутому слову. У
       Google Docs команды есть, и их справка говорит прямо: «Voice commands are
       available only in English. The account language and document language
       must both be English». У браузерных диктовщиков (Speechnotes,
       Dictation.io, TalkTyper) правки нет ни на каком языке.

       То есть человек, диктующий по-русски в браузере, сегодня не может
       сказать «удали последнее слово» нигде. Здесь может — и на всех локалях
       сайта, потому что распознавание уже отдаёт нам текст, а править надо
       СВОЙ же список сегментов.

       ⚠️ Команда обязана быть ЗАМЕТНОЙ. Нераспознанная команда молча уедет в
       текст словами («удали последнее слово» посреди письма), и человек решит,
       что тул сломан. Поэтому каждое срабатывание говорит, что именно сделано,
       и любое действие откатывается голосом же — «отмени». */
    var VOICE_EDIT_PATTERNS = {
        undo: [
            /^(отмени(те)?|отмена|верни(те)? как было)$/,
            /^(скасуй|скасувати|поверни як було)$/,
            /^(undo|undo that|revert|scratch that)$/,
            /^(rückgängig|mach das rückgängig)$/,
            /^(annule|annuler|reviens en arrière)$/,
            /^(deshacer|deshaz eso)$/,
            /^(desfazer|desfaça isso)$/,
            /^(batalkan|urungkan)$/,
            /^(실행 취소|되돌려|취소해)$/,
            /^(تراجع|ارجع)$/
        ],
        delWord: [
            /^(удали|сотри|убери)( последнее| последнее)? слово$/,
            /^(видали|зітри|прибери)( останнє)? слово$/,
            /^(delete|remove|scratch)( the)?( last)? word$/,
            /^(letztes wort löschen|lösche das letzte wort)$/,
            /^(supprime|efface)( le)?( dernier)? mot$/,
            /^(borra|elimina)( la)?( última)? palabra$/,
            /^(apaga|apague)( a)?( última)? palavra$/,
            /^(hapus kata( terakhir)?)$/,
            /^(마지막 단어 지워|단어 삭제)$/,
            /^(احذف الكلمة الأخيرة|امسح الكلمة)$/
        ],
        delSentence: [
            /^(удали|сотри|убери)( последнее| последнее)? предложение$/,
            /^(видали|зітри|прибери)( останнє)? речення$/,
            /^(delete|remove)( the)?( last)? sentence$/,
            /^(letzten satz löschen|lösche den letzten satz)$/,
            /^(supprime|efface)( la)?( dernière)? phrase$/,
            /^(borra|elimina)( la)?( última)? frase$/,
            /^(apaga|apague)( a)?( última)? frase$/,
            /^(hapus kalimat( terakhir)?)$/,
            /^(마지막 문장 지워|문장 삭제)$/,
            /^(احذف الجملة الأخيرة|امسح الجملة)$/
        ]
    };
    /* «исправь X на Y» — два аргумента, поэтому отдельным списком. */
    var VOICE_REPLACE_PATTERNS = [
        /^(?:исправь|исправить|замени|заменить)\s+(.+?)\s+на\s+(.+)$/,
        /^(?:виправ|виправити|заміни|замінити)\s+(.+?)\s+на\s+(.+)$/,
        /^(?:replace|change)\s+(.+?)\s+(?:with|to)\s+(.+)$/,
        /^(?:ersetze)\s+(.+?)\s+(?:durch|mit)\s+(.+)$/,
        /^(?:remplace|remplacer)\s+(.+?)\s+par\s+(.+)$/,
        /^(?:reemplaza|cambia)\s+(.+?)\s+(?:por|a)\s+(.+)$/,
        /^(?:substitua|troque)\s+(.+?)\s+(?:por|para)\s+(.+)$/,
        /^(?:ganti)\s+(.+?)\s+(?:dengan|jadi)\s+(.+)$/,
        /^(?:استبدل)\s+(.+?)\s+(?:بـ|ب)\s*(.+)$/
    ];

    /* Стек отмены. Глубина 12 — достаточно, чтобы отыграть подряд идущие
       промахи распознавания, и не настолько, чтобы держать в памяти длинную
       диктовку целиком. */
    var editUndoStack = [];

    function pushEditUndo() {
        editUndoStack.push(transcriptSegments.map(function (s) {
            return { text: s.text, timestamp: s.timestamp, isFinal: s.isFinal, isParagraph: !!s.isParagraph };
        }));
        if (editUndoStack.length > 12) editUndoStack.shift();
    }

    function commitEdit(kind, detail) {
        finalTranscript = transcriptSegments.map(function (s) { return s.text; }).join(' ');
        renderTranscript();
        updateStats();
        try { autoSave(); } catch (e) {}
        /* Видимый ответ: команда, которая молчит, неотличима от команды,
           которая уехала в текст словами. */
        var msg = (STR['edit_' + kind] || kind);
        if (detail) msg += ' — ' + detail;
        updateStatus(msg, 'ok');
        try { window.__toast && window.__toast(msg, 'success'); } catch (e) {}
        try { window.__ae && window.__ae('feature_use', { slug: TOOL_SLUG, f: 'voice_edit', kind: kind }); } catch (e) {}
    }

    /* Последнее слово: режем хвост последнего непустого сегмента; если сегмент
       состоял из одного слова — выбрасываем сегмент целиком. */
    function editDeleteWord() {
        for (var i = transcriptSegments.length - 1; i >= 0; i--) {
            var seg = transcriptSegments[i];
            if (seg.isParagraph) { continue; }
            var words = String(seg.text || '').trim().split(/\s+/).filter(Boolean);
            if (!words.length) continue;
            pushEditUndo();
            var removed = words.pop();
            if (words.length) seg.text = words.join(' ');
            else transcriptSegments.splice(i, 1);
            commitEdit('word_deleted', removed);
            return true;
        }
        return false;
    }

    /* Последнее предложение: собираем текст, отрезаем хвост после предыдущего
       завершающего знака и кладём обратно ОДНИМ сегментом — дробить старые
       границы незачем, а время берём у первого выжившего. */
    function editDeleteSentence() {
        var text = transcriptSegments.map(function (s) { return s.text; }).join(' ').trim();
        if (!text) return false;
        var cut = text.replace(/[^.!?…]*$/u, '').replace(/\s+$/, '');
        if (cut === text) cut = '';
        pushEditUndo();
        var ts = transcriptSegments.length ? transcriptSegments[0].timestamp : 0;
        transcriptSegments = cut ? [{ text: cut, timestamp: ts, isFinal: true }] : [];
        commitEdit('sentence_deleted');
        return true;
    }

    /* Замена: ищем ПОСЛЕДНЕЕ вхождение — человек правит то, что только что
       сказал, а не первое совпадение в часовой расшифровке. */
    function editReplace(from, to) {
        var needle = String(from || '').trim();
        if (!needle) return false;
        var esc = needle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        var re = new RegExp(esc, 'i');
        for (var i = transcriptSegments.length - 1; i >= 0; i--) {
            var seg = transcriptSegments[i];
            if (seg.isParagraph || !re.test(seg.text || '')) continue;
            pushEditUndo();
            seg.text = String(seg.text).replace(re, String(to).trim());
            commitEdit('replaced', needle + ' → ' + String(to).trim());
            return true;
        }
        /* Сказали заменить то, чего в тексте нет: это НЕ команда — вернём её в
           текст словами, иначе фраза пропадёт бесследно. */
        return false;
    }

    function editUndo() {
        if (!editUndoStack.length) {
            updateStatus(STR.edit_nothing_to_undo || '', '');
            return true;
        }
        transcriptSegments = editUndoStack.pop();
        commitEdit('undone');
        return true;
    }

    /* Разбор фразы как команды правки. Возвращает true, если команда выполнена
       (и текст в расшифровку не попадает). */
    function processVoiceEdit(text) {
        if (!$voiceCommands.checked) return false;
        var lower = String(text || '').trim().toLowerCase().replace(/[.!?]+$/u, '');
        if (!lower) return false;
        for (var kind in VOICE_EDIT_PATTERNS) {
            var list = VOICE_EDIT_PATTERNS[kind];
            for (var i = 0; i < list.length; i++) {
                if (!list[i].test(lower)) continue;
                if (kind === 'undo') return editUndo();
                if (kind === 'delWord') return editDeleteWord();
                if (kind === 'delSentence') return editDeleteSentence();
            }
        }
        for (var j = 0; j < VOICE_REPLACE_PATTERNS.length; j++) {
            var m = lower.match(VOICE_REPLACE_PATTERNS[j]);
            if (m) return editReplace(m[1], m[2]);
        }
        return false;
    }

    /* Тестовый вход в разбор команд правки. Настоящий путь идёт через Web
       Speech, а он в headless-браузере живёт секунду и гасится сторожем
       доставки: сессия успевает открыться и тут же abort. Проверять при этом
       надо НЕ распознавание (оно чужое), а разбор уже полученной фразы —
       поэтому у сторожа есть прямая дверь к нему.
       Сторож: tests/playwright/voice-edit-commands.mjs. */
    window.__sttVoiceEdit = function (text) {
        return { handled: processVoiceEdit(text), text: getPlainTranscript() };
    };
    window.__sttSeedSegments = function (list) {
        transcriptSegments = (list || []).map(function (x, i) {
            return { text: String(x), timestamp: i * 3, isFinal: true };
        });
        editUndoStack = [];
        userHasEdited = false;
        renderTranscript();
        updateStats();
    };

    function processVoiceCommands(text) {
        if (!$voiceCommands.checked) return { isCommand: false, text: text };
        var lower = text.trim().toLowerCase();
        /* Entire text is a command */
        if (VOICE_COMMANDS[lower] !== undefined) {
            return { isCommand: true, char: VOICE_COMMANDS[lower] };
        }
        /* Command at end of text */
        for (var cmd in VOICE_COMMANDS) {
            if (lower.endsWith(' ' + cmd)) {
                var cleaned = text.slice(0, text.length - cmd.length).trimEnd();
                return { isCommand: false, text: cleaned + VOICE_COMMANDS[cmd] };
            }
        }
        return { isCommand: false, text: text };
    }

    function autoPunctuate(text) {
        if (!$autoPunct.checked || !text) return text;
        return text.charAt(0).toUpperCase() + text.slice(1);
    }

    /* =====================================================
       Section 6: Web Speech API — Recognition
       ===================================================== */
    var _sttEvBuf = null;
    function sttSpeechEvidence() {
        if (!analyser || !audioContext || audioContext.state === 'closed') return null;
        try {
            var n = analyser.fftSize;
            if (!_sttEvBuf || _sttEvBuf.length !== n) _sttEvBuf = new Uint8Array(n);
            analyser.getByteTimeDomainData(_sttEvBuf);
            var sum = 0;
            for (var i = 0; i < n; i++) { var v = (_sttEvBuf[i] - 128) / 128; sum += v * v; }
            return Math.sqrt(sum / n) > 0.01;
        } catch (_) { return null; }
    }

    /* Build the recognition session via the shared WebSpeechSession module.
       The module owns the MECHANISM (robust auto-restart with setTimeout
       escape + fresh-instance fallback + bounded retry — the эталон fix for
       the Yandex 14 s cutoff bug 3b5637cc; error classification; network
       retry-once; feature_use:recognition_error telemetry on every branch).
       STT owns the POLICY via the callbacks below. */
    function initVoiceSession() {
        if (!window.WebSpeechSession || !WebSpeechSession.isSupported()) {
            /* Persistent banner + one-click file-mode escape, NOT a 3-second
               toast: "speech recognition unavailable" is unrecoverable on
               this page, and Whisper file mode works without it. The toast
               variant was missable and left no trace (ES feedback
               2026-07-30: 7.8 min on the page, zero telemetry). */
            try { window.__ae && window.__ae('feature_use', { slug: TOOL_SLUG, f: 'record_gate_blocked', gate: 'sr_unsupported' }); } catch (_) {}
            showWarning(STR.error_speech_not_supported, { canRetry: false });
            return false;
        }
        if (voiceSession) { voiceSession.destroy(); voiceSession = null; }
        voiceSession = new WebSpeechSession({
            slug: TOOL_SLUG,
            lang: $lang.value,
            continuous: true,
            interimResults: true,
            maxAlternatives: 1,
            /* Restart on the engine's ~14-60 s session timeout while actively
               recording, not paused, and the user wants continuous capture. */
            autoRestart: function() { return isRecording && !isPaused && $continuous.checked; },
            onResult: handleVoiceResult,
            onError: handleVoiceError,
            onFatal: handleVoiceFatal,
            onEnd: handleVoiceEnd,
            onSpeechStart: function() { updateStatus(STR.listening, 'active'); },
            onSpeechEnd: function() { if (isRecording) updateStatus(STR.recording + '...', 'active'); },
            /* Independent proof that the user is speaking, from OUR waveform
               analyser rather than from the recogniser we are judging. Returns
               null while the analyser cannot answer (stream not open yet, or
               the AudioContext was closed out from under us — a state this
               tool demonstrably reaches) so the module degrades to the
               engine's own speechstart instead of to "no evidence".
               0.01 is the site-wide speech-activity floor, shared with
               voice-translator's wedge guard and rms-meter.js. */
            speechEvidence: sttSpeechEvidence,
        });
        return true;
    }

    /* onResult — identical transcript / voice-command logic as before; the
       module hands us {final, interim, results, resultIndex}. */
    function handleVoiceResult(r) {
        noSpeechCount = 0;
        hasGotResult = true;
        if (noResultTimer) { clearTimeout(noResultTimer); noResultTimer = null; }
        if (!r.results || !r.results.length) return;
        var interim = '';
        var startIdx = (typeof r.resultIndex === 'number') ? r.resultIndex : 0;
        for (var i = startIdx; i < r.results.length; i++) {
            var result = r.results[i];
            if (!result || !result[0]) continue;
            var alt = result[0];
            if (!alt || typeof alt.transcript !== 'string') continue;
            var transcriptText = alt.transcript;
            if (result.isFinal) {
                /* Правка голосом идёт ПЕРЕД знаками препинания: «удали
                   последнее слово» — это команда целиком, и разобрать её как
                   текст значило бы вписать её в письмо словами. */
                if (processVoiceEdit(transcriptText)) { continue; }

                /* Voice commands processing */
                var cmd = processVoiceCommands(transcriptText);
                if (cmd.isCommand) {
                    /* Pure command — append char to last segment or directly */
                    if (transcriptSegments.length > 0) {
                        var lastSeg = transcriptSegments[transcriptSegments.length - 1];
                        lastSeg.text = lastSeg.text.trimEnd() + cmd.char;
                    } else {
                        appendFinalText(cmd.char);
                    }
                    finalTranscript = transcriptSegments.map(function(s){return s.text;}).join(' ');
                    renderTranscript();
                    updateStats();
                } else {
                    /* Auto-paragraphs: insert break on long pause */
                    var now = timerSeconds;
                    if ($autoParagraphs.checked && lastSpeechTimestamp > 0 && (now - lastSpeechTimestamp) >= 3 && transcriptSegments.length > 0) {
                        transcriptSegments.push({ text: '\n', timestamp: now, isFinal: true, isParagraph: true });
                    }
                    lastSpeechTimestamp = now;
                    /* Auto-punctuation */
                    appendFinalText(autoPunctuate(cmd.text));
                }
            } else {
                interim += transcriptText;
            }
        }
        updateInterimText(interim);
    }

    /* onError — the module emits feature_use:recognition_error itself and
       classifies the error; fatal errors route to handleVoiceFatal. Here we
       only handle the non-fatal `no-speech` hint. */
    function handleVoiceError(ev) {
        if (ev.cls === 'no-speech') {
            noSpeechCount++;
            updateStatus(STR.no_speech_detected, '');
            if (noSpeechCount >= NO_SPEECH_HINT_THRESH && !hasGotResult) {
                /* Warning banner, not a toast that fades. */
                showWarning(STR.speech_not_working);
                noSpeechCount = 0;
            }
        }
    }

    /* onFatal — Web Speech is unrecoverable. The MediaRecorder stream is
       INDEPENDENT, so for backend / network failures we keep recording and
       let Whisper transcribe on stop (whisperTakeover); only a genuine
       mic-level failure ends the recording. */
    function handleVoiceFatal(reason) {
        if (reason === 'permission') {
            /* User (or OS / browser policy) denied speech-recognition perm. */
            if (mediaStream) { showWarning(STR.error_speech_denied); }
            else { showError(STR.error_mic_denied); }
            stopRecording();
        } else if (reason === 'audio-capture') {
            /* Mic device disappeared mid-recording (USB unplugged, default
               device switched, OS exclusive-mode lock). Different copy from
               "permission denied" — the user CAN'T just re-grant; they need
               to fix the device. */
            showError(STR.error_mic_unavailable || STR.error_mic_denied);
            stopRecording();
        } else if (reason === 'backend') {
            /* Mic works, speech BACKEND rejected (region-block, quota). */
            if (mediaStream) { whisperTakeover('service_not_allowed'); }
            else { showError(STR.error_mic_denied); stopRecording(); }
        } else if (reason === 'network') {
            whisperTakeover('network');
        } else if (reason === 'restart_cap' || reason === 'start_failed') {
            /* Web Speech exhausted its restart budget — Whisper on capture. */
            whisperTakeover('restart_exhausted');
        } else {
            whisperTakeover(reason || 'unknown');
        }
    }

    /* onEnd — fires only when the session ends WITHOUT us tearing it down
       (STT-initiated stops call voiceSession.destroy(), which suppresses
       this callback). So reaching here means Web Speech ended on its own:
       - webSpeechFailed → whisperTakeover keeps MediaRecorder running, the
         session ending is expected — leave the recording alone;
       - otherwise it's a non-continuous-mode natural end → finalize. */
    function handleVoiceEnd() {
        if (webSpeechFailed) return;
        if (isRecording && !isPaused) stopRecording();
    }

    /* Tear down and rebuild the recognition session — used by the warning
       Try-again button and the language-change handler. destroy() is
       synchronous, so there is no abort→start race. */
    function restartVoiceSession() {
        if (!isRecording || isPaused) return;
        if (voiceSession) { voiceSession.destroy(); voiceSession = null; }
        if (initVoiceSession()) voiceSession.start();
    }

    /* Whisper-takeover — Web Speech died mid-recording (network unreachable,
       backend rejected). The MediaRecorder stream is independent and STILL
       capturing audio, so rather than killing the session at ~1 s we keep
       recording and let Whisper transcribe the full audio when the user
       stops. Idempotent — re-firing on a subsequent onerror is a no-op.
       Bug-report 2026-05-16 sid 24d8087b (Edge 148, Bolivia, "graba 1
       segundo y para"). */
    function whisperTakeover(reason) {
        if (webSpeechFailed) return;
        webSpeechFailed = true;
        pendingAutoTranscribe = true;   /* showPlayback → Whisper on stop */
        try { window.__ae && window.__ae('feature_use', {
            slug: TOOL_SLUG, f: 'whisper_takeover', reason: reason || 'unknown',
        }); } catch(_) {}
        /* The WebSpeechSession is already dead (the module aborts it as part
           of going fatal). MediaRecorder is untouched and keeps capturing.
           Tell the user plainly: live preview is paused but recording
           continues and Whisper will transcribe — so the empty transcript
           area doesn't read as "broken". */
        updateStatus(STR.whisper_live_unavailable || (STR.recording + '...'), 'active');
        showToast(STR.whisper_live_unavailable || STR.whisper_auto_fallback_started, 'info');
        /* Kill any earlier showWarning() panel — its "Switch to file mode"
           link is harmful once takeover has engaged (clicking it abandons
           the in-progress recording instead of letting Whisper rescue it).
           14d telemetry: 5/164 takeover sessions clicked Switch-to-file
           AFTER takeover engaged → recording lost despite the toast. */
        hideWarning();
        /* Persist whatever's been captured so far so a tab-close right
           now is recoverable — the next ondataavailable will keep it
           current. Closes the 18% (29 sessions) tab-close abandon path. */
        persistRecoveryChunks(reason);
    }

    /* Check IndexedDB for unfinished Whisper-takeover recordings from
       previous sessions. If any exist, surface the recovery banner so the
       user can transcribe (or discard) audio that was captured but never
       finished. Stale entries (> RECOVERY_MAX_AGE_MS) are auto-purged. */
    function initRecoveryPanel() {
        if (!window.WhisperRecoveryStore || !window.WhisperRecoveryStore.isSupported()) return;
        var $panel   = document.getElementById('sttRecovery');
        var $meta    = document.getElementById('sttRecoveryMeta');
        var $accept  = document.getElementById('sttRecoveryAccept');
        var $discard = document.getElementById('sttRecoveryDiscard');
        if (!$panel || !$meta || !$accept || !$discard) return;

        /* Quiet cleanup of forgotten old entries — runs once per page load. */
        window.WhisperRecoveryStore.purgeStale(RECOVERY_MAX_AGE_MS).catch(function () {});

        window.WhisperRecoveryStore.listPending().then(function (items) {
            if (!items || !items.length) return;
            /* Pick the most recent — if the user has multiple abandoned
               sessions, after Accept/Discard the next-most-recent will
               surface on their next visit. */
            items.sort(function (a, b) { return (b.updatedAt || 0) - (a.updatedAt || 0); });
            var entry = items[0];
            var ageMin = Math.max(1, Math.round((Date.now() - (entry.updatedAt || Date.now())) / 60000));
            var sizeKb = Math.max(1, Math.round((entry.byteSize || 0) / 1024));

            /* Body template ships with {minutes}/{size} placeholders so each
               locale can word it naturally. */
            var template = STR.recovery_body || '{minutes} min ago — {size} KB';
            $meta.textContent = ' ' + template.replace('{minutes}', ageMin).replace('{size}', sizeKb);
            $panel.classList.remove('hidden');
            try { window.__ae && window.__ae('feature_use', {
                slug: TOOL_SLUG, f: 'recovery_panel_shown', age_min: ageMin, kb: sizeKb,
            }); } catch (_) {}

            $accept.addEventListener('click', function () {
                try { window.__ae && window.__ae('feature_use', { slug: TOOL_SLUG, f: 'recovery_accept' }); } catch (_) {}
                $accept.disabled = true;
                $discard.disabled = true;
                window.WhisperRecoveryStore.load(entry.id).then(function (blob) {
                    if (!blob) { $panel.classList.add('hidden'); return; }
                    /* Funnel into the same transcribeFile pipeline the user
                       would hit by uploading the audio manually — keeps
                       the model selection + ETA + UI rendering identical. */
                    var ext = ((entry.meta && entry.meta.mimeType) || 'audio/webm').indexOf('mp4') >= 0 ? 'm4a' : 'webm';
                    currentFile = new File([blob], 'recovered-recording.' + ext, { type: blob.type });
                    $panel.classList.add('hidden');
                    if (typeof handleFile === 'function') handleFile(currentFile);
                    if (typeof transcribeFile === 'function') {
                        transcribeFile(currentFile).then(function () {
                            return window.WhisperRecoveryStore.discard(entry.id);
                        }).catch(function () {});
                    }
                });
            });

            $discard.addEventListener('click', function () {
                try { window.__ae && window.__ae('feature_use', { slug: TOOL_SLUG, f: 'recovery_discard' }); } catch (_) {}
                window.WhisperRecoveryStore.discard(entry.id).catch(function () {});
                $panel.classList.add('hidden');
            });
        }).catch(function () {});
    }

    /* Write current MediaRecorder chunks to the IndexedDB recovery store.
       Idempotent (overwrites). Fire-and-forget — IDB errors are silent
       since recovery is opportunistic. */
    function persistRecoveryChunks(takeoverReason) {
        if (!window.WhisperRecoveryStore || !recoverySessionId || !recordedChunks.length) return;
        try {
            window.WhisperRecoveryStore.persist(recoverySessionId, recordedChunks, {
                mimeType:        (mediaRecorder && mediaRecorder.mimeType) || 'audio/webm',
                lang:            $lang && $lang.value,
                model:           $model && $model.value,
                takeoverReason:  takeoverReason || null,
                startedAt:       recordingStartedAt,
                locale:          window.__LOCALE || 'en',
            }).catch(function () {});
        } catch (_) {}
    }

    function startRecording() {
        if (isRecording) { stopRecording(); return; }
        /* Funnel head — emitted BEFORE every gate. Until 2026-07-30 the first
           event in the record funnel was mic_acquire, so ANY death before
           getUserMedia (cap gate, SR-unsupported, sync exception) was
           invisible: an ES user spent 7.8 min failing to start dictation and
           telemetry showed nothing at all. record_click → mic_acquire delta
           now measures exactly that gap. */
        try { window.__ae && window.__ae('feature_use', { slug: TOOL_SLUG, f: 'record_click' }); } catch (_) {}
        /* Soft daily-run limit — block a NEW recording at the cap (a stop above
           is always allowed). Recorded on stop when segments were produced. */
        if (sttLimitBlocked()) {
            try { window.__ae && window.__ae('feature_use', { slug: TOOL_SLUG, f: 'record_gate_blocked', gate: 'limit' }); } catch (_) {}
            return;
        }
        /* Cancel any pending status-clear from a prior stop */
        if (statusClearTimer) { clearTimeout(statusClearTimer); statusClearTimer = null; }
        /* Fresh session — clear the Web-Speech-dead flag (a new recording
           may have working network; restart/network counters now live
           inside the WebSpeechSession module and reset on its own start()). */
        webSpeechFailed = false;
        /* New recovery session — generated even if takeover never fires,
           but only written to IndexedDB once webSpeechFailed flips. */
        recoverySessionId = (typeof crypto !== 'undefined' && crypto.randomUUID)
            ? crypto.randomUUID()
            : ('rec-' + Date.now() + '-' + Math.random().toString(36).slice(2));
        recordingStartedAt = Date.now();
        /* Immediate visual feedback before async chain */
        $recordBtn.classList.add('preparing');
        $recordBtn.disabled = true;

        /* The synchronous section below (session init → recognition.start)
           MUST NOT leave the button dead on an exception. Measured on real
           Edge 2026-07-30: a throwing SpeechRecognition constructor
           (enterprise policy / disabled platform speech service) left the
           button permanently `preparing`+disabled — further clicks don't
           even fire events on a disabled button, so the user saw a control
           that "cannot be activated" and telemetry recorded nothing. */
        try {
            if (!initVoiceSession()) { $recordBtn.classList.remove('preparing'); $recordBtn.disabled = false; return; }

            /* Hide playback from previous recording */
            hidePlayback();

            /* Clear previous transcript on new recording. The claim comes with
               it: from here the LIVE dictation owns the surface, so a Whisper
               job still running over the previous recording stops painting
               here and finishes into history instead (see transcribeFile). */
            claimTranscript();
            if (isTranscribing) detachRunningJob();
            clearTranscript();

            /* Start recognition FIRST — iOS requires the user-gesture context;
               the module's start() calls recognition.start() synchronously, and
               handles InvalidStateError internally (fresh-instance fallback). */
            voiceSession.start();
        } catch (e) {
            $recordBtn.classList.remove('preparing');
            $recordBtn.disabled = false;
            if (voiceSession) { try { voiceSession.destroy(); } catch (_) {} voiceSession = null; }
            try { window.__ae && window.__ae('feature_use', { slug: TOOL_SLUG, f: 'record_start_failed', err: (e && e.name) || 'Error' }); } catch (_) {}
            /* Same persistent banner + file-mode escape as SR-unsupported —
               live dictation is dead here, Whisper file mode still works. */
            showWarning(STR.error_speech_not_supported, { canRetry: false });
            return;
        }

        (function(){
            if(!window._sttMic) window._sttMic = new MicManager({
                /* Wire the recovery modal's secondary CTA. When mic is denied
                   /not_found/busy and the user can't resolve it, the modal
                   offers a one-click switch to /audio-to-text where Whisper
                   handles transcription locally with no microphone needed.
                   Bug-report 2026-05-07 sid 110fb0dd: user spent 16 minutes
                   trying to unblock mic via Yandex Browser settings before
                   succeeding — would have escaped to file mode much sooner
                   if the modal had offered this path. */
                fallbackAction: {
                    label: STR.switch_to_file_mode,
                    handler: function() {
                        window.location.href = CFG.urls.fileMode;
                    }
                }
            });
            window._sttMic.startRaw({
                audio: { sampleRate: { ideal: getMicPreset().sr }, channelCount: { ideal: getMicPreset().ch }, echoCancellation: false, noiseSuppression: false, autoGainControl: true }
            }).catch(function() {
                /* Detailed constraints failed — retry with simple audio:true */
                return window._sttMic.start();
            }).then(startRecordingWithStream).catch(function(err) {
                $recordBtn.classList.remove('preparing');
                $recordBtn.disabled = false;
                if (voiceSession) { voiceSession.destroy(); voiceSession = null; }
                showError(err.message);
            });
        })();

        function startRecordingWithStream(stream) {
            mediaStream = stream;
            setupWaveform(stream);
            startMediaRecorder(stream);
            /* Active "we can't hear you" (shared watchdog via MicManager): a DEAD
               input (digital flatline) otherwise surfaces only as the generic
               "recognition not working" hint. 15 s window — dictation pauses are
               legitimate; digital silence for 15 s is not. Auto-stops in stop(). */
            if (window._sttMic && window._sttMic.watchSilence) window._sttMic.watchSilence({ anchorEl: $status, ms: 15000 });
            isRecording = true;
            isPaused = false;
            lastSpeechTimestamp = 0;
            noSpeechCount = 0;
            hasGotResult = false;
            $recordBtn.classList.remove('preparing');
            $recordBtn.disabled = false;
            startTimer();
            updateRecordingUI();
            updateStatus(STR.recording + '...', 'active');
            /* If no result inside NO_RESULT_HINT_MS, surface the actionable warning. */
            if (noResultTimer) clearTimeout(noResultTimer);
            noResultTimer = setTimeout(function() {
                if (isRecording && !hasGotResult) {
                    showWarning(STR.speech_not_working);
                }
            }, NO_RESULT_HINT_MS);
        }
    }

    function stopRecording() {
        isRecording = false;
        isPaused = false;
        if (noResultTimer) { clearTimeout(noResultTimer); noResultTimer = null; }
        /* destroy() (not stop/abort) — synchronous teardown that suppresses
           the module's onEnd, so handleVoiceEnd doesn't re-enter stopRecording. */
        if (voiceSession) { voiceSession.destroy(); voiceSession = null; }
        /* Chain showPlayback off mediaRecorder.onstop — fires after the final
           dataavailable, so playbackAudio is built deterministically the moment
           recording bytes are complete. No setTimeout race. */
        stopMediaRecorder(showPlayback);
        stopWaveform();
        stopTimer();
        updateRecordingUI();
        /* Status: confirm save (operational state), then clear after 4s.
           Never restore "Start recording" here — that text duplicates the button's CTA
           and was being mis-clicked as if it were a button (rage_click telemetry on #sttStatus). */
        updateStatus(STR.recording_saved || STR.done || '', 'success');
        if (statusClearTimer) clearTimeout(statusClearTimer);
        statusClearTimer = setTimeout(function() {
            if (!isRecording) updateStatus('', '');
        }, STATUS_CLEAR_MS);
        if (transcriptSegments.length > 0) {
            saveToHistory();
            try{window.__aeToolComplete()}catch(e){}
            /* A completed mic dictation counts as one run (speech-to-text slug). */
            sttLimitRecord();
        }
        /* Discoverability nudge — when the heuristic suggests Whisper would
           materially improve transcript quality, pulse the refine button for
           ~4 s so the user notices it sits in the playback panel. Triggers:
             - recording > 30 s AND ratio chars/sec < 1.5  (sparse transcript)
             - OR locale === 'ru' AND recording > 20 s    (Yandex SpeechKit is
               weaker on Russian than Whisper, especially with informal speech
               or profanity which the SpeechKit free tier censors → garbled).
           Bug session 2026-05-14 14:42 (ru, Yandex Browser) recorded 4 min
           total, never noticed the existing refine button, rated 1 star.
           pendingAutoTranscribe is for the harder "Web Speech entirely
           failed" path; this nudge is for "Web Speech worked but result is
           plausibly poor". Emits feature_use:whisper_refine_nudge_shown so
           T+7d we can measure shown→clicked conversion. */
        if (!pendingAutoTranscribe && $whisperRefineBtn) {
            try {
                var transcriptText = transcriptSegments.map(function (s) { return s.text || ''; }).join(' ');
                var charsPerSec = timerSeconds > 0 ? transcriptText.length / timerSeconds : 0;
                var nudgeReason = null;
                if (timerSeconds >= 30 && charsPerSec < 1.5) nudgeReason = 'sparse_transcript';
                else if (window.__LOCALE === 'ru' && timerSeconds >= 20) nudgeReason = 'ru_locale';
                if (nudgeReason) {
                    /* Defer until playback panel becomes visible so the pulse
                       isn't wasted on a hidden button. */
                    setTimeout(function () {
                        if (!$whisperRefineBtn || $whisperRefineBtn.offsetParent === null) return;
                        $whisperRefineBtn.classList.add('nudge');
                        setTimeout(function () { $whisperRefineBtn.classList.remove('nudge'); }, 4200);
                        try { window.__ae && window.__ae('feature_use', { slug: TOOL_SLUG, f: 'whisper_refine_nudge_shown', reason: nudgeReason, dur_s: Math.round(timerSeconds), chars_per_s: Math.round(charsPerSec * 100) / 100 }); } catch (_) {}
                    }, 400);
                }
            } catch (_) {}
        }
        /* Note: showPlayback is invoked via stopMediaRecorder's `stop` event
           callback above — no setTimeout here. */
    }

    function pauseRecording() {
        if (!isRecording) return;
        isPaused = true;
        /* destroy() — Web Speech has no real pause; tear the session down
           (suppressing onEnd) and rebuild it fresh on resume. MediaRecorder
           keeps the audio stream; only the live preview pauses. */
        if (voiceSession) { voiceSession.destroy(); voiceSession = null; }
        pauseTimer();
        updateRecordingUI();
        updateStatus(STR.paused, '');
    }

    function resumeRecording() {
        if (!isRecording || !isPaused) return;
        isPaused = false;
        if (!webSpeechFailed) {
            /* Rebuild the recognition session (picks up the current $lang).
               If Web Speech already failed this recording, leave it dead —
               MediaRecorder + Whisper-on-stop carry the session. */
            if (initVoiceSession()) voiceSession.start();
        }
        resumeTimer();
        updateRecordingUI();
        updateStatus(STR.recording + '...', 'active');
    }

    function updateRecordingUI() {
        $recordBtn.classList.toggle('recording', isRecording && !isPaused);
        $recordBtn.classList.toggle('paused', isRecording && isPaused);
        $pauseBtn.classList.toggle('hidden', !isRecording);
        $stopBtn.classList.toggle('hidden', !isRecording);
        $bookmarkBtn.classList.toggle('hidden', !isRecording);
        $audioDl.classList.toggle('disabled', isRecording || recordedChunks.length === 0);

        if (isRecording && isPaused) {
            $pauseBtn.innerHTML = '&#9654; ' + STR.resume;
        } else {
            $pauseBtn.innerHTML = '&#9208; ' + STR.pause;
        }

        /* Dictation mode sync */
        if ($dictationRecordBtn) {
            $dictationRecordBtn.classList.toggle('recording', isRecording && !isPaused);
            $dictationRecordBtn.classList.toggle('paused', isRecording && isPaused);
        }
    }

    function updateStatus(text, cls) {
        $status.textContent = text;
        $status.className = 'stt-status' + (cls ? ' ' + cls : '');
    }

    /* =====================================================
       Section 7: Waveform visualization
       ===================================================== */
    /* The bars say one thing — «the microphone hears you» — and they stay on
       screen for the whole dictation, which on this tool runs 15-20 minutes
       on a phone (comment #1773, 2026-09-28: «быстро нагревается телефон»).
       Until 2026-09-29 they were drawn on every display frame, paused or not,
       and every frame forced a page layout (getBoundingClientRect) and filled
       ~50 bars with ~50 freshly built gradients: ~3 000 gradient fills a
       second at DPR 3 for as long as the microphone was open. And because
       `rect.width * dpr` is fractional on most phones while canvas.width is an
       integer, the size check failed on every frame and the bitmap was
       reallocated 60 times a second.
       Now: 20 frames a second from a timer (a pending rAF wakes the rendering
       pipeline on every vsync), ONE path and ONE gradient per frame, the size
       read when it changes (ResizeObserver) and rounded, nothing drawn in a
       hidden tab. Before/after counts — memory tool_speech_to_text. */
    var WAVE_FRAME_MS = 50;
    var waveBuf = null, waveW = 0, waveH = 0, waveGrad = null, waveRO = null, waveTick = 0;

    function measureWaveform() {
        var dpr = window.devicePixelRatio || 1;
        var rect = $waveform.getBoundingClientRect();
        waveW = Math.round(rect.width * dpr);
        waveH = Math.round(rect.height * dpr);
    }

    function setupWaveform(stream) {
        audioContext = new (window.AudioContext || window.webkitAudioContext)();
        var source = audioContext.createMediaStreamSource(stream);
        analyser = audioContext.createAnalyser();
        analyser.fftSize = 256;
        source.connect(analyser);
        waveBuf = new Uint8Array(analyser.frequencyBinCount);
        measureWaveform();
        /* A ResizeObserver callback runs after layout, so reading the box
           there costs no extra layout — unlike reading it from the draw loop. */
        if (!waveRO && window.ResizeObserver) {
            waveRO = new ResizeObserver(measureWaveform);
            waveRO.observe($waveform);
        }
        if (waveTimer) clearTimeout(waveTimer);
        drawWaveform();
    }

    function drawWaveform() {
        if (!analyser) return;
        waveTimer = setTimeout(drawWaveform, WAVE_FRAME_MS);
        if (document.hidden) return;
        /* No ResizeObserver (old engines): re-read the box once a second. */
        if (!waveRO && ++waveTick % 20 === 0) measureWaveform();

        var canvas = $waveform;
        var W = waveW, H = waveH;
        if (!W || !H) return;
        var ctx = canvas.getContext('2d');
        if (canvas.width !== W || canvas.height !== H) {
            canvas.width = W;
            canvas.height = H;
            waveGrad = null;
        }
        if (!waveGrad) {
            waveGrad = ctx.createLinearGradient(0, 0, 0, H);
            waveGrad.addColorStop(0, 'rgba(99, 102, 241, 0.9)');
            waveGrad.addColorStop(1, 'rgba(139, 92, 246, 0.5)');
        }

        var data = waveBuf;
        var bufLen = data.length;
        analyser.getByteFrequencyData(data);
        ctx.clearRect(0, 0, W, H);

        var barW = Math.max(2, (W / bufLen) * 2.5);
        var gap = 1;
        var x = 0;

        ctx.beginPath();
        for (var i = 0; i < bufLen && x < W; i++) {
            var barH = Math.max(2, data[i] / 255 * H * 0.85);
            if (ctx.roundRect) {
                ctx.roundRect(x, H - barH, barW, barH, 2);
            } else {
                ctx.rect(x, H - barH, barW, barH);
            }
            x += barW + gap;
        }
        ctx.fillStyle = waveGrad;
        ctx.fill();
    }

    function stopWaveform() {
        if (waveTimer) { clearTimeout(waveTimer); waveTimer = null; }
        if (waveRO) { try { waveRO.disconnect(); } catch (e) {} waveRO = null; }
        if (audioContext) { try { audioContext.close(); } catch(e) {} audioContext = null; }
        analyser = null;
        if (window._sttMic) window._sttMic.stop();
        mediaStream = null;
        var ctx = $waveform.getContext('2d');
        ctx.clearRect(0, 0, $waveform.width, $waveform.height);
    }

    /* =====================================================
       Section 7b: Playback (after recording)
       ===================================================== */
    function showPlayback() {
        if (!recordedChunks.length) return;
        var recMime = (mediaRecorder && mediaRecorder.mimeType) || 'audio/webm';
        var blob = new Blob(recordedChunks, { type: recMime });
        /* This blob is the PREVIEW of what the microphone captured, not the
           thing the user came for — the deliverable is text. Without this
           opt-out the telemetry blob-guess fired a tool_complete for every
           recording, so a dictation that produced NOTHING was booked as a
           success: 1759 such phantom completions in 30 days on this tool,
           and they are precisely the sessions in the bug report. Same class
           as the /voice-cover false-delivery incident that put the guess
           behind an opt-out in the first place. A real completion is
           announced explicitly on the transcript path in stopRecording(). */
        try { window.__skipBlobAutoTrack && window.__skipBlobAutoTrack(blob); } catch (_) {}
        var url = URL.createObjectURL(blob);

        playbackAudio = new Audio(url);
        playbackAudio.preload = 'metadata';

        /* Consume pendingAutoTranscribe — set by whisperTakeover() when Web
           Speech failed mid-recording. recordedChunks is finalized by this
           point (mediaRecorder.onstop chain), so it's safe to fire Whisper now. */
        if (pendingAutoTranscribe) {
            pendingAutoTranscribe = false;
            /* Brief inline status so the user knows what's happening. */
            updateStatus(STR.whisper_auto_fallback_started || STR.transcribing + '...', 'active');
            setTimeout(function () { transcribeRecordedAudio({ auto: true }); }, 100);
            /* The recovery store entry is no longer useful — Whisper is
               running on the audio right now, the user is here. Discard
               so the recovery panel doesn't pop up on next visit. */
            if (window.WhisperRecoveryStore && recoverySessionId) {
                window.WhisperRecoveryStore.discard(recoverySessionId).catch(function () {});
            }
        }

        // Sentry 117937893 (Yandex 26.3 Win, /ru/speech-to-text):
        // `Cannot read properties of null (reading 'duration')`. User
        // hit the record button 5× in quick succession (likely after a
        // `SpeechRecognition error: network` during the WG-tunnel
        // outage), each click null'd the module-level `playbackAudio`
        // before the previous Audio's `loadedmetadata` event fired.
        // Async handler then read the now-null global. Capture the
        // specific Audio instance at registration and bail if the user
        // has already moved on (global no longer points at our audio).
        var thisPlaybackAudio = playbackAudio;
        var thisBlob = blob;
        playbackAudio.addEventListener('loadedmetadata', function() {
            if (playbackAudio !== thisPlaybackAudio) return; // user re-recorded
            if (!isFinite(thisPlaybackAudio.duration)) {
                try { thisPlaybackAudio.currentTime = 1e10; } catch(e) {}
                thisPlaybackAudio.addEventListener('timeupdate', function fixDur() {
                    thisPlaybackAudio.removeEventListener('timeupdate', fixDur);
                    if (playbackAudio !== thisPlaybackAudio) return;
                    try { thisPlaybackAudio.currentTime = 0; } catch(e) {}
                    buildPlaybackWave(thisBlob);
                    $playbackLabel.textContent = '0:00 / ' + fmtPlayTime(thisPlaybackAudio.duration);
                });
            } else {
                buildPlaybackWave(thisBlob);
                $playbackLabel.textContent = '0:00 / ' + fmtPlayTime(thisPlaybackAudio.duration);
            }
        });
        playbackAudio.addEventListener('ended', function() {
            if (playbackAudio !== thisPlaybackAudio) return;
            stopPlayback();
        });

        $playback.classList.add('show');
    }

    function buildPlaybackWave(blob) {
        var ACtor = window.AudioContext || window.webkitAudioContext;
        var ctx = new ACtor();
        var reader = new FileReader();
        reader.onload = function() {
            ctx.decodeAudioData(reader.result, function(buffer) {
                ctx.close();
                var raw = buffer.getChannelData(0);
                var bars = 200;
                var blockSize = Math.floor(raw.length / bars);
                playbackWaveData = new Float32Array(bars);
                for (var i = 0; i < bars; i++) {
                    var sum = 0;
                    for (var j = 0; j < blockSize; j++) sum += Math.abs(raw[i * blockSize + j]);
                    playbackWaveData[i] = sum / blockSize;
                }
                drawPlaybackWave(0);
            }, function() { ctx.close(); }).catch(function(){});
        };
        reader.readAsArrayBuffer(blob);
    }

    function drawPlaybackWave(progress) {
        if (!playbackWaveData) return;
        var canvas = $playbackWave;
        var dpr = window.devicePixelRatio || 1;
        var rect = canvas.getBoundingClientRect();
        var W = rect.width * dpr;
        var H = rect.height * dpr;
        if (canvas.width !== W || canvas.height !== H) {
            canvas.width = W; canvas.height = H;
        }
        var ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, W, H);
        var bars = playbackWaveData.length;
        var maxVal = 0;
        for (var i = 0; i < bars; i++) if (playbackWaveData[i] > maxVal) maxVal = playbackWaveData[i];
        if (maxVal === 0) maxVal = 1;
        var barW = Math.max(1, (W / bars) - 1);
        var gap = 1;
        for (var i = 0; i < bars; i++) {
            var v = playbackWaveData[i] / maxVal;
            var barH = Math.max(2, v * H * 0.85);
            var x = i * (barW + gap);
            var frac = i / bars;
            if (frac <= progress) {
                var grad = ctx.createLinearGradient(0, H - barH, 0, H);
                grad.addColorStop(0, 'rgba(99,102,241,0.95)');
                grad.addColorStop(1, 'rgba(139,92,246,0.7)');
                ctx.fillStyle = grad;
            } else {
                ctx.fillStyle = 'rgba(255,255,255,0.15)';
            }
            ctx.beginPath();
            if (ctx.roundRect) ctx.roundRect(x, H - barH, barW, barH, 1);
            else ctx.rect(x, H - barH, barW, barH);
            ctx.fill();
        }
    }

    function animatePlayback() {
        if (!playbackAudio || playbackAudio.paused) return;
        if (!isFinite(playbackAudio.duration)) { playbackAnimFrame = requestAnimationFrame(animatePlayback); return; }
        var dur = playbackAudio.duration || 1;
        var cur = playbackAudio.currentTime;
        var progress = cur / dur;
        $playbackCursor.style.left = (progress * 100) + '%';
        $playbackTimeOv.textContent = fmtPlayTime(cur);
        $playbackLabel.textContent = fmtPlayTime(cur) + ' / ' + fmtPlayTime(dur);
        drawPlaybackWave(progress);
        playbackAnimFrame = requestAnimationFrame(animatePlayback);
    }

    function togglePlayback() {
        /* playbackAudio is null only if showPlayback hasn't run — and
           showPlayback now runs deterministically via mediaRecorder.onstop
           (see stopMediaRecorder rewrite). The only legitimate way to land
           here is "no recorded chunks yet" (page just loaded). Use the local
           showToast (renders into #sttToast) rather than the global __toast
           (renders into #toast-msg, separate element). */
        if (!playbackAudio) {
            /* Nothing recorded yet — guide the user. Reuse existing locale
               string rather than introduce another key for an edge that
               post-fix is essentially unreachable. */
            showToast(STR.transcript_placeholder || 'No recording yet', 'warning');
            return;
        }
        if (playbackAudio.paused) {
            try {
                var p = playbackAudio.play();
                if (p && p.catch) p.catch(function(err) {
                    console.warn('Playback failed:', err.message);
                    // Log only once per session to avoid spamming analytics
                    if (!window.__sttPlaybackErrorLogged) {
                        window.__sttPlaybackErrorLogged = true;
                        window.__handleError && window.__handleError(err, 'speech-to-text playback');
                    }
                    stopPlayback();
                    if (/not supported/i.test(err.message)) {
                        __toast && __toast(((window.__commonStrings||{}).js_no_audio_playback || "Audio playback is not supported in this browser. Try Chrome or Firefox."), 'warning');
                    }
                });
                $playIcon.classList.add('hidden');
                $stopIcon.classList.remove('hidden');
                animatePlayback();
            } catch(err) {
                console.warn('Playback error:', err.message);
                if (!window.__sttPlaybackErrorLogged) {
                    window.__sttPlaybackErrorLogged = true;
                    window.__handleError && window.__handleError(err, 'speech-to-text playback');
                }
            }
        } else {
            stopPlayback();
        }
    }

    function stopPlayback() {
        if (!playbackAudio) return;
        try { playbackAudio.pause(); } catch(e) {}
        try { playbackAudio.currentTime = 0; } catch(e) {}
        if (playbackAnimFrame) { cancelAnimationFrame(playbackAnimFrame); playbackAnimFrame = null; }
        $playIcon.classList.remove('hidden');
        $stopIcon.classList.add('hidden');
        $playbackCursor.style.left = '0';
        $playbackTimeOv.textContent = '0:00';
        var dur = (playbackAudio && isFinite(playbackAudio.duration)) ? playbackAudio.duration : 0;
        $playbackLabel.textContent = '0:00 / ' + fmtPlayTime(dur);
        drawPlaybackWave(0);
    }

    function seekPlayback(e) {
        if (!playbackAudio || !isFinite(playbackAudio.duration)) return;
        var rect = $playbackWrap.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width;
        x = Math.max(0, Math.min(1, x));
        try { playbackAudio.currentTime = x * playbackAudio.duration; } catch(err) { return; }
        $playbackCursor.style.left = (x * 100) + '%';
        drawPlaybackWave(x);
        $playbackTimeOv.textContent = fmtPlayTime(playbackAudio.currentTime);
        $playbackLabel.textContent = fmtPlayTime(playbackAudio.currentTime) + ' / ' + fmtPlayTime(playbackAudio.duration);
    }

    function hidePlayback() {
        if (playbackAudio) {
            try { playbackAudio.pause(); } catch(e) {}
            var src = playbackAudio.src;
            playbackAudio = null;
            if (src) URL.revokeObjectURL(src);
        }
        if (playbackAnimFrame) { cancelAnimationFrame(playbackAnimFrame); playbackAnimFrame = null; }
        playbackWaveData = null;
        $playback.classList.remove('show');
        $playIcon.classList.remove('hidden');
        $stopIcon.classList.add('hidden');
        $playbackCursor.style.left = '0';
    }

    function fmtPlayTime(s) {
        if (!isFinite(s) || s < 0) return '0:00';
        var m = Math.floor(s / 60);
        var sec = Math.floor(s % 60);
        return m + ':' + (sec < 10 ? '0' : '') + sec;
    }

    /* =====================================================
       Section 8: Timer
       ===================================================== */
    function startTimer() {
        timerSeconds = 0;
        updateTimerDisplay();
        timerInterval = setInterval(function() { timerSeconds++; updateTimerDisplay(); }, 1000);
    }

    function stopTimer() { clearInterval(timerInterval); timerInterval = null; }

    function pauseTimer() { clearInterval(timerInterval); timerInterval = null; }

    function resumeTimer() {
        timerInterval = setInterval(function() { timerSeconds++; updateTimerDisplay(); }, 1000);
    }

    function updateTimerDisplay() {
        var m = Math.floor(timerSeconds / 60);
        var s = timerSeconds % 60;
        var display = pad2(m) + ':' + pad2(s);
        $timer.textContent = display;
        if (isDictationMode && $dictationTimer) $dictationTimer.textContent = display;
    }

    function pad2(n) { return n < 10 ? '0' + n : '' + n; }

    /* =====================================================
       Section 9: Transcript management
       ===================================================== */
    function appendFinalText(text) {
        var trimmed = text.trim();
        if (!trimmed && text !== '\n' && text !== '\n\n') return;

        finalTranscript += text + ' ';
        transcriptSegments.push({
            text: trimmed || text,
            timestamp: timerSeconds,
            isFinal: true
        });

        /* Append to transcript DOM (editable-friendly) */
        appendToTranscriptDOM(text, false);

        /* Dictation mode sync */
        if (isDictationMode && $dictationText) {
            $dictationText.textContent += text + ' ';
        }

        updateStats();
        autoSave();
        scheduleWordCloud();
    }

    function updateInterimText(text) {
        /* Remove old interim span */
        var oldInterim = $transcript.querySelector('.stt-interim');
        if (oldInterim) oldInterim.remove();
        if (isDictationMode) {
            var oldDI = $dictationText ? $dictationText.querySelector('.stt-interim') : null;
            if (oldDI) oldDI.remove();
        }

        if (text) {
            var span = document.createElement('span');
            span.className = 'stt-interim';
            span.textContent = text;
            /* Remove placeholder if present */
            var ph = $transcript.querySelector('.stt-placeholder');
            if (ph) ph.remove();
            $transcript.appendChild(span);

            if (isDictationMode && $dictationText) {
                var span2 = document.createElement('span');
                span2.className = 'stt-interim';
                span2.textContent = text;
                $dictationText.appendChild(span2);
            }
        }

        if ($autoScroll.checked) $transcript.scrollTop = $transcript.scrollHeight;
    }

    function appendToTranscriptDOM(text, isInterim) {
        /* The result panel starts hidden (it is an empty box over a row of zeros
           until there is a result). Reveal it HERE, at the moment text is
           written, rather than relying only on updateStats(): if the stats path
           ever stops firing, a panel that never un-hides means the tool silently
           shows no transcript at all. Two independent reveals, because the cost
           of this one failing is the whole tool. */
        var _tsec = _$('sttTranscriptSection');
        if (_tsec && _tsec.hidden) _tsec.hidden = false;

        /* Remove placeholder if present */
        var ph = $transcript.querySelector('.stt-placeholder');
        if (ph) ph.remove();
        /* Remove old interim */
        var oldInterim = $transcript.querySelector('.stt-interim');
        if (oldInterim) oldInterim.remove();

        if (!isInterim && text) {
            var showTs = $timestamps.checked;
            var seg = transcriptSegments[transcriptSegments.length - 1];
            if (showTs && seg && (transcriptSegments.length === 1 || seg.timestamp - (transcriptSegments[transcriptSegments.length - 2] || {}).timestamp > 5)) {
                var tsSpan = document.createElement('span');
                tsSpan.className = 'stt-timestamp';
                tsSpan.textContent = '[' + formatTime(seg.timestamp) + ']';
                $transcript.appendChild(tsSpan);
                $transcript.appendChild(document.createTextNode(' '));
            }
            $transcript.appendChild(document.createTextNode(text + ' '));
        }

        if ($autoScroll.checked) $transcript.scrollTop = $transcript.scrollHeight;
    }

    function renderTranscript(interim) {
        /* Second, independent reveal of the result panel (the first is in
           appendToTranscriptDOM). The panel starts hidden because empty it is
           a box captioned «текст появится здесь» over a row of zeros; the one
           thing that must never happen is it staying hidden when there IS a
           transcript, so both write paths open it. */
        var _ts = _$('sttTranscriptSection');
        if (_ts && _ts.hidden) _ts.hidden = false;

        var showTs = $timestamps.checked;

        if (!transcriptSegments.length && !interim) {
            $transcript.innerHTML = '<div class="stt-placeholder">' + escHtml(STR.transcript_placeholder) + '</div>';
            return;
        }

        var html = '';
        for (var i = 0; i < transcriptSegments.length; i++) {
            var seg = transcriptSegments[i];
            if (seg.isParagraph) { html += '<br><br>'; continue; }
            if (showTs && (i === 0 || seg.timestamp - (transcriptSegments[i - 1] || {}).timestamp > 5)) {
                html += '<span class="stt-timestamp">[' + formatTime(seg.timestamp) + ']</span> ';
            }
            html += escHtml(seg.text) + ' ';
        }

        if (interim) {
            html += '<span class="stt-interim">' + escHtml(interim) + '</span>';
        }

        $transcript.innerHTML = html;

        if ($autoScroll.checked) {
            $transcript.scrollTop = $transcript.scrollHeight;
        }
    }

    function getPlainTranscript() {
        /* An in-place edit is picked up structure-first: the DOM still carries
           paragraphs, speaker chips and per-segment times, so copy/TXT/DOCX keep
           them. Only when the structure is gone (select-all + retype) does the
           plain text of the box win. */
        if (userHasEdited) {
            syncSegmentsFromDom();
            if (userHasEdited) return $transcript.textContent.trim();
        }
        return paragraphsToText(buildParagraphs(transcriptSegments), {
            speakers: showSpeakersOn(),
            timestamps: !!($timestamps && $timestamps.checked)
        });
    }

    /* ── Paragraphs (2026-09-04) ──────────────────────────────────────────
       Until now the file mode glued every segment with a space: a 2.5-hour
       lecture came back as ONE block of 105 000 characters, and a Premium
       user compared it with a competitor's turn-by-turn layout («каша
       текста, в отличии от других сервисов»). A paragraph starts on a speaker
       turn, on a long pause, or — inside a monologue — on a sentence end once
       the block is long enough to read as a paragraph. Thresholds measured on
       that recording: median gap 0.74 s, p90 1.96 s, so 2.5 s is a real pause
       and 1.0 s after a full stop is a breath. The same builder feeds the
       screen, copy and every export, so what you see is what you save. */
    var PARA_GAP_HARD = 2.5, PARA_GAP_SOFT = 1.0, PARA_SOFT_CHARS = 350, PARA_HARD_CHARS = 700, PARA_MAX_CHARS = 1200;
    function endsSentence(t) { return /[.!?…][»"”)]?\s*$/.test(t || ''); }
    function buildParagraphs(segs) {
        var paras = [], cur = null, chars = 0, prev = null;
        for (var i = 0; i < segs.length; i++) {
            var s = segs[i];
            if (s.isParagraph) { if (cur) { paras.push(cur); cur = null; } prev = null; chars = 0; continue; }
            if (!s || !s.text) continue;
            var start = s.timestamp || 0;
            var spk = s.speaker || (cur ? cur.speaker : null);
            var brk = !cur;
            if (cur) {
                if (spk && spk !== cur.speaker) brk = true;
                else {
                    var prevEnd = (prev && typeof prev.end === 'number') ? prev.end : (prev ? prev.timestamp : start);
                    var gap = start - prevEnd;
                    var sentenceEnd = prev ? endsSentence(prev.text) : true;
                    if (gap >= PARA_GAP_HARD) brk = true;
                    else if (chars >= PARA_MAX_CHARS) brk = true;
                    else if (sentenceEnd && (chars >= PARA_HARD_CHARS || (chars >= PARA_SOFT_CHARS && gap >= PARA_GAP_SOFT))) brk = true;
                }
            }
            if (brk) { if (cur) paras.push(cur); cur = { speaker: spk, start: start, end: (typeof s.end === 'number') ? s.end : start, segs: [] }; chars = 0; }
            cur.segs.push(s);
            if (typeof s.end === 'number') cur.end = s.end;
            chars += s.text.length + 1;
            prev = s;
        }
        if (cur) paras.push(cur);
        return paras;
    }
    /* Speaker label only where the speaker CHANGES; a monologue split into
       paragraphs must not repeat «Говорящий 1» on every one. */
    function paragraphsToText(paras, opts) {
        var out = [], prevSpk = null;
        for (var i = 0; i < paras.length; i++) {
            var p = paras[i], head = [];
            if (opts.timestamps) head.push('[' + formatTime(Math.round(p.start || 0)) + ']');
            if (opts.speakers && p.speaker && p.speaker !== prevSpk) head.push(p.speaker + ':');
            if (p.speaker) prevSpk = p.speaker;
            var body = p.segs.map(function (s) { return s.text; }).join(' ').replace(/\s+/g, ' ').trim();
            out.push((head.length ? head.join(' ') + ' ' : '') + body);
        }
        return out.join('\n\n').trim();
    }
    function transcriptHasSpeakers() {
        for (var i = 0; i < transcriptSegments.length; i++) if (transcriptSegments[i].speaker) return true;
        return false;
    }
    function showSpeakersOn() {
        if (!transcriptHasSpeakers()) return false;
        return $showSpeakers ? !!$showSpeakers.checked : true;
    }
    function syncSpeakersToggle() {
        var wrap = _$('sttSpeakersToggleWrap');
        if (wrap) wrap.hidden = !transcriptHasSpeakers();
    }
    /* Rename a speaker everywhere at once («Говорящий 2» → «Анна»): the label
       lives on the segments, so the screen, copy, DOCX/PDF/TXT, SRT/VTT, the
       history entry and the dialogue module all pick it up from one place. */
    function renameSpeaker(oldName, newName) {
        newName = String(newName || '').replace(/\s+/g, ' ').trim().slice(0, 40);
        if (!newName || newName === oldName) return false;
        flushEdits();
        /* Имя уже носит другой голос — значит, это не переименование, а слияние
           двух людей. До 07.10.2026 оно происходило молча и без возврата:
           человек правил одну реплику и терял различие голосов во всём тексте.
           Теперь спрашиваем. */
        var other = SPK ? SPK.clash(transcriptSegments, oldName, newName) : null;
        if (other) { askMerge(oldName, other); return false; }
        spkRemember();
        var n = 0;
        for (var i = 0; i < transcriptSegments.length; i++) {
            if (transcriptSegments[i].speaker === oldName) { transcriptSegments[i].speaker = newName; n++; }
        }
        if (n) { renderFileTranscript(); saveToHistory(); syncSpkUndo(); try { aeTranscribe('speaker_renamed', { segs: n }); } catch (_) {} }
        else spkForget();
        return n > 0;
    }
    /* ══ Панель «Кто говорит» ═════════════════════════════════════════════════
       Один список найденных голосов вместо охоты за цветной меткой в тексте.
       Замер, из-за которого она существует: 112 расшифровок с метками за 60
       дней у 12 аккаунтов и НОЛЬ переименований — прежний способ (нажать метку,
       подсказка в `title`) на телефоне не сообщает о себе ничем.

       ⚠️ Порог правдоподобия. Диаризация иногда возвращает бессмыслицу: замер
       06.09 по проду — на сервере медиана 4 голоса, но 12 % прогонов дают
       больше восьми, вплоть до 99; в браузере таких 30 %. Девяносто девять
       полей имени — не интерфейс, а издевательство, поэтому выше порога панель
       говорит прямо, что голоса разделить не удалось, и предлагает единственное
       осмысленное действие — снять метки. Число взято с запасом к живым
       данным: 8 голосов на записи бывают (совещание), 20 — нет. */
    var ROSTER_MAX = 12;
    var rosterPlaying = null;   /* кнопка ▶, которая сейчас играет */

    /** Голоса из сегментов: имя, доля речи, время первой реплики. */
    function rosterVoices() {
        var by = {}, order = [], total = 0;
        for (var i = 0; i < transcriptSegments.length; i++) {
            var sg = transcriptSegments[i];
            if (!sg || sg.isParagraph || !sg.speaker) continue;
            var start = sg.timestamp || 0;
            var len = (typeof sg.end === 'number' && sg.end > start) ? (sg.end - start)
                    : Math.max(1, (sg.text || '').length / 15);   /* нет времён — по длине текста */
            if (!by[sg.speaker]) { by[sg.speaker] = { name: sg.speaker, len: 0, first: start }; order.push(sg.speaker); }
            by[sg.speaker].len += len;
            if (start < by[sg.speaker].first) by[sg.speaker].first = start;
            total += len;
        }
        var out = order.map(function (k) {
            var v = by[k];
            v.share = total > 0 ? Math.round((v.len / total) * 100) : 0;
            /* Цвет — по ПОРЯДКУ ПОЯВЛЕНИЯ, ровно как в тексте (renderFileTranscript
               красит так же), иначе панель и текст назовут один голос разными
               цветами, и вся её польза пропадёт. */
            v.colour = order.indexOf(k) % 8;
            return v;
        });
        /* Сортировка по доле речи: главный голос первым — его называют раньше
           остальных, и на телефоне он виден без прокрутки. */
        out.sort(function (a, b) { return b.len - a.len; });
        return { voices: out, total: total };
    }

    function renderRoster() {
        var host = _$('sttRoster'), list = _$('sttRosterList');
        if (!host || !list) return;
        if (mode !== 'file' || !transcriptHasSpeakers() || !showSpeakersOn()) { host.hidden = true; stopRosterPreview(); return; }

        var r = rosterVoices();
        host.hidden = false;
        list.innerHTML = '';

        if (r.voices.length > ROSTER_MAX) {
            /* Честно: столько голосов в одной записи не бывает, значит разделить
               не удалось. Молчаливая выдача 99 меток — это то, что человек и так
               видит в тексте; объяснение и выход — то, чего у него не было. */
            var note = document.createElement('p');
            note.className = 'stt-roster-note';
            note.textContent = (STR.roster_too_many || 'Voices could not be separated ({n} found).').replace('{n}', r.voices.length);
            list.appendChild(note);
            var off = document.createElement('button');
            off.type = 'button'; off.className = 'stt-tool-btn';
            off.textContent = STR.roster_drop_labels || 'Remove labels';
            off.addEventListener('click', function () {
                for (var i = 0; i < transcriptSegments.length; i++) transcriptSegments[i].speaker = null;
                renderFileTranscript(); saveToHistory();
                try { aeTranscribe('roster_labels_dropped', { voices: r.voices.length }); } catch (_) {}
            });
            list.appendChild(off);
            _$('sttRosterHint') && (_$('sttRosterHint').textContent = '');
            var sg0 = _$('sttRosterSugg'); if (sg0) sg0.hidden = true;
            try { aeTranscribe('roster_shown', { voices: r.voices.length, ok: 0 }); } catch (_) {}
            return;
        }

        _$('sttRosterHint') && (_$('sttRosterHint').textContent = STR.roster_hint || '');
        r.voices.forEach(function (v) {
            var row = document.createElement('div');
            row.className = 'stt-roster-row';
            row.dataset.speaker = v.name;

            var dot = document.createElement('span');
            dot.className = 'stt-roster-dot';
            dot.dataset.spk = String(v.colour);
            row.appendChild(dot);

            var input = document.createElement('input');
            input.type = 'text'; input.className = 'stt-roster-name'; input.maxLength = 40;
            input.value = v.name;
            input.setAttribute('aria-label', STR.rename_speaker || 'Rename');
            /* Применяем по уходу с поля и по Enter — не на каждое нажатие: иначе
               «Ле» станет именем раньше, чем человек допишет «Лена», и весь текст
               перерисуется на середине слова. */
            var commit = function () {
                var was = row.dataset.speaker;
                var now = input.value.replace(/\s+/g, ' ').trim();
                if (!now || now === was) { input.value = was; return; }
                if (renameSpeaker(was, now)) {
                    row.dataset.speaker = now;
                    try { aeTranscribe('speaker_renamed', { via: 'roster' }); } catch (_) {}
                    persistSpeakerNames();
                }
            };
            input.addEventListener('blur', commit);
            input.addEventListener('keydown', function (ev) {
                if (ev.key === 'Enter') { ev.preventDefault(); input.blur(); }
                else if (ev.key === 'Escape') { ev.preventDefault(); input.value = row.dataset.speaker; input.blur(); }
                ev.stopPropagation();
            });
            row.appendChild(input);

            var share = document.createElement('span');
            share.className = 'stt-roster-share';
            share.textContent = v.share + '%';
            share.title = STR.roster_share || '';
            row.appendChild(share);

            var play = document.createElement('button');
            play.type = 'button'; play.className = 'stt-roster-play';
            play.innerHTML = '&#9654;';
            play.setAttribute('aria-label', STR.roster_listen || 'Listen');
            play.title = STR.roster_listen || 'Listen';
            play.addEventListener('click', function () { rosterPreview(play, v.first); });
            row.appendChild(play);

            list.appendChild(row);
        });

        renderRosterSuggestions(r.voices);
        try { renderCourtRoles(r.voices); } catch (_) {}
        try { aeTranscribe('roster_shown', { voices: r.voices.length, ok: 1 }); } catch (_) {}
    }

    /* ── Послушать голос ──────────────────────────────────────────────────────
       6 секунд с первой реплики — этого хватает узнать человека и не хватает,
       чтобы уехать в чужую речь. Второе нажатие останавливает: кнопка, которая
       умеет только начать, на телефоне превращается в ловушку. */
    function rosterPreview(btn, at) {
        if (!$audioPlayer || !$audioPlayer.src || playerIsOtherRecording()) {
            if (window.__toast) window.__toast(STR.roster_no_audio || '', 'info');
            return;
        }
        if (rosterPlaying === btn && !$audioPlayer.paused) { stopRosterPreview(); return; }
        stopRosterPreview();
        rosterPlaying = btn;
        btn.classList.add('is-playing');
        try { $audioPlayer.currentTime = Math.max(0, at || 0); } catch (_) {}
        var stopAt = (at || 0) + 6;
        var tick = function () {
            if (!rosterPlaying) return;
            if ($audioPlayer.currentTime >= stopAt) { stopRosterPreview(); return; }
            requestAnimationFrame(tick);
        };
        var p = $audioPlayer.play();
        if (p && p.catch) p.catch(function () { stopRosterPreview(); });
        requestAnimationFrame(tick);
        try { aeTranscribe('roster_listen', {}); } catch (_) {}
    }
    function stopRosterPreview() {
        if (rosterPlaying) { rosterPlaying.classList.remove('is-playing'); rosterPlaying = null; }
        try { if ($audioPlayer && !$audioPlayer.paused) $audioPlayer.pause(); } catch (_) {}
    }

    /* ── Имена, названные до расшифровки ──────────────────────────────────────
       Показываем как подсказки, а НЕ раскладываем по голосам сами: система не
       знает, чей это голос, и при троих участниках угадала бы один раз из шести.
       Уверенно подписанная чужим именем запись консультации хуже нейтрального
       «Говорящий 2» — она выглядит достоверной. */
    function renderRosterSuggestions(voices) {
        var wrap = _$('sttRosterSugg'), chips = _$('sttRosterSuggChips');
        if (!wrap || !chips) return;
        var names = peopleNames();
        var taken = {};
        voices.forEach(function (v) { taken[v.name.toLowerCase()] = 1; });
        var left = names.filter(function (n) { return !taken[n.toLowerCase()]; });
        if (!names.length) { wrap.hidden = true; return; }
        wrap.hidden = false;
        chips.innerHTML = '';
        names.forEach(function (n) {
            var c = document.createElement('button');
            c.type = 'button';
            c.className = 'stt-roster-chip' + (taken[n.toLowerCase()] ? ' is-used' : '');
            c.textContent = n;
            c.addEventListener('click', function () {
                /* В поле, которое сейчас в фокусе; если фокуса нет — в первое
                   ещё не переименованное. Так один тап всегда что-то делает. */
                var target = document.activeElement;
                if (!target || !target.classList || !target.classList.contains('stt-roster-name')) {
                    var all = Array.prototype.slice.call(document.querySelectorAll('.stt-roster-name'));
                    target = all.filter(function (i) { return /^\D+\s*\d+$/.test(i.value); })[0] || all[0];
                }
                if (!target) return;
                var row = target.closest('.stt-roster-row');
                var was = row && row.dataset.speaker;
                if (was && renameSpeaker(was, n)) {
                    row.dataset.speaker = n;
                    try { aeTranscribe('speaker_renamed', { via: 'suggestion' }); } catch (_) {}
                    persistSpeakerNames();
                    renderRoster();
                }
            });
            chips.appendChild(c);
        });
    }

    /* ── Имена обязаны пережить возвращение ───────────────────────────────────
       Переименование живёт в сегментах на экране и в локальной истории, а
       библиотечная копия остаётся с «Говорящий 1»: открыв запись завтра через
       «Мои генерации», человек получал безымянных обратно. Пишем имена в
       библиотеку — тихо, по одному на изменение, и молча при отказе: это
       удобство, а не результат работы, и ронять из-за него ничего нельзя. */
    var _persistTimer = null;
    function persistSpeakerNames() {
        if (!libraryTranscriptId) return;
        clearTimeout(_persistTimer);
        _persistTimer = setTimeout(function () {
            var names = {};
            for (var i = 0; i < transcriptSegments.length; i++) {
                var sp = transcriptSegments[i].speaker;
                if (sp) names[sp] = 1;
            }
            var map = [];
            for (var i2 = 0; i2 < transcriptSegments.length; i2++) {
                var sg = transcriptSegments[i2];
                if (sg && sg.speaker) map.push({ at: sg.timestamp || 0, name: sg.speaker });
            }
            fetch(CFG.urls.speakers + '/' + libraryTranscriptId, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': (document.querySelector('meta[name=csrf-token]') || {}).content || '',
                    'X-Requested-With': 'XMLHttpRequest',
                },
                credentials: 'same-origin',
                body: JSON.stringify({ names: map }),
            }).then(function (r) {
                try { aeTranscribe('speaker_names_saved', { ok: r.ok ? 1 : 0 }); } catch (_) {}
            }).catch(function () {});
        }, 800);
    }
    function showResultNote(html) {
        var el = _$('sttResultNote');
        if (!el) return;
        el.innerHTML = html;
        el.hidden = false;
    }
    function hideResultNote() {
        var el = _$('sttResultNote');
        if (el) { el.hidden = true; el.innerHTML = ''; }
    }

    /* After a manual edit of the contenteditable transcript, rebuild
       transcriptSegments FROM the DOM so timestamps, SRT/VTT, playback-highlight
       and find-by-segment stay in sync with the edited text (previously a single
       edit silently desynced the segment array → stale exports). Reads each
       .stt-segment's data-start/end + text (minus the timestamp chip) and the
       preceding .stt-speaker chip; if the span structure was destroyed (e.g.
       select-all + retype) it falls back to one text cue. Does NOT re-render
       (that would move the caret) — only the underlying array is refreshed. */
    function syncSegmentsFromDom() {
        /* Document order, at any depth: the file mode wraps segments in
           paragraph blocks with a head (timestamp + speaker chip), the mic mode
           keeps them flat — one walk serves both. */
        var nodes = $transcript.querySelectorAll('.stt-speaker, .stt-segment'), segs = [], curSpeaker = null;
        for (var i = 0; i < nodes.length; i++) {
            var n = nodes[i];
            if (!n || n.nodeType !== 1) continue;
            if (n.classList && n.classList.contains('stt-speaker')) { curSpeaker = (n.dataset.speaker || n.textContent || '').trim() || curSpeaker; continue; }
            if (n.classList && n.classList.contains('stt-segment')) {
                var clone = n.cloneNode(true);
                var ts = clone.querySelector('.stt-timestamp'); if (ts) ts.remove();
                var text = (clone.textContent || '').replace(/\s+/g, ' ').trim();
                if (!text) continue;
                var seg = { text: text, timestamp: parseFloat(n.dataset.start || 0) || 0, isFinal: true };
                var de = parseFloat(n.dataset.end); if (isFinite(de)) seg.end = de;
                if (curSpeaker) seg.speaker = curSpeaker;
                segs.push(seg);
            }
        }
        if (segs.length) {
            transcriptSegments = segs;
            userHasEdited = false;   /* array now matches the DOM → timestamped exports valid again */
        } else {
            var txt = ($transcript.textContent || '').replace(/\s+/g, ' ').trim();
            transcriptSegments = txt ? [{ text: txt, timestamp: 0, isFinal: true }] : [];
            userHasEdited = true;    /* structure gone — plain-text only */
        }
    }

    /* Часы появляются, когда запись дошла до часа. До 07.10.2026 минута 75
       писалась «75:03» — на экране, в копии, в TXT и в PDF, — а тот же момент в
       файле Word и в плеере звался «1:15:03»: цитату «на 75:03» было не найти
       ни там, ни там. Форма одна с __transcriptFile.clock, так что экран, копия
       и каждый файл называют момент одинаково. */
    function formatTime(seconds) {
        var sec = Math.max(0, Math.round(seconds || 0));
        var h = Math.floor(sec / 3600), m = Math.floor((sec % 3600) / 60), s = sec % 60;
        return (h > 0 ? h + ':' : '') + pad2(m) + ':' + pad2(s);
    }

    /* Take the transcript surface. Returns the token the new owner must carry
       and check before every write it makes after an `await`. */
    function claimTranscript() { return ++transcriptRun; }
    /* Does the running transcribe job still own the surface? Every write the
       job performs — progress bar, streaming paint, final result — asks this
       first. `jobRun` starts at -1 so a page with no job never claims to own
       anything. */
    function jobOwnsSurface() { return jobRun === transcriptRun; }

    /* The user took the surface back while a transcribe job was running. Give
       the job's chrome back too — its progress bar and ETA belong to work the
       user has visibly moved on from, and leaving them up made the new
       recording look like it was the thing being processed. The job itself
       keeps running; only its claim on the screen is gone.
       Until today this event had NO instrument at all: the collision was
       reconstructible only by reading one session's raw event stream. */
    function detachRunningJob() {
        try { stopProgressTimer(); } catch (_) {}
        try { clearETAHint(); } catch (_) {}
        try { $progress.classList.add('hidden'); } catch (_) {}
        try {
            window.__ae && window.__ae('feature_use', {
                slug: TOOL_SLUG, f: 'transcribe_job_detached',
                /* `selectedModel` is function-local to transcribeFile — reading
                   it here throws a ReferenceError that this try/catch would
                   swallow, leaving the class mute all over again. */
                chunks: ckptStreamSegs.length, model: ($model && $model.value) || '',
            });
        } catch (_) {}
    }

    function clearTranscript() {
        transcriptSegments = [];
        finalTranscript = '';
        userHasEdited = false;
        /* Чистый лист — новый документ: следующее сохранение не перепишет запись
           истории, которая была на экране. */
        adoptDocument({});
        bookmarks = [];
        hideResultNote();
        renderTranscript();
        renderBookmarks();
        updateStats();
        clearWordCloud();
        try { localStorage.removeItem('stt_autosave'); } catch(e) {}
    }

    function autoSave() {
        try {
            localStorage.setItem('stt_autosave', JSON.stringify(transcriptSegments));
        } catch(e) {}
    }

    function loadAutoSave() {
        try {
            var data = localStorage.getItem('stt_autosave');
            if (data) {
                var segs = JSON.parse(data);
                if (segs && segs.length) {
                    transcriptSegments = segs;
                    finalTranscript = segs.map(function(s) { return s.text; }).join(' ') + ' ';
                    renderTranscript();
                    updateStats();
                }
            }
        } catch(e) {}
    }

    /* =====================================================
       Section 9b: Device-capability detection, preflight, ETA helpers
       ===================================================== */

    /* Async-detect WebGPU adapter. Adapter presence (not just navigator.gpu)
       is the real signal — older drivers expose the API without usable GPU. */
    async function detectCaps() {
        if (navigator.gpu) {
            try {
                var adapter = await navigator.gpu.requestAdapter();
                if (adapter) caps.webgpu = true;
            } catch(_) {}
        }
        caps.ready = true;
        /* Low-memory turbo guard now lives in the shared whisper-model-
           picker component (runs on DOMContentLoaded before this detectCaps
           fires). Don't duplicate it here. (Literal x-tag avoided in this
           comment — Blade compiles x-tags inside JS comments too.) */
        /* If user hasn't explicitly picked a model, tailor the default to the
           device AND the language (see smartDefaultModel). */
        if (!userChangedModel) {
            $model.value = smartDefaultModel();
            updateLangQualityHint();
        }
        /* Проба кэша асинхронна: первый вердикт считает модель нескачанной, и
           на медленном канале умолчание съезжает на `base`. Когда проба
           ответит «файлы уже здесь» — пересматриваем, пока человек не выбрал
           сам. Без этого владелец знал бы про кэш, а дверь — нет. */
        try {
            if (window.__deviceCap && window.__deviceCap.onModelCacheKnown) {
                window.__deviceCap.onModelCacheKnown(function () {
                    if (userChangedModel) return;
                    var next = smartDefaultModel();
                    if (next !== $model.value) { $model.value = next; updateLangQualityHint(); }
                });
            }
        } catch (_) {}
        renderBackendBadge();
    }

    /* Language-aware, device-tailored default (Farid 2026-07-22, after #865):
       non-English speech deserves the accurate model — base garbles
       non-English words (measured RU: base 9.0% WER vs small 2.8%) — but
       NEVER at the price of an unusable wait. `small` becomes the default
       only when THIS device can afford it: the estimate must be ≤1.2x
       realtime AND the device must have proven itself (a measured run on
       record, or ≥6 cores — a 2-core laptop advertising "WebGPU" is an iGPU
       that runs 8x slower than the bench constants, the Zorra case).
       English keeps base (accuracy tie with small); weak devices keep tiny —
       the quality hint still steers those users consciously. */
    /* ── Сколько ждать не просят, а терпят ─────────────────────────────────
       Потолок АВТОМАТИЧЕСКОГО выбора: сколько ждать мы готовы навязать тому,
       кто про модель не спрашивал. Два числа, потому что у нас две статистики
       одной выборки (см. estimateRealtimeFactor / gateRealtimeFactor):
         оценка (p50) ≤ 5 мин — обещание типичному случаю;
         ворота (p90) ≤ 10 мин — страховка от хвоста; заодно автоматический
           выбор никогда не приводит человека прямо в модалку преflight'а,
           которая срабатывает на 15 воротных минутах.
       Ручной выбор этим не ограничен — человек вправе ждать сколько угодно. */
    var AUTO_EST_BUDGET_MIN  = 5;
    var AUTO_GATE_BUDGET_MIN = 10;
    /* Длительность, которой мы отвечаем, ПОКА материала нет (страница только
       открыта). Медианы за 60 дней по обоим шардам: диктовка 50 с (RU) и 30 с
       (intl), файл 196 с и 178 с. Догадка здесь неизбежна, но честная догадка
       лучше молчаливого нуля. */
    var ASSUMED_MIC_SEC  = 45;
    var ASSUMED_FILE_SEC = 190;

    /* Можно ли отдать этому устройству вес модели, НЕ спросив. Загрузка —
       отдельная от времени ось: быстрый процессор на мобильном тарифе всё
       равно не должен молча качать четверть гигабайта. Сигналы те же, что у
       двери GigaAM в пикере. */
    /* Адрес весов — чтобы вопрос «потянем ли» считал БАЙТЫ К СКАЧИВАНИЮ, а не
       скорость канала. Зеркало своё (`/vendor/whisper-hf/`, оба шарда), путь
       строит сам transformers.js: remoteHost + '{model}/resolve/{revision}/'.
       `large-v3-turbo` у нас не зеркалится — адрес зависит от того, какой хост
       HF окажется живым, поэтому его байты неизвестны и канал решает как
       раньше (600 МБ с чужого CDN — как раз тот случай, где осторожность
       уместна). */
    function weightUrls(model) {
        if (!MIRRORED_WHISPER[model]) return '';
        var dir = '/vendor/whisper-hf/onnx-community/whisper-' + model + '/resolve/main/onnx/';
        return [dir + 'encoder_model_quantized.onnx', dir + 'decoder_model_merged_quantized.onnx'];
    }

    /* Владелец вопроса «можно ли себе позволить эту модель прямо сейчас» — один
       на весь сайт (`__deviceCap.modelAffordable`, 23.09.2026). Здесь до этого
       дня лежала четвёртая копия правил, и она, как и три остальные, отказывала
       по каналу даже тогда, когда модель уже лежала на диске. Разбор —
       обращение #6850 и шапка примитива. */
    function weightAffordable(model) {
        var mb = (model === 'large-v3-turbo') ? 600 : (model === 'small' ? 240 : 75);
        if (mb <= 100) return true;                    /* tiny/base — не разговор */
        var dc = window.__deviceCap;
        if (!dc || !dc.modelAffordable) return true;
        return dc.modelAffordable({ url: weightUrls(model), mb: mb, minMemoryGB: 6 }).ok;
    }

    /* ── Окупается ли `small` НА ЭТОМ ЯЗЫКЕ ────────────────────────────────
       До 19.09 ответ был «на любом, кроме английского». Это обобщение одного
       замера на русском (base 9.0% против small 2.8%), и прогон тем же
       прибором по FLEURS через настоящую страницу показал, что обобщать было
       нельзя (BENCHMARK-de-2026-09-19.md, таблица по языкам):

         испанский     base 40.4% → small 11.5%   окупается с запасом
         португальский      22.2% →       11.9%   окупается
         русский            51.4% →       28.6%   окупается (GigaAM лучше обоих)
         немецкий           20.1% →       20.6%   НИЧЬЯ      (замерено дважды)
         французский        30.3% →       37.3%   ХУЖЕ       (замерено дважды)

       Поэтому здесь СПИСОК ОТКАЗОВ, а не список разрешений: прежнее намерение
       отменяется только там, где есть замер против него, а незамеренный язык
       ведёт себя как вчера. Ничья тоже попадает сюда: 240 МБ и вдвое большее
       ожидание за ноль пользы — это цена без покупки.
       ⚠️ Корпус — читаная речь FLEURS, а люди приносят шумную и спонтанную.
       У французского в выдаче 277 слов на 241 эталонных — подпись зацикливания
       Whisper, а не «модель хуже слышит». Прежде чем расширять этот список,
       нужен корпус, похожий на то, что приносят; пополнять его по одному
       чистому прогону нельзя. */
    var SMALL_NOT_WORTH_IT = { de: 1, fr: 1 };

    /* Влезает ли ЭТА модель в бюджет ожидания на ЭТОМ материале. */
    function modelFitsBudget(model, durSec) {
        if (!weightAffordable(model)) return false;
        return estimateWaitMinutes(durSec, model, caps) <= AUTO_EST_BUDGET_MIN
            && gateWaitMinutes(durSec, model, caps) <= AUTO_GATE_BUDGET_MIN;
    }

    function smartDefaultModel(durSecArg) {
        var langSel = ($lang && $lang.value || 'auto');
        var base2 = (langSel === 'auto' ? (window.__LOCALE || 'en') : langSel).split('-')[0].toLowerCase();
        /* Русский ведёт GigaAM, и это замер, а не предпочтение. Три независимых
           корпуса дают одно и то же: 4.0% WER против 34.7% у whisper-base на
           микрофонной речи (bench voice-translator), 7.9% против 29.2% на
           серверном корпусе (09.08), 5.3% против 38.1% на 3.5-минутном диалоге
           (/redub, 03.09). Серверный лейн ведёт им с 09.08 (`smartServerModel`),
           а браузерный не вёл никогда — и человек получал в спасателе ту самую
           модель, которую наши же замеры зовут негодной для русского.
           Жалоба #3061: Премиум, русская диктовка, спасатель на whisper-base.
           Решение о ПРЕДЛОЖЕНИИ (хватит ли памяти, не просил ли экономить
           трафик) принадлежит пикеру — он же владеет согласием на 215 МБ и
           откатом на `base`, если человек откажется. Здесь мы только
           спрашиваем; ручной выбор сильнее (`userChangedModel`). */
        if (base2 === 'ru') {
            var giga = false;
            try {
                giga = !!(window.WhisperModelPicker
                    && window.WhisperModelPicker.syncLang('stt', base2));
            } catch (_) {}
            if (giga) return 'gigaam-ru';
        }
        /* Слабое устройство (ни WebGPU, ни SAB): tiny — ТОЛЬКО для английского.
           Замер 2026-08-05 (FLEURS, 12 реальных клипов на язык, те же q8-байты,
           что грузит браузер): tiny на неанглийском — не «хуже», а МУСОР с
           галлюцинационными петлями: es 128% WER, id 172% (потеряно 4 клипа из
           12), ar 77% (потеряно 6/12), ru 59%, fr 64%. base на тех же языках —
           рабочие 12–27% (кроме ar 58% и id 48% — их подсказка ведёт на сервер,
           там turbo даёт 9% и 5%). Медленный честный результат лучше быстрого
           мусора: пять минут ожидания против пяти минут, выброшенных на
           перепечатку бессмыслицы. en на tiny — приемлемые 29%, ему скорость. */
        if (!caps.webgpu && !caps.sab) return base2 === 'en' ? 'tiny' : 'base';
        if (base2 === 'en') return 'base';

        /* ⚠️⚠️ Здесь до 2026-09-19 стояло: «`small` становится умолчанием,
           только если оценка ≤1.2× реального времени И устройство себя
           проявило — замеренный прогон в истории ИЛИ ≥6 ядер». Вторая
           половина была ПОДМЕНОЙ: число ядер — не скорость, а в этом же файле
           двумя экранами выше лежит настоящая модель скорости (RT_SEED по
           бакету «устройство × бэкенд», EWMA замеренных прогонов, воротной
           разброс). Замер 19.09 по обоим шардам: из 23 347 сессий этих двух
           тулов у 6371 (27%) меньше шести ядер — и у 5675 из них (89%) ЕСТЬ
           WebGPU. То есть каждой четвёртой сессии модель получше отказывали по
           счётчику ядер при живом графическом ускорителе. Цена отказа
           измерена на FLEURS через настоящую страницу: испанский `base` 40.4%
           против `small` 11.5% — в 3.5 раза больше ошибок в словах.

           Вторая подмена — время считалось В РАЗАХ (≤1.2× реального времени),
           а человек ждёт МИНУТЫ. 1.2× — это полторы минуты на заметку и два
           часа на лекцию; одно число не может отвечать за оба случая. Теперь
           решение принимается по ожиданию на КОНКРЕТНОМ материале, а раз
           длительность известна только после выбора файла (или остановки
           записи) — выбор там и пересматривается (см. transcribeFile).

           ⛔ `large-v3-turbo` в АВТОМАТИЧЕСКУЮ лестницу не входит, хотя на
           немецком он втрое точнее `base` (6.2% против 20.1%, замер 19.09).
           Причина не в скорости, а в последовательности: 215-мегабайтный
           GigaAM у нас спрашивает разрешения отдельной дверью — значит
           600 МБ молча качать нельзя тем более. Его место — осознанное
           предложение, а не тихая загрузка. */
        var durSec = (typeof durSecArg === 'number' && durSecArg > 0)
            ? durSecArg
            : (mode === 'file' ? ASSUMED_FILE_SEC : ASSUMED_MIC_SEC);
        if (!SMALL_NOT_WORTH_IT[base2] && modelFitsBudget('small', durSec)) return 'small';
        return 'base';
    }

    /* Realtime factor = (processing_seconds / audio_seconds). Lower = faster. */
    /* THIS device's measured speed for backend+model — written after every
       completed run (EWMA). The static table below is only the first-run
       fallback: a 2-core laptop's "WebGPU" is nothing like the mid-range
       bench constant (Zorra, #865: est said ~0 min, reality was 3.7 min on a
       127-second file). Measure, don't guess. */
    function measuredRt(model, capsNow) {
        var backend = capsNow.webgpu ? 'webgpu' : 'wasm';
        var v = window.__toolSettings
            ? parseFloat(window.__toolSettings.load(PERF_NS, 'rt_' + backend + '_' + model, 0)) : 0;
        return (isFinite(v) && v > 0.01) ? v : null;
    }
    function recordMeasuredRt(model, backend, rtFactor) {
        if (!window.__toolSettings || !isFinite(rtFactor) || rtFactor <= 0.01 || rtFactor > 60) return;
        var key = 'rt_' + (backend || 'wasm') + '_' + model;
        var prev = parseFloat(window.__toolSettings.load(PERF_NS, key, 0));
        var next = (isFinite(prev) && prev > 0.01) ? (prev * 0.5 + rtFactor * 0.5) : rtFactor;
        window.__toolSettings.save(PERF_NS, key, next);
    }

    /* ⚠️⚠️⚠️ ВЫЖИВАТЕЛЬНОЕ СМЕЩЕНИЕ: EWMA выше пишется ТОЛЬКО на доведённом
       прогоне. Значит устройство, которое ни разу не доходит до конца, ничему
       нас не учит — и оценка остаётся оптимистичной ровно там, где она вреднее
       всего. Именно этот случай и произошёл 28.08: два прогона, оба брошены,
       ноль записанных замеров, оценка на второй раз та же самая «18 минут».

       Брошенный прогон — это не «нет данных». Это ДОКАЗАННАЯ НИЖНЯЯ ГРАНИЦА:
       за W секунд работы обработано не больше A секунд аудио, значит rt ≥ W/A.
       Записываем её отдельным ключом и берём в воротах максимумом. Зеркало
       серверного `AsrRateModel::observeTimeout()` (28.08) — там таймаут тоже
       записывается как доказанная граница, а не выбрасывается. */
    function measuredRtFloor(model, capsNow) {
        var backend = capsNow.webgpu ? 'webgpu' : 'wasm';
        var v = window.__toolSettings
            ? parseFloat(window.__toolSettings.load(PERF_NS, 'rtfloor_' + backend + '_' + model, 0)) : 0;
        return (isFinite(v) && v > 0.01) ? v : null;
    }
    function recordRtFloor(model, backend, rtLowerBound) {
        if (!window.__toolSettings || !isFinite(rtLowerBound) || rtLowerBound <= 0.01 || rtLowerBound > 60) return;
        var key = 'rtfloor_' + (backend || 'wasm') + '_' + model;
        var prev = parseFloat(window.__toolSettings.load(PERF_NS, key, 0));
        /* Граница только РАСТЁТ: более длинное ожидание доказывает больше, а
           короткое ничего не опровергает (могли отменить через минуту). */
        if (isFinite(prev) && prev >= rtLowerBound) return;
        window.__toolSettings.save(PERF_NS, key, rtLowerBound);
    }
    /* ── Затравка скорости браузерного лейна: ИЗМЕРЕНО, а не выведено ────────
       Прежняя таблица (webgpu 0.10 / sab 0.40 / ничего 1.00 × множитель модели)
       была стендовым бенчем настольной видеокарты. Сверка с 1029 РЕАЛЬНЫМИ
       доведёнными прогонами (прод-телеметрия 01.07–28.08, стык
       `transcription_started.durSec` ↔ `transcription_done.ms`) показала, что
       она врёт в ОБЕ стороны, и сильнее всего там, где цена ошибки выше всего:

         бакет               было    p50 (замер)   n
         desk/gpu/small      0.50      1.155      432   оптимизм 2.3×
         desk/wasm/small     5.00      1.426       31   пессимизм 3.5×
         desk/gpu/base       0.20      0.548      218   оптимизм 2.7×
         desk/wasm/base      2.00      0.619       98   пессимизм 3.2×
         mob/gpu/small       0.50      2.394       49   ОПТИМИЗМ 4.8×
         mob/wasm/base       2.00      0.858       37   пессимизм 2.3×

       Два вывода, которых в прежней модели не было вообще:

       1. **На десктопе WebGPU и голый WASM идут одинаково** (0.55 против 0.62
          на `base`, 1.16 против 1.43 на `small`). Десятикратный разрыв, который
          утверждала таблица, в данных ОТСУТСТВУЕТ. Наличие `navigator.gpu` —
          это не скорость, это только наличие адаптера.
       2. **Штраф телефона растёт с размером модели.** `small` на мобильном —
          2.39 против 0.32 у `base` на тех же телефонах, то есть в 7.5 раза, при
          настольном отношении 2.1. Воспроизвелось в ОБОИХ мобильных бакетах
          (7.46 на gpu, 8.75 на wasm) — это не шум, это память.

       Инцидент, которым это оплачено (RU-прод, 28.08, Премиум-аккаунт): файл
       2120 с, iPhone, `webgpu:1 sab:0`, модель `small`. Формула сказала
       **18 минут**, замеренная медиана этого бакета даёт **85**, p90 — **173**.
       Человек дважды запустил, дважды ушёл, четыре раза перезагрузил страницу
       и пошёл проверять, прошла ли оплата. Подробности — заголовок
       chooseFasterLane ниже. */
    /* 15.10.2026: таблица переехала в config/whisper-models.php (`rt_seed`) — те же
       числа печатает справочник под тулом, а третья копия (строки списка моделей)
       успела разойтись с этой впятеро. Сюда она приходит через __sttCfg.rtSeed
       (partials.speech-workspace-boot); второго литерала здесь нет намеренно. */
    var RT_SEED = CFG.rtSeed || {};
    /* Разброс ВНУТРИ бакета, тоже замеренный: p90/p50 по десяти бакетам с n≥5 —
       1.32 1.97 2.04 2.23 2.51 2.94 3.29 3.46 3.77 5.21, медиана ≈ 2.4. Одно
       измеренное число вместо второй таблицы. */
    var RT_GATE_SPREAD = 2.4;

    function rtBucket(capsNow) {
        return (isMobileDevice() ? 'mob' : 'desk') + '/' + (capsNow.webgpu ? 'gpu' : 'wasm');
    }
    /* Затравка для (устройство, модель). `large-v3-turbo` на десктопе замерен на
       n=13 с разбросом p90/p50 = 22× — выборка непригодна, поэтому во всех
       бакетах он выводится как small × 2.2 (единственный честный замер вне gpu:
       3.08 при small 1.43 = ×2.16). Незнакомая модель — самая медленная в
       бакете, а не самая быстрая. */
    function rtSeed(model, capsNow) {
        var row = RT_SEED[rtBucket(capsNow)] || RT_SEED['desk/wasm'] || {};
        if (row[model] != null) return row[model];
        var worst = 0;
        for (var k in row) if (row[k] > worst) worst = row[k];
        return worst;
    }

    /* ⚠️⚠️ ДВА потребителя скорости, и им нужны РАЗНЫЕ статистики одной
       выборки — ровно та развилка, из-за которой серверный лейн убивал
       оплаченную работу своим же таймаутом (см. шапку App\Services\Voice\
       AsrRateModel, 28.08). Здесь она повторена зеркально:

         оценка  → ТИПИЧНЫЙ случай (p50): на вопрос «сколько ждать» отвечают
                   медианой, иначе каждая оценка звучит как угроза;
         ворота  → МЕДЛЕННЫЙ хвост (p50 × замеренный разброс): решение «пустить
                   ли это в браузер» обязано ошибаться в сторону отказа.

       Пока число одно, любая правка в пользу красивой оценки МОЛЧА ослабляет
       ворота. Поэтому это два разных вызова, а не один с флагом. */
    function estimateRealtimeFactor(model, capsNow) {
        /* Правда этого устройства — сильнее любой затравки (см. measuredRt). */
        var measured = measuredRt(model, capsNow);
        if (measured !== null) return measured;
        return rtSeed(model, capsNow);
    }
    /* Скорость для РЕШЕНИЯ. Берёт самое медленное из всего, что мы знаем: не
       быстрее затравки бакета и не быстрее того, что это устройство уже
       показало (включая нижнюю границу, оставленную брошенным прогоном —
       см. recordRtFloor). */
    function gateRealtimeFactor(model, capsNow) {
        var seed = rtSeed(model, capsNow);
        var meas = measuredRt(model, capsNow);
        var floor = measuredRtFloor(model, capsNow);
        var worst = Math.max(seed, meas || 0, floor || 0);
        return worst * RT_GATE_SPREAD;
    }

    /* Returns estimated wait in minutes (rounded). */
    function estimateWaitMinutes(audioDurationSec, model, capsNow) {
        var factor = estimateRealtimeFactor(model, capsNow);
        return Math.round((audioDurationSec * factor) / 60);
    }
    /* То же в минутах, но по воротной (медленной) скорости. */
    function gateWaitMinutes(audioDurationSec, model, capsNow) {
        return Math.round((audioDurationSec * gateRealtimeFactor(model, capsNow)) / 60);
    }

    /* Names and terms reach the engine as a hint on every lane but ONE: the
       in-browser Russian model (GigaAM CTC) has no beam search to put a hint
       into. The page promises «так ИИ напишет их правильно»; on that lane the
       promise is false, so the note says so instead of letting a person find
       out from the transcript (#1737, 24.09.2026). Measured before choosing
       this over a browser-side hint search: 30 days, 343 sessions on this
       lane, 12 filled the glossary, none of them on this lane. */
    var _namesNoteShown = false;
    function updateNamesNote() {
        var el = _$('sttNamesNote');
        if (!el) return;
        var browserPath = !(procMode === 'server' && asrServerAllowed());
        var show = mode === 'file' && browserPath && !!$model && $model.value === 'gigaam-ru'
            && promptWithPeople() !== '';
        el.hidden = !show;
        if (show && !_namesNoteShown) {
            _namesNoteShown = true;
            aeTranscribe('names_note_shown', {});
        }
    }

    /* Non-English quality steering (see the sttLangHint markup comment). */
    var _langHintShownFor = '';
    function updateLangQualityHint() {
        updateNamesNote();
        /* The Russian on-device option is language-bound, so it follows the
           language picker rather than sitting in the list for everyone. The
           picker owns the reveal (and the save-data / low-memory guards);
           the tool only tells it which language was chosen. */
        try {
            if (window.WhisperModelPicker) {
                var lsel = ($lang && $lang.value) || 'auto';
                WhisperModelPicker.syncLang('stt',
                    lsel === 'auto' ? (window.__LOCALE || 'en') : lsel);
            }
        } catch (_) {}
        var el = document.getElementById('sttLangHint');
        if (!el || mode !== 'file') return;
        var langSel = ($lang && $lang.value || 'auto');
        var base2 = langSel === 'auto' ? (window.__LOCALE || 'en') : langSel;
        base2 = String(base2).split('-')[0].toLowerCase();
        var m = ($model && $model.value) || 'base';
        var show = base2 !== 'en' && (m === 'tiny' || m === 'base');
        if (!show) { el.hidden = true; return; }
        var langName = base2;
        if ($lang) {
            /* auto → look up the option matching the inferred base code, so the
               hint says "Español", not "es" */
            for (var oi = 0; oi < $lang.options.length; oi++) {
                var ov = ($lang.options[oi].value || '').toLowerCase();
                if (ov !== 'auto' && ov.indexOf(base2) === 0) {
                    langName = ($lang.options[oi].text || base2).replace(/\s*\(.*\)$/, '');
                    break;
                }
            }
        }
        el.textContent = (STR.lang_quality_hint || '{lang}: the fast model often garbles words — pick a more accurate model, or use server processing.')
            .replace('{lang}', langName);
        el.hidden = false;
        if (_langHintShownFor !== base2 + ':' + m) {
            _langHintShownFor = base2 + ':' + m;
            aeTranscribe('lang_quality_hint_shown', { lang: base2, model: m });
        }
    }

    /* Backend badge — shows under model select once capabilities resolve. */
    function renderBackendBadge() {
        if (!$backendBadge) return;
        var label, cls;
        /* Prefer live activeBackend (reported by worker after real load) over
           pre-flight detection — the worker is authoritative. */
        var effectiveWebGPU = activeBackend === 'webgpu' || (activeBackend == null && caps.webgpu);
        if (effectiveWebGPU) {
            label = '\u26A1 ' + (STR.backend_webgpu || 'GPU acceleration');
            cls = '';
        } else if (caps.sab) {
            label = (STR.backend_wasm_mt || 'Multi-thread CPU');
            cls = '';
        } else if (caps.ready) {
            label = (STR.backend_wasm_st || 'Single-thread CPU');
            cls = 'wasm-st';
        } else {
            $backendBadge.hidden = true;
            return;
        }
        $backendBadge.textContent = label;
        $backendBadge.className = 'stt-backend-badge ' + cls;
        $backendBadge.hidden = false;
    }

    /* ── Preflight / mid-process modal ─────────────────────────────────────
       Returns Promise<boolean>: resolves true if user confirmed, false if
       canceled. Shared for both pre-start and mid-process confirmations. */
    function showConfirmModal(opts) {
        return new Promise(function(resolve) {
            var overlay = document.createElement('div');
            overlay.className = 'stt-modal-overlay';
            overlay.setAttribute('role', 'dialog');
            overlay.setAttribute('aria-modal', 'true');

            var modal = document.createElement('div');
            modal.className = 'stt-modal';

            var h = document.createElement('h3');
            h.textContent = opts.title || '';

            var p = document.createElement('p');
            p.innerHTML = opts.html || '';   /* trusted: built from our own STR table */

            var actions = document.createElement('div');
            actions.className = 'stt-modal-actions';

            var btnCancel = document.createElement('button');
            btnCancel.type = 'button';
            btnCancel.className = 'stt-modal-btn';
            btnCancel.textContent = opts.cancelLabel || STR.cancel;

            var btnOk = document.createElement('button');
            btnOk.type = 'button';
            btnOk.className = 'stt-modal-btn primary';
            btnOk.textContent = opts.confirmLabel || (STR.modal_continue || 'Continue');

            /* Optional third action (e.g. "Switch to a faster model") — resolves
               the promise with the string 'alt' so the caller can branch. */
            var btnAlt = null;
            if (opts.altLabel) {
                btnAlt = document.createElement('button');
                btnAlt.type = 'button';
                btnAlt.className = 'stt-modal-btn';
                btnAlt.textContent = opts.altLabel;
            }

            function close(result) {
                document.removeEventListener('keydown', onKey);
                overlay.remove();
                resolve(result);
            }
            function onKey(e) { if (e.key === 'Escape') close(false); }

            btnCancel.addEventListener('click', function() { close(false); });
            btnOk.addEventListener('click', function() { close(true); });
            if (btnAlt) btnAlt.addEventListener('click', function() { close('alt'); });
            overlay.addEventListener('click', function(e) { if (e.target === overlay) close(false); });
            document.addEventListener('keydown', onKey);

            actions.appendChild(btnCancel);
            if (btnAlt) actions.appendChild(btnAlt);
            actions.appendChild(btnOk);
            modal.appendChild(h);
            modal.appendChild(p);
            modal.appendChild(actions);
            overlay.appendChild(modal);
            document.body.appendChild(overlay);
            setTimeout(function(){ btnOk.focus(); }, 50);
        });
    }

    /* Passive ETA hint inserted under the progress bar (5-15 min range) */
    function showETAHint(text) {
        var existing = document.getElementById('sttEtaHint');
        if (existing) existing.remove();
        if (!text) return;
        var hint = document.createElement('div');
        hint.id = 'sttEtaHint';
        hint.className = 'stt-eta-hint';
        hint.textContent = text;
        $progress.appendChild(hint);
    }
    function clearETAHint() {
        var existing = document.getElementById('sttEtaHint');
        if (existing) existing.remove();
    }

    /* =====================================================
       Section 10: File mode — Whisper via Web Worker
       (runs inference off main thread so UI stays responsive)
       ===================================================== */
    /* Served via /workers/whisper-worker (Laravel route) so the response
       carries Cross-Origin-Embedder-Policy: credentialless. Static /js/
       files bypass middleware and Chrome blocks a worker load inside a
       COEP-isolated page without that header. Cached 1h by nginx. */
    /* Models we host ON OUR OWN ORIGIN (public/vendor/whisper-hf/, both shards).
       The worker probes the mirror via whisper-tiny/config.json and would 404 on
       an un-mirrored model, so this map must list only what is actually there.

       ⚠️ Why this matters more here than anywhere else (MEASURED 2026-08-05):
       with huggingface.co blackholed at the resolver — the RU reality when RKN
       blocks it — transcription on this page FAILED outright: 6 minutes of
       waiting, then «Не удалось загрузить ИИ-модель». The console showed BOTH
       fallbacks dying: `host https://huggingface.co/ failed` (expected) and
       `host https://timbrica.com/cdn/hf/ failed` — our RU proxy cannot serve the
       weights at all (302 → xet-bridge → 404; the Xet-signed CloudFront URL is
       not proxyable). So the proxy is not a fallback, it only looked like one.
       Six other tools (auto-captions, redub, reels-maker, video-audio,
       lyrics-ai-timing, dub-orchestrator) already pass hfmirror; the biggest
       transcription tool on the site — and the entry point to the paid dialogue
       module — was the one that did not. */
    /* Имена, которые понимает воркер Whisper. Всё остальное (GigaAM) в него не
       уходит: whisperModelOf отдаёт base — см. settleRunModel. */
    var WHISPER_SIZES = { tiny: 1, base: 1, small: 1, 'large-v3-turbo': 1 };
    function whisperModelOf(model) {
        return WHISPER_SIZES[model] ? model : 'base';
    }
    var MIRRORED_WHISPER = { tiny: 1, base: 1, small: 1 };
    var whisperWorkerKey = '';
    function getWhisperWorker() {
        /* «gigaam-ru» — не Whisper: прогон, ушедший в Whisper, идёт на base,
           и воркер должен брать его с зеркала, как base. */
        var selModel = whisperModelOf(($model && $model.value) || 'tiny');
        var loc = (window.__LOCALE || 'en').toString().toLowerCase();
        /* The worker is a singleton here (other tools rebuild per model), so the
           mirror flag has to be part of its identity — otherwise switching from
           a mirrored model to an un-mirrored one keeps a worker pointed at a
           mirror that will 404 for the new weights. Rebuilt only at the start of
           a run, which is the only place this is called. */
        var key = loc + '|' + (MIRRORED_WHISPER[selModel] ? 'm' : '-');
        if (whisperWorker && whisperWorkerKey !== key) {
            try { whisperWorker.terminate(); } catch (e) {}
            whisperWorker = null;
            activeBackend = null;
        }
        if (!whisperWorker) {
            var qs = CFG.urls.whisperWorker
                   + '&locale=' + encodeURIComponent(loc);
            if (MIRRORED_WHISPER[selModel]) qs += '&hfmirror=' + encodeURIComponent('/vendor/whisper-hf/');
            whisperWorker = new Worker(qs, { type: 'module' });
            whisperWorkerKey = key;
        }
        return whisperWorker;
    }

    /* What the browser lane may read whole: the device's `av` kind — the number
       the zone held until 01.10.2026 (layout __effectiveFileLimit). Above it the
       sound is extracted by streaming before anything is decoded. */
    function directReadCeiling() {
        var f = window.__effectiveFileLimit;
        var dev = typeof f === 'function' ? +f('av') : 0;
        return dev > 0 ? dev : 1073741824;
    }

    /* Extract audio from video/unsupported containers via FFmpeg WASM.
       channels: 1 (default) or 2 — a big input keeps its stereo (see the
       browser lane's decode). */
    async function extractAudioWithFFmpeg(file, channels) {
        extractFailReason = '';
        try {
            updateProgress(STR.processing, 12);
            // Lazy-load ffmpeg-processor.js. The legacy `typeof FFmpegProcessor
            // === 'undefined'` gate was always false (the timbrica-core
            // __sharedModule stub is on every page), so the dynamic loader
            // never fired and init() ran on the stub → 15 s timeout. Use the
            // layout-defined __ensureFFmpeg() which uses __hasRealFFmpeg as
            // the discriminator and resolves once the real script drains.
            if (window.__ensureFFmpeg) await window.__ensureFFmpeg();
            updateProgress(STR.loading || 'Loading…', 15);
            var ok = await FFmpegProcessor.init();
            if (!ok) return null;
            updateProgress(STR.processing, 25);
            /* Extract audio as WAV 16kHz mono (optimal for Whisper); stereo when
               the caller keeps the channels. process() streams the input from
               disk (WORKERFS) — the file is never copied into memory. */
            var result = await FFmpegProcessor.process(
                file, ['-vn', '-ar', '16000', '-ac', channels === 2 ? '2' : '1'], 'audio.wav'
            );
            if (result.url) URL.revokeObjectURL(result.url);
            return result.blob;
        } catch(err) {
            console.error('FFmpeg audio extraction failed:', err);
            /* "moov atom not found" / "Invalid data" = broken/misnamed container.
               Repair by content, not by extension guessing: a CRLF-prefixed MP4
               needs its garbage prefix stripped; a raw ADTS stream needs `-f aac`
               (process() derives the pre-input format from the input extension).
               The old "non-mp3 → -f aac" guess mis-fed CRLF-MP4s to the aac
               demuxer → "Invalid data" → the recovery that never recovered. */
            if(/moov atom|Invalid data/i.test(err.message||'')){
                console.warn('Trying audio container repair...');
                var rkind = 'aac_guess';
                try {
                    await FFmpegProcessor.reinit();
                    var head = await file.slice(0, 64).arrayBuffer();
                    var rep = window.__repairAudioContainer
                        ? window.__repairAudioContainer(head, { ext: (file.name||'').split('.').pop().toLowerCase(), type: file.type })
                        : null;
                    /* Well-formed container header (ftyp at offset 4) but ffmpeg
                       still can't find the moov atom = the file is truncated /
                       incomplete (upload cut short, or moov never written), not
                       a fixable prefix/format issue. Flag it so the user gets an
                       actionable "re-export and re-upload" message. */
                    if (!rep) {
                        try {
                            /* ⚠️ Здесь стояла проверка ftyp РОВНО по смещению 4.
                               Ровно этот дефект уже находили и чинили — но в
                               audio-recover.js (телеметрия 2026-05-17..20, четыре
                               сессии с ~3 МБ m4a): ftyp не обязан лежать по
                               смещению 4, он встречается на 12, 20 и дальше, если
                               перед ним идёт другой бокс. Там детектор переписали
                               на скан первых 256 байт, здесь — нет, и вторая копия
                               продолжала молча пропускать те же файлы: человек
                               получал «не удалось декодировать» вместо действенной
                               подсказки. Поэтому зовём ОБЩИЙ детектор, а не пишем
                               третью копию проверки. Он же покрывает moov-в-хвосте
                               и размеры, на которых наивная проверка ошибается. */
                            var AR = window.AudioRecover;
                            if (AR && AR.detectMoovMissing) {
                                if (await AR.detectMoovMissing(file)) extractFailReason = 'truncated';
                            } else {
                                var hb = new Uint8Array(head);
                                if (hb.length >= 8 && hb[4]===0x66 && hb[5]===0x74 && hb[6]===0x79 && hb[7]===0x70) {
                                    extractFailReason = 'truncated';
                                }
                            }
                        } catch (_) {}
                    }
                    var inBlob, inName;
                    if (rep && rep.kind === 'stripped_prefix') {
                        inBlob = file.slice(rep.stripped);   /* strip prefix off the FULL file */
                        inName = 'input.' + rep.ext;
                        rkind = rep.kind;
                    } else if (rep && rep.kind === 'raw_adts') {
                        inBlob = file; inName = 'input.aac'; rkind = rep.kind;
                    } else {
                        inBlob = file; inName = 'input.aac';   /* last-ditch raw-AAC attempt */
                    }
                    var result = await FFmpegProcessor.process(
                        inBlob, ['-vn', '-ar', '16000', '-ac', '1'], 'audio.wav', inName
                    );
                    if (result.blob && result.blob.size > 1000) {
                        if (result.url) URL.revokeObjectURL(result.url);
                        try{window.__ae('feature_use',{slug:TOOL_SLUG,action:'moov_recovery_ok',kind:rkind,sizeMB:Math.round(file.size/1048576)})}catch(_){}
                        return result.blob;
                    }
                } catch(e2) {
                    console.warn('Container repair also failed:', e2.message);
                    try{window.__ae('feature_use',{slug:TOOL_SLUG,action:'moov_recovery_fail',kind:rkind,err:(e2.message||'').substring(0,100)})}catch(_){}
                }
            }
            return null;
        }
    }

    /* =====================================================
       File-mode long-transcription resilience helpers
       (bug-report 38fdd911 — 2 h file ran ~200 min then vanished with no
        trace; the blade ignored every streamed chunk and persisted nothing)
       ===================================================== */

    /* Approximate audio position (seconds) of a finalized chunk. Whisper's
       pipeline uses chunk_length=29 s, stride=5 s → effective jump 19 s. */
    function chunkStartSec(chunkIndex) {
        return Math.max(0, (chunkIndex - 1) * 19);
    }

    /* ── ИСХОД ПРОГОНА: одно событие на запуск, ВСЕГДА ────────────────────
       Замер 30 дней: 1734 сессии запустили расшифровку, 943 получили текст,
       791 — нет. Телеметрия объясняла меньше половины: 135 отмен, 94 провала,
       112 зависших загрузок модели. Остальные ~350 уходили БЕЗ СЛЕДА, и
       отличить «устал ждать» от «закрыл вкладку» было нечем.

       ⚠️ СЕНСОР НЕ БЕРЁТ НИЧЕГО ИЗ ЧУЖИХ ОБЛАСТЕЙ. Первая версия читала
       selectedModel / audioDuration / ckptStreamSegs напрямую — они живут во
       ВЛОЖЕННОЙ функции, и `ReferenceError: selectedModel is not defined`
       уводил успешный прогон в catch, превращая его в «провал». То есть
       измеритель ломал то, что измеряет. Теперь всё нужное кладётся в
       runState при старте и передаётся аргументом. */
    var runState = { sent: true, t0: 0, model: '', lane: 'browser', durSec: 0 };
    function markRunStart(info) {
        info = info || {};
        runState = { sent: false, t0: Date.now(), model: info.model || '',
                     lane: info.lane || 'browser', durSec: Math.round(info.durSec || 0) };
    }
    function runIsLive() { return !runState.sent && runState.t0 > 0; }
    /* Начало и конец прогона — событием `stt:run` на document, по паре на
       прогон: очередь файлов ведёт по ним следующий файл, а не по классам
       полосы прогресса. Конец без начала не шлётся. */
    var runSeq = 0, runOpen = 0;   /* номер открытого прогона, 0 — нет */
    function emitRun(phase, detail, only) {
        if (phase === 'start') runOpen = ++runSeq;
        else if (!runOpen || (only && only !== runOpen)) return 0;
        else runOpen = 0;
        try {
            var d = { phase: phase };
            if (detail) for (var k in detail) if (Object.prototype.hasOwnProperty.call(detail, k)) d[k] = detail[k];
            document.dispatchEvent(new CustomEvent('stt:run', { detail: d }));
        } catch (_) {}
        return runSeq;
    }
    function reportRunOutcome(reason, extra) {
        emitRun('end', { reason: reason });
        if (runState.sent) return;
        runState.sent = true;
        try {
            var p = {
                reason: reason,
                sec: runState.t0 ? Math.round((Date.now() - runState.t0) / 1000) : null,
                lane: runState.lane, model: runState.model, durSec: runState.durSec,
            };
            if (extra) for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) p[k] = extra[k];
            aeTranscribe('run_ended', p);
            /* Уход со страницы — единственный случай, когда очередь не доживёт
               до следующего тика: отправляем немедленно (внутри sendBeacon). */
            if (reason === 'left_page') { try { window.__aeFlush && window.__aeFlush(); } catch (_) {} }
        } catch (_) { /* сенсор не имеет права ломать прогон */ }
    }
    /* Вкладку закрыли или ушли назад, пока шёл прогон, — это и есть та
       половина, которой не было в данных. Живость спрашиваем у СВОЕГО
       состояния, а не у чужого isTranscribing: он объявлен в другой области. */
    window.addEventListener('pagehide', function () {
        if (runIsLive()) reportRunOutcome('left_page', { vis: document.visibilityState });
    });
    document.addEventListener('visibilitychange', function () {
        /* Свернул — ещё НЕ исход: человек часто возвращается. Отмечаем факт
           отдельным событием, чтобы потом отличить «ушёл насовсем» от «свернул
           и вернулся». */
        if (document.visibilityState === 'hidden' && runIsLive()) {
            try { aeTranscribe('run_backgrounded', { sec: Math.round((Date.now() - runState.t0) / 1000) }); } catch (_) {}
        }
    });

    function aeTranscribe(f, extra) {
        try {
            var p = { slug: TOOL_SLUG, f: f };
            if (extra) for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) p[k] = extra[k];
            window.__ae && window.__ae('feature_use', p);
        } catch (_) {}
    }

    /* Persist the current partial transcript to IndexedDB. Called once per
       finalized chunk — for a real long file that's minutes apart, so we write
       eagerly (no throttle) and never depend on an unload-time flush, which is
       unreliable (the IDB transaction may not commit while the tab is torn
       down). The text payload is tiny, so per-chunk writes are cheap even on a
       fast device with short chunks. `force` is accepted for call-site clarity
       but the write is always immediate. */
    function saveCheckpoint(status) {
        if (!ckptKey || !window.TranscriptCheckpointStore) return;
        ckptLastSaveMs = Date.now();
        var fullText = ckptStreamSegs.join(' ').trim();
        var segs = ckptStreamSegs.map(function (txt, i) {
            return { text: txt, timestamp: chunkStartSec(i + 1), isFinal: true };
        });
        var data = Object.assign({
            fileName: (currentFile && currentFile.name) || '',
            fileSize: (currentFile && currentFile.size) || 0,
            segments: segs,
            fullText: fullText,
            chunksDone: ckptStreamSegs.length,
            lastTimestamp: chunkStartSec(ckptStreamSegs.length + 1),
            status: status || 'in_progress',
            /* Откуда эта работа. Хранилище одно на origin, а страницы две, и
               предлагать диктовщику недоделанный чужой файл (или наоборот) —
               значит звать человека продолжать не своё. Старые записи метки не
               имеют: у них единственным режимом с восстановлением был файл. */
            origin: mode,
        }, ckptMeta || {});
        window.TranscriptCheckpointStore.save(ckptKey, data).catch(function () {});
    }

    function discardCheckpoint() {
        if (ckptKey && window.TranscriptCheckpointStore) {
            window.TranscriptCheckpointStore.discard(ckptKey).catch(function () {});
        }
    }

    /* Paint the live transcript while the worker streams. INCREMENTAL: append
       only newly-finalized chunks to the committed span and update the
       in-progress tail in place — rebuilding the whole innerHTML every ~800 ms
       would re-escape + reparse the entire (up to hundreds of KB) transcript on
       a slow device, exactly when it's already CPU-bound. Authoritative
       segments (real timestamps) replace this once `result` arrives. */
    var _streamDomCount = 0;
    function renderStreamingTranscript() {
        /* Live paint of a job's chunks. A job that no longer owns the surface
           must keep ACCUMULATING (ckptStreamSegs stays the job's own state,
           and its history entry is built from it) but must not paint — the
           surface now belongs to a live dictation. */
        if (!jobOwnsSurface()) return;
        var committed = _$('sttStreamCommitted');
        /* Rebuild on the run's FIRST paint as well as when the container is
           missing. That is what lets transcribeFile leave the previous text
           on screen until there is something to replace it with: a leftover
           container from an earlier run would otherwise be appended to, and
           the two runs' text would run together. */
        if (!committed || _streamDomCount === 0) {
            $transcript.innerHTML =
                '<div class="stt-streaming"><span id="sttStreamCommitted"></span>' +
                '<span id="sttStreamTail" class="stt-stream-tail"></span></div>';
            committed = _$('sttStreamCommitted');
            _streamDomCount = 0;
        }
        for (var i = _streamDomCount; i < ckptStreamSegs.length; i++) {
            committed.appendChild(document.createTextNode(ckptStreamSegs[i] + ' '));
        }
        _streamDomCount = ckptStreamSegs.length;
        var tail = _$('sttStreamTail');
        if (tail) tail.textContent = ckptPartial || '';
        /* keep the newest text in view WITHOUT scrolling the page (internal only) */
        try { $transcript.scrollTop = $transcript.scrollHeight; } catch (_) {}
    }

    /* No-progress watchdog. Single-thread WASM can legitimately spend minutes
       on one chunk of a long file, so the window is generous — this only fires
       when the worker has almost certainly died (OOM / killed). It does NOT
       abort: the partial is already persisted and the run may still be alive,
       so we only surface an actionable, non-destructive notice + telemetry. */
    function bumpProgress() { lastProgressMs = Date.now(); }
    function startWatchdog() {
        stallNotified = false;
        bumpProgress();
        clearInterval(transcribeWatchdog);
        transcribeWatchdog = setInterval(function () {
            if (!isTranscribing) { stopWatchdog(); return; }
            if (stallNotified) return;
            if (Date.now() - lastProgressMs >= WATCHDOG_IDLE_MS) {
                stallNotified = true;
                aeTranscribe('transcription_stalled', {
                    chunksDone: ckptStreamSegs.length,
                    idleMin: Math.round((Date.now() - lastProgressMs) / 60000),
                    model: (ckptMeta && ckptMeta.model) || '',
                });
                /* Non-destructive: tell the user the run looks stuck, that their
                   progress IS saved, and that a smaller model / shorter clip is
                   the fix. The progress panel + its Cancel button stay visible
                   (Cancel commits the streamed partial). */
                try { $progressText.textContent = STR.transcribe_stalled || STR.error_model_load; } catch (_) {}
                showToast(STR.transcribe_stalled || STR.error_model_load, 'warning');
            }
        }, 30000);
    }
    function stopWatchdog() { clearInterval(transcribeWatchdog); transcribeWatchdog = null; }

    /* Best-effort screen Wake Lock — keeps the display (and, on some platforms,
       the tab) from sleeping during a multi-minute transcription. Silently
       no-ops where unsupported. */
    function acquireWakeLock() {
        try {
            if (navigator.wakeLock && navigator.wakeLock.request) {
                navigator.wakeLock.request('screen').then(function (s) {
                    wakeLockSentinel = s;
                    /* Re-acquire if the system released it (tab refocus). */
                    s.addEventListener && s.addEventListener('release', function () { wakeLockSentinel = null; });
                }).catch(function () {});
            }
        } catch (_) {}
    }
    function releaseWakeLock() {
        try { if (wakeLockSentinel && wakeLockSentinel.release) wakeLockSentinel.release(); } catch (_) {}
        wakeLockSentinel = null;
    }
    /* Wake Lock is auto-released when the tab is hidden; re-acquire on return
       so a long backgrounded run keeps the lock when the user comes back. */
    document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'visible' && isTranscribing && !wakeLockSentinel) {
            acquireWakeLock();
        }
    });

    /* Warn before leaving while a transcription is running. The work is
       checkpointed so it's recoverable, but an accidental close mid-run is
       worth a confirm — this is exactly the moment the bug-reporter lost. */
    window.addEventListener('beforeunload', function (e) {
        if (isTranscribing) { e.preventDefault(); e.returnValue = ''; return ''; }
    });
    /* Flush the checkpoint the instant the tab is hidden / closed — this is the
       exact moment the bug-reporter lost her work. The throttle is fine for the
       minutes-apart chunks of a long run, but a force-flush here guarantees the
       most recent finalized chunk is durable even if the next throttled write
       never gets to fire. */
    function flushCheckpointNow() {
        if (isTranscribing && ckptKey && ckptStreamSegs.length) saveCheckpoint('in_progress', true);
    }
    document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') flushCheckpointNow();
    });
    window.addEventListener('pagehide', flushCheckpointNow);

    /* ── Recovery / resume banner ──────────────────────────────────────────
       initFileRecovery() runs on page load: if a previous session left an
       unfinished transcript in IndexedDB, offer to RESTORE the text. When the
       user later (re)picks the SAME file, maybeOfferResume() offers to CONTINUE
       transcribing only the remaining tail. Both reuse the .stt-recovery card. */
    /* Уведомление живёт в потоке, в начале рабочей области — и при возврате,
       и после выбора файла. */
    function ckptBannerActions(html) {
        $fileRecovery.innerHTML = html;
        $fileRecovery.classList.remove('hidden');
    }

    function hideCkptBanner() {
        if (!$fileRecovery) return;
        $fileRecovery.classList.add('hidden');
    }

    /* ⚠️ Раньше здесь стояло `if (mode !== 'file') return;`, и диктовка
       НИКОГДА не предлагала вернуть недоделанное — хотя пишет чекпойнты ровно
       так же: спасатель зовёт `transcribeFile`, а тот заводит `ckptKey` без
       оглядки на режим. То есть текст уже лежал в IndexedDB, и мы про него
       молчали. Это и есть механика той половины беды, которую видно в проде:
       из спасателей на телефонах доходит 23 % против 54 % на компьютерах, а
       41 % оборванных — `run_backgrounded`, то есть вкладку заморозила система.
       Восстановление файла работает без самого файла: банер поднимается по
       ключу чекпойнта, а текст рисуется в тот же `$transcript`. */
    async function initFileRecovery() {
        if (!window.TranscriptCheckpointStore || !window.TranscriptCheckpointStore.isSupported()) return;
        try {
            await window.TranscriptCheckpointStore.purgeStale(CKPT_MAX_AGE_MS);
            var pend = await window.TranscriptCheckpointStore.listPending();
            pend = (pend || []).filter(function (p) {
                                   if (p.status !== 'in_progress' || !(p.chunksDone > 0)) return false;
                                   /* Своё, а не соседкино: записи без метки —
                                      из времён, когда восстанавливал только файл. */
                                   return (p.origin || 'file') === mode;
                               })
                               .sort(function (a, b) { return (b.updatedAt || 0) - (a.updatedAt || 0); });
            if (!pend.length) return;
            showRestoreBanner(pend[0]);
        } catch (_) {}
    }

    function showRestoreBanner(meta) {
        var min = Math.max(1, Math.round((meta.lastTimestamp || 0) / 60));
        var body = (STR.ckpt_recover_body || '')
            .replace('{file}', meta.fileName || 'audio')
            .replace('{min}', min)
            .replace('{words}', meta.wordCount || 0);
        ckptBannerActions(
            '<div class="stt-recovery-text"><strong>' + escHtml(STR.ckpt_recover_title || 'Unfinished transcript') + '</strong>' + escHtml(body) + '</div>' +
            '<div class="stt-recovery-actions">' +
              '<button class="stt-recovery-btn primary" id="sttCkptRestore" type="button">' + escHtml(STR.ckpt_restore || 'Restore') + '</button>' +
              '<button class="stt-recovery-btn" id="sttCkptDiscard" type="button">' + escHtml(STR.ckpt_discard || 'Discard') + '</button>' +
            '</div>'
        );
        aeTranscribe('ckpt_recover_shown', { min: min, words: meta.wordCount || 0, pinned: 0 });
        _$('sttCkptRestore').addEventListener('click', function () {
            window.TranscriptCheckpointStore.get(meta.key).then(function (cp) {
                if (cp && cp.segments && cp.segments.length) {
                    transcriptSegments = cp.segments.map(function (s) {
                        return { text: (s.text || '').trim(), timestamp: s.timestamp || 0, isFinal: true };
                    });
                    finalTranscript = cp.fullText || transcriptSegments.map(function (s) { return s.text; }).join(' ');
                    userHasEdited = false;
                    adoptDocument({ src: meta.fileName || cp.fileName || '' });
                    renderFileTranscript();
                    updateStats();
                    generateWordCloud(true);
                    /* Восстановленный транскрипт — такая же работа, как только
                       что расшифрованная: из него тоже должны открываться
                       разбор диалога и саммари. Без этого возврат отдавал текст
                       в тупик — тот же дефект, что был у истории (27b9d53185). */
                    revealAiButtons();
                    showToast(STR.done || 'Done', 'success');
                }
            }).catch(function () {});
            aeTranscribe('ckpt_restore');
            hideCkptBanner();
        });
        _$('sttCkptDiscard').addEventListener('click', function () {
            window.TranscriptCheckpointStore.discard(meta.key).catch(function () {});
            aeTranscribe('ckpt_discard');
            hideCkptBanner();
        });
    }

    /* Called after a file is picked — if a matching unfinished checkpoint
       exists for THIS file + current model/lang, offer to continue the tail. */
    function maybeOfferResume(file) {
        if (!file || !window.TranscriptCheckpointStore || !window.TranscriptCheckpointStore.isSupported()) return;
        var selModel = $model.value || 'tiny';
        var wLang = getWhisperLang();
        var key = window.TranscriptCheckpointStore.fingerprint(file, selModel + ':' + (wLang || 'auto') + (($translateChk && $translateChk.checked) ? ':tr' : ''));
        window.TranscriptCheckpointStore.get(key).then(function (cp) {
            if (!cp || cp.status !== 'in_progress' || !cp.chunksDone) return;
            showResumeBanner(cp);
        }).catch(function () {});
    }

    function showResumeBanner(cp) {
        var min = Math.max(1, Math.round((cp.lastTimestamp || 0) / 60));
        var words = (cp.fullText || '').split(/\s+/).filter(Boolean).length;
        var body = (STR.ckpt_resume_body || '').replace('{min}', min).replace('{words}', words);
        ckptBannerActions(
            '<div class="stt-recovery-text"><strong>' + escHtml(STR.ckpt_resume_title || 'Continue transcription?') + '</strong>' + escHtml(body) + '</div>' +
            '<div class="stt-recovery-actions">' +
              '<button class="stt-recovery-btn primary" id="sttCkptResume" type="button">' + escHtml(STR.ckpt_resume_continue || 'Continue') + '</button>' +
              '<button class="stt-recovery-btn" id="sttCkptRestart" type="button">' + escHtml(STR.ckpt_resume_restart || 'Start over') + '</button>' +
            '</div>'
        );
        aeTranscribe('ckpt_resume_shown', { min: min });
        _$('sttCkptResume').addEventListener('click', function () {
            /* Same gate as the Transcribe button. Without it, Continue was the
               one un-gated entry into transcribeFile: at the cap a user could
               resume a checkpoint, complete, and record() pushed the counter to
               11/10. Billing stays fair — an interrupted run never committed
               (record fires only at completion), so a gated resume that finishes
               bills exactly once for exactly one delivered transcript. */
            if (sttLimitBlocked()) return;
            /* Under a running job this click would set resumeFromSec that the
               job then adds to every timestamp it delivers. */
            if (isTranscribing) { hideCkptBanner(); return; }
            /* Re-do the LAST finalized chunk: Whisper's chunk_length(29s) >
               jump(19s), so consecutive chunks overlap ~10s. Resuming exactly at
               the next boundary would double-transcribe that overlap → duplicated
               words at the seam. Drop the last head chunk and resume one boundary
               earlier so the tail cleanly re-covers it. */
            var keepChunks = Math.max(0, (cp.chunksDone || 0) - 1);
            resumeFromSec = keepChunks * 19;
            pendingCkpt = Object.assign({}, cp, { segments: (cp.segments || []).slice(0, keepChunks) });
            aeTranscribe('ckpt_resume_continue', { fromSec: resumeFromSec, keepChunks: keepChunks });
            hideCkptBanner();
            if (currentFile) transcribeFile(currentFile);
        });
        _$('sttCkptRestart').addEventListener('click', function () {
            window.TranscriptCheckpointStore.discard(cp.key).catch(function () {});
            resumeFromSec = 0; pendingCkpt = null;
            aeTranscribe('ckpt_resume_restart');
            hideCkptBanner();
        });
    }

    /* =====================================================
       Server-side transcription (Pro) — variant A
       Browser path stays the default + free; "On server" offloads to whisper.cpp
       (Pro only). Non-Pro see the option locked with an upgrade offer; weak
       devices get the offer proactively. The job survives a tab close — we
       persist its id and resume polling on the next visit.
       ===================================================== */
    function isWeakDevice() {
        var mem = caps.mem;          /* уже от владельца бюджета — см. caps выше */
        return mem <= 4 || (!caps.webgpu && !caps.sab);
    }
    function setProcMode(m, opts) {
        procMode = m;
        /* Persist ONLY on explicit user choice (default opts.persist=true).
           First-paint init at the end of initServerAsr() passes persist:false
           — otherwise we'd write 'server' to localStorage before the user
           ever clicked, and a later Pro expiry would leave 'saved=server'
           baiting them with a pill that routes to the upsell. The
           expired-Pro downgrade in the IIFE catches that anyway, but
           not-writing-it-in-the-first-place is the cleaner contract. */
        if (!opts || opts.persist !== false) {
            try { localStorage.setItem(STT_PROC_MODE_KEY, m); } catch (_) {}
        }
        if ($proc) Array.prototype.forEach.call($proc.querySelectorAll('.stt-proc-btn'), function (b) {
            b.classList.toggle('active', b.dataset.proc === m);
        });
        if (m === 'browser') hideUpsell();
        /* Quality select only matters for the server path (Pro). */
        if ($serverQuality) $serverQuality.classList.toggle('hidden', !(m === 'server' && asrServerAllowed()));
        /* Active-server badge: confirms the paid Pro perk is what's about
           to run. Hidden when on browser path or when the user isn't Pro. */
        if ($procActiveBadge) $procActiveBadge.classList.toggle('hidden', !(m === 'server' && asrServerAllowed()));
        syncDiarizeAvailability();
        updateNamesNote();
    }

    /* Speaker labels exist on BOTH lanes now, by two different means:
         browser — a post-process over the decoded PCM (runDiarization, fed by
                   diarPcm captured in the browser transcribe path);
         server  — sherpa-onnx over the same 16 kHz WAV whisper read (2026-08-04).

       Until then the server path had none, so the checkbox was visible, tickable
       — and silently ignored. A Pro user transcribing consultations reported
       exactly that ("текст идет сплошной, трудно распознать кто когда что
       говорил", support 2026-08-01) while paying for the very path that dropped
       the feature. It is still possible for the server side to be unavailable —
       the diarizer is a binary on disk and a box may simply not have it — so the
       control keeps telling the truth rather than assuming. */
    function syncDiarizeAvailability() {
        if (!$diarizeRow || $diarizeRow.hidden) return;
        var serverPath = (procMode === 'server' && asrServerAllowed());
        var unavailable = serverPath && !__serverAsr.diarize;
        if ($diarize) {
            $diarize.disabled = unavailable;
            if (unavailable) $diarize.checked = false;
        }
        $diarizeRow.classList.toggle('is-unavailable', unavailable);
        if ($diarizeHint) {
            $diarizeHint.textContent = unavailable
                ? (STR.diarize_server_note || STR.diarize_hint)
                : STR.diarize_hint;
        }
        /* Поле «сколько человек» живёт при галочке, но до 2026-09-04 показывалось
           ТОЛЬКО по событию change: галочка, восстановленная из prefs программно,
           события не даёт — и поле оставалось спрятанным при включённой галочке.
           Премиум-пользователь с 2,5-часовой записью так и не нашёл, «где это
           указывать», а диаризация без числа на неё и не рассчитана. Синхронизируем
           здесь — это вызывается и при старте, и при смене лейна. */
        if (typeof syncSpeakersRow === 'function') syncSpeakersRow();
    }

    /* Honest per-file ETA (minutes) for a model's realtime factor. Null until we
       know the file duration. */
    /* ⚠️ Оценка обязана включать ВСЕ выбранные этапы, а не только расшифровку.
       Разделение говорящих идёт отдельным проходом и на длинной записи стоит
       кратно больше самой расшифровки: у трёхчасовой консультации при rt 18 на
       gigaam расшифровка ≈10 мин, а диаризация при rt 1.5 — ещё ≈123.
       Живой случай 2026-08-11 (Екатерина): на экране «≈14 мин», прошёл час,
       работа честно шла — просто число молчало о самой долгой фазе. Оценка,
       умалчивающая о главном, хуже отсутствия оценки: человек решает, что всё
       зависло, и закрывает вкладку. */
    function serverEtaMin(rt) {
        if (!serverAudioDur || !rt) return null;
        var sec = serverAudioDur / rt;
        if ($diarize && $diarize.checked && !$diarize.disabled) {
            var drt = parseFloat((__serverAsr && __serverAsr.diarizeRt) || 0);
            if (drt > 0) sec += serverAudioDur / drt;
        }
        return Math.max(1, Math.ceil(sec / 60));
    }
    /* Серверная оценка для ПРОИЗВОЛЬНОЙ длительности — нужна там, где файл ещё
       не проходил серверную ветку и `serverAudioDur` пуст (преflight
       браузерного лейна). Модель берётся ТА, которая реально побежит, и её
       `rt` — из того же реестра, что рисует пикер.

       ⚠️ Прежде на этом месте стояло `durationMin / 8` — «whisper.cpp base
       ~8× реального времени». Для русского это занижало выигрыш в 2.5 раза
       (gigaam на проде 28.08: 2120 с аудио за 105 с, то есть 20.2×), то есть
       единственная строка, звавшая на сервер, продавала его вдвое хуже, чем он
       есть. Захардкоженная скорость движка стареет молча — здесь её больше нет. */
    function serverEtaMinutes(durSec) {
        if (!durSec) return 0;
        var key = serverModel || smartServerModel();
        var ms = __serverAsr.models || [], rt = 0;
        for (var i = 0; i < ms.length; i++) if (ms[i].key === key) rt = parseFloat(ms[i].rt) || 0;
        if (rt <= 0) return 0;
        var sec = durSec / rt;
        if ($diarize && $diarize.checked && !$diarize.disabled) {
            var drt = parseFloat((__serverAsr && __serverAsr.diarizeRt) || 0);
            if (drt > 0) sec += durSec / drt;
        }
        return Math.max(1, Math.ceil(sec / 60));
    }
    /* Per-model duration ceiling (seconds; 0 = unknown). Caps come from the
       server config, derived from the worker's measured capacity. */
    function serverModelCapSec(key) {
        var ms = __serverAsr.models || [];
        for (var i = 0; i < ms.length; i++) if (ms[i].key === key) return (ms[i].maxMin || 0) * 60;
        return 0;
    }
    /* Can this quality mode take the loaded file? +60 s slack — container
       metadata may overstate duration; near the cap the server's ffprobe
       verdict decides. Unknown duration (0) = fail-open to the server gate. */
    function serverModelFits(key) {
        var cap = serverModelCapSec(key);
        return !serverAudioDur || !cap || serverAudioDur <= cap + 60;
    }
    var serverCapNoticeFor = 0;   /* duration already announced — one toast per file */
    /* Steering hint reacts to both selectors + first paint. */
    setTimeout(function () {
        try {
            updateLangQualityHint();
            if ($lang)  $lang.addEventListener('change', function () {
                if (!userChangedModel && caps.ready && mode === 'file') $model.value = smartDefaultModel();
                /* the server lane picks by language too — re-decide until the user picks */
                if (!userChangedServerModel) { serverModel = null; renderServerQuality(); }
                updateLangQualityHint();
            });
            if ($model) $model.addEventListener('change', updateLangQualityHint);
        } catch (_) {}
    }, 0);

    var QUALITY_LABELS = {
        base:  { name: function () { return STR.asr_q_std  || 'Standard'; }, hint: function () { return STR.asr_q_std_hint  || ''; } },
        small: { name: function () { return STR.asr_q_high || 'High';     }, hint: function () { return STR.asr_q_high_hint || ''; } },
        /* ⚠️ «Точнее всех» — правда ТОЛЬКО пока рядом нет языкового специалиста.
           Замер 2026-08-09 (BENCHMARK-ru, тот же корпус и прод-путь) по условиям
           записи: студия turbo 4.9% против GigaAM 6.6% — turbo лучше; телефон
           8.5 против 5.7 и через комнату 10.2 против 6.7 — turbo хуже в полтора
           раза. То есть превосходство держится в одном условии из трёх, и в
           самом редком у наших пользователей.
           Две превосходные степени рядом («точнее всех» и «самая точная на
           русском») — это не стилистика: 27.08 Премиум-пользователь по этой
           подписи ушёл с верного дефолта, который уже отдал ей текст за минуту,
           и потратила день. «Максимум» — самый частый ручной выбор (32 из 96
           переключений). Поэтому подпись зависит от того, что реально
           предложено рядом, а не от того, как хочется назвать режим. */
        'large-v3-turbo': {
            name: function () { return STR.asr_q_max || 'Maximum'; },
            hint: function () {
                /* Именно ДОСТУПНЫЕ для выбранного языка, а не весь каталог:
                   для английского специалиста рядом нет, turbo там честно
                   точнейший, и оговорка про русский была бы шумом. */
                var specialist = serverModelsAvailable().some(function (m) {
                    return m.key !== 'large-v3-turbo' && m.langs && m.langs.length;
                });
                return (specialist ? STR.asr_q_max_hint_alt : STR.asr_q_max_hint) || '';
            },
        },
        gigaam: { name: function () { return STR.asr_q_giga || 'Russian'; }, hint: function () { return STR.asr_q_giga_hint || ''; } },
        /* OpenAI gpt-transcribe — a PAID choice (intl only; the server builds the
           entry nowhere else). The hint names the price per minute and that the
           audio goes to OpenAI: both are facts a person needs BEFORE picking it.
           Measured 2026-10-18: half the errors of turbo on all nine languages it
           is offered for (docs/why/asr-openai.md). */
        openai: {
            name: function () { return STR.asr_q_openai || 'OpenAI'; },
            hint: function () {
                var m = serverModelByKey('openai');
                return (STR.asr_q_openai_hint || '').replace('{rate}', m && m.rate ? m.rate : '');
            },
        },
    };
    function serverModelByKey(key) {
        var list = __serverAsr.models || [];
        for (var i = 0; i < list.length; i++) if (list[i].key === key) return list[i];
        return null;
    }

    /* Which server models may be offered for the language in the selector.
       A model with `langs` can only transcribe those languages — GigaAM is
       Russian-only — and offering it for anything else does not fail loudly,
       it returns a fluent transcription of a language that was never spoken.
       `langs: null` (every whisper tier) means no restriction. */
    function serverLangBase() {
        var sel = ($lang && $lang.value) || 'auto';
        return (sel === 'auto' ? (window.__LOCALE || 'en') : sel).split('-')[0].toLowerCase();
    }
    function serverModelsAvailable() {
        var lb = serverLangBase();
        return (__serverAsr.models || []).filter(function (m) {
            return !m.langs || m.langs.indexOf(lb) !== -1;
        });
    }
    /* Language-aware default for the SERVER lane — the sibling of smartDefaultModel()
       (which does the same job for the browser lane, line ~3344).
       Until 2026-08-04 this lane simply took models[0], i.e. ALWAYS `base`, and that
       default was measurably wrong for anything but English. Measured on 2-speaker
       Russian dialogue (FLEURS ground truth, 3 recording conditions, run through the
       production transcribe.sh):
           base   24.5% / 29.1% / 42.7% WER  — and it silently DROPPED 4 of 16 turns
           small  10.5% / 19.2% / 28.6%      — 15/16 turns
           turbo   6.4% /  7.8% /  —         — 15/16 turns
       The lost turns are the point: a paying user comparing text to audio does not
       read that as "9% WER", she reads it as "неверно распознаёт" (support 2026-08-01).
       Both better models are already installed and enabled on both boxes — only the
       default was wrong. English keeps `small` (base ties on accuracy there but loses
       the same turns; small costs 3x less throughput than turbo for no EN gain).
       The device can't be too slow for this — the work runs on OUR box, so unlike the
       browser lane there is no capability test, only a per-model duration ceiling that
       the existing serverModelFits() cascade already enforces below. */
    function smartServerModel() {
        var keys = serverModelsAvailable().map(function (m) { return m.key; });
        var base2 = serverLangBase();
        /* Russian leads with GigaAM: measured 2026-08-09 on this corpus it is
           BOTH more accurate than every whisper tier and an order of magnitude
           faster (7.9% WER / 15.3 of 16 turns / 18.3x, against base's 29.2% /
           8.0 / 5.1x). Turbo stays second — it is the escape hatch for a
           recording that mixes Russian with a lot of English, which is the one
           place a Russian-only model is expected to be weaker. */
        var wanted = base2 === 'en' ? ['small', 'large-v3-turbo', 'base']
            : base2 === 'ru' ? ['gigaam', 'large-v3-turbo', 'small', 'base']
            : ['large-v3-turbo', 'small', 'base'];
        for (var i = 0; i < wanted.length; i++) if (keys.indexOf(wanted[i]) !== -1) return wanted[i];
        /* A paid model is a choice the person makes, never one made for them. */
        var free = keys.filter(function (k) { var m = serverModelByKey(k); return !(m && m.paid); });
        return free[0] || keys[0] || 'base';
    }

    function renderServerQuality() {
        if (!$qualityOpts || !__serverAsr.models || !__serverAsr.models.length) return;
        var avail = serverModelsAvailable();
        if (!avail.length) avail = __serverAsr.models;   /* never render an empty picker */
        /* A language change can strand the current pick on a model that cannot
           speak the new language — including one the user chose by hand. Their
           choice is honoured while it is still valid and re-decided when it is
           not, rather than silently sending Spanish to a Russian-only model. */
        if (serverModel && !avail.some(function (m) { return m.key === serverModel; })) {
            serverModel = null;
            userChangedServerModel = false;
        }
        if (!serverModel) {
            serverModel = smartServerModel();
            if (serverDefaultReported !== serverModel) {
                serverDefaultReported = serverModel;
                aeTranscribe('server_quality_default', { model: serverModel, loc: ($lang && $lang.value) || 'auto' });
            }
        }
        /* If the ACTIVE mode can't take the loaded file but another can, hop to
           the one that fits and SAY so — announced, never silent (the quality
           choice is the user's; the greyed button + toast explain why). */
        if (serverAudioDur && !serverModelFits(serverModel)) {
            for (var fi = 0; fi < avail.length; fi++) {
                var fit = avail[fi];
                if (fit.paid || !serverModelFits(fit.key)) continue;
                var fromLab = QUALITY_LABELS[serverModel], toLab = QUALITY_LABELS[fit.key];
                var fromCap = Math.round(serverModelCapSec(serverModel) / 60);
                serverModel = fit.key;
                if (serverCapNoticeFor !== serverAudioDur) {
                    serverCapNoticeFor = serverAudioDur;
                    showToast((STR.asr_auto_switch || '{from}: up to {cap} min. Switched to {to} for this {min}-min recording.')
                        .replace('{from}', fromLab ? fromLab.name() : 'High')
                        .replace('{to}', toLab ? toLab.name() : fit.key)
                        .replace('{cap}', fromCap)
                        .replace('{min}', Math.round(serverAudioDur / 60)), 'info');
                    aeTranscribe('server_quality_autoswitch', { to: fit.key, min: Math.round(serverAudioDur / 60) });
                }
                break;
            }
        }
        $qualityOpts.innerHTML = '';
        avail.forEach(function (mdl) {
            var lab = QUALITY_LABELS[mdl.key] || { name: function () { return mdl.key; }, hint: function () { return ''; } };
            var eta = serverEtaMin(mdl.rt);
            var fits = serverModelFits(mdl.key);
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'stt-quality-opt' + (mdl.key === serverModel ? ' active' : '');
            btn.dataset.model = mdl.key;
            btn.disabled = !fits;
            var html = '<span class="q-name">' + escHtml(lab.name()) + '</span>';
            if (!fits) {
                /* honest reason instead of an ETA it will never reach */
                html += '<span class="q-hint">' + escHtml((STR.asr_q_too_long || 'recording longer than {cap} min').replace('{cap}', mdl.maxMin)) + '</span>';
            } else {
                if (lab.hint()) html += '<span class="q-hint">' + escHtml(lab.hint()) + '</span>';
                if (eta) html += '<span class="q-eta">' + escHtml((STR.asr_eta || '≈ {min} min').replace('{min}', eta)) + '</span>';
            }
            btn.innerHTML = html;
            btn.addEventListener('click', function () {
                if (btn.disabled) return;
                serverModel = mdl.key;
                userChangedServerModel = true;   /* stop re-deciding on language change */
                renderServerQuality();
                /* The cost line depends on the model now (the paid one has its own
                   rate and no free minutes) — and it never followed a click before. */
                renderAsrQuota();
                aeTranscribe('server_quality_pick', { model: mdl.key });
            });
            $qualityOpts.appendChild(btn);
        });
    }
    var upsellReason = 'server';   /* which lock opened the panel — purchase attribution */
    function showServerUpsell(reason, bodyText, titleText) {
        upsellReason = reason || 'server';
        if ($upsellBody) $upsellBody.textContent = bodyText || STR.server_upsell_body || '';
        if ($upsellTitle) $upsellTitle.textContent = titleText || STR.server_upsell_title || '';
        if ($upsell) $upsell.classList.remove('hidden');
        aeTranscribe('server_upsell_shown', { weak: isWeakDevice() ? 1 : 0, reason: upsellReason });
    }

    /* ── When the offer appears ──────────────────────────────────────────────
       Until 2026-08-09 the panel was opened at page init for anyone matching
       isWeakDevice() — «no WebGPU AND no SharedArrayBuffer», which is most
       browsers. Measured over 30 days: shown in 6 273 of 6 554 sessions (95.7%)
       and clicked in 53 (0.84%). An offer everyone sees before they have a
       problem is wallpaper.
       It now waits for a MEASURED reason and carries the numbers behind it, so
       the sentence a person reads is about their own file. One offer per
       session: the second one is nagging, not information. */
    var offerShown = false;
    function offerServerLane(reason, bodyText) {
        if (offerShown || asrServerAllowed() || !__serverAsr.offer) return;
        offerShown = true;
        /* The stock title asks «Слабое устройство?» — right for the old
           device-capability trigger, wrong for all three new ones, which are
           about waiting, breaking and phones. */
        showServerUpsell(reason, bodyText, STR.server_upsell_title_wait || STR.server_upsell_title);
    }
    /* Browser-time estimate for the loaded file, in minutes — the same
       measure-don't-guess path the ETA label uses (this device's recorded
       speed first, the static table only on a first run). */
    function browserEtaMin() {
        if (!serverAudioDur || !isFinite(serverAudioDur)) return 0;
        var m = ($model && $model.value) || smartDefaultModel();
        var rt = estimateRealtimeFactor(m, caps);
        return rt > 0 ? Math.round((serverAudioDur * rt) / 60) : 0;
    }
    function serverEtaMinForOffer() {
        var mdl = (__serverAsr.models || []).slice().sort(function (a, b) { return b.rt - a.rt; })[0];
        var rt = (mdl && mdl.rt) || 4.5;
        return Math.max(1, Math.round(serverAudioDur / rt / 60));
    }
    /* Reason 1 — the wait. The single largest hole in this tool: 756 sessions a
       month start a transcription and never see it finish, and the measured
       browser mean is 8.7 min on WASM+base (worst single run in 30 days: 23.7
       hours). Offer at the moment the estimate for THEIR file crosses the line,
       quoting both numbers. */
    function offerOnSlowEta() {
        var bMin = browserEtaMin();
        if (bMin < OFFER_ETA_MIN_MINUTES) return;
        /* `:name` placeholders, matching the project's translation convention.
           Laravel leaves them untouched when __() is called without a
           replacement array, so the substitution happens here with the numbers
           for THIS file. Longest-first, so `:server` can never be eaten by a
           shorter prefix — the class of bug that once hid speaker names. */
        var tpl = STR.server_upsell_eta || 'In this browser ≈ :browser min; on our server ≈ :server min.';
        offerServerLane('eta', tpl.replace(':browser', bMin).replace(':server', serverEtaMinForOffer()));
    }
    /* Reason 2 — it broke. A failed or stalled run is the one moment the value
       of "not on this device" needs no explaining. */
    function offerAfterFailure(kind) {
        offerServerLane('failed:' + kind, STR.server_upsell_failed || STR.server_upsell_body || '');
    }
    /* Reason 4 — dictation's own failure. The browser's recogniser took the
       audio and returned nothing (fatal 'not_delivering'); Whisper rescued the
       take, so the person HAS their text and this is not a rescue plea — it is
       the one moment they have first-hand evidence that the lane the server
       does not depend on is worth something. Reuses server_upsell_failed: the
       sentence «обработка прервалась на вашем устройстве, на нашем сервере она
       не зависит от вкладки и браузера» is already true here and already
       translated into ten locales.
       ⚠️ Deliberately AFTER delivery, not at the moment of the verdict. A rival
       CTA next to a recording that is still running has cost this tool real
       takes before: 5 of 164 takeover sessions clicked Switch-to-file mid-
       rescue and lost the recording. */
    function offerAfterSilentLane() {
        offerServerLane('mic_not_delivering', STR.server_upsell_failed || STR.server_upsell_body || '');
    }
    /* Reason 3 — a phone with a long recording. Measured over 30 days: mobile
       sessions finish 34% of the runs they start against desktop's 66%, and
       "recorded the meeting on my phone" is the archetypal transcription job.
       Offered before the run rather than after the loss. */
    function offerOnMobileLongFile() {
        if (!isMobileDevice() || !serverAudioDur || serverAudioDur < OFFER_MOBILE_MIN_SEC) return;
        offerServerLane('mobile_long', STR.server_upsell_mobile || STR.server_upsell_body || '');
    }
    var OFFER_ETA_MIN_MINUTES = 5;
    var OFFER_MOBILE_MIN_SEC  = 600;
    function isMobileDevice() {
        return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent || '');
    }

    /* ── One free minute on our engine ───────────────────────────────────────
       The gap between the two lanes is large and measured — on Russian dialogue
       the browser default gets 29.9% of words wrong and loses 6 utterances of
       16, our server gets 6.3% and loses 0.4 — and it is INVISIBLE. Someone
       reading their own free transcript has no reference to compare against, so
       a bad result reads as "this site transcribes badly" rather than "I am on
       the weak lane". This shows them, on their own audio, at no charge. */
    var demoRan = false, demoBusy = false;
    function demoAvailable() {
        return !!(__serverAsr && __serverAsr.demoUrl) && !asrServerAllowed()
            && serverLangBase() === 'ru' && mode === 'file';
    }
    function maybeShowDemo() {
        if (!$demo || demoRan || !demoAvailable() || !currentFile) return;
        $demo.classList.remove('hidden');
    }
    /* The browser side of the comparison: whatever this device produced for the
       same opening minute. Empty before the browser run — the panel then shows
       only our column plus an invitation, which is still the honest thing to
       display and does not pretend a comparison exists. */
    function browserTextForFirstMinute() {
        if (!transcriptSegments || !transcriptSegments.length) return '';
        var out = [];
        for (var i = 0; i < transcriptSegments.length; i++) {
            var s = transcriptSegments[i];
            /* `timestamp`, not `start` — the browser lane's segment shape. Using
               the wrong field silently yields 0 for every segment, which would
               dump the WHOLE transcript into a column labelled "first minute". */
            if ((s.timestamp || 0) >= 60) break;
            if (s.isParagraph || !s.text) continue;
            out.push((s.text || '').trim());
        }
        return out.join(' ').trim();
    }
    async function runDemoMinute() {
        if (demoBusy || !currentFile) return;
        demoBusy = true;
        $demoBtn.disabled = true;
        var label = $demoBtn.textContent;
        $demoBtn.textContent = STR.demo_running || label;
        aeTranscribe('demo_click', { mob: isMobileDevice() ? 1 : 0 });
        try {
            /* Trim in the browser, not on the way out: uploading an hour so the
               server can throw away 59 minutes of it would cost the user their
               connection for a demo. The server enforces the same 60 s anyway —
               this is politeness, not the boundary. */
            if (window.__ensureFFmpeg) await window.__ensureFFmpeg();
            if (!(await FFmpegProcessor.init())) throw new Error('engine');
            /* Opus at 24 kbps mono, not WAV. Measured on production: the same
               60 seconds is 1.92 MB as 16 kHz PCM and ~120 KB as opus, and the
               upload dominated the wait — a live browser run took 32.7 s
               end-to-end against ~7 s of actual server work. A demo whose point
               is "look how fast this is" cannot spend 25 seconds uploading, and
               on mobile data it would be worse than useless.
               Speech at 24 kbps opus is transparent to an ASR model — it decodes
               to the same 16 kHz mono the engine wants either way. WAV stays as
               the fallback if this build has no encoder.
               ⚠️ Until 08.10.2026 this never ran: the exec door renamed libopus
               to the built-in opus, which takes 48 kHz only, so every demo went
               as WAV. The door now keeps libopus for MONO only (FFmpegOpusRule —
               stereo libopus traps in this core), so `-ac 1` is load-bearing.
               Measured on the server's demo engine, 9 hearing minutes: WAV 6.6 %
               word errors, libopus 24k 6.9 %, built-in opus 24k 8.3 %. */
            var r = null;
            try {
                r = await FFmpegProcessor.process(currentFile,
                    ['-t', '60', '-vn', '-sn', '-ar', '16000', '-ac', '1', '-c:a', 'libopus', '-b:a', '24k'],
                    'demo.ogg');
            } catch (_) { r = null; }
            var demoName = 'demo.ogg', demoType = 'audio/ogg';
            if (!r || !r.blob || r.blob.size < 1000) {
                r = await FFmpegProcessor.process(
                    currentFile, ['-t', '60', '-vn', '-sn', '-ar', '16000', '-ac', '1'], 'demo.wav');
                demoName = 'demo.wav'; demoType = 'audio/wav';
            }
            if (r && r.url) URL.revokeObjectURL(r.url);
            if (!r || !r.blob || r.blob.size < 1000) throw new Error('trim');
            aeTranscribe('demo_clip_ready', { kb: Math.round(r.blob.size / 1024), fmt: demoName.slice(-3) });

            var fd = new FormData();
            fd.append('audio', new File([r.blob], demoName, { type: demoType }), demoName);
            var resp = await fetch(__serverAsr.demoUrl, {
                method: 'POST', body: fd, credentials: 'same-origin',
                headers: { 'X-CSRF-TOKEN': (document.querySelector('meta[name=csrf-token]') || {}).content || '' },
            });
            var data = await resp.json().catch(function () { return {}; });
            if (!resp.ok || !data.success) throw new Error(data.error || ('http_' + resp.status));

            var mine = browserTextForFirstMinute();
            $demoBrowser.textContent = mine || (STR.demo_browser_empty || '');
            $demoServer.textContent  = data.text || '';
            $demoResult.classList.remove('hidden');
            demoRan = true;
            $demoBtn.hidden = true;
            aeTranscribe('demo_done', {
                chars: (data.text || '').length,
                hadBrowser: mine ? 1 : 0,
                engine: data.engine || '',
            });
            /* The comparison IS the argument, so the offer belongs right after
               it — and only after, so the number on screen is theirs. */
            offerServerLane('demo', STR.server_upsell_demo || STR.server_upsell_body || '');
        } catch (e) {
            aeTranscribe('demo_failed', { msg: (e && e.message || '').slice(0, 60) });
            showToast(STR.demo_failed || STR.error_generic || '', 'error');
            $demoBtn.disabled = false;
            $demoBtn.textContent = label;
        } finally {
            demoBusy = false;
        }
    }
    function hideUpsell() { if ($upsell) $upsell.classList.add('hidden'); }

    /* Drop Whisper's non-speech annotation segments ("[музыка]", "[Music]",
       "ТРЕВОЖНАЯ МУЗЫКА", subtitle-credit hallucinations) from
       transcriptSegments, and be honest with the user about what happened.
       Runs after BOTH engines' ingestion (browser Whisper + server
       whisper.cpp) — a music-heavy file previously rendered as a wall of
       "[музыка] [музыка]…" which a paying user read as a scam (#894).
       Returns the filter counts for telemetry. */
    var nonSpeechNotice = null;   /* {empty:bool, n:int} → picked up by showCompletionToast */
    /* Collapse degenerate repetition (comment #864 — "the the the…"): the
       worker's in-window n-gram guard can't see ACROSS windows, and a
       wrong-language decode emits the same junk word/segment in window after
       window. Two collapses, both conservative so legitimate speech repeats
       ("да, да", chorus lines) survive:
         • ≥8 consecutive identical words inside a segment → keep 2;
         • ≥3 consecutive identical whole segments → keep 1.
       Returns how much was removed so the caller can be honest about it. */
    function collapseRepetition(segs) {
        var wordsCut = 0, segsCut = 0, charsCut = 0, i, out = [];
        for (i = 0; i < segs.length; i++) {
            var t = String(segs[i].text || '');
            var collapsed = t.replace(/(\S{1,24})((?:[\s,]+\1){7,})(?=[\s,]|$)/gi, function (m, w, tail) {
                wordsCut += tail.split(/[\s,]+/).filter(Boolean).length - 1;
                return w + ' ' + w;
            });
            /* A collapsed decode repeats ONE CHARACTER with no separators at
               all ("!" × 445 — the whole 448-token window spent on Whisper
               token 0). The rule above is word-based, so `\S{1,24}` never
               matched it and the wall passed through untouched — measured on
               the text from support case #2680: 915 chars in, 915 chars out,
               nothing cut. Runs this long are not writing in any language, and
               collapsing them here also repairs transcripts that were already
               written to a resume checkpoint before the tripwire existed. */
            collapsed = collapsed.replace(/(\S)\1{23,}/g, function (m, ch) {
                charsCut += m.length - 3;
                return ch + ch + ch;
            });
            segs[i] = Object.assign({}, segs[i], { text: collapsed });
        }
        var runStart = 0;
        for (i = 1; i <= segs.length; i++) {
            var same = i < segs.length
                && String(segs[i].text || '').trim() !== ''
                && String(segs[i].text || '').trim() === String(segs[runStart].text || '').trim();
            if (!same) {
                var runLen = i - runStart;
                if (runLen >= 3) { out.push(segs[runStart]); segsCut += runLen - 1; }
                else { for (var k = runStart; k < i; k++) out.push(segs[k]); }
                runStart = i;
            }
        }
        return { segs: out, wordsCut: wordsCut, segsCut: segsCut, charsCut: charsCut };
    }

    function applyNonSpeechFilter(engine) {
        nonSpeechNotice = null;
        var F = window.WhisperNonSpeech;
        var r = F ? F.filter(transcriptSegments, function (s) { return s.text; })
                  : { dropped: 0, kept: transcriptSegments };
        if (r.dropped) {
            transcriptSegments = r.kept;
            aeTranscribe('nonspeech_filtered', { dropped: r.dropped, kept: r.kept.length, engine: engine });
        }
        var rc = collapseRepetition(transcriptSegments);
        if (rc.wordsCut + rc.segsCut + rc.charsCut > 0) {
            transcriptSegments = rc.segs;
            aeTranscribe('repetition_collapsed', { words: rc.wordsCut, segs: rc.segsCut, chars: rc.charsCut, engine: engine, lang: ($lang && $lang.value) || '' });
            /* Heavy garbage = the decode itself went wrong (usually language
               misdetection on a small model) — say so honestly with a way out.
               A character wall counts as heavy on its own: one collapsed window
               is already a broken decode, not a stylistic repeat. */
            if (rc.wordsCut + rc.segsCut >= 12 || rc.charsCut > 0) {
                showToast(STR.repetition_notice || 'Part of the audio was not recognised clearly — try a more accurate model, or set the language manually.', 'warning');
            }
        }
        /* The worker judged the FINISHED run degenerate and had no re-run left
           to try (it was already on the reliable backend). Say so — the same
           honest wording, because it is the same truth: this decode did not
           work and the way out is a different model or an explicit language. */
        if (degenerateFinal) {
            showToast(STR.repetition_notice || 'Part of the audio was not recognised clearly — try a more accurate model, or set the language manually.', 'warning');
        }
        /* A TRULY EMPTY transcript (whisper found no speech at all) must also
           surface the honest "no speech found" completion notice — otherwise a
           green "Done!" sits over an empty box (the comment-#894 confusion).
           This became common with server VAD (2026-07-05): music/silence now
           yield a genuinely empty result instead of a hallucination wall, so
           there are no dropped fragments to trigger the notice — the emptiness
           itself is the signal. */
        if (!transcriptSegments.length) {
            nonSpeechNotice = { empty: true, n: r.dropped || 0 };
        } else if (r.dropped) {
            nonSpeechNotice = { empty: false, n: r.dropped };
        }
        return r;
    }
    /* Completion toast that tells the truth. A green "Done!" over an empty
       transcript is exactly the confusion that produced comment #894 — if
       the file turned out to be music/noise, say that instead. The single
       #sttToast element means a later toast overwrites an earlier one, so
       the choice has to happen HERE, not as a second toast. */
    function showCompletionToast(doneMsg) {
        if (nonSpeechNotice && nonSpeechNotice.empty) {
            showToast(STR.no_speech_music || STR.error_no_speech, 'warning');
            showMusicDoor(nonSpeechNotice.n);
        } else if (nonSpeechNotice) {
            showToast((STR.music_segments_skipped || '{n} non-speech fragments skipped')
                .replace('{n}', nonSpeechNotice.n), 'info');
        } else {
            showToast(doneMsg, 'success');
        }
        nonSpeechNotice = null;
    }

    /* A FILE that came out as music only — the door to «Текст песни из аудио»
       (#sttMusicDoor, /audio-to-text markup only) carrying the same file through
       tool-handoff.js. The toast alone said «слова песен поверх музыки
       распознаются плохо» and ended there: RU 20 days to 29.10, 102 sessions got
       an empty result with only music/noise dropped, and the July thread #906
       («[музыка] [музыка]…») is exactly a song. The wording says «если это
       песня» — silence and noise land here too. The door is not in the result
       note: an empty result leaves #sttTranscriptSection hidden, so the note is
       invisible (stand, 29.10). carry() is wired on first show, not at load:
       tool-handoff.js is deferred and its stub has no carry() until then; it
       reads currentFile at the tap, so a later file goes, not the first one. */
    var musicDoorWired = false;
    function showMusicDoor(n) {
        var box = document.getElementById('sttMusicDoor');
        var a = document.getElementById('sttMusicDoorGo');
        if (!box || !a || !currentFile) return;
        box.hidden = false;
        if (!musicDoorWired && window.__toolHandoff && window.__toolHandoff.carry) {
            musicDoorWired = true;
            window.__toolHandoff.carry(a, function () {
                var f = currentFile;
                return f ? { size: f.size, type: f.type || '', filename: f.name || 'audio', make: function () { return f; } } : null;
            });
            a.addEventListener('click', function () {
                aeTranscribe('music_door_click', { mb: currentFile ? Math.round(currentFile.size / 1048576) : 0 });
            });
        }
        aeTranscribe('music_door_shown', { dropped: n || 0 });
    }
    function hideMusicDoor() {
        var box = document.getElementById('sttMusicDoor');
        if (box) box.hidden = true;
    }

    function renderServerResult(result) {
        /* Метки говорящих запрошены, но диаризация не справилась — сказать
           честно, а не отдать «просто транскрипт» без объяснения (#27969). */
        /* Один голос там, где просили различить: для монолога это правда, для
           беседы похожих голосов — молчаливая ошибка. Сообщаем нейтрально:
           утверждать «мы не справились» тоже нельзя — запись МОЖЕТ быть
           монологом, и мы этого не знаем. */
        hideResultNote();
        if (result && result.speakerSingle) {
            showResultNote(escHtml(STR.speakers_single || ''));
            try { aeTranscribe('server_diarize_single', {}); } catch (_) {}
        }
        if (result && result.speakerFailed) {
            /* Persistent, not a toast: the person may return from the "ready"
               e-mail an hour later and must still see why there are no labels,
               and what to do (name the number of participants and rerun). */
            showResultNote(escHtml(STR.speakers_failed || 'Could not tell the speakers apart on this recording — the transcript is delivered without labels.')
                + ' ' + escHtml(STR.speakers_failed_hint || ''));
            try { aeTranscribe('server_diarize_failed', {}); } catch (_) {}
        }
        /* speaker_NN → «Говорящий 1, 2, …» in the order people first speak — the
           same shape the browser lane writes, so the transcript view, the
           SRT/VTT/DOCX exports and the dialogue module see ONE thing whichever
           lane produced it. NOT the engine's own number + 1: after the fragment
           filter the two voices of a phone call could survive as speaker_22 and
           speaker_36 and read «Говорящий 23 / Говорящий 37» — «it found 37
           people» (support, 19.10.2026). The server renumbers new results too
           (App\Support\SpeakerOrder); this covers jobs finished before that. */
        var spkOrder = {}, spkSeen = 0;
        transcriptSegments = (result.segments || []).map(function (s) {
            var who = null;
            if (s.speaker) {
                var raw = String(s.speaker);
                if (/^speaker[_\s-]?\d+$/i.test(raw)) {
                    if (!(raw in spkOrder)) spkOrder[raw] = spkSeen++;
                    who = spkLabel(spkOrder[raw]);
                } else {
                    who = raw;
                }
            }
            return { text: (s.text || '').trim(), timestamp: s.timestamp || 0,
                     end: (typeof s.end === 'number') ? s.end : null, isFinal: true,
                     speaker: who };
        });
        /* Число людей не назвали — оно угадано на слух, и на записях звонков
           угадывается с лишними (19.10.2026: разговоры двоих → 4–9 «говорящих»).
           Сказать об этом и дать выход здесь же, а не оставить человека
           переименовывать девять меток: лишних объединяет одно имя в панели
           «Кто говорит», а в следующий раз — число заранее. */
        if (result && typeof result.speakersHint === 'number' && result.speakersHint < 2
            && !result.speakerFailed && !result.speakerSingle && spkSeen >= 3 && STR.speakers_guessed) {
            showResultNote(escHtml(STR.speakers_guessed.replace('{n}', spkSeen)));
            try { aeTranscribe('server_diarize_guessed', { voices: spkSeen }); } catch (_) {}
        }
        if (result.speakerCount > 1) {
            aeTranscribe('diarized', { speakers: result.speakerCount, segs: transcriptSegments.length, src: 'server' });
        }
        if (!transcriptSegments.length && result.text) {
            transcriptSegments = [{ text: result.text.trim(), timestamp: 0, isFinal: true }];
        }
        applyNonSpeechFilter('server');
        showDetectedLang(result.detectedLang);
        finalTranscript = transcriptSegments.map(function (s) { return s.text; }).join(' ');
        userHasEdited = false;
        renderFileTranscript();
        updateStats();
        generateWordCloud(true);
        saveToHistory();
        $transcript.classList.add('stt-done');
        setTimeout(function () { $transcript.classList.remove('stt-done'); }, 1600);
    }

    function serverFinish(ok, err, retryable) {
        clearTimeout(serverPollTimer); serverPollTimer = null; serverPollNow = null;
        try { localStorage.removeItem(SERVER_JOB_LS_KEY); } catch (_) {}
        serverJobId = null;
        serverQueuedSince = 0;
        isTranscribing = false;
        stopProgressTimer();
        updateFileUI();
        if (ok) {
            updateProgress(STR.done, 100);
            setTimeout(function () { $progress.classList.add('hidden'); }, 1500);
            showCompletionToast(STR.server_done || STR.done);
            revealAiButtons();
            reportRunOutcome('ok', { lane: 'server' });
            aeTranscribe('server_transcribe_done');
            try { window.__aeToolComplete(); } catch (_) {}
            /* NOT counted against the free daily counter: a server run is paid for
               in minutes and tokens (settled server-side in TranscribeAudioJob).
               Billing it here too would charge the same work twice, in two
               different currencies, and wall a paying user at the free ceiling. */
            refreshAsrBalance();
        } else {
            $progress.classList.add('hidden');
            /* Honest copy for known failure shapes instead of the generic toast:
               'too_long' = the job-level duration backstop; 'exceeded the timeout'
               = the whisper process budget ran out (should be prevented by the
               upload gate — kept as the last-line message, comment #925). */
            if (err === 'too_long' || /exceeded the timeout/i.test(err || '')) {
                showError(tooLongMessage('?', Math.round(serverModelCapSec(serverModel) / 60) || 240, null));
            } else if (/^openai_/.test(err || '')) {
                /* The OpenAI lane failed mid-run (no answer, refused account): the
                   tokens are back (the job settles a failure as no charge), and
                   our own engines still work — say both. */
                showError(STR.asr_openai_failed || STR.server_failed_retry || STR.server_failed);
                aeTranscribe('server_openai_failed', { kind: (err || '').split(':')[0] });
            } else if (err === 'not_found') {
                /* The job row is gone: either its collect window closed (the
                   result WAS produced — we just no longer hold it) or the id
                   belongs to another account. Silence here was the whole of
                   support case 2026-08-01 ("вылетела обработка") — a Pro user
                   watched the progress panel vanish with no message, twice,
                   and re-uploaded a 112 MB file over mobile to get it back.
                   Say what happened and give the one action that works. */
                showWarning(STR.server_expired || STR.server_failed, { canRetry: false, showFileLink: false });
            } else if (err) {
                /* ⚠️⚠️ «Попробуйте обработку в браузере» — совет, а не текст, и
                   он обязан быть выполнимым. Для 35-минутной записи на телефоне
                   это не запасной путь, а тупик: замер бакета mob/gpu/small даёт
                   медиану 2.39× реального времени, то есть 85 минут против 105
                   СЕКУНД на нашем сервере. Хуже того, человек следует совету,
                   переключатель лейна пишется в localStorage — и остаётся там
                   после того, как серверный лейн починен. Ровно так и был
                   потерян день Премиум-аккаунта 27–28.08.
                   Поэтому браузер предлагается, только когда он действительно
                   справится; иначе честнее позвать повторить. */
                var _brMin = serverAudioDur
                    ? gateWaitMinutes(serverAudioDur, ($model && $model.value) || 'base', caps) : 0;
                var _browserViable = (_brMin > 0 && _brMin <= 15);
                if (retryable === false) {
                    /* Отказ НАШЕГО конвейера на этом файле детерминирован: сервер
                       так и сказал (status.retryable=false). Звать повторить —
                       ложь, которая стоит человеку ещё одной загрузки: 04–05.09
                       один и тот же файл был отправлен 11 раз, 128 МБ с телефона
                       трижды, и каждый раз ответ был «попробуйте ещё раз». */
                    showError(STR.server_failed_internal || STR.server_failed_retry || STR.server_failed
                        || STR.error_model_load);
                    aeTranscribe('server_failed_advice', { browserMin: _brMin, viable: _browserViable ? 1 : 0, internal: 1 });
                } else {
                showError((_browserViable ? STR.server_failed : (STR.server_failed_retry || STR.server_failed))
                    || STR.error_model_load);
                aeTranscribe('server_failed_advice', { browserMin: _brMin, viable: _browserViable ? 1 : 0 });
                }
            }
            reportRunOutcome('failed', { lane: 'server', stage: 'poll' });
            aeTranscribe('server_transcribe_failed', { stage: 'poll', msg: (err || '').slice(0, 80) });
        }
    }

    /* Честность хранения (Фарид 2026-08-05, «как у лучших»): после готовности
       серверной расшифровки показываем, до какого ЧАСА живёт копия на сервере
       (24 ч, viewer-локальное время), и кнопку удалить её сейчас. Аудио к этому
       моменту уже стёрто джобом — речь только о тексте; текст в редакторе
       остаётся у пользователя. */
    function showServerRetention(jobId, keptUntilIso, tookSec) {
        var host = document.getElementById('sttServerKeep');
        if (!host) {
            host = document.createElement('div');
            host.id = 'sttServerKeep';
            host.style.cssText = 'margin:10px 0 0;font-size:12.5px;color:var(--text-muted);display:flex;gap:10px;align-items:center;flex-wrap:wrap;';
            var anchor = document.getElementById('sttTranscript');
            if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(host, anchor.nextSibling);
            else return;
        }
        var when = '';
        try {
            var dt = keptUntilIso ? new Date(keptUntilIso) : null;
            if (dt && !isNaN(dt)) when = dt.toLocaleString([], { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
        } catch (_) {}
        host.innerHTML = '';
        /* How long the server really worked, from its own clock — the page's
           elapsed line cannot know it once the tab has slept (08.10.2026:
           «сколько по факту расшифровывалась — не знаю»; it was 27 min). */
        if (tookSec > 0) {
            var took = document.createElement('span');
            took.className = 'stt-server-took';
            took.textContent = (STR.server_took || 'Transcribed on the server in {took}').replace('{took}', durationText(tookSec));
            host.appendChild(took);
        }
        var span = document.createElement('span');
        span.textContent = (STR.server_kept_until || 'Server copy kept until {time}').replace('{time}', when || '—');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'stt-tool-btn';
        btn.textContent = STR.server_delete_now || 'Delete from server now';
        btn.addEventListener('click', function () {
            btn.disabled = true;
            fetch(CFG.urls.transcribeDelete + '/' + jobId, {
                method: 'POST',
                headers: { 'X-CSRF-TOKEN': (document.querySelector('meta[name=csrf-token]') || {}).content || '', 'Accept': 'application/json' },
            }).then(function (r) { return r.json(); }).then(function (d) {
                if (d && d.success) {
                    host.remove();
                    try { localStorage.removeItem(SERVER_JOB_LS_KEY); } catch (_) {}
                    showToast(STR.server_deleted || 'Server copy deleted. The text stays here — save it.', 'success');
                    aeTranscribe('server_result_deleted', {});
                } else { btn.disabled = false; }
            }).catch(function () { btn.disabled = false; });
        });
        host.appendChild(span);
        host.appendChild(btn);
    }

    function pollServerJob(jobId) {
        clearTimeout(serverPollTimer);
        /* A new watch starts its own queue clock: after a job cancelled while it
           was still queued, the next upload reported the cancelled job's wait. */
        serverQueuedSince = 0; serverAheadMax = 0;
        var statusUrl = (__serverAsr.statusUrl || '').replace(/\/0$/, '/' + jobId);
        /* One request at a time: the visibility handler may ask while a tick's
           request is still out, and two chains would each schedule the next. */
        var inFlight = false;
        var tick = function () {
            if (inFlight) return;
            inFlight = true;
            fetch(statusUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
                .then(function (r) { return r.json().catch(function () { return null; }); })
                .then(function (d) {
                    inFlight = false;
                    elapsedHeld = false;
                    if (!d || !d.success) { serverFinish(false, (d && d.error) || 'not_found'); return; }
                    if (d.status === 'done' && d.result) {
                        /* Задача, начатая на этой странице, уже назвала документ
                           своим файлом; вернувшаяся по ссылке из письма или после
                           перезагрузки — берёт имя записи из библиотеки, иначе
                           Word выходил «расшифровка <сегодня>». */
                        adoptDocument({ src: exportSourceName || d.title || '', dur: d.duration_sec || exportDurationSec,
                                        lib: d.transcript_id || null, size: docSize });
                        renderServerResult(d.result); showServerRetention(jobId, d.kept_until, d.took_sec); serverFinish(true); return;
                    }
                    if (d.status === 'error') { serverFinish(false, d.error, d.retryable !== false); return; }
                    var srvLabel = d.status === 'queued' ? (STR.server_queued || 'Queued…') : (STR.server_processing || 'Processing on server…');
                    var srvPct = d.status === 'queued' ? 15 : 55;
                    /* The speaker pass is the larger half of a labelled job, and its
                       own line («Определяем говорящих: N%») was never seen: it was
                       painted first and replaced by the generic label a few lines
                       further down in the same tick. It IS the label while it runs. */
                    var srvDiarizing = d.status === 'processing' && d.diarize_progress != null;
                    if (srvDiarizing) {
                        srvLabel = (STR.diarize_progress || 'Определяем говорящих: {p}%').replace('{p}', d.diarize_progress);
                        srvPct = 80 + Math.min(19, Math.round(d.diarize_progress / 5));
                    }
                    /* Position + ETA. A job waits only for jobs of its own lane
                       (short / mid / long — the server sorts by work, and each
                       lane has a worker of its own). Inside a lane Premium goes
                       first (decided 24.10.2026), so the only overtaking is a
                       Premium job passing an ordinary one — and then the line
                       says so, instead of a place that went back for no reason.
                       The minutes can tick up a little when a lighter job starts
                       beside this one: the lanes share the processor. */
                    var srvWaits = !!(d.queue && d.status === 'queued' && d.queue.ahead > 0);
                    if (srvWaits) {
                        srvLabel = (STR.server_queue_pos || 'In queue: {n}')
                            .replace('{n}', d.queue.position);
                        if (d.queue.premium_ahead > 0 && STR.server_queue_premium) {
                            srvLabel += ' · ' + STR.server_queue_premium;
                        }
                    }
                    if (d.queue && d.queue.eta_sec > 0) {
                        srvLabel += ' · ' + (STR.server_eta || '~{min} min')
                            .replace('{min}', Math.max(1, Math.round(d.queue.eta_sec / 60)));
                    }
                    /* Standing in a queue is the moment to say the tab may go:
                       05.10.2026 a two-minute file waited 67 minutes with the
                       page reopened twelve times. The "processing" label has
                       always said so; the "queued" one never did. */
                    if (srvWaits && STR.server_queue_leave) {
                        srvLabel += '. ' + STR.server_queue_leave;
                    }
                    /* How long this job stood in the queue, once, when it starts —
                       the wait is the thing the lanes exist to remove, and until
                       now nothing on the client measured it. */
                    if (d.status === 'processing' && serverQueuedSince) {
                        aeTranscribe('server_queue_wait', {
                            sec: Math.round((Date.now() - serverQueuedSince) / 1000),
                            ahead: serverAheadMax,
                        });
                        serverQueuedSince = 0;
                    } else if (d.status === 'queued') {
                        if (!serverQueuedSince) { serverQueuedSince = Date.now(); serverAheadMax = 0; }
                        if (d.queue && d.queue.ahead > serverAheadMax) serverAheadMax = d.queue.ahead;
                    }
                    if (!srvDiarizing && d.progress && /^\d+\/\d+$/.test(d.progress)) {
                        srvLabel += ' · ' + d.progress;   /* chunked long file: real "part N of M" */
                        var pp = d.progress.split('/');
                        srvPct = Math.max(20, Math.min(90, Math.round((+pp[0] / +pp[1]) * 100)));
                    }
                    updateProgress(srvLabel, srvPct);
                    serverPollTimer = setTimeout(tick, 4000);
                })
                .catch(function (e) { inFlight = false; serverPollTimer = setTimeout(tick, 6000); /* transient network — keep polling */ });
        };
        serverPollNow = tick;
        tick();
    }

    /* Back from the background — a phone that slept while the server worked.
       Ask the server NOW instead of at the next tick, and keep the elapsed line
       off until it answers: 08.10.2026 Екатерина woke the phone at 07:45 to
       «идёт 445:12» for a job that had finished at 00:48 (27 min of work). */
    function serverPollOnReturn() {
        if (document.visibilityState !== 'visible' || !serverJobId || typeof serverPollNow !== 'function') return;
        elapsedHeld = true;
        if ($progressTime) $progressTime.textContent = '';
        clearTimeout(serverPollTimer);
        serverPollNow();
    }
    document.addEventListener('visibilitychange', serverPollOnReturn);
    window.addEventListener('pageshow', function (e) { if (e && e.persisted) serverPollOnReturn(); });

    /* Compose the honest too-long message: base sentence + what to DO about it
       (a mode that fits, or split the file when nothing fits). */
    function tooLongMessage(minutes, capMin, altKey, reason) {
        /* A TIER ceiling and a MODEL ceiling need different sentences. Telling a
           free user to «pick another quality» for a 40-minute file sends them
           round a loop in which every option is also capped at five minutes —
           the honest answer is that length is what Premium sells. */
        /* NOT `error_too_long_tier` — that key already belongs to the anonymous
           browser cap and says «log in to transcribe any length». This user IS
           logged in; repeating it would send them to a door they are already
           through. */
        if (reason === 'tier_file_cap') {
            return ((STR.error_too_long_plan || 'Recordings up to {cap} min run here; yours is {min} min.')
                .replace('{min}', minutes).replace('{cap}', capMin)).trim();
        }
        var msg = (STR.error_too_long_server || 'Too long for server processing ({min}/{cap} min).')
            .replace('{min}', minutes).replace('{cap}', capMin);
        var altCap = altKey ? Math.round(serverModelCapSec(altKey) / 60) : 0;
        msg += ' ' + (altCap ? (STR.error_too_long_alt || '').replace('{altcap}', altCap)
                             : (STR.error_too_long_split || ''));
        return msg.trim();
    }

    /* Keep the local view of the wallet honest after every server answer, so the
       "N minutes left" hint never shows a number the server has already spent. */
    function asrSyncBalance(d) {
        if (!d) return;
        if (typeof d.free_left === 'number') __serverAsr.freeLeft = d.free_left;
        if (typeof d.free_cap === 'number') __serverAsr.freeCap = d.free_cap;
        if (typeof d.tokens_have === 'number') {
            /* A refusal for the paid model reports ITS pool, not the lane's. */
            var _pm = d.model ? serverModelByKey(d.model) : null;
            if (_pm && _pm.paid) __serverAsr.tokensPaid = d.tokens_have;
            else __serverAsr.tokens = d.tokens_have;
        }
        renderAsrQuota();
    }
    /* After a delivered transcript the minutes are spent — but the exact figure
       lives server-side (the job settles on the MEASURED duration, which can be
       lower than the quote). Subtract optimistically so the hint moves at once;
       the next server answer corrects it. */
    function refreshAsrBalance() {
        if (typeof serverAudioDur === 'number' && serverAudioDur > 0) {
            var spent = Math.max(1, Math.ceil(serverAudioDur / 60));
            __serverAsr.freeLeft = Math.max(0, (__serverAsr.freeLeft | 0) - spent);
        }
        renderAsrQuota();
    }
    /* «1 ноября» на языке страницы. Дата приходит календарной (Y-m-d, UTC) и
       так же показывается — без сдвига в часовой пояс читателя. */
    function asrResetDate() {
        var d = __serverAsr.freeResetsOn;
        if (!d) return '';
        try {
            return new Date(d + 'T00:00:00Z').toLocaleDateString(
                window.__intlLocale ? window.__intlLocale() : undefined,
                { day: 'numeric', month: 'long', timeZone: 'UTC' });
        } catch (_) { return d; }
    }
    function renderAsrQuota() {
        var el = document.getElementById('sttQuotaHint');
        /* Nothing is metered while the ladder is off — a hint would be inventing a
           number the account cannot spend down. */
        var paidM = serverModel ? serverModelByKey(serverModel) : null;
        if (!(paidM && paidM.paid)) paidM = null;
        if (!el || !asrServerAllowed() || !(__serverAsr.ladder || paidM)) return;
        var left = __serverAsr.freeLeft | 0, cap = __serverAsr.freeCap | 0;
        /* The paid model spends no free minutes: its hint is its rate. */
        if (paidM) {
            left = 0;
            el.textContent = (STR.server_rate_hint || '{rate} tokens/min').replace('{rate}', paidM.rate || '');
        } else if (cap > 0) {
            /* ⭐ Когда минуты вернутся и куда ушли — прямо здесь. Обращение
               19.10.2026: «где отслеживать счётчик минут и дату обновления?» —
               счётчик был, а даты и расхода не было нигде, и «0 из 600» читалось
               как поломка. Норма — календарный месяц, не дата оплаты. */
            var base = left > 0
                ? (STR.server_free_left || '{n}/{cap} min this month').replace('{n}', left).replace('{cap}', cap)
                : (STR.server_free_out || STR.server_free_left || '').replace('{n}', 0).replace('{cap}', cap);
            var html = escHtml(base);
            var on = asrResetDate();
            if (on && STR.server_free_resets) html += ' · ' + escHtml(STR.server_free_resets.replace('{date}', on));
            if (__serverAsr.minutesUrl && STR.server_minutes_link) {
                html += ' · <a href="' + escHtml(__serverAsr.minutesUrl) + '">' + escHtml(STR.server_minutes_link) + '</a>';
            }
            el.innerHTML = html;
        } else {
            /* Tokens alone answered nothing («непонятно как токены соотносятся с
               минутами», 2026-09-04): the rate is shown as tokens AND roubles per
               minute of recording whenever the page knows the token price. */
            var rateT = __serverAsr.ratePerMin || 17;
            var rateR = (__serverAsr.rubPerToken || 0) * rateT;
            el.textContent = (rateR > 0 && STR.server_rate_hint_rub)
                ? STR.server_rate_hint_rub.replace('{rate}', rateT).replace('{rub}', rateR < 10 ? rateR.toFixed(1).replace('.', ',') : Math.round(rateR))
                : (STR.server_rate_hint || '{rate} tokens/min').replace('{rate}', rateT);
        }

        /* ⭐ Во что обойдётся ИМЕННО ЭТОТ файл — до нажатия, а не после отказа.
           Просьба Фарида 2026-08-13 по следам той же жалобы у разбора диалога:
           там человек узнавал цену, только получив отказ. Все числа у страницы
           уже есть (остаток нормы, ставка за минуту, баланс, ссылка в кассу) —
           не хватало ровно показа.
           ⚠️ Длительность известна ДО отправки: мы её измеряем. Значит и цена
           известна точно, а не приблизительно. */
        var costEl = document.getElementById('sttRunCost');
        if (costEl) {
            var dur = Math.ceil((serverAudioDur || 0) / 60);
            if (dur > 0) {
                var payMin = Math.max(0, dur - left);
                if (payMin <= 0) {
                    costEl.innerHTML = escHtml((STR.cost_free_only || 'Спишется {n} мин из нормы')
                        .replace('{n}', dur));
                    costEl.classList.remove('stt-cost--short');
                } else {
                    var rate = paidM ? (paidM.rate || 1) : (__serverAsr.ratePerMin || 17);
                    var mult = __serverAsr.isPro ? (1 - (__serverAsr.proDiscount || 0)) : 1;
                    var need = Math.max(1, Math.ceil(payMin * rate * mult));
                    /* Its own pool: the signup grant does not fund the paid model. */
                    var have = paidM ? (__serverAsr.tokensPaid | 0) : (__serverAsr.tokens | 0);
                    var txt  = paidM
                        ? (STR.cost_paid || '{tok} tokens for {n} min').replace('{tok}', need.toLocaleString()).replace('{n}', dur)
                        : (STR.cost_mixed || '{free} мин из нормы + {tok} токенов')
                            .replace('{free}', Math.min(dur, left)).replace('{tok}', need.toLocaleString());

                    /* Roubles only for the rouble shop: the paid model lives on the
                       intl domain, where tokens are bought in other currencies. */
                    var rub = paidM ? 0 : (__serverAsr.rubPerToken || 0) * need;
                    if (rub > 0) {
                        txt += ' ' + (STR.cost_rub || '≈ {n} ₽')
                            .replace('{n}', rub < 10 ? rub.toFixed(1).replace('.', ',') : Math.round(rub));
                    }

                    /* Нехватка видна ЗАРАНЕЕ, вместе со ссылкой в кассу. Ссылка
                       в новой вкладке: уход отсюда потерял бы выбранный файл. */
                    if (need > have) {
                        txt += ' — ' + (STR.cost_short || 'не хватает {n}')
                            .replace('{n}', (need - have).toLocaleString());
                        costEl.classList.add('stt-cost--short');
                    } else {
                        costEl.classList.remove('stt-cost--short');
                    }

                    costEl.innerHTML = escHtml(txt) + ((need > have && __serverAsr.topupUrl)
                        ? ' <a href="' + escHtml(__serverAsr.topupUrl) + '" target="_blank" rel="noopener">'
                          + escHtml(STR.topup || '') + '</a>' : '');
                }
                costEl.hidden = false;
            } else {
                costEl.hidden = true;
            }
        }

        el.hidden = false;
    }

    /* Video in → audio out, BEFORE the upload.
       A one-hour phone video is 2–3 GB, of which the ~30 MB audio track is the
       only part transcription needs. Sending the whole container is why a 500 MB
       ceiling read as "your file is too big" on files whose AUDIO was tiny — the
       limit was never really about length. FFmpegProcessor streams File inputs
       through WORKERFS (ffmpeg-auto-guard.js), so the video is read lazily off
       disk via File.slice() and never has to fit in WASM memory.

       Phone video first (08.10.2026, Екатерина: «текст можно получить только из
       аудио?» — she was extracting the sound with /extract-audio by hand): AAC
       in mp4/mov is repackaged by MediaAudioTrack — the moov of the sound alone,
       the samples are slices of the picked file — in milliseconds and without
       the 30 MB FFmpeg download. Everything else: stream-copy into Matroska (no
       re-encode, seconds rather than minutes); if the codec will not sit there,
       the WAV 16 kHz mono path this page already uses for the browser lane.
       The extracted file is named after the recording: the server titles the
       transcript and the «ready» email from the upload's name, and until this
       change 92 of 924 transcripts in the library read «audio.mka».

       The video itself travels only when the browser could not take the sound
       out AND it fits the POST ceiling — the server's ffmpeg has the last word,
       and the progress line says the whole file is going. Above the ceiling,
       nothing is uploaded (it would die as a bare 413 after the whole upload).

       → { file, mode } to upload, or { refuse: true } — the reason is already
         on the screen. */
    function recordingBase(file) {
        var n = String((file && file.name) || '').replace(/\.[^.\/\\]{1,8}$/, '').trim();
        return n || 'audio';
    }
    function sizeLabel(bytes) {
        var mb = bytes / 1048576, n, unit;
        if (mb >= 1024) { n = Math.round(mb / 102.4) / 10; unit = STR.unit_gb || 'GB'; }
        else { n = mb >= 10 ? Math.round(mb) : Math.max(0.1, Math.round(mb * 10) / 10); unit = STR.unit_mb || 'MB'; }
        var txt;
        try { txt = n.toLocaleString((window.__LOCALE || 'en') + '-u-nu-latn'); } catch (_) { txt = String(n); }
        return txt + ' ' + unit;
    }
    async function extractAudioForUpload(file) {
        if (!file) return { refuse: true };
        var capBytes = (__serverAsr.maxMb || 500) * 1048576;
        /* Already audio and already small enough: nothing to gain, and pulling in
           30 MB of FFmpeg WASM to re-package it would be pure waste. */
        if (/^audio\//.test(file.type || '') && file.size <= capBytes) return { file: file, mode: 'as_is' };

        var t0 = Date.now();
        /* Picked-file ceiling — separate from what may be POSTed. A 2 GB video is
           fine to CHOOSE because only its audio track travels. */
        if (file.size > (__serverAsr.pickMaxMb || 2048) * 1048576) {
            showError((STR.error_file_too_big || '').replace('{cap}', __serverAsr.pickMaxMb || 2048));
            aeTranscribe('server_pick_too_large', { mb: Math.round(file.size / 1048576) });
            return { refuse: true };
        }
        var base = recordingBase(file);
        var isVideo = !!(window.MediaAudioTrack && MediaAudioTrack.isVideoContainer(file));
        function extracted(out, mode) {
            aeTranscribe('server_audio_extracted', {
                mode: mode,
                fromMB: Math.round(file.size / 1048576),
                toMB: Math.round(out.size / 1048576),
                ms: Date.now() - t0,
            });
            if (isVideo) {
                updateProgress((STR.server_extracted || 'Sound separated in the browser: {from} → {to}')
                    .replace('{from}', sizeLabel(file.size)).replace('{to}', sizeLabel(out.size)), 5);
            }
            return { file: out, mode: mode, fromBytes: isVideo ? file.size : 0 };
        }
        updateProgress(STR.server_extracting || STR.processing, 3);
        if (isVideo) try {
            var plan = await MediaAudioTrack.plan(file);
            if (plan.hasAudio === false) {
                showError(STR.error_no_audio_track || 'This video has no sound track — there is nothing to transcribe.');
                aeTranscribe('server_no_audio_track', { fromMB: Math.round(file.size / 1048576) });
                return { refuse: true };
            }
            /* Only the remux lane here: it needs no engine. Any other codec goes
               to the Matroska copy below, which takes every codec as it is —
               the primitive's own fallback re-encodes to AAC, minutes of WASM
               work for nothing the server needs. */
            if (plan.lane === 'remux') {
                var at = await MediaAudioTrack.extract(file, { slug: TOOL_SLUG });
                if (at && at.file && at.file.size > 1000) return extracted(at.file, 'remux');
            }
        } catch (e) {
            if (e && e.code === 'no-audio') {
                showError(STR.error_no_audio_track || 'This video has no sound track — there is nothing to transcribe.');
                aeTranscribe('server_no_audio_track', { fromMB: Math.round(file.size / 1048576) });
                return { refuse: true };
            }
            console.warn('[asr] remux of the sound failed, trying the stream copy:', e && (e.code || e.message));
        }
        /* Uncompressed PCM cannot shrink by a stream copy — the .mka would be the
           whole WAV again, held in the engine's memory (a 1.9 GB WAV past its
           1600 MiB wall), only to fail the upload ceiling. It goes straight to
           the 16 kHz WAV below. */
        var pcmSource = /\.(wav|wave|w64|rf64|aif|aiff|aifc|caf)$/i.test(file.name || '')
            || /^audio\/(x-)?(wav|wave|aiff)$/i.test(file.type || '');
        if (!pcmSource) try {
            if (window.__ensureFFmpeg) await window.__ensureFFmpeg();
            if (!(await FFmpegProcessor.init())) throw new Error('engine');
            /* The engine's ready event paints «Расшифровка аудио..» over the line —
               nothing is being transcribed yet. */
            updateProgress(STR.server_extracting || STR.processing, 4);
            var r = await FFmpegProcessor.process(file, ['-vn', '-sn', '-acodec', 'copy'], 'audio.mka');
            if (r && r.url) URL.revokeObjectURL(r.url);
            if (r && r.blob && r.blob.size > 1000) {
                return extracted(new File([r.blob], base + '.mka', { type: 'audio/x-matroska' }), 'copy');
            }
        } catch (e) {
            console.warn('[asr] stream-copy extract failed, falling back to WAV:', e && e.message);
        }
        try {
            var wav = await extractAudioWithFFmpeg(file);
            if (wav && wav.size > 1000) {
                return extracted(new File([wav], base + '.wav', { type: 'audio/wav' }), 'wav');
            }
        } catch (e) {
            console.warn('[asr] WAV extract failed too:', e && e.message);
        }
        aeTranscribe('server_audio_extract_failed', { fromMB: Math.round(file.size / 1048576), fromVideo: isVideo ? 1 : 0 });
        /* Extraction failed AND the original is past the POST ceiling: uploading it
           would die as a bare nginx 413 that no in-app message can explain. Say so
           here instead — and upload nothing. Until 08.10.2026 the caller fell back
           to the original right after this message, file size notwithstanding. */
        if (file.size > capBytes) {
            showError((STR.error_extract_failed_big || '').replace('{cap}', __serverAsr.maxMb || 500));
            return { refuse: true };
        }
        updateProgress((STR.server_upload_whole || 'Could not separate the sound here — uploading the whole file ({size}), this takes longer')
            .replace('{size}', sizeLabel(file.size)), 5);
        return { file: file, mode: 'original' };
    }

    async function transcribeOnServer(file) {
        if (!file || isTranscribing) return;
        /* Pre-UPLOAD duration gate — never spend minutes uploading a file the
           server is guaranteed to refuse. The handler's ffprobe gate stays
           authoritative; this layer only saves the wasted upload (fail-open:
           unknown duration falls through, +60 s slack near the cap). */
        var mdlNow = serverModel || ((__serverAsr.models || [{}])[0] || {}).key;
        if (mdlNow && !serverModelFits(mdlNow)) {
            var preCap = Math.round(serverModelCapSec(mdlNow) / 60), preAlt = null;
            var pms = __serverAsr.models || [];
            for (var pi = 0; pi < pms.length; pi++) {
                if (pms[pi].key !== mdlNow && serverModelFits(pms[pi].key)) { preAlt = pms[pi].key; break; }
            }
            showError(tooLongMessage(Math.round(serverAudioDur / 60), preCap, preAlt));
            aeTranscribe('server_too_long', { min: Math.round(serverAudioDur / 60), cap: preCap, pre: 1 });
            return;
        }
        isTranscribing = true;
        /* The run owns the transcript surface, as transcribeFile's does. Since
           18.09.2026 every progress write asks jobOwnsSurface(), and this lane
           never claimed it: on a fresh page jobRun stayed -1, so the whole server
           run painted no label at all — no queue place, no ETA, no «можно закрыть
           вкладку», no «часть 2/3», no speakers % — only «идёт 12:34» (proof
           stand 08.10.2026: zero labels through extraction, upload and polls). */
        jobRun = claimTranscript();
        transcriptSegments = []; finalTranscript = ''; $transcript.innerHTML = '';
        adoptDocument({ src: file.name || '', dur: serverAudioDur, size: (!file.__link && file.size) || 0 });
        emitRun('start', { src: file.name || '', lane: 'server' });
        updateFileUI();
        $progress.classList.remove('hidden'); startProgressTimer();
        /* No «В очереди» here: nothing is queued yet — the sound is still being
           separated (video) and the file is still going up. Each step names
           itself below; «queued» comes from the server when it is true. */
        /* ⚠️ Только величины ЭТОЙ области. selectedModel и audioDuration живут во
           вложенной функции браузерного лейна — обращение к ним отсюда это
           ReferenceError на ПЕРВОЙ строке серверной расшифровки (Sentry
           TIMBRICA-FRONTEND-HK, 5 событий у 3 человек за первые часы 03.09):
           кнопка «Расшифровать» на серверном лейне была мёртвой целиком, а
           предупреждение об этой самой ловушке уже стояло в шапке сенсора. */
        markRunStart({ model: 'server', durSec: serverAudioDur, lane: 'server' });
        aeTranscribe('server_transcribe_start', { fileMB: Math.round((file.size || 0) / 1048576) });
        try {
            /* Запись с Яндекс Диска уже лежит на сервере (initDiskLink): отделять
               звук и заливать нечего — в запрос уходит её токен. */
            var prep = file.__link ? { file: file, mode: 'link' } : await extractAudioForUpload(file);
            if (!prep || prep.refuse || !prep.file) throw new Error('extract_refused');
            var upFile = prep.file;
            /* Built per attempt: a FormData whose File part turns out to be
               unreadable cannot be reused, and the revival retry below has to
               send a different body. */
            function buildUploadBody(part) {
                var fd = new FormData();
                if (part.__link) fd.append('link_token', part.__link.token);
                else fd.append('audio', part, part.name || 'audio');
                fd.append('lang', ($lang.value || 'auto').split('-')[0].toLowerCase());
                if (serverModel) fd.append('model', serverModel);
                if ($translateChk && $translateChk.checked) fd.append('task', 'translate');
                /* Имена участников — в ту же подсказку слов: движку они нужны,
                   чтобы писать «Денис», а не «Даниз». Порядок: сперва имена
                   (они важнее), потом термины; общий потолок тот же. */
                var srvGloss = promptWithPeople();
                if (srvGloss) fd.append('prompt', srvGloss.slice(0, 600));
                /* Speaker labels are now a SERVER capability too (sherpa-onnx over the
                   same WAV). Only send the flag when this box can honour it — the
                   handler re-checks, so a stale page cannot promise labels a box
                   without the binary would never produce. */
                if ($diarize && $diarize.checked && __serverAsr.diarize) {
                    fd.append('diarize', '1');
                    /* Число участников, если человек его назвал. Пусто → как прежде,
                       определяем на слух: поле необязательное по замыслу. */
                    var _n = speakersWanted();
                    if (_n >= 2) fd.append('speakers_hint', String(_n));
                }
                return fd;
            }
            var csrf = (document.querySelector('meta[name="csrf-token"]') || {}).content || '';
            /* The recording goes AHEAD, in slices sized by the link
               (window.__uploadFetch → /api/upload-slice): one long POST of it
               is what a phone's uplink loses — RU nginx, 06–07.10.2026: four
               presses in five minutes, each cut after 30–270 s (499/408). */
            /* The upload is minutes on a phone, and the line used to stand still
               on «В очереди на сервере…» the whole time — the queue had not even
               started. It says what goes up and how much of it: «Загружаем звук
               на сервер: 12 из 25 МБ · ~40 с» (active-time ETA, __makeEta). */
            var upEta = (typeof window.__makeEta === 'function') ? window.__makeEta() : null;
            var upT0 = Date.now(), upBytes = 0;
            var upLabel = prep.mode === 'original'
                ? (STR.server_uploading_whole || 'Uploading the file to the server: {sent} of {total}')
                : (STR.server_uploading || 'Uploading the sound to the server: {sent} of {total}');
            /* «Звук отделён: 12 МБ → 0,6 МБ» lives a few milliseconds before the
               upload line replaces it — so the upload line itself names the video
               the sound came out of. */
            if (prep.fromBytes > 0) {
                upLabel += ' ' + (STR.server_uploading_from || '(from a {size} video)').replace('{size}', sizeLabel(prep.fromBytes));
            }
            function uploadProgress(sent, total) {
                if (!(total > 0)) return;
                upBytes = total;
                var frac = Math.max(0, Math.min(1, sent / total));
                var tail = '';
                if (upEta) {
                    var est = upEta.update(frac);
                    if (est && est.etaSec) tail = ' · ' + String(est.text).split(' · ').slice(1).join(' · ');
                }
                updateProgress(upLabel.replace('{sent}', sizeLabel(sent)).replace('{total}', sizeLabel(total)) + tail,
                    5 + Math.round(frac * 5));
            }
            function postUpload(part) {
                var init = {
                    method: 'POST',
                    headers: { 'X-CSRF-TOKEN': csrf, 'X-Requested-With': 'XMLHttpRequest' },
                    credentials: 'same-origin',
                };
                /* Токен записи с Диска — строка, а не файл: ни заливки, ни её полосы. */
                if (part.__link) {
                    init.body = buildUploadBody(part);
                    return fetch(__serverAsr.uploadUrl, init);
                }
                uploadProgress(0, part.size || 0);
                if (upEta) upEta.reset();
                if (typeof window.__uploadFetch === 'function') {
                    return window.__uploadFetch(__serverAsr.uploadUrl, buildUploadBody(part), init, { onProgress: uploadProgress });
                }
                init.body = buildUploadBody(part);
                return fetch(__serverAsr.uploadUrl, init);
            }

            var resp;
            try {
                resp = await postUpload(upFile);
            } catch (netErr) {
                /* ── Dead picker handle, not a dead network ──────────────────
                   `extractAudioForUpload` hands the ORIGINAL File straight
                   through when the input is already audio and small enough —
                   so this is the one lane in the tool that still trusts a
                   picker handle. Everything else reads through FileBytes,
                   whose whole reason for existing is that the handle goes bad
                   (its header: ~100 FILE_LOST/week; Android reclaiming the
                   file, OneDrive/iCloud relocating it, low-memory eviction).
                   When the bytes behind the handle are gone, the browser fails
                   the request BEFORE sending anything, so it looks like a
                   network outage while the connection is perfectly healthy.

                   Reproduced in a real browser 2026-08-17 (picked a file, then
                   deleted it from disk):
                     raw handle   → "Failed to fetch" in 3 ms, 0 bytes sent
                     primed bytes → HTTP 401 in 4114 ms, all 8 MB delivered
                   Support case #2680 is the same shape: 42 ms, 40 MB, nothing
                   uploaded — then the browser lane transcribed the very same
                   file, because IT reads the primed copy.

                   So: retry once from the cache we already hold. Only worth it
                   when we actually sent the raw handle — a body we built
                   ourselves is in RAM already, and its failure IS the network.
                   Costs nothing on the happy path (no extra copy is made). */
                var _isNet = /Failed to fetch|Load failed|NetworkError|network request failed/i
                    .test((netErr && netErr.message) || '');
                /* A remuxed sound is the same handle in disguise: its samples are
                   slices of the picked file (MediaAudioTrack, remux lane), so a
                   dead handle fails it the same way — revive the bytes and take
                   the sound out of the revived copy. */
                var _viaHandle = upFile === file || prep.mode === 'remux';
                if (!_isNet || !_viaHandle || !window.FileBytes || !window.FileBytes.asFile) throw netErr;
                var revived = null;
                try { revived = await window.FileBytes.asFile(file, file.name || 'audio'); } catch (_r) { revived = null; }
                if (revived && revived.size && prep.mode === 'remux') {
                    try { revived = (await MediaAudioTrack.extract(revived, { slug: TOOL_SLUG })).file; }
                    catch (_x) { revived = null; }
                }
                if (!revived || !revived.size) {
                    aeTranscribe('server_upload_revive_failed', { fileMB: Math.round((file.size || 0) / 1048576) });
                    throw netErr;
                }
                aeTranscribe('server_upload_revived', {
                    fileMB: Math.round((file.size || 0) / 1048576),
                    msg: ((netErr && netErr.message) || '').slice(0, 60),
                    mode: prep.mode,
                });
                resp = await postUpload(revived);
            }
            /* What the upload costs people — the reason the sound goes up instead
               of the video, measured instead of assumed. */
            if (upBytes > 0) {
                var upSec = Math.max(0.1, (Date.now() - upT0) / 1000);
                aeTranscribe('server_upload_done', {
                    mb: Math.round(upBytes / 1048576), sec: Math.round(upSec),
                    kbps: Math.round(upBytes * 8 / 1024 / upSec), mode: prep.mode,
                });
            }
            var data = await resp.json().catch(function () { return {}; });
            if (resp.status === 401 || data.error === 'login_required') {
                showError(STR.server_login_required || STR.server_failed);
                aeTranscribe('server_login_required', {});
                throw new Error('login_required');
            }
            if (resp.status === 403 || data.error === 'pro_required') { showServerUpsell(); throw new Error('pro_required'); }
            /* Запись с Диска пролежала на сервере дольше трёх часов или уже ушла
               в работу — взять её снова можно только по ссылке. */
            if (resp.status === 410 || data.error === 'link_expired') {
                showError(STR.link_expired || STR.server_failed);
                aeTranscribe('disk_link_expired', {});
                throw new Error('link_expired');
            }
            /* REAL daily cap: ONLY when the server body says so. A NAKED 429 is a
               transient route rate-limit — Laravel's per-user throttle bucket is
               shared across un-prefixed routes, and a page-load API burst starved
               the upload's budget (proven 2026-07-09; a paying Pro user was shown
               "you've hit the FREE daily limit — get Pro"). Never show limit/upsell
               copy for it — honest "too many requests, wait a minute" instead. */
            /* Not enough minutes — refused BEFORE a second of worker time,
               because ffprobe told the server the duration up front. The old
               shape started the job and let a two-hour file die halfway; this
               says exactly what is missing and what it costs instead. The daily
               `daily_limit` branch is gone with the run counter it belonged to —
               the server lane is metered in minutes now, not runs. */
            /* The paid model refused before any work: not offered here right now,
               not for this language, cannot translate. Named, not «server failed». */
            if (data.error === 'model_unavailable' || data.error === 'model_lang' || data.error === 'model_no_translate') {
                showError((data.error === 'model_lang' ? STR.asr_openai_lang
                    : data.error === 'model_no_translate' ? STR.asr_openai_no_translate
                    : STR.asr_openai_unavailable) || STR.server_failed);
                aeTranscribe('server_model_refused', { why: data.error });
                throw new Error('model_refused');
            }
            /* The paid model's wallet said no for a reason that is NOT «too few
               tokens»: only signup-gift tokens (it does not take them), or the
               whole site's daily ceiling for this lane. */
            if ((resp.status === 402 || data.error === 'quota_exceeded') && (data.obstacle === 'locked' || data.obstacle === 'day_site')) {
                asrSyncBalance(data);
                showError((data.obstacle === 'locked' ? STR.asr_openai_locked : STR.asr_openai_busy) || STR.server_failed);
                aeTranscribe('server_quota_exceeded', { obstacle: data.obstacle, model: data.model || '' });
                throw new Error('quota_exceeded');
            }
            if (resp.status === 402 || data.error === 'quota_exceeded') {
                asrSyncBalance(data);
                var _short = (STR.server_quota_short || 'Not enough minutes: {min} min = {tokens} tokens.')
                    .replace('{min}', data.minutes_billed || 0)
                    .replace('{tokens}', data.tokens_needed || 0)
                    .replace('{short}', data.tokens_short || 0);
                if (__serverAsr.topupUrl) {
                    _short += ' <a href="' + __serverAsr.topupUrl + '" class="stt-topup-link">'
                            + (STR.server_topup || 'Top up') + '</a>';
                }
                showError(_short);
                aeTranscribe('server_quota_exceeded', {
                    min: data.minutes || 0,
                    billed: data.minutes_billed || 0,
                    need: data.tokens_needed || 0,
                    short: data.tokens_short || 0,
                });
                throw new Error('quota_exceeded');
            }
            if (resp.status === 429) {
                showError(STR.error_too_many_requests || STR.server_failed);
                aeTranscribe('server_throttled', {});
                throw new Error('throttled');
            }
            if (resp.status === 413 || data.error === 'too_large') { throw new Error('too_large'); }
            /* Instant per-model duration rejection (upload-time ffprobe) — the
               honest replacement for "queue it, grind for an hour, die on the
               process timeout" (comment #925: two 58-min deaths on 2026-07-04). */
            if (data.error === 'too_long_model') {
                showError(tooLongMessage(data.minutes || '?', data.cap || '?', data.alt || null, data.reason || ''));
                aeTranscribe('server_too_long', { min: data.minutes || 0, cap: data.cap || 0 });
                throw new Error('too_long_model');
            }
            /* Комбинация «длительность × качество × Кто говорил» не влезает в
               бюджет обработки бокса. Честный отказ ЗДЕСЬ, с выходом: без
               диаризации этот же файл может пройти — говорим это, только когда
               это правда (fits_plain с сервера). */
            if (data.error === 'too_long_total') {
                var msg = (STR.asr_too_long_total || 'This recording is too long to process at this quality{diar}. Split the file or pick a faster quality.')
                    .replace('{min}', data.minutes || '?');
                msg = msg.replace('{diar}', data.fits_plain ? (STR.asr_too_long_total_diar || '') : '');
                showError(msg);
                aeTranscribe('server_too_long_total', { min: data.minutes || 0, diar: !!data.diarize, fits_plain: !!data.fits_plain });
                throw new Error('too_long_model');
            }
            if (!resp.ok || !data.job_id) { throw new Error(data.error || 'upload_failed'); }
            /* Метки говорящих выключены из-за длины файла — сказать СРАЗУ,
               а не через три часа обработки (инцидент #27969). */
            if (data.diarize_skipped_too_long) {
                showToast((STR.diarize_too_long || 'Speaker labels are available for recordings up to {max} min on this server — the transcript will be delivered without labels.')
                    .replace('{max}', data.diarize_max_min || '?'), 'warning');
                aeTranscribe('server_diarize_skipped_len', { max: data.diarize_max_min || 0 });
            }
            serverJobId = data.job_id;
            asrSyncBalance(data);
            /* Указатель несёт ВРЕМЯ постановки — без него восстановление не
               отличает «джоб шёл, когда я закрыл вкладку» от «джоб отвалился
               вчера». См. рядом с чтением ключа. */
            try { localStorage.setItem(SERVER_JOB_LS_KEY, serverJobId + ':' + Date.now()); } catch (_) {}
            /* 12, not 40: the bar follows the work — the upload ended at 10, the
               server's own steps (queue 15, processing 20–99) come next. */
            updateProgress(STR.server_processing || 'Processing on server…', 12);
            pollServerJob(serverJobId);
        } catch (e) {
            stopProgressTimer(); $progress.classList.add('hidden'); isTranscribing = false; updateFileUI();
            if (e.message === 'too_large') showError(STR.error_file_too_large || STR.server_failed);
            else if (e.message !== 'pro_required' && e.message !== 'daily_limit' && e.message !== 'throttled' && e.message !== 'too_long_model' && e.message !== 'extract_refused' && e.message !== 'model_refused' && e.message !== 'quota_exceeded' && e.message !== 'link_expired') showError(STR.server_failed || STR.error_model_load);
            reportRunOutcome('failed', { lane: 'server', stage: 'upload' });
            aeTranscribe('server_transcribe_failed', { stage: 'upload', msg: (e.message || '').slice(0, 80) });
        }
    }

    /* ── Pro AI post-processing: summary + translate (server gen-api LLM) ──
       Tested to be etalon-quality + cheap on the server, unlike browser
       translation models. Works on the transcript TEXT, so both browser and
       server transcriptions can use it. */
    var _aiBusy = false, _aiInited = false;
    /* Chrome's built-in AI is a capability of the BROWSER, not of our server:
       where it exists, the summary/translate buttons work for everyone even
       on an instance whose server lane is off. */
    function hasOnDeviceAi(kind) {
        try {
            if (kind === 'translate') return typeof Translator !== 'undefined' && typeof Translator.availability === 'function';
            return typeof Summarizer !== 'undefined' && typeof Summarizer.availability === 'function';
        } catch (_) { return false; }
    }
    function initTranscriptAi() {
        if (_aiInited || mode !== 'file') return;
        var serverAi = (typeof __transcriptAi !== 'undefined' && __transcriptAi && __transcriptAi.enabled);
        if (!serverAi && !hasOnDeviceAi('summarize') && !hasOnDeviceAi('translate')) return;
        _aiInited = true;
        if ($aiTransLang) {
            var seen = {}, html = '';
            for (var i = 0; i < LANGUAGES.length; i++) {
                var base = LANGUAGES[i].code.split('-')[0];
                if (seen[base]) continue; seen[base] = 1;
                html += '<option value="' + base + '">' + langDisplayName(base, LANGUAGES[i].name) + '</option>';
            }
            $aiTransLang.innerHTML = html;
            var ui = (window.__LOCALE || 'en').split('-')[0];
            if ($aiTransLang.querySelector('option[value="' + ui + '"]')) $aiTransLang.value = ui;
        }
        if ($aiSummaryBtn) $aiSummaryBtn.addEventListener('click', function () { runTranscriptAi('summarize'); });
        if ($aiTransBtn)   $aiTransBtn.addEventListener('click', function () { runTranscriptAi('translate'); });
        if ($aiCopy)  $aiCopy.addEventListener('click', function () {
            try { navigator.clipboard.writeText($aiResultBody.textContent || ''); showToast(STR.copied || 'Copied', 'success'); } catch (_) {}
        });
        /* Заголовок, текст и имя файла — ОДИН источник на оба формата. Иначе
           TXT и DOCX однажды разойдутся в мелочи (в одном заголовок есть, в
           другом нет), и никто этого не заметит месяцами. */
        function aiExportParts() {
            var body = ($aiResultBody.textContent || '').trim();
            if (!body) return null;
            /* Заголовок идёт в файл первой строкой: через месяц «summary.txt»
               ничего не скажет, а «Краткое содержание» — скажет. */
            var head = ($aiResultTitle.textContent || '').trim();
            /* Имя от исходной записи, чтобы разбор лежал рядом с ней и
               узнавался. Латиница: не-ASCII в имени ломается у части клиентов. */
            var base = (currentFile && currentFile.name ? currentFile.name : 'transcript')
                .replace(/\.[A-Za-z0-9]{1,5}$/, '')
                .replace(/[^A-Za-z0-9._-]+/g, '_').replace(/^_+|_+$/g, '') || 'transcript';
            return { head: head, body: body, base: base };
        }

        if ($aiDownload) $aiDownload.addEventListener('click', function () {
            var p = aiExportParts();
            if (!p) return;
            var text = p.head ? p.head + '\n\n' + p.body : p.body;
            var blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
            /* Общий примитив, а не <a download>: тот молча не работает во
               встроенных браузерах Android. */
            if (window.__downloadFile) window.__downloadFile(blob, p.base + '_ai.txt');
            aeTranscribe('ai_result_download', { chars: text.length, fmt: 'txt' });
        });

        /* Word. Просьба 2026-08-13: «можно ли скачать ещё в word формате?».
           Берём ОБЩИЙ `docx-writer.js` — тот же, что у разбора диалога. Вторая
           своя сборка .docx стала бы переносчиком уже исправленных ошибок.

           ⚠️ Свой загрузчик здесь НЕ НУЖЕН: сборщик уже подключён на странице
           тегом выше (через light, js/docx-writer.js). Я его сперва добавил, и
           сторож версий поймал — ссылка шла без версии, а Cloudflare держит
           /js полгода как неизменяемый, так что правки сборщика не дошли бы до
           людей. Прежде чем что-то подключать, стоит посмотреть, не подключено
           ли оно уже. */
        if ($aiDocx) $aiDocx.addEventListener('click', function () {
            var p = aiExportParts();
            if (!p) return;
            var busyLabel = $aiDocx.textContent;
            $aiDocx.disabled = true;
            $aiDocx.textContent = '…';

            var ready = window.DocxWriter
                ? Promise.resolve(window.DocxWriter)
                : Promise.reject(new Error('writer missing'));

            ready.then(function (W) {
                /* Абзацы, а не одна простыня: Word без разбиения даёт документ,
                   который невозможно править. Пустые строки исходника — границы. */
                var paras = p.body.split(/\n{2,}/).map(function (t) { return t.trim(); }).filter(Boolean);
                return W.build({
                    title: p.head || (STR.ai_result_title || ''),
                    subtitle: (currentFile && currentFile.name) ? currentFile.name : '',
                    paragraphs: paras,
                });
            }).then(function (blob) {
                if (window.__downloadFile) window.__downloadFile(blob, p.base + '_ai.docx');
                aeTranscribe('ai_result_download', { chars: p.body.length, fmt: 'docx' });
            }).catch(function (e) {
                /* Молчаливый отказ хуже отказа названного: человек нажмёт ещё
                   пять раз, решив, что не попал по кнопке. */
                showToast(STR.export_failed || STR.failed || 'Не удалось собрать файл', 'error');
                aeTranscribe('ai_result_download_failed', { fmt: 'docx', err: String(e).slice(0, 80) });
            }).finally(function () {
                $aiDocx.disabled = false;
                $aiDocx.textContent = busyLabel;
            });
        });
        if ($aiClose) $aiClose.addEventListener('click', function () { $aiResult.classList.add('hidden'); });
    }
    /* Reveal the AI buttons once there's a transcript — for Pro users, and for
       non-Pro where Pro is sold (click → upgrade offer = funnel). */
    function revealAiButtons() {
        revealDialogueButton();
        if (mode !== 'file' || !transcriptSegments.length) return;
        var serverAi = (typeof __transcriptAi !== 'undefined' && __transcriptAi && __transcriptAi.enabled
                        && (__transcriptAi.isPro || __transcriptAi.offer));
        if ($aiSummaryBtn && (serverAi || hasOnDeviceAi('summarize'))) $aiSummaryBtn.hidden = false;
        if ($aiTransWrap  && (serverAi || hasOnDeviceAi('translate'))) $aiTransWrap.hidden = false;
    }

    /* ── Разбор диалога (embedded module) ──────────────────────────────────
       The transcript is already here and already carries per-segment times, so
       the hand-off is the whole integration: we pass the SEGMENTS, not the flat
       text, because the timecodes are what let the analysis put a clickable
       moment on every quote. Everything after that — price, payment, grounding,
       rendering — belongs to the module, which is also what /dialogue-analysis
       runs. There is no second copy of that logic here to drift.

       This is deliberately NOT gated on Pro: it is bought per analysis with
       tokens, so an upsell wall in front of it would be selling the wrong thing. */
    var _dlgSeekBound = false;
    /* Открыть модуль разбора — общий обработчик чипа в панели и CTA-карточки. */
    function openDialogueModule() {
            var wrap = _$('sttDialogueWrap');
            if (wrap) wrap.hidden = false;
            if (!window.__dialogueAnalysis) return;
            bindDialogueSeek();
            /* ⭐ Сегменты ИЛИ простой текст. Модуль принимает и то и другое
               (`payload.text || payload.segments`), а сегменты нужны лишь для
               кликабельных цитат — без них разбор всё равно делается.
               ЗАМЕР 30 дней: в стену «нужен Премиум» упёрлись 118 сессий, а
               предложение бесплатной двери увидели ВОСЕМЬ. Остальные 110 не
               увидели ничего — потому что у них не оказалось сегментов, хотя
               текст был. Дверь была открыта и занавешена. */
            var _segs = dialogueSegments();
            var _txt  = (typeof getPlainTranscript === 'function' ? (getPlainTranscript() || '') : '').trim();
            var _hand = (_segs && _segs.length) ? { segments: _segs } : { text: _txt };
            /* Заседание суда разбирается своим сценарием: ходатайства и чем они
               кончились, что определил суд, позиции, показания, сроки. */
            if (courtState.hearing) _hand.scenario = 'court';
            window.__dialogueAnalysis.set(_hand);
            aeTranscribe('dialogue_handoff', {
                segments: transcriptSegments.length,
                via: (_segs && _segs.length) ? 'segments' : 'text',
            });
            try {
                if (wrap) wrap.scrollIntoView({ block: 'nearest' });
            } catch (_) {}
    }
    /* Route a blocked AI click to the analysis module, which is available to
       everyone. Returns true when it actually did something — the caller falls
       through to the subscription offer otherwise, so a locale where the module
       is not live still gets an answer instead of silence. */
    var dialogueOfferShown = false;
    function offerDialogueInstead() {
        var wrap = _$('sttDialogueWrap');
        /* ⚠️ Требовать САМИ СЕГМЕНТЫ здесь было лишним: разбор делается и по
           простому тексту. Это условие и закрывало дверь 110 людям из 118. */
        var _hasText = (typeof getPlainTranscript === 'function' ? (getPlainTranscript() || '') : '').trim().length > 20;
        if (!wrap || !window.__dialogueAnalysis || (!transcriptSegments.length && !_hasText)) return false;
        openDialogueModule();
        if (!dialogueOfferShown) {
            dialogueOfferShown = true;
            showToast(STR.dialogue_instead_hint || '', 'info');
        }
        aeTranscribe('dialogue_offered_from_ai_lock', { mode: 'ai' });
        return true;
    }
    var dialogueDoorReported = false;
    function revealDialogueButton() {
        var btn = _$('sttDialogueBtn');
        if (!btn) return;                       /* tool not live on this locale */
        /* ⚠️ Требовать САМИ СЕГМЕНТЫ здесь было тем же лишним условием, что
           уже сняли в offerDialogueInstead() («закрывало дверь 110 людям из
           118»): разбор делается и по простому тексту. Там его сняли, здесь
           оно осталось — и прятало ту же дверь этажом выше, у самой кнопки.
           Случаи, когда текст есть, а сегментов нет: фильтр неречевого
           выбросил все (событие nonspeech_filtered), транскрипт восстановлен
           из чекпоинта, человек вставил текст руками. */
        var hasText = (typeof getPlainTranscript === 'function' ? (getPlainTranscript() || '') : '').trim().length > 20;
        btn.hidden = !(mode === 'file' && (transcriptSegments.length > 0 || hasText));
        /* Живой случай 2026-08-05 (Екатерина, телефон): кнопка БЫЛА на
           странице — одним из ~10 одинаковых чипов в панели высотой 246px на
           ширине 316px, ниже экрана. «Не вижу "Разобрать диалог"» — точное
           описание: присутствует, но неотличима. Зрелые сервисы (Otter,
           Fireflies) после готовности транскрипта показывают главное действие
           ОТДЕЛЬНОЙ крупной карточкой над текстом — делаем так же; чип в
           панели остаётся для повторного открытия. */
        var cta = _$('sttDialogueCta');
        if (!btn.hidden && !cta) {
            var toolbar = btn.closest('.stt-toolbar');
            if (toolbar && toolbar.parentNode) {
                cta = document.createElement('button');
                cta.type = 'button';
                cta.id = 'sttDialogueCta';
                cta.className = 'stt-dialogue-cta';
                cta.innerHTML = '&#128209; <b>' + escHtml(STR.dialogue_cta_title || 'Разобрать диалог') + '</b><span>'
                    + escHtml((courtState.hearing && CFG.court && CFG.court.cta_sub) || STR.dialogue_cta_sub || '') + '</span>';
                cta.addEventListener('click', function () {
                    openDialogueModule();
                    cta.remove();   /* карточка сделала своё дело; чип остаётся */
                });
                toolbar.parentNode.insertBefore(cta, toolbar);
            }
        } else if (btn.hidden && cta) {
            cta.remove();
        }
        /* Дверь к платному разбору мерялась только по НАЖАТИЯМ (124 сессии из
           936 с готовым текстом), и по ним нельзя отличить «не захотели» от
           «не увидели». Меряем показ — и не факт создания элемента, а наличие
           у него коробки на следующем кадре: ровно так же, как это пришлось
           сделать со стеной лимита, где show() отрабатывал внутри
           display:none и 442 нажатия ушли в невидимое. Один замер на
           транскрипт, иначе повторные вызовы зальют телеметрию. */
        if (!dialogueDoorReported) {
            dialogueDoorReported = true;
            if (btn.hidden) {
                aeTranscribe('dialogue_cta_absent', {
                    reason: mode !== 'file' ? 'mode' : (hasText ? 'other' : 'no_text'),
                    segs: transcriptSegments.length
                });
            } else {
                var _cta = _$('sttDialogueCta');
                requestAnimationFrame(function () {
                    var r = _cta ? _cta.getBoundingClientRect() : null;
                    aeTranscribe('dialogue_cta_shown', {
                        boxed: (r && r.width > 0 && r.height > 0) ? 1 : 0,
                        card: _cta ? 1 : 0,
                        segs: transcriptSegments.length
                    });
                });
            }
        }
        if (btn.hidden || btn.dataset.bound) return;
        btn.dataset.bound = '1';
        btn.addEventListener('click', openDialogueModule);
    }
    /* Our segments in the module's shape. Paragraph markers are layout, not
       speech — passing them through would put empty "«»" quotes in the protocol. */
    function dialogueSegments() {
        var out = [];
        for (var i = 0; i < transcriptSegments.length; i++) {
            var s = transcriptSegments[i];
            if (!s || s.isParagraph) continue;
            var text = String(s.text || '').trim();
            if (!text) continue;
            var seg = { text: text };
            if (typeof s.timestamp === 'number' && isFinite(s.timestamp)) {
                seg.start = s.timestamp;
                seg.end = (transcriptSegments[i + 1] && typeof transcriptSegments[i + 1].timestamp === 'number')
                    ? transcriptSegments[i + 1].timestamp : s.timestamp;
            }
            if (s.speaker) seg.speaker = s.speaker;
            out.push(seg);
        }
        return out;
    }
    /* The module owns no player, so it asks the host to seek. We have one. */
    function bindDialogueSeek() {
        if (_dlgSeekBound) return;
        _dlgSeekBound = true;
        /* Плеер у страницы один, и движок держит его сам. До 07.10.2026 он
           искался по узлам прежней общей страницы (`sttPlayer`, `.stt-panel
           audio`): после разведения страниц 08.09 таких узлов не стало, и клик
           по таймкоду в платном разборе не делал ничего — молча. */
        window.__dialogueAnalysisSeek = function (sec) {
            var ok = seekTo(sec);
            try { aeTranscribe('dialogue_seek', { ok: ok ? 1 : 0 }); } catch (_) {}
            return ok;
        };
    }
    /* ── On-device AI: Chrome's built-in Summarizer / Translator (stable on
       desktop Chrome since 2026) ────────────────────────────────────────────
       When the browser already holds the model, a summary or a translation
       costs nothing and no server round-trip — so it runs FIRST, for every
       visitor, and the server lane stays the fallback (no API, no model for
       this language, mobile, other browsers). Only an ALREADY available model
       is used: `create()` on a 'downloadable' state pulls gigabytes, and that
       has to be the person's decision, not a side effect of a button. Long
       transcripts are split by paragraph under the model's input quota. */
    function aiSourceLang() {
        var v = ($lang && $lang.value && $lang.value !== 'auto') ? $lang.value : (window.__LOCALE || 'en');
        return String(v).split('-')[0].toLowerCase();
    }
    async function aiSplitForQuota(session, text) {
        var quota = (session && session.inputQuota) || 0;
        if (!quota || typeof session.measureInputUsage !== 'function') return [text];
        var usage = await session.measureInputUsage(text);
        if (usage <= quota) return [text];
        var maxChars = Math.max(400, Math.floor(text.length * (quota / usage) * 0.85));
        var parts = [], cur = '';
        text.split(/\n\n+/).forEach(function (p) {
            if (cur && (cur.length + p.length + 2) > maxChars) { parts.push(cur); cur = ''; }
            while (p.length > maxChars) { parts.push(p.slice(0, maxChars)); p = p.slice(maxChars); }
            cur = cur ? cur + '\n\n' + p : p;
        });
        if (cur) parts.push(cur);
        return parts;
    }
    async function onDeviceAi(modeStr, text, lang) {
        var src = aiSourceLang();
        try {
            if (modeStr === 'summarize') {
                if (typeof Summarizer === 'undefined' || typeof Summarizer.availability !== 'function') return null;
                var sOpts = { type: 'key-points', format: 'plain-text', length: 'medium', outputLanguage: lang, expectedInputLanguages: [src] };
                if ((await Summarizer.availability(sOpts)) !== 'available') return null;
                var s = await Summarizer.create(sOpts);
                var parts = await aiSplitForQuota(s, text), outs = [];
                for (var i = 0; i < parts.length; i++) outs.push(String(await s.summarize(parts[i])).trim());
                try { s.destroy && s.destroy(); } catch (_) {}
                return outs.filter(Boolean).join('\n\n');
            }
            if (modeStr === 'translate') {
                if (typeof Translator === 'undefined' || typeof Translator.availability !== 'function') return null;
                if (src === lang) return null;
                var tOpts = { sourceLanguage: src, targetLanguage: lang };
                if ((await Translator.availability(tOpts)) !== 'available') return null;
                var tr = await Translator.create(tOpts);
                var paras = text.split(/\n\n+/), outT = [];
                for (var j = 0; j < paras.length; j++) outT.push(String(await tr.translate(paras[j])).trim());
                try { tr.destroy && tr.destroy(); } catch (_) {}
                return outT.join('\n\n');
            }
        } catch (e) {
            aeTranscribe('ai_ondevice_failed', { mode: modeStr, msg: String(e && e.message || e).slice(0, 60) });
        }
        return null;
    }

    /* Whose consent the transcript-AI run carries. Not this page's slug: the
       AI route exists once, as tools.audio-to-text.ai, whichever page hosts the
       shared engine, and lane-pay.js remembers consent per lane. */
    var TRANSCRIPT_AI_LANE = 'audio-to-text';

    /* The offer box for a priced refusal — under the result card, made once. */
    function aiPayBox() {
        var box = document.getElementById('swAiPay');
        if (box || !$aiResult || !$aiResult.parentNode) return box;
        box = document.createElement('div');
        box.id = 'swAiPay';
        box.hidden = true;
        box.setAttribute('role', 'status');
        $aiResult.parentNode.insertBefore(box, $aiResult.nextSibling);
        return box;
    }

    async function runTranscriptAi(modeStr) {
        if (_aiBusy) return;
        /* On-device first — for everyone, before the subscription gate. */
        var odText = getPlainTranscript();
        if (odText && odText.trim().length >= 20) {
            var odLang = (modeStr === 'translate') ? ($aiTransLang ? $aiTransLang.value : 'en') : ((window.__LOCALE || 'en').split('-')[0]);
            _aiBusy = true;
            $aiResult.classList.remove('hidden');
            $aiResultTitle.textContent = (modeStr === 'translate')
                ? ((STR.ai_translate || 'Translation') + ' — ' + ($aiTransLang && $aiTransLang.selectedOptions[0] ? $aiTransLang.selectedOptions[0].textContent : odLang))
                : (STR.ai_summary || 'AI summary');
            $aiResultBody.textContent = STR.ai_working || 'Working…';
            var od = null;
            try { od = await onDeviceAi(modeStr, odText, odLang); } finally { _aiBusy = false; }
            if (od) {
                $aiResultBody.textContent = od;
                $aiResultTitle.textContent += ' · ' + (STR.ai_ondevice_note || 'in your browser');
                try { $aiResult.scrollIntoView({ block: 'nearest' }); } catch (_) {}
                aeTranscribe('ai_' + modeStr + '_done', { out: od.length, ondevice: 1 });
                return;
            }
            $aiResult.classList.add('hidden');
        }
        /* No server lane on this instance (or no route): the browser's model was
           the only option and it is not available for this language/state. */
        if (typeof __transcriptAi === 'undefined' || !__transcriptAi || !__transcriptAi.enabled || !__transcriptAi.url) {
            showToast(STR.ai_ondevice_unavailable || 'The browser model is not available for this language.', 'warning');
            aeTranscribe('ai_ondevice_unavailable', { mode: modeStr });
            return;
        }
        /* __isProNow: blade flag freezes false in CF-cached anon HTML (class bug 2026-07-16).
           With a token price (`priced`, 30.10.2026) there is no lock here: the
           server answers a non-Premium run with the price, lane-pay.js shows it. */
        if (!__transcriptAi.priced && !(window.__isProNow ? window.__isProNow(__transcriptAi.isPro) : __transcriptAi.isPro)) {
            aeTranscribe('ai_locked_click', { mode: modeStr });
            /* Two AI features sit next to each other here and only one is behind
               the subscription. Measured over 30 days: 892 sessions get a
               transcript, 167 press this locked button — and 17 open the
               dialogue analysis, which needs no subscription at all and does
               more (a checkable protocol with quotes from their own recording).
               The demand is landing on the wall while the door is open beside
               it. So the lock now points AT the door first, and only then at
               the subscription. */
            if (offerDialogueInstead()) return;
            try { showServerUpsell('ai'); } catch (_) {}
            return;
        }
        var text = getPlainTranscript();
        if (!text || text.trim().length < 20) { showError(STR.error_no_speech || STR.error_model_load); return; }
        _aiBusy = true;
        var lang = (modeStr === 'translate') ? ($aiTransLang ? $aiTransLang.value : 'en') : ((window.__LOCALE || 'en').split('-')[0]);
        var title = (modeStr === 'translate')
            ? ((STR.ai_translate || 'Translation') + ' — ' + ($aiTransLang && $aiTransLang.selectedOptions[0] ? $aiTransLang.selectedOptions[0].textContent : lang))
            : (STR.ai_summary || 'AI summary');
        $aiResult.classList.remove('hidden');
        $aiResultTitle.textContent = title;
        $aiResultBody.textContent = STR.ai_working || 'Working…';
        try { $aiResult.scrollIntoView({ block: 'nearest' }); } catch (_) {}
        aeTranscribe('ai_' + modeStr + '_start', { chars: text.length });
        try {
            var csrf = (document.querySelector('meta[name="csrf-token"]') || {}).content || '';
            var resp = await fetch(__transcriptAi.url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': csrf, 'X-Requested-With': 'XMLHttpRequest' },
                body: JSON.stringify({ mode: modeStr, text: text, lang: lang,
                    pay: (window.__lanePay && window.__lanePay.agreed(TRANSCRIPT_AI_LANE)) ? 'tokens' : undefined }),
                credentials: 'same-origin',
            });
            var data = await resp.json().catch(function () { return {}; });
            /* A priced refusal is an offer, not an error: «Run for N tokens». */
            var payBox = aiPayBox();
            if (payBox && window.__lanePay) window.__lanePay.hide(payBox);
            if (payBox && window.__lanePay && window.__lanePay.show(payBox, data, { slug: TRANSCRIPT_AI_LANE, run: function () { runTranscriptAi(modeStr); } })) {
                $aiResult.classList.add('hidden');
                aeTranscribe('ai_' + modeStr + '_offer', { status: resp.status });
                return;
            }
            if (resp.status === 403 || data.error === 'pro_required') { $aiResult.classList.add('hidden'); try { showServerUpsell(); } catch (_) {} throw new Error('pro_required'); }
            /* daily_limit ONLY from the body; a naked 429 is the route rate-limit
               (shared-bucket class — see transcribeOnServer) → transient message. */
            if (data.error === 'daily_limit') { $aiResultBody.textContent = STR.ai_daily_limit || 'Daily AI limit reached — try again tomorrow.'; throw new Error('daily_limit'); }
            if (resp.status === 429) { $aiResultBody.textContent = STR.error_too_many_requests || 'Too many requests — wait a minute and try again.'; throw new Error('throttled'); }
            if (!resp.ok || !data.success || !data.text) throw new Error(data.error || 'ai_failed');
            $aiResultBody.textContent = data.text;
            if (data.paid_tokens > 0 && data.paid_text) showToast(data.paid_text, 'info');
            aeTranscribe('ai_' + modeStr + '_done', { out: (data.text || '').length, paid: data.paid_tokens > 0 ? 1 : 0 });
        } catch (e) {
            if (e.message !== 'pro_required' && e.message !== 'daily_limit') $aiResultBody.textContent = STR.ai_failed || 'AI request failed. Please try again.';
            aeTranscribe('ai_' + modeStr + '_failed', { msg: (e.message || '').slice(0, 60) });
        } finally {
            _aiBusy = false;
        }
    }

    function initServerAsr() {
        if (typeof __serverAsr === 'undefined' || !__serverAsr.enabled || mode !== 'file') return;
        /* Show the switch when the user can actually USE server mode (Pro, any
           locale) OR when we OFFER Pro on this locale (so a non-Pro RU user sees
           the upgrade path). A non-Pro user on a locale where Pro isn't sold yet
           (non-RU today) sees nothing — browser stays the only path, no dead
           locked toggle, no upsell to a funnel that doesn't exist. */
        if (!asrServerAllowed() && !__serverAsr.offer) return;
        if ($proc) $proc.hidden = false;
        if ($upsellCta && __serverAsr.proUrl) $upsellCta.href = __serverAsr.proUrl;
        /* Purchase attribution: the upsell CTA remembers which lock opened the
           panel; the preflight modal's inline pro-link is delegated (it is
           injected as HTML into the confirm modal, no stable element). */
        if ($upsellCta) $upsellCta.addEventListener('click', function () {
            try { window.__proSrc && window.__proSrc.set(TOOL_SLUG + '-' + upsellReason); } catch (_) {}
        });
        if ($demoBtn) $demoBtn.addEventListener('click', runDemoMinute);
        /* A file may already be loaded by the time this runs (recovery panel,
           ?job= return, a fast picker) — so ask once here too rather than
           relying solely on the handleFile() path. */
        try { maybeShowDemo(); } catch (_) {}
        document.addEventListener('click', function (e) {
            if (e.target && e.target.closest && e.target.closest('.stt-pro-link')) {
                try { window.__proSrc && window.__proSrc.set(TOOL_SLUG + '-preflight'); } catch (_) {}
            }
        }, true);
        if (!asrServerAllowed() && $procLock) $procLock.hidden = false;
        if ($proc) Array.prototype.forEach.call($proc.querySelectorAll('.stt-proc-btn'), function (b) {
            b.addEventListener('click', function () {
                var m = b.dataset.proc;
                if (m === 'server' && !asrServerAllowed()) { showServerUpsell(); aeTranscribe('server_locked_click'); return; }
                setProcMode(m);
            });
        });
        /* Paint the correct active pill + badge from the resolved procMode
           (Pro default / saved preference). Without this, the toggle is
           visible but the previously-hardcoded `active` class on the
           browser button left even Pro users routed to the free path —
           the comment-#652 silent gap. persist:false → don't write the
           pre-existing default back into localStorage (Wave 2 hardening
           — only explicit user clicks should set the saved preference,
           so a later Pro expiry can't leave a stale 'server' choice). */
        setProcMode(procMode, { persist: false });
        /* Build the quality options (Pro) + keep ETA fresh when a file loads —
           duration comes cheaply from the <audio> element's metadata, no decode. */
        if (asrServerAllowed()) {
            renderAsrQuota();
            renderServerQuality();
        }
        /* The duration is read for EVERYONE, not just for users who already have
           the lane. It used to live inside the branch above, so a non-Pro user's
           `serverAudioDur` stayed 0 — and every offer that wants to say "your
           file would take N minutes here and M there" needs exactly that number.
           It costs nothing: <audio> metadata, no decode. */
        if ($audioPlayer) $audioPlayer.addEventListener('loadedmetadata', function () {
            if (!isFinite($audioPlayer.duration) || $audioPlayer.duration <= 0) return;
            serverAudioDur = $audioPlayer.duration;
            /* The cost line names THIS file's price — it needs the duration, which
               arrives only now. It used to be drawn once at boot (duration 0, so
               hidden) and never again until a server answer. */
            if (asrServerAllowed()) { renderServerQuality(); renderAsrQuota(); return; }
            /* Pain-point offers, in priority order — the slow-wait one first
               because it is the measured hole (756 sessions/month start and
               never finish). Each returns immediately once one has fired. */
            offerOnSlowEta();
            offerOnMobileLongFile();
        });
        /* Resume a server job that survived a reload / closed tab. Keyed on lane
           ACCESS, not membership — the whole point of the minutes ladder is that a
           verified non-Premium user also gets the "закрыл вкладку — результат
           ждёт" experience, and their job must resume like anyone else's. */
        /* ⚠️⚠️ Ссылка из письма читается ДО гейта доступа, а не внутри него.
           До 2026-08-13 весь этот блок стоял под `if (asrServerAllowed())`, то
           есть под условием «человек залогинен ИМЕННО В ЭТОМ браузере». Открыв
           письмо в другом браузере, человек получал обычную страницу: параметр
           ?job= не читался ВООБЩЕ, ни одного сообщения не показывалось.
           Замерено на проде: ноль сообщений, страница неотличима от обычной.
           Молчание здесь — худший исход: человек уверен, что расшифровка
           пропала, хотя она жива и ждёт за логином. */
        try {
            var qjPre = new URLSearchParams(location.search).get('job');
            if (qjPre && /^[0-9]+$/.test(qjPre) && !asrServerAllowed()) {
                showWarning(STR.job_needs_login || STR.server_expired || '', {
                    canRetry: false, showFileLink: false
                });
                aeTranscribe('job_link_needs_login', { job: qjPre });
            }
        } catch (_) {}

        if (asrServerAllowed()) {
            var pending = null; try { pending = localStorage.getItem(SERVER_JOB_LS_KEY); } catch (_) {}
            /* ⚠️⚠️⚠️ УКАЗАТЕЛЬ ПРОТУХАЕТ. До 28.08 он хранил голый id без
               времени и снимался только тем самым опросом, который показывает
               результат. Значит вкладка, закрытая на упавшем джобе, оставляла
               указатель НАВСЕГДА: при следующем заходе страница опрашивала
               вчерашний джоб, получала его давний `error` и здоровалась
               всплывающим «Не удалось обработать на сервере» ДО того, как
               человек к чему-либо прикоснулся.

               Замерено на живом обращении (28.08, 06:29 UTC): `server_transcribe_
               failed` в телеметрии есть, а серверных джобов у этого аккаунта в
               тот день НЕТ НИ ОДНОГО — сообщение было эхом джоба от 18:02
               предыдущего дня. Человек прочитал его как сегодняшнюю поломку и
               написал в поддержку, что «опять не работает», хотя лейн к тому
               часу был уже пять часов как починен.

               Час — с запасом больше самого длинного бюджета, который мы вообще
               ставим на приёме (BUDGET_CEIL_SEC 6.5 ч) поделить нельзя, поэтому
               берём именно его: восстанавливаем то, что МОГЛО идти, и не
               воскрешаем то, что заведомо закончилось. Результат при этом не
               теряется — за ним ведёт письмо со ссылкой ?job=N, которая читается
               выше и указателю не подчиняется. */
            var STALE_JOB_MS = 6.5 * 60 * 60 * 1000;
            if (pending && pending.indexOf(':') !== -1) {
                var _pp = pending.split(':');
                var _at = parseInt(_pp[1], 10);
                if (!isFinite(_at) || (Date.now() - _at) > STALE_JOB_MS) {
                    aeTranscribe('server_job_pointer_stale', {
                        ageH: isFinite(_at) ? Math.round((Date.now() - _at) / 36e5) : -1,
                    });
                    try { localStorage.removeItem(SERVER_JOB_LS_KEY); } catch (_) {}
                    pending = null;
                } else {
                    pending = _pp[0];
                }
            } else if (pending) {
                /* Легаси-указатель без времени (записан до 28.08): возраст
                   недоказуем, а именно эта форма и порождала фантом. Снимаем. */
                try { localStorage.removeItem(SERVER_JOB_LS_KEY); } catch (_) {}
                pending = null;
            }
            /* Письмо «расшифровка готова» ведёт на ?job=N — оно открывается с
               ЛЮБОГО устройства, где localStorage-указателя нет. Параметр
               главнее локального указателя (человек пришёл за КОНКРЕТНЫМ
               результатом); владение проверяет сервер — чужой job тихо даст
               not_found, и страница останется обычной. */
            try {
                var qj = new URLSearchParams(location.search).get('job');
                if (qj && /^[0-9]+$/.test(qj)) pending = qj;
            } catch (_) {}
            if (pending && /^[0-9]+$/.test(pending)) {
                serverJobId = parseInt(pending, 10);
                /* The layout's cross-page cue (PendingResultCue) skips this page
                   only when the page holds the job — announce it. Opened directly
                   on another device (no ?job=, no pointer) the page knows nothing,
                   and the cue is what brings the transcript back here. */
                try { window.__pendingJobAttached = { tool: TOOL_SLUG, id: serverJobId }; } catch (_) {}
                isTranscribing = true; setProcMode('server');
                jobRun = claimTranscript();   /* the resumed job owns the surface — see transcribeOnServer */
                $progress.classList.remove('hidden'); startProgressTimer();
                updateProgress(STR.server_processing || 'Processing on server…', 12);
                updateFileUI();
                pollServerJob(serverJobId);
            }
        }
    }

    /* ── Запись на Яндекс Диске — по ссылке, мимо устройства ─────────────────
       Обращение 19.10.2026: записи созвонов лежат на Диске (Телемост кладёт их
       туда сам), и полуторачасовой звонок приходилось скачивать на телефон,
       чтобы залить его сюда. Теперь сервер берёт файл по публичной ссылке сам.
       Два шага, как у выбранного файла: сервер забирает запись и меряет длину
       → страница называет цену той же строкой, что и для файла, → «Расшифровать»
       запускает обычный серверный прогон с токеном вместо файла. Только на
       timbrica.com (`linkUrl` есть лишь там) и только тем, кому открыт лейн. */
    function initDiskLink() {
        var row = _$('sttLinkRow'), inp = _$('sttLinkUrl'), go = _$('sttLinkGo'), st = _$('sttLinkStatus');
        if (!row || !inp || !go || !__serverAsr.linkUrl || !asrServerAllowed()) return;
        var hint = st ? st.textContent : '';
        function say(msg, err) {
            if (!st) return;
            st.textContent = msg || hint;
            st.classList.toggle('is-error', !!err);
        }
        row.hidden = false;
        /* Выбран файл с устройства — ссылка ни к чему; убрали файл — снова нужна. */
        if ($dropzone) {
            $dropzone.addEventListener('tool-uploader:file', function () { row.hidden = true; });
            $dropzone.addEventListener('tool-uploader:clear', function () { if (!isTranscribing) row.hidden = false; });
        }
        inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); go.click(); } });
        go.addEventListener('click', async function () {
            if (isTranscribing || go.disabled) return;
            var url = (inp.value || '').trim();
            if (!url) { say(STR.link_invalid, true); inp.focus(); return; }
            go.disabled = true; inp.disabled = true;
            say(STR.link_fetching, false);
            aeTranscribe('disk_link_fetch', {});
            var d = null, code = 0;
            try {
                var csrf = (document.querySelector('meta[name="csrf-token"]') || {}).content || '';
                var r = await fetch(__serverAsr.linkUrl, {
                    method: 'POST', credentials: 'same-origin',
                    headers: { 'X-CSRF-TOKEN': csrf, 'X-Requested-With': 'XMLHttpRequest',
                               'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify({ url: url }),
                });
                code = r.status;
                d = await r.json().catch(function () { return null; });
            } catch (_) { d = null; }
            go.disabled = false; inp.disabled = false;
            if (!d || !d.success) {
                var why = (d && d.error) || (code === 429 ? 'throttled' : 'link_unavailable');
                var msg = why === 'too_large' ? (STR.link_too_large || '').replace('{max}', (d && d.max_mb) || '')
                    : why === 'throttled' ? STR.error_too_many_requests
                    : why === 'login_required' ? STR.server_login_required
                    : (STR[why] || STR.link_unavailable);
                say(msg || STR.server_failed, true);
                if (why === 'pro_required') showServerUpsell();
                aeTranscribe('disk_link_refused', { why: why, http: code });
                return;
            }
            aeTranscribe('disk_link_ready', {
                mb: Math.round((d.bytes || 0) / 1048576), min: Math.round((d.duration_sec || 0) / 60),
            });
            /* Длина — для цены и для гейтов лейна, ровно как у выбранного файла. */
            serverAudioDur = d.duration_sec || 0;
            setProcMode('server');
            renderAsrQuota();
            var cost = (_$('sttRunCost') || {}).textContent || '';
            var body = escHtml((STR.link_confirm_body || '{name}')
                .replace('{name}', d.name || '').replace('{len}', serverAudioDur ? formatTime(serverAudioDur) : '—'));
            if (cost.trim()) body += '<br><br>' + escHtml(cost.trim());
            var ok = await showConfirmModal({
                title: STR.link_confirm_title || '',
                html: body,
                confirmLabel: STR.link_go || STR.transcribe,
            });
            if (!ok) { say('', false); aeTranscribe('disk_link_declined', {}); return; }
            say('', false);
            row.hidden = true;
            exportSourceName = d.name || '';
            aeTranscribe('disk_link_run', {});
            await transcribeOnServer({ __link: { token: d.link_token }, name: d.name || '', size: d.bytes || 0 });
            /* Прогон не начался (не хватило токенов, ссылка устарела) — строка
               ссылки возвращается: иначе вставить её снова было бы некуда. */
            if (!isTranscribing) row.hidden = false;
        });
    }

    function initLibraryRestore() {
        try {
            var qt = new URLSearchParams(location.search).get('transcript');
            if (qt && /^[0-9]+$/.test(qt)) restoreFromLibrary(qt);
        } catch (_) {}
    }

    /* Библиотечная копия как запись: {src, dur, lib, segments, text} или
       {error}. Один разбор ответа на возврат из «Моих генераций» и на «открыть
       готовую» перед повторной расшифровкой. */
    function fetchLibraryEntry(id) {
        var url = CFG.urls.transcriptFile + '/' + id + '?format=json';
        return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.json() : r.json().catch(function () { return null; }); })
            .then(function (d) {
                if (!d || !d.ok || !Array.isArray(d.segments) || !d.segments.length) return { error: (d && d.error) || 'empty' };
                var segs = d.segments.map(function (s) {
                    return { text: String(s.text || '').trim(), timestamp: s.timestamp || 0,
                             end: (typeof s.end === 'number') ? s.end : null,
                             speaker: s.speaker || null, isFinal: true };
                });
                return { src: d.title || '', dur: d.duration_sec || 0, lib: parseInt(id, 10) || null, segments: segs,
                         text: segs.map(function (x) { return x.text; }).join(' ') };
            })
            .catch(function () { return { error: 'network' }; });
    }

    function restoreFromLibrary(id) {
        fetchLibraryEntry(id).then(function (e) {
            if (e.error) {
                if (e.error === 'expired') showError(STR.library_expired || STR.server_expired || '');
                aeTranscribe('library_restore', { ok: 0, why: e.error });
                return;
            }
            /* Имя записи — оно и назовёт скачанные файлы, и подпишет документ
               внутри (openEntry → adoptDocument). */
            openEntry(e);
            /* Режим чтения: рейка запуска складывается (см. .stt--library).
               Замер до правки — панель говорящих на 2291 px от верха на телефоне. */
            var _app = document.querySelector('.stt-app, .tc');
            if (_app) _app.classList.add('stt--library');
            aeTranscribe('library_restore', { ok: 1, segs: transcriptSegments.length });
        });
    }

    /* No WASM-SIMD → browser Whisper cannot run on this device. Resolve it the
       honest way instead of letting ort crash mid-load:
         • Pro with server transcription → seamlessly use the server path
           (whisper.cpp runs server-side, independent of the browser engine).
         • everyone else → an actionable "update your browser" message, plus the
           Pro server upsell where it's offered (the only path that works here). */
    function handleNoSimd(file, why) {
        aeTranscribe('simd_unsupported', {
            why: why || 'simd',
            pro: !!(typeof __serverAsr !== 'undefined' && __serverAsr.isPro),
            serverAvail: !!(typeof __serverAsr !== 'undefined' && __serverAsr.enabled),
            mem: caps.mem, webgpu: caps.webgpu, sab: caps.sab,
        });
        if (typeof __serverAsr !== 'undefined' && asrServerAllowed()) {
            setProcMode('server', { persist: false });
            showToast(STR.simd_switch_server || STR.proc_server, 'info');
            transcribeOnServer(file);
            return;
        }
        showError(STR.error_old_browser || STR.error_model_load);
        if (typeof __serverAsr !== 'undefined' && __serverAsr.offer) {
            try { showServerUpsell(); } catch (_) {}
        }
    }

    /* ── Модель ЭТОГО прогона ─────────────────────────────────────────────
       Список называет выбор человека, а прогон идёт той моделью, которую
       решили дверь GigaAM и спасатель. До 01.10.2026 решение («не кэширована —
       берём base») жило в selectedModel, а воркер Whisper получал
       $model.value — то есть «gigaam-ru» — и собирал из него адрес
       onnx-community/whisper-gigaam-ru: HF 401, прогон падал без текста.
       Прод RU 11.09–30.09: 757 автоспасений без кэша GigaAM, ~750 провалов
       «Unauthorized access to file …whisper-gigaam-ru…» при 164 успехах.
       Правило: решение принимает settleRunModel, а в воркер Whisper уходит
       только whisperModelOf(решение). */
    async function settleRunModel(model, fileOpts) {
        if (model !== 'gigaam-ru') return model;
        if (!(window.GigaamAsr || window.ACGigaam)) {
            aeTranscribe('gigaam_auto_skipped', { why: 'lane_missing' });
            return 'base';
        }
        if (!window.WhisperModelPicker) return model;
        /* ⚠️ Спрашиваем ТОЛЬКО там, где человек сам нажал «Уточнить».
         * Автоспасатель запускаем МЫ — после того, как браузерное
         * распознавание уже подвело человека, — и модальная дверь на
         * 215 МБ там встаёт между ним и его текстом. Прод за 30 дней
         * (/auto-captions, тот же гейт): увидели 2066 сессий, приняли 435,
         * отказались 125, а 1516 (73%) не ответили НИЧЕГО. Значит цена
         * вопроса в спасателе — пустой лист, а это ровно то, на что
         * жаловались (#3061). Кэшированную модель берём молча: качать
         * нечего, спрашивать не о чем. Не кэширована — отдаём текст
         * быстрой моделью, а осознанный выбор остаётся на кнопке
         * «Уточнить», куда русского пользователя и так зовёт
         * whisper_refine_nudge. */
        var ok = fileOpts && fileOpts.auto
            ? await WhisperModelPicker.readyWithoutDownload('stt')
            : await WhisperModelPicker.ensureConsent('stt');
        if (ok) return model;
        if (fileOpts && fileOpts.auto) aeTranscribe('gigaam_auto_skipped', { why: 'not_cached' });
        /* Отказ у двери пикер переводит на base сам; остальное — тоже base. */
        return whisperModelOf($model && $model.value);
    }
    /* Adapter: GigaamAsr.run answers in whisper's shape —
       {text, chunks:[{text, timestamp:[a,b]}]} (auto-captions-gigaam.js) — and
       every consumer below (SRT/VTT timings, the playback highlight, the
       non-speech filter, the per-channel merge) needs those timestamps. Until
       2026-10-01 this read `out.segments`, which the wrapper never returns:
       every GigaAM transcript became one untimed block, and the channel split
       collapsed each speaker into a [0, 2 s] segment the merge could drop
       whole. `segments` stays as a fallback for the worker's raw shape. */
    async function runGigaamLane(pcm, durationSec, speechSegments) {
        var G = window.GigaamAsr || window.ACGigaam;
        updateProgress(STR.loading_model || STR.processing_file, 20);
        var gOpts = { durationSec: durationSec };
        if (speechSegments && speechSegments.length) gOpts.segments = speechSegments;
        var out = await G.run(pcm, gOpts, function (evt) {
            if (!evt) return;
            if (evt.type === 'progress' && evt.phase === 'model') {
                var pct = evt.total ? Math.round((evt.loaded / evt.total) * 100) : 0;
                updateProgress((STR.loading_model || '') + ' ' + pct + '%', 20 + Math.round(pct * 0.3));
            } else if (evt.type === 'progress') {
                updateProgress(STR.transcribing || STR.processing_file, 60);
            }
            bumpProgress();
        });
        var chunks = (out && out.chunks && out.chunks.length)
            ? out.chunks.map(function (c) {
                var ts = c.timestamp || [];
                return { text: c.text || '', timestamp: [ts[0] || 0, ts[1] != null ? ts[1] : null] };
            })
            : ((out && out.segments) || []).map(function (s) {
                return { text: s.text || '', timestamp: [s.start || 0, s.end != null ? s.end : null] };
            });
        return {
            chunks: chunks,
            text: (out && out.text) || chunks.map(function (c) { return c.text; }).join(' '),
            detectedLang: 'ru',
        };
    }
    /* Прогон, ушедший до своего исхода (файл не декодировался, отказ до
       воркера — у тела восемь ранних выходов), тоже закончился: иначе очередь
       ждала бы его вечно. Закрывается только СВОЙ прогон — тело может передать
       работу серверному лейну, и тот живёт дальше. */
    async function transcribeFile(file, fileOpts) {
        var mine = runSeq + 1;
        try { return await transcribeFileRun(file, fileOpts); }
        finally { emitRun('end', { reason: 'failed' }, mine); }
    }
    async function transcribeFileRun(file, fileOpts) {
        fileOpts = fileOpts || {};
        hideResultNote();   /* the note describes the PREVIOUS result */
        hideMusicDoor();    /* …and so does the lyrics door */
        if (!file || isTranscribing) return;
        /* The Transcribe button asks browserLaneBlocker() first; these runs come
           here without it — the restored recording, «Continue» after a
           checkpoint, the mic rescue when Web Speech dies. Same verdict, same
           exits, before a byte is decoded. */
        var runBlocker = browserLaneBlocker();
        if (runBlocker) { handleNoSimd(file, runBlocker); return; }
        isTranscribing = true;
        transcribeCanceled = false;
        /* This run now owns the transcript surface. Everything below that
           writes to it after an `await` re-checks with jobOwnsSurface(). */
        jobRun = claimTranscript();
        /* Cancel bumps cancelGen; this run remembers the value it started
           under. NOT the surface claim (`jobRun`): a new recording DETACHES a
           running job, which must keep going and file its text into History —
           a claim check killed exactly those (review 2026-10-01). */
        var runCancelGen = cancelGen;
        try { hideCkptBanner(); } catch (_) {}   /* a stale «Продолжить» must not be clickable under a running job */
        /* Fresh run replaces any prior output — including a just-restored
           checkpoint. Resume re-seeds the head from resumeHeadSegs below, so a
           clean slate here is what prevents head text duplicating. */
        transcriptSegments = [];
        finalTranscript = '';
        _streamDomCount = 0;                 /* force the live-stream container to rebuild */
        /* Документ этого прогона — имя файла (на странице диктовки имени нет:
           запись безымянна, и файл называется датой). */
        var runSrc = mode === 'file' ? (file.name || '') : '';
        adoptDocument({ src: runSrc, dur: mode === 'file' ? serverAudioDur : 0, size: mode === 'file' ? (file.size || 0) : 0 });
        emitRun('start', { src: runSrc, lane: 'browser' });
        /* The SHEET is deliberately not blanked here. The state above must
           reset (otherwise this run's chunks append to the previous run's),
           but the text the user is looking at is the only copy they can see,
           and this run may take minutes — on the bug-report session it took
           90 s, during which the page showed nothing at all and the user
           concluded the tool had eaten his dictation. The first streaming
           paint replaces it (see renderStreamingTranscript). */
        updateFileUI();

        try {
            /* Capability detection hasn't finished? Wait briefly — it's async
               but usually completes within ~50ms of page load. */
            if (!caps.ready) {
                for (var i = 0; i < 20 && !caps.ready; i++) {
                    await new Promise(function(r){ setTimeout(r, 50); });
                }
            }

            updateProgress(STR.processing_file, 10);
            $progress.classList.remove('hidden');
            startProgressTimer();

            /* Decode audio to 16kHz mono float32 (fast, stays on main thread).
               A file past what this page used to accept — the device's `av`
               kind, the zone's number until 01.10.2026 — is never read whole:
               readFileBuffer + the page's decodeAudioData shim (it decodes a
               COPY, buf.slice(0)) hold it twice before a single sample, and a
               2 GB recording does not fit one JS buffer at all. That is why
               the zone stopped at 1 GiB while the server lane was already
               promised 2 GB (config pro.asr.pick_max_mb, Farid 02.08). Its
               sound goes through FFmpeg first, streamed from disk (WORKERFS),
               as 16 kHz with the source's stereo kept — the guarded mid/side
               downmix and the channel split below need both channels; `-ac 1`
               would average anti-phase call stereo into silence (#906). */
            var arrayBuffer = null, audioCtx = null, audioBuffer = null;
            var bigInput = file.size > directReadCeiling();
            if (!bigInput) {
                arrayBuffer = await readFileBuffer(file);
                audioCtx = new (window.AudioContext || window.webkitAudioContext)({ sampleRate: 16000 });
                try {
                    audioBuffer = await audioCtx.decodeAudioData(arrayBuffer);
                } catch(decErr) {
                    /* decodeAudioData failed — try FFmpeg to extract audio (handles .mov, .mp4, .avi etc.) */
                    console.warn('decodeAudioData failed, trying FFmpeg extraction:', decErr.message);
                    await audioCtx.close();
                    audioCtx = null;
                    arrayBuffer = null;
                }
            }
            if (!audioBuffer) {
                var extractCh = 1;
                if (bigInput) {
                    try {
                        if (window.__ensureFFmpeg) await window.__ensureFFmpeg();
                        var srcAudio = await FFmpegProcessor.probeAudioStream(file);
                        if (srcAudio && srcAudio.channels >= 2) extractCh = 2;
                    } catch (_) {}
                    aeTranscribe('big_input_extract', { mb: Math.round(file.size / 1048576), ch: extractCh });
                }
                var extracted = await extractAudioWithFFmpeg(file, extractCh);
                if (!extracted) {
                    showError(extractFailReason === 'truncated' ? (STR.error_incomplete_file || STR.error_decode) : STR.error_decode);
                    isTranscribing = false;
                    updateFileUI();
                    $progress.classList.add('hidden');
                    return;
                }
                audioCtx = new (window.AudioContext || window.webkitAudioContext)({ sampleRate: 16000 });
                try {
                    arrayBuffer = await readFileBuffer(extracted);
                    audioBuffer = await audioCtx.decodeAudioData(arrayBuffer);
                } catch(decErr2) {
                    showError(STR.error_decode);
                    isTranscribing = false;
                    updateFileUI();
                    $progress.classList.add('hidden');
                    await audioCtx.close();
                    return;
                }
            }

            /* Mid/side guarded downmix — mirrors the server decode policy
               (TranscribeAudioJob::recoverCancelledDownmix, same measured
               thresholds). The old ch0-only extraction LOST the second party
               of dual-channel call recordings (speaker per channel — measured:
               ch0 transcribed only speaker A); a plain average would cancel
               anti-phase call-recorder stereo into silence (comment #906).
               So: mid=(L+R)/2 keeps both speakers; when the cancellation
               signature shows (mid ≪ side), transcribe side=(L−R)/2 instead. */
            var rawData;
            /* Признаки входа для телеметрии (docs/asr-plan-2026-08-26.md §8.2).
               За 90 дней у нас НОЛЬ событий про каналы, поэтому доля записей, где
               в каналах разные говорящие, неизвестна — а без неё разделение
               каналов перед распознаванием может оказаться фичей про 1% файлов.
               Оба числа считаются в УЖЕ идущих проходах: лишнего обхода нет. */
            var _chCount = audioBuffer.numberOfChannels, _chCorr = null;
            if (audioBuffer.numberOfChannels >= 2) {
                var _L = audioBuffer.getChannelData(0), _R = audioBuffer.getChannelData(1);
                var _n = Math.min(_L.length, _R.length);
                var _buf = new Float32Array(_n);
                var _eM = 0, _eS = 0, _eL = 0, _eR = 0;
                for (var _i = 0; _i < _n; _i++) {
                    var _l = _L[_i], _r = _R[_i];
                    var _m = (_l + _r) / 2, _s = (_l - _r) / 2;
                    _buf[_i] = _m; _eM += _m * _m; _eS += _s * _s;
                    _eL += _l * _l; _eR += _r * _r;
                }
                /* Корреляция каналов без отдельного прохода: ΣLR = ΣM² − ΣS² —
                   тождество, а не приближение. 1.0 = моно в стерео-обёртке,
                   около 0 = каналы несут РАЗНЫХ говорящих (тот самый случай),
                   −1.0 = противофаза. */
                if (_eL > 0 && _eR > 0) _chCorr = (_eM - _eS) / Math.sqrt(_eL * _eR);
                var _midDb = 10 * Math.log10(_eM / _n + 1e-12);
                var _sideDb = 10 * Math.log10(_eS / _n + 1e-12);
                if (_midDb < -30 && _sideDb > -60 && (_sideDb - _midDb) >= 15) {
                    for (var _j = 0; _j < _n; _j++) _buf[_j] = (_L[_j] - _R[_j]) / 2;
                    aeTranscribe('antiphase_side_used', { mid: Math.round(_midDb), side: Math.round(_sideDb) });
                }
                rawData = _buf;
            } else {
                rawData = audioBuffer.getChannelData(0);
            }
            /* Многоканальный вход: держим каналы врозь — по ним, возможно, и
               пойдёт распознавание вместо моно-сведения. Решение и все его
               пороги ИЗМЕРЕНЫ, см. шапку public/js/asr-channel-split.js
               (F1 69.2% → 76.3% на настоящей многоканальной записи).
               getChannelData отдаёт ССЫЛКУ на внутренний буфер, не копию, —
               лишней памяти здесь не тратится; копия делается по одному
               каналу за раз уже перед отправкой в воркер. */
            var splitChannels = null, splitVerdict = null;
            if (_chCount >= 2 && window.AsrChannelSplit) {
                splitChannels = [];
                for (var _sc = 0; _sc < _chCount; _sc++) splitChannels.push(audioBuffer.getChannelData(_sc));
                try { splitVerdict = window.AsrChannelSplit.shouldSplit(splitChannels); } catch (_) { splitVerdict = null; }
            }
            /* Спектральный наклон = нормированная автокорреляция лага 1.
               ⚠️ Частоту дискретизации ФАЙЛА отсюда взять нельзя: контекст создан
               с sampleRate 16000, и decodeAudioData пересэмплирует всё — поле
               audioBuffer.sampleRate ВСЕГДА 16000 и про «телефон или студия»
               (§2 плана) не говорит ничего. Полоса — говорит: телефонная запись
               300–3400 Гц после пересэмплирования даёт ρ₁ около единицы,
               широкополосная речь заметно ниже. 32 окна, а не весь сигнал. */
            var _tilt = (function (x) {
                var n = x.length; if (n < 1024) return null;
                var W = Math.min(4096, n), step = Math.max(W, Math.floor(n / 32));
                var num = 0, den = 0;
                for (var o = 0; o + W <= n; o += step) {
                    for (var i = o + 1; i < o + W; i++) { var v = x[i]; num += v * x[i - 1]; den += v * v; }
                }
                return den > 0 ? num / den : null;
            })(rawData);
            var audioDuration = audioBuffer.duration;
            /* Длина документа — длина ЗВУКА, а не конец последней реплики: по ней
               запись узнаётся при повторном выборе того же файла. На старте её
               ещё нет (метаданные плеера приходят позже нажатия в очереди). */
            if (mode === 'file' && jobOwnsSurface() && audioDuration > 0) exportDurationSec = Math.round(audioDuration);
            /* chunk_length=29s, stride=5s, jump=29-2*5=19s */
            var totalChunks = audioDuration <= 29 ? 1 : Math.ceil((audioDuration - 29) / 19) + 1;
            var chunksProcessed = 0;
            await audioCtx.close();

            var audioData = new Float32Array(rawData.length);
            audioData.set(rawData);

            /* Тихая запись (телефон через стол): речь на 30–45 дБ ниже нормы,
               и её теряют И VAD, И модель. Поднимаем уровень ЗДЕСЬ — до любого
               VAD и до воркера — общим примитивом asr-level.js; серверный лейн
               делает то же самое в transcribe.sh с теми же порогами. Нормальный
               файл он не трогает (мёртвая зона 6 дБ), воркер потом мерит ещё
               раз и видит норму. Это НЕ шумодав: на слабой речи шумодав стирает
               голоса — так и погиб файл из обращения 2026-06. Замер:
               infra/whisper/BENCHMARK-quiet-input-2026-09-02.md. */
            var inputLevel = null;
            try {
                if (window.__asrLevel) {
                    inputLevel = window.__asrLevel.level(audioData);
                    if (splitChannels) {
                        for (var _lc = 0; _lc < splitChannels.length; _lc++) window.__asrLevel.level(splitChannels[_lc]);
                    }
                    if (inputLevel && inputLevel.applied) {
                        aeTranscribe('input_leveled', {
                            levelDb: inputLevel.levelDb, gainDb: inputLevel.gainDb,
                            limitedPct: Math.round((inputLevel.limitedFrac || 0) * 10000) / 100,
                            durSec: Math.round(audioDuration), where: 'page',
                        });
                    }
                }
            } catch (_) { inputLevel = null; }

            /* ── Модель выбирается ТЕПЕРЬ, когда длительность известна ─────
               До 19.09 умолчание считалось один раз на загрузке страницы, то
               есть до того, как появился материал — и потому не могло знать
               главного слагаемого ожидания. Здесь длительность уже измерена
               декодером, поэтому пересматриваем: у короткой заметки бюджет
               выдерживает модель поточнее, у двухчасовой лекции — нет.
               Ручной выбор сильнее (`userChangedModel`), как и был. */
            if (!userChangedModel && $model && audioDuration > 0) {
                var autoModel = smartDefaultModel(audioDuration);
                if (autoModel && autoModel !== $model.value) {
                    var wasModel = $model.value;
                    $model.value = autoModel;
                    try { savePrefs(); } catch (_) {}
                    aeTranscribe('model_auto_retuned', {
                        from: wasModel, to: autoModel, durSec: Math.round(audioDuration),
                        estMin: estimateWaitMinutes(audioDuration, autoModel, caps),
                    });
                }
            }

            /* ── Preflight: estimate wait time, warn if long ────────────── */
            var selectedModel = $model.value || 'tiny';
            var preflightEstMin = estimateWaitMinutes(audioDuration, selectedModel, caps);
            var preflightFactor = estimateRealtimeFactor(selectedModel, caps);
            /* Порог переступается по ВОРОТНОЙ скорости, а показывается типичная
               (см. estimateRealtimeFactor / gateRealtimeFactor). Иначе решение
               «предупредить ли» принимает то же оптимистичное число, которое мы
               и собирались перестать ему доверять. */
            var preflightGateMin = gateWaitMinutes(audioDuration, selectedModel, caps);

            if (preflightGateMin >= 15) {
                /* Hard threshold: block with a confirm modal. */
                var durationMin = Math.round(audioDuration / 60);
                var estLow = Math.max(1, Math.round(preflightEstMin * 0.7));
                var estHigh = Math.round(preflightEstMin * 1.4);
                var bodyHtml = (STR.preflight_body || '')
                    .replace('{duration}', '<strong>' + durationMin + '</strong>')
                    .replace('{low}', '<strong>' + estLow + '</strong>')
                    .replace('{high}', '<strong>' + estHigh + '</strong>');
                if (!caps.webgpu && !caps.sab) {
                    bodyHtml += '<br><br>' + (STR.preflight_slow_device_hint || '');
                }
                /* Offer the fastest model when the user isn't already on it and
                   the estimate is large — Tiny is ~2-5× faster than Base/Small
                   and turns a 4 h job into ~1-2 h. Actionable beats advisory. */
                var offerFaster = (selectedModel !== 'tiny');
                if (offerFaster) {
                    var tinyMin = Math.max(1, estimateWaitMinutes(audioDuration, 'tiny', caps));
                    bodyHtml += '<br><br>' + (STR.preflight_faster_hint || '').replace('{min}', '<strong>' + tinyMin + '</strong>');
                }
                /* ⚠️⚠️⚠️ КОРЕНЬ ИНЦИДЕНТА 28.08 (Премиум-аккаунт, iPhone, файл
                   35 мин) БЫЛ ЗДЕСЬ. Условие показа серверного выхода стояло
                   `__serverAsr.offer && !isPro && !caps.webgpu && !caps.sab`,
                   с обоснованием «Pro users never reach this modal (they default
                   to the server path)». Оба множителя отсекли ровно того, кому
                   выход был нужен:

                     • `!isPro` — предположение «Премиум всегда уже на сервере»
                       перестаёт быть верным в ту секунду, когда человек трогает
                       переключатель. А трогает он его ПО НАШЕМУ ЖЕ СОВЕТУ:
                       текст `server_failed` буквально говорил «Попробуйте
                       обработку в браузере». Выбор лейна лежит в localStorage
                       навсегда и ничем не пересматривается.
                     • `!caps.webgpu` — у неё `navigator.gpu` есть (iOS 26), так
                       что даже не-Премиум в её положении ничего бы не увидел.

                   Итог: два независимых стража (дефолт procMode='server' для
                   Премиума и эта ветка) опирались на ОДНО И ТО ЖЕ допущение,
                   поэтому отказали вместе. Замер: её файл на сервере — 105 с
                   (gigaam, прод, дословно её длительность и условия записи),
                   в браузере на её бакете — медиана 85 мин. Разрыв 50×, при
                   600 неиспользованных оплаченных минут на счету.

                   Поэтому теперь вопрос задаётся правильный: НЕ «продаём ли мы
                   тут подписку», а «может ли ЭТОТ человек прямо сейчас пустить
                   ЭТОТ файл по лейну, который его вытянет». Если может —
                   это КНОПКА, а не ссылка на прайс. */
                var serverBtnLabel = '';
                if (typeof __serverAsr !== 'undefined' && asrServerAllowed()) {
                    var srvMin = Math.max(1, serverEtaMinutes(audioDuration));
                    /* Предлагаем только когда сервер ощутимо быстрее — на
                       коротком файле с быстрым устройством гнать на сервер
                       незачем, и лишний вопрос дороже выигрыша. */
                    if (srvMin * 2 <= preflightEstMin) {
                        bodyHtml += '<br><br>' + (STR.preflight_server_ready || '')
                            .replace('{min}', '<strong>' + srvMin + '</strong>')
                            .replace('{left}', '<strong>' + Math.max(0, __serverAsr.freeLeft | 0) + '</strong>');
                        serverBtnLabel = STR.preflight_use_server || '';
                        aeTranscribe('preflight_server_offered', {
                            est: preflightEstMin, gate: preflightGateMin, srvMin: srvMin,
                            durSec: Math.round(audioDuration), freeLeft: __serverAsr.freeLeft | 0,
                        });
                    }
                } else if (typeof __serverAsr !== 'undefined' && __serverAsr.offer && STR.preflight_pro_hint) {
                    /* Лейн этому аккаунту закрыт (не залогинен) — тогда это
                       по-прежнему воронка, но уже без `!caps.webgpu`: медленно
                       ему будет независимо от того, отдаёт ли браузер адаптер. */
                    var srvMinOffer = Math.max(1, serverEtaMinutes(audioDuration));
                    bodyHtml += '<br><br>' + STR.preflight_pro_hint
                        .replace('{min}', '<strong>' + srvMinOffer + '</strong>')
                        .replace('{url}', (__serverAsr.proUrl || '#'));
                    aeTranscribe('preflight_pro_hint_shown', { est: preflightEstMin, srvMin: srvMinOffer });
                }
                /* Серверная кнопка вытесняет «быструю модель»: у модалки три
                   места, и выход, который РЕШАЕТ задачу, важнее того, который
                   меняет её на менее точную. */
                var ok = await showConfirmModal({
                    title: STR.preflight_title,
                    html: bodyHtml,
                    confirmLabel: STR.modal_continue,
                    cancelLabel: STR.cancel,
                    altLabel: serverBtnLabel || (offerFaster ? (STR.preflight_use_faster || '') : ''),
                });
                if (ok === 'alt' && serverBtnLabel) {
                    /* Уходим на серверный лейн ЭТИМ же нажатием. Браузерный
                       прогон ещё не начался (мы до воркера не дошли), поэтому
                       достаточно снять флаг и передать ИСХОДНЫЙ File — сервер
                       читает файл сам, декодированный PCM ему не нужен. */
                    isTranscribing = false;
                    stopProgressTimer();
                    $progress.classList.add('hidden');
                    clearETAHint();
                    setProcMode('server');
                    aeTranscribe('preflight_server_taken', { durSec: Math.round(audioDuration) });
                    transcribeOnServer(file);
                    return;
                }
                if (ok === 'alt') {
                    /* Switch to Tiny and proceed. Set the dropdown without
                       dispatching change (its handler would clear resume + pop a
                       banner mid-run); drop any stale worker so the next load
                       picks up Tiny. */
                    $model.value = 'tiny';
                    try { savePrefs(); } catch (_) {}
                    if (whisperWorker) { whisperWorker.terminate(); whisperWorker = null; activeBackend = null; }
                    selectedModel = 'tiny';
                    preflightEstMin = estimateWaitMinutes(audioDuration, 'tiny', caps);
                    aeTranscribe('preflight_switch_to_tiny', { est: preflightEstMin });
                } else if (!ok) {
                    isTranscribing = false;
                    transcribeCanceled = true;
                    stopProgressTimer();
                    $progress.classList.add('hidden');
                    clearETAHint();
                    updateFileUI();
                    return;
                }
            } else if (preflightEstMin >= 5) {
                /* Soft hint: passive notice under progress bar. */
                showETAHint((STR.eta_hint || 'Estimated time ~{min} min')
                    .replace('{min}', preflightEstMin));
            }

            updateProgress(STR.processing_file, 20);

            /* Send to Web Worker — main thread stays free */
            /* Каналы разведены → предлагаем распознать по отдельности.
               ПРЕДЛОЖЕНИЕ, а не автоматика: прогон стоит по проходу на канал,
               и платить временем вправе решать только пользователь. Заодно
               число показов само меряет, у скольких людей такие записи. */
            if (splitVerdict && splitVerdict.split && STR.split_offer_title) {
                aeTranscribe('chansplit_offered', {
                    ch: _chCount, corr: Math.round(splitVerdict.maxCorr * 100), durSec: Math.round(audioDuration),
                });
                var wantSplit = await showConfirmModal({
                    title: STR.split_offer_title,
                    html: (STR.split_offer_body || '').replace('{n}', '<strong>' + _chCount + '</strong>'),
                    confirmLabel: STR.split_offer_yes || STR.modal_continue,
                    cancelLabel: STR.split_offer_no || STR.cancel,
                });
                if (wantSplit) {
                    aeTranscribe('chansplit_accepted', { ch: _chCount });
                    audioData = null;      /* моно-проход не понадобится */
                    /* The previous run's streamed chunks and checkpoint key are
                       still here — Cancel would repaint and re-save THEM. */
                    ckptStreamSegs = []; ckptPartial = ''; ckptKey = null;
                    /* The model is settled BEFORE the try: its finally resets the
                       page's run state, which must not happen for a run that was
                       cancelled while the door was open. */
                    selectedModel = await settleRunModel(selectedModel, fileOpts);
                    if (cancelGen !== runCancelGen) return;
                    try {
                        await transcribeByChannels(splitChannels, file, selectedModel, function () { return cancelGen === runCancelGen; });
                    } finally {
                        /* A cancelled run's state was reset by Cancel, and a run
                           started after it owns the page now — leave both alone. */
                        if (cancelGen === runCancelGen) {
                        /* Ранний выход минует общий хвост функции — он стоит
                           ПОСЛЕ try/catch. Повторяем те же четыре действия, иначе
                           тул остаётся с isTranscribing=true и мёртвой кнопкой.
                           Держать синхронно с хвостом transcribeFile. */
                        isTranscribing = false;
                        stopWatchdog();
                        releaseWakeLock();
                        updateFileUI();
                        }
                    }
                    return;
                }
                aeTranscribe('chansplit_declined', { ch: _chCount });
            }

            var worker = getWhisperWorker();
            var wLang = getWhisperLang();

            /* ── Checkpoint / live-streaming / resume setup ──────────────────
               Persist the transcript incrementally so a multi-hour job survives
               a crash / tab discard, and paint text live so the user can SEE it
               working instead of staring at a frozen bar. */
            deadChunkCount = 0; degenerateFinal = false;
            ckptKey = (window.TranscriptCheckpointStore)
                ? window.TranscriptCheckpointStore.fingerprint(file, selectedModel + ':' + (wLang || 'auto') + (($translateChk && $translateChk.checked) ? ':tr' : ''))
                : null;
            ckptMeta = {
                lang: wLang || 'auto', model: selectedModel,
                task: ($translateChk && $translateChk.checked) ? 'translate' : 'transcribe',
                audioDuration: audioDuration, totalChunks: totalChunks, startedAt: Date.now(),
            };
            /* Honour a resume only when the recovered checkpoint matches the
               EXACT same file+model+lang+task fingerprint — otherwise the head
               text was produced by different settings and must not be merged. */
            if (resumeFromSec > 0 && (!pendingCkpt || pendingCkpt.key !== ckptKey)) {
                resumeFromSec = 0; pendingCkpt = null;
            }
            var resumeHeadSegs = [];
            if (resumeFromSec > 0 && pendingCkpt && pendingCkpt.segments) {
                /* Resuming a recovered run — keep the head text, transcribe only
                   the tail from the next chunk boundary so a 2 h file isn't
                   redone from scratch. */
                resumeHeadSegs = pendingCkpt.segments.slice();
                ckptStreamSegs = resumeHeadSegs.map(function (s) { return s.text; });
                var offSamples = Math.min(audioData.length, Math.floor(resumeFromSec * 16000));
                if (offSamples > 0 && offSamples < audioData.length) {
                    var tail = audioData.subarray(offSamples);
                    var tailCopy = new Float32Array(tail.length);
                    tailCopy.set(tail);
                    audioData = tailCopy;
                }
                renderStreamingTranscript();
            } else {
                ckptStreamSegs = [];
            }
            ckptPartial = '';
            markRunStart({ model: selectedModel, durSec: audioDuration, lane: 'browser' });
            aeTranscribe('transcription_started', {
                durSec: Math.round(audioDuration), model: selectedModel,
                est: preflightEstMin, fileMB: Math.round((file.size || 0) / 1048576),
                resume: resumeFromSec > 0 ? 1 : 0,
                sab: caps.sab ? 1 : 0, webgpu: caps.webgpu ? 1 : 0,
                ch: _chCount,
                corr: _chCorr === null ? null : Math.round(_chCorr * 100),
                tilt: _tilt === null ? null : Math.round(_tilt * 100),
            });
            acquireWakeLock();
            startWatchdog();
            var transcribeOkMs = 0;

            var transcribeStartMs = Date.now();
            var firstChunkMs = 0;
            /* «· ~N min» for the progress line — ONE formula for every writer:
               a rolling average over ALL processed chunks. The first chunk
               alone carries model warm-up and never self-corrects on a
               throttling laptop. */
            var chunkEtaSuffix = function () {
                if (!firstChunkMs || !(chunksProcessed > 0)) return '';
                var secPerChunk = ((Date.now() - transcribeStartMs) / 1000) / chunksProcessed;
                var remaining = Math.ceil(secPerChunk * (totalChunks - chunksProcessed) / 60);
                return remaining > 0 ? ' · ~' + remaining + ' min' : '';
            };

            /* Russian on-device lane. Measured in the BROWSER on one corpus
               (infra/whisper/BENCHMARK-browser-lane-2026-08-09.md, дозамер
               08-20): GigaAM 23.4% WER against small's 28.6% and base's 51.4%,
               and it is nearly twice as fast as small at a comparable download.
               That measurement is why /auto-captions defaults Russian to it —
               this tool simply never got the lane, and its Russian users were
               being handed the model the same bench calls the worse one.
               The engine lives behind the shared picker's consent door, so
               nothing is fetched until the user accepts. */
            /* Ask before downloading — one owner, settleRunModel: it resolves
               immediately for every other model and for a GigaAM already in
               cache; declined or not cached in the rescuer, it names the Whisper
               model this run really uses, and the worker below receives THAT. */
            selectedModel = await settleRunModel(selectedModel, fileOpts);
            /* Cancel can be pressed while the door is open; answering the door
               afterwards must not bring the cancelled run back (it would stream
               into the sheet and spend a daily-cap file). */
            if (cancelGen !== runCancelGen) return;
            /* A declined door switches the select to base, and the select's
               change handler TERMINATES the Whisper worker captured above —
               posting to it was silently dropped and the run hung until Cancel
               (review 2026-10-01). Take the live one for the decided model. */
            if (selectedModel !== 'gigaam-ru') worker = getWhisperWorker();
            var result;
            var runModelLive = null;   /* the model the worker downgraded to */
            var downgradeStage = '';   /* 'load' | 'inference' — an inference-stage downgrade pollutes the timer */
            if (selectedModel === 'gigaam-ru') {
                result = await runGigaamLane(audioData, audioDuration);
                /* Cancel does not reach the GigaAM worker: a cancelled run's
                   result is dropped here instead of painted and billed. */
                if (cancelGen !== runCancelGen) return;
            } else
            result = await new Promise(function(resolve, reject) {
                worker.onmessage = function(e) {
                    var msg = e.data;
                    bumpProgress();   /* any worker message proves it's alive — feed the watchdog */

                    if (msg.type === 'status') {
                        if (msg.status === 'loading_model') {
                            updateProgress(STR.loading_model, 20);
                        } else if (msg.status === 'transcribing') {
                            transcribeStartMs = Date.now();
                            updateProgress(STR.transcribing + ' (1/' + totalChunks + ')...', 50);
                        }
                    }
                    else if (msg.type === 'download_progress') {
                        var p = msg.data;
                        /* `loaded/total` (байты весов) воркер whisper шлёт с 17.10.2026 — до этого
                           ветка не срабатывала ни разу, и загрузка модели шла под неподвижными
                           20 %. Полоса загрузки — отрезок 20…50 между «Загружаю модель» и
                           началом распознавания, иначе она прыгала бы назад со 100 на 50. */
                        if (p.status === 'progress' && p.total) {
                            var pct = Math.round((p.loaded / p.total) * 100);
                            updateProgress(STR.downloading_model + ' (' + pct + '%)', 20 + pct * 0.3);
                        } else if (p.status === 'ready') {
                            updateProgress(STR.loading_model + '...', 95);
                        }
                    }
                    else if (msg.type === 'heartbeat') {
                        var cur = chunksProcessed + 1;
                        var pct = 50 + Math.round((chunksProcessed / totalChunks) * 45);
                        var eta = chunkEtaSuffix();
                        updateProgress(STR.transcribing + ' (' + cur + '/' + totalChunks + ')' + eta, Math.min(pct, 95));
                    }
                    else if (msg.type === 'backend') {
                        activeBackend = msg.backend;
                        renderBackendBadge();
                    }
                    else if (msg.type === 'model_load_stalled') {
                        /* A host's weight download wedged; the worker is failing
                           over to the next host (silent recovery — no user-facing
                           error unless ALL hosts stall). Record it so prod can
                           confirm the failover is firing on the real stall
                           population (8 chunksDone:0 hangs / 30 d, one 54-min). */
                        aeTranscribe('model_load_stalled', { host: msg.host || '', attempt: msg.attempt || 0, model: selectedModel });
                    }
                    else if (msg.type === 'lib_reload') {
                        /* The transformers library loaded incompletely ("Unsupported
                           model type: whisper") and the worker re-imported it fresh
                           (cache-busted) to recover. Record it so prod confirms the
                           recovery is firing on the real cluster (15 fails / 3 d,
                           2026-06-27..29). Each one = a user saved from a hard fail. */
                        aeTranscribe('lib_reload', { reason: (msg.reason || '').slice(0, 80), model: selectedModel });
                    }
                    else if (msg.type === 'model_downgraded') {
                        /* ⚠️⚠️ ЭТОГО ОБРАБОТЧИКА ЗДЕСЬ НЕ БЫЛО. Воркер понижал
                           модель при нехватке памяти и сообщал об этом —
                           /auto-captions это ловит и тостит с 2026-06, а
                           крупнейший тул расшифровки МОЛЧАЛ. Два следствия, и
                           второе хуже первого:
                             1) человек получал текст ДРУГОЙ модели, не зная об
                                этом, и списывал качество на сайт;
                             2) в телеметрии `model_downgraded` за 30 дней —
                                НОЛЬ при 16 видимых OOM. Я сам прочитал этот
                                ноль как «понижение не срабатывает», и только
                                grep по обработчикам показал, что тул просто
                                не докладывает. Отсутствие события здесь
                                означало отсутствие ПРИЁМНИКА, а не события. */
                        var _dgTo = msg.to || '';
                        if (_dgTo) { runModelLive = _dgTo; downgradeStage = msg.stage || ''; }
                        if ($model && _dgTo) {
                            $model.value = _dgTo;          /* пикер обязан показывать то, что реально считает */
                            try { savePrefs(); } catch (_) {}
                        }
                        showToast((STR.model_downgraded_oom || '').replace('{model}', _dgTo) || STR.error_model_load, 'warning');
                        aeTranscribe('model_downgraded', {
                            from: msg.from || '', to: _dgTo, stage: msg.stage || '',
                            reason: (msg.reason || '').slice(0, 120),
                        });
                        bumpProgress();
                    }
                    else if (msg.type === 'webgpu_fallback') {
                        /* WebGPU returned garbage (1 chunk for long audio) — the
                           worker is re-running on WASM. Reset the chunk counter so
                           progress repaints from 0, tell the user we're switching
                           to the reliable engine, and log it for telemetry. */
                        chunksProcessed = 0; deadChunkCount = 0;
                        ckptStreamSegs = []; ckptPartial = ''; _streamDomCount = 0; $transcript.innerHTML = '';
                        updateProgress(STR.transcribing + ' (1/' + totalChunks + ')...', 50);
                        bumpProgress();
                        /* reason/detect were being dropped here, so the two
                           transcription tools reported only a bare count while
                           /auto-captions reported WHY — 497 fallbacks in 30 d
                           with no cause attached. Forward what the worker sends. */
                        aeTranscribe('webgpu_fallback', {
                            durSec: msg.audioDur || 0, model: whisperModelOf(runModelLive || selectedModel),
                            reason: msg.reason || '', detect: msg.detect || '',
                            tokensBefore: msg.tokensBefore || 0,
                        });
                    }
                    else if (msg.type === 'input_level') {
                        /* This page levels before sending, so the worker's own
                           pass normally reports gain 0; it applies only when
                           the page-side helper failed to load. Record it then,
                           so the two paths can be told apart in telemetry. */
                        if (msg.applied) {
                            aeTranscribe('input_leveled', {
                                levelDb: msg.levelDb, gainDb: msg.gainDb,
                                limitedPct: Math.round((msg.limitedFrac || 0) * 10000) / 100,
                                durSec: Math.round(audioDuration), where: 'worker',
                            });
                        }
                    }
                    else if (msg.type === 'dead_decode') {
                        /* The decoder emitted NaN logits — the failure that used
                           to reach the user as walls of "!". The worker bails at
                           the first bad token and recovers; we only record it. */
                        aeTranscribe('dead_decode', {
                            backend: msg.backend || '', model: msg.model || '',
                            chunksDone: msg.chunksDone || 0, durSec: msg.audioDur || 0,
                        });
                    }
                    else if (msg.type === 'asr_recovery') {
                        aeTranscribe('asr_recovery', {
                            detect: msg.detect || '', tokensBefore: msg.tokensBefore || 0,
                            tokensAfter: msg.tokensAfter || 0, durSec: msg.audioDur || 0,
                            improved: msg.improved ? 1 : 0,
                        });
                    }
                    else if (msg.type === 'asr_degenerate_final') {
                        /* Degenerate output with no re-run left to try. Say so
                           instead of handing it over as a transcript. */
                        degenerateFinal = true;
                        aeTranscribe('asr_degenerate_final', {
                            backend: msg.backend || '', model: msg.model || '',
                            detect: msg.detect || '', durSec: msg.audioDur || 0,
                        });
                    }
                    else if (msg.type === 'chunk_done') {
                        chunksProcessed = msg.chunkIndex;
                        if (chunksProcessed === 1) {
                            firstChunkMs = Date.now() - transcribeStartMs;
                            /* Mid-process calibration: if reality is dramatically
                               worse than preflight predicted, prompt to cancel.
                               We DON'T block the worker — it keeps running while
                               the user thinks, so no time is wasted. */
                            var realEtaMin = Math.round((firstChunkMs / 1000) * (totalChunks - 1) / 60);
                            var predicted = Math.max(1, preflightEstMin);
                            if (realEtaMin >= 20 && realEtaMin >= predicted * 1.8) {
                                (async function() {
                                    var html = (STR.midprocess_body || '')
                                        .replace('{eta}', '<strong>' + realEtaMin + '</strong>');
                                    var keep = await showConfirmModal({
                                        title: STR.midprocess_title,
                                        html: html,
                                        confirmLabel: STR.midprocess_keep || STR.modal_continue,
                                        cancelLabel: STR.midprocess_abort || STR.cancel,
                                    });
                                    if (!keep) {
                                        $cancelBtn.click();
                                    }
                                })();
                            }
                        }
                        /* Доказанная нижняя граница скорости ЭТОГО устройства,
                           записываемая ПО ХОДУ, а не в конце. Прогон, который
                           человек бросит на середине (а именно так и уходят
                           безнадёжные прогоны), к этому моменту уже научил нас
                           тому, что успел показать. Со второго куска и не
                           меньше 30 с обработанного аудио — на первом куске
                           доминирует загрузка модели, а не скорость. */
                        if (chunksProcessed >= 2 && audioDuration > 0) {
                            var _doneSec = audioDuration * (chunksProcessed / totalChunks);
                            var _spentSec = (Date.now() - transcribeStartMs) / 1000;
                            /* After an INFERENCE-stage downgrade the timer still holds the
                               failed pass — no speed is learned from such a run. After a
                               load-stage one the timer restarts on 'transcribing', so the
                               time belongs to the model the worker fell back to. */
                            if (_doneSec >= 30 && downgradeStage !== 'inference') recordRtFloor(runModelLive || selectedModel, activeBackend, _spentSec / _doneSec);
                        }
                        var pct = 50 + Math.round((chunksProcessed / totalChunks) * 45);
                        var next = Math.min(chunksProcessed + 1, totalChunks);
                        /* Same formula as the heartbeat's — the two wrote the
                           same line, and this one still divided by the FIRST
                           chunk (model warm-up included): on a 27-min file the
                           line flipped «~34 min» / «~10 min» every few seconds
                           (01.10.2026). */
                        var eta = chunkEtaSuffix();
                        updateProgress(STR.transcribing + ' (' + next + '/' + totalChunks + ')' + eta, Math.min(pct, 95));
                    }
                    else if (msg.type === 'partial_text') {
                        /* Live transcript painting + incremental persistence.
                           on_finalize emits a `final:true` partial carrying the
                           whole chunk's text right before chunk_done — that's
                           the unit we commit + checkpoint. Non-final partials
                           just update the in-progress tail for live preview. */
                        /* A degenerate window is neither painted nor persisted.
                           The worker's own verdict is taken on the FINISHED run;
                           a phone that backgrounds the tab never gets there, and
                           the checkpoint then hands the garbage back as a
                           "recovered transcript" in a later session — exactly
                           what support case #2680 received. The rule itself is
                           the shared one from asr-quality-guard.js, so the page
                           cannot drift from the worker. */
                        if (msg.final) {
                            if (typeof msg.text === 'string' && msg.text.trim()) {
                                if (sttChunkIsDead(msg.text)) {
                                    deadChunkCount++;
                                    aeTranscribe('dead_chunk_dropped', {
                                        chunk: msg.chunk || 0, chars: msg.text.length,
                                        backend: activeBackend || '', model: runModelLive || selectedModel,
                                    });
                                } else {
                                    ckptStreamSegs.push(msg.text.trim());
                                }
                            }
                            ckptPartial = '';
                            saveCheckpoint('in_progress');
                        } else {
                            var _tail = (typeof msg.text === 'string') ? msg.text : '';
                            ckptPartial = sttChunkIsDead(_tail) ? '' : _tail;
                        }
                        renderStreamingTranscript();
                    }
                    else if (msg.type === 'result') {
                        resolve(msg.result);
                    }
                    else if (msg.type === 'error') {
                        reject(new Error(msg.message));
                    }
                };

                worker.onerror = function(err) {
                    /* Handled: the rejection is classified and said below. An
                       uncancelled event also reaches window.onerror — the shared
                       «something went wrong» toast over our own message. */
                    if (err && err.preventDefault) err.preventDefault();
                    reject(new Error(err.message || 'Worker error'));
                };

                /* Transfer audioBuffer (zero-copy) */
                var payload = {
                    type: 'transcribe',
                    audioBuffer: audioData.buffer,
                    modelSize: whisperModelOf(selectedModel),
                    /* The media duration, so the verdict can use the rate the
                       USER perceives and not only density on what the model
                       heard — see asr-quality-guard.js -> mediaVerdict. Nothing
                       is VAD-packed on this page, so the two agree here; what it
                       buys is the "this file has no speech" classification,
                       which stops a music file from being re-run on WASM for
                       nothing. */
                    mediaSec: Math.round(audioDuration || 0),
                };
                if (wLang) payload.language = wLang;
                if ($translateChk && $translateChk.checked) payload.task = 'translate';
                /* Glossary → Whisper initial_prompt (worker tokenises it, ≤200 tok).
                   Conditions spelling of proper nouns / brand names / terms. */
                var glossTxt = promptWithPeople();
                if (glossTxt) payload.initialPrompt = glossTxt.slice(0, 600);
                /* Test-only hooks (prod never sets these window flags): force one
                   incomplete-library load to exercise the lib_reload recovery, or
                   shrink the load-stall window. */
                if (window.__simBadLib) payload.__simBadLib = 1;
                if (window.__loadStallMs) payload.__loadStallMs = window.__loadStallMs;

                /* Keep a copy of the mono PCM for opt-in speaker diarization —
                   the buffer is about to be transferred (detached) to the worker.
                   Only when the user asked for it (memory cost is real on long
                   files). Diarization runs as a post-process after the result. */
                diarPcm = null;
                if ($diarize && $diarize.checked && window.SpeakerDiarization && window.SpeakerDiarization.isSupported()) {
                    try { diarPcm = new Float32Array(audioData); } catch (_) { diarPcm = null; }
                }
                worker.postMessage(payload, [audioData.buffer]);
            });

            transcribeOkMs = Date.now() - transcribeStartMs;

            /* The user took the surface back while we were working (started a
               new recording, opened focus mode, cleared the sheet). Writing
               into transcriptSegments from here is what put a previous
               recording's 219 words on top of a live dictation — and the
               resume-head merge just below is the same write by another name,
               so the verdict is taken BEFORE it, not after. The work is still
               real, so it lands in history with a note instead of on screen —
               and NOT via an early `return`, which would skip the shared tail
               below and leave isTranscribing stuck (the trap already
               documented at transcribeByChannels). */
            var _painted = jobOwnsSurface();
            /* A resumed run only transcribed the TAIL; its head lives in
               resumeHeadSegs. Hand both over, or the filed copy would be
               half a transcript wearing a full one's label. */
            if (!_painted) deliverDetachedResult(result, (resumeFromSec > 0 ? resumeHeadSegs : null), { src: runSrc, dur: audioDuration || 0, size: mode === 'file' ? (file.size || 0) : 0 });

            /* Process results. When resuming, the worker only saw the tail, so
               its timestamps are tail-relative — offset them and keep the
               recovered head segments in front. */
            if (_painted && resumeFromSec > 0 && resumeHeadSegs.length) {
                for (var hi = 0; hi < resumeHeadSegs.length; hi++) {
                    transcriptSegments.push({
                        text: (resumeHeadSegs[hi].text || '').trim(),
                        timestamp: resumeHeadSegs[hi].timestamp || 0,
                        isFinal: true,
                    });
                }
            }

            if (_painted && result.chunks && result.chunks.length) {
                for (var ci = 0; ci < result.chunks.length; ci++) {
                    var chunk = result.chunks[ci];
                    var cEnd = chunk.timestamp && chunk.timestamp[1];
                    transcriptSegments.push({
                        text: chunk.text.trim(),
                        timestamp: ((chunk.timestamp && chunk.timestamp[0]) || 0) + resumeFromSec,
                        /* Keep the REAL segment end (transformers.js gives it on
                           every chunk — measured 2026-07-05). Drives correct
                           SRT/VTT durations + playback-highlight; null-safe. */
                        end: (typeof cEnd === 'number') ? cEnd + resumeFromSec : null,
                        isFinal: true,
                    });
                }
            } else if (_painted && result.text) {
                transcriptSegments.push({ text: result.text.trim(), timestamp: resumeFromSec, isFinal: true });
            }

            if (_painted) {
                applyNonSpeechFilter('browser');
                showDetectedLang(result.detectedLang);
                finalTranscript = transcriptSegments.map(function(s) { return s.text; }).join(' ');
                renderFileTranscript();
                updateStats();
                generateWordCloud(true);
                saveToHistory();
                /* Count a completed FILE transcription (audio-to-text slug). Guarded
                   to mode==='file' so a mic-page Whisper-refine (same code path,
                   mode==='mic') doesn't double-count against the mic session already
                   recorded in stopRecording(). */
                if (mode === 'file') sttLimitRecord(currentFile);

                /* The dictation lane went silent and this run was its rescue: the
                   text is on screen NOW, so the offer lands next to first-hand
                   evidence instead of interrupting a live take. */
                if (mode === 'mic' && webSpeechFailed) {
                    try { offerAfterSilentLane(); } catch (_) {}
                }
            }

            /* Job finished — the checkpoint is no longer needed. */
            discardCheckpoint();
            stopWatchdog();
            releaseWakeLock();
            resumeFromSec = 0; pendingCkpt = null;
            /* Count THIS run's words. When detached, `finalTranscript` belongs
               to the live dictation that took the surface — reading it here
               would book someone else's text as this job's output. */
            var _doneWords = (_painted ? finalTranscript : resultPlainText(result))
                .split(/\s+/).filter(Boolean).length;
            reportRunOutcome('ok', { words: _doneWords });
            aeTranscribe('transcription_done', {
                ms: transcribeOkMs, words: _doneWords,
                chunks: (result.chunks && result.chunks.length) || 0,
                model: runModelLive || selectedModel, backend: activeBackend || '',
                detached: _painted ? 0 : 1,
            });
            /* Teach the ETA this device's real speed (EWMA per backend+model). */
            if (audioDuration > 10 && downgradeStage !== 'inference') recordMeasuredRt(runModelLive || selectedModel, activeBackend, (transcribeOkMs / 1000) / audioDuration);

            stopProgressTimer();
            clearETAHint();
            updateProgress(STR.done, 100);
            /* Keep the progress bar if speaker diarization is about to run — it
               reuses it for the "identifying speakers" phase and hides it itself. */
            setTimeout(function() { if (!_diarizing && !diarPcm) $progress.classList.add('hidden'); }, 2000);

            /* Everything below announces the result ON the surface — toast,
               AI buttons, the done-flash, the completion ping, speaker labels.
               A detached job has already said its piece next to history. */
            if (_painted) {
                /* Completion feedback — honest variant when the file turned out
                   to be music/noise (see showCompletionToast). */
                showCompletionToast(STR.done);
                revealAiButtons();

                $transcript.classList.add('stt-done');
                setTimeout(function() { $transcript.classList.remove('stt-done'); }, 1600);
                try{window.__aeToolComplete()}catch(e2){}

                /* Opt-in speaker labels — post-process on the mono PCM we kept. */
                if (diarPcm) runDiarization();
            }

        } catch(e) {
            stopProgressTimer();
            stopWatchdog();
            releaseWakeLock();
            /* KEEP the checkpoint — the partial transcript is the user's work
               and the recovery banner will offer it back on return. Flush a
               final persist so the very last finalized chunk is durable. */
            saveCheckpoint('in_progress', true);
            if (e.name === 'AbortError') {
                /* Отмена доезжает своим событием ниже по стеку, но исход
                   прогона обязан быть записан здесь же: иначе прерванный
                   прогон остаётся без причины. */
                reportRunOutcome('canceled');
            }
            if (e.name !== 'AbortError') {
                /* Classify the worker failure so the user gets an actionable
                   message, not the engine's raw string. Telemetry (30 d) split
                   the cryptic "no available backend found" into TWO unrelated
                   causes that must NOT share a message:
                     • "…SIMD is not supported"  → genuinely too-old engine
                       (iOS<16.4, Win7 Chrome). Permanent → "update your browser".
                       The pre-flight caps.simd gate catches these first; this is
                       only the rare probe-disagrees backstop.
                     • "…Aborted(NetworkError)" / "Failed to fetch" → the wasm or
                       model weights failed to download. Transient → "try again".
                   Mapping a network abort to "update your browser" (the old
                   regex did) would send a fine browser on a wild goose chase. */
                var rawMsg = e.message || '';
                var simdFail = /SIMD is not supported/i.test(rawMsg);
                var loadFail = !simdFail && /Failed to fetch|NetworkError|Aborted|Load failed|Forbidden|backend found|no available backend|stalled|HTTP \d/i.test(rawMsg);
                reportRunOutcome('failed', { stage: simdFail ? 'no_simd' : (loadFail ? 'model_load' : 'worker'),
                chunks: ckptStreamSegs.length });
                aeTranscribe('transcription_failed', {
                    stage: simdFail ? 'no_simd' : (loadFail ? 'model_load' : 'worker'),
                    msg: rawMsg.slice(0, 120), chunksDone: ckptStreamSegs.length, model: runModelLive || selectedModel,
                });
                /* Never surface the engine's raw string (e.g. transformers.js
                   "Uncaught ReferenceError: t is not defined" — a rare internal
                   bug, ×1/30 d) to the user: it's noise, not actionable. SIMD →
                   update-browser; everything else → a clean retryable message.
                   The raw text is preserved in telemetry above for diagnosis. */
                showError(simdFail ? (STR.error_old_browser || STR.error_model_load)
                                   : STR.error_model_load);
                /* The one moment "not on this device" needs no explaining: the
                   run they were waiting on just died on their device. */
                offerAfterFailure(simdFail ? 'no_simd' : (loadFail ? 'model_load' : 'worker'));
            }
            $progress.classList.add('hidden');
        }

        isTranscribing = false;
        stopWatchdog();
        releaseWakeLock();
        updateFileUI();
    }

    /* After an AUTO-detect run, tell the user which language Whisper heard — so a
       mis-detection is visible, not silent. Only shown when the user was on Auto
       (an explicit language choice is already known to them). Localised name via
       Intl.DisplayNames with an ISO fallback. */
    function showDetectedLang(iso) {
        if (!$detectedLang) return;
        if ($lang.value !== 'auto' || !iso) { $detectedLang.hidden = true; return; }
        var name = iso;
        try { name = new Intl.DisplayNames([window.__LOCALE || 'en'], { type: 'language' }).of(iso) || iso; } catch (_) {}
        $detectedLang.textContent = (STR.detected_lang || 'Detected: {lang}').replace('{lang}', name);
        $detectedLang.hidden = false;
        try { window.__ae && window.__ae('feature_use', { slug: TOOL_SLUG, f: 'lang_autodetected', iso: iso }); } catch (_) {}
    }

    /* Opt-in speaker diarization ("who spoke when") — a post-process over the
       finished transcript. Embeds each segment with a speaker-embedding model and
       clusters by voice (public/js/speaker-diarization.js; validated 1→1/2→2/3→3).
       Runs on the mono PCM kept in diarPcm, so it works for mono AND the mono mix
       of a dual-channel call. Non-blocking: the transcript is already visible; the
       speaker chips appear when it finishes. */
    var _diarizing = false;
    /* Поле «сколько человек» живёт вместе с галочкой «Кто говорил»: без неё оно
       бессмысленно, а показанное впустую поле люди заполняют и потом не понимают,
       почему оно ни на что не влияет. */
    function syncSpeakersRow() {
        var on = !!($diarize && $diarize.checked && !$diarize.disabled);
        if ($speakersRow) $speakersRow.hidden = !on;
        /* Имена участников имеют смысл ровно тогда же, когда и их число: без
           разметки голосов называть некого. */
        var pr = _$('sttPeopleRow');
        if (pr) pr.hidden = !on;
        /* Сохранённые имена и число __toolSettings возвращает без события input. */
        if (typeof syncSpeakersHint === 'function') syncSpeakersHint();
    }
    if ($diarize) $diarize.addEventListener('change', syncSpeakersRow);
    if ($speakers && window.__toolSettings) {
        window.__toolSettings.bind(TOOL_SLUG, $speakers, 'speakers_hint', '');
    }
    if ($people && window.__toolSettings) {
        /* Психолог ведёт одну и ту же пару людей неделями — набирать имена
           заново каждый раз незачем. */
        window.__toolSettings.bind(TOOL_SLUG, $people, 'people', '');
    }

    /* Подсказка слов для движка = имена участников + глоссарий. Имена первыми:
       собственное имя, написанное неверно, портит текст заметнее термина, а
       окно initial_prompt конечное. Одна функция на оба лейна — иначе браузер и
       сервер начнут писать имена по-разному. */
    function promptWithPeople() {
        return [($people && $people.value || '').trim(), ($glossary && $glossary.value || '').trim()]
            .filter(Boolean).join(', ');
    }
    /* Имена из поля «Кто участвует» — один разбор на подсказки, число голосов и
       кнопки имён в панели «Кто говорит». */
    function peopleNames() {
        var seen = {}, out = [];
        String(($people && $people.value) || '').split(/[,;\n]+/).forEach(function (x) {
            x = x.replace(/\s+/g, ' ').trim();
            if (x.length < 2 || x.length > 40 || seen[x.toLowerCase()]) return;
            seen[x.toLowerCase()] = 1;
            out.push(x);
        });
        return out;
    }
    /* ⭐ Сколько голосов искать: названное число, а если его нет — число имён.
       Обращение 19.10.2026: Премиум-пользовательница вписывала имена двоих
       собеседников, а поле числа оставляла «на слух» — и число до движка не
       доходило: телефонный разговор двоих делился на 4–9 «говорящих». Имена
       людей и есть ответ на «сколько человек говорит»; спрашивать дважды
       незачем. Одно имя (своё) числом не считается. 0 — определяем на слух. */
    function speakersWanted() {
        var n = parseInt(($speakers && $speakers.value) || '0', 10);
        if (n >= 2 && n <= 20) return n;
        var k = peopleNames().length;
        return (k >= 2 && k <= 20) ? k : 0;
    }
    /* Подпись под полем числа говорит, откуда возьмётся число: из поля, из имён
       или на слух — а не повторяет одну и ту же фразу. */
    function syncSpeakersHint() {
        var el = _$('sttSpeakersHint');
        if (!el) return;
        var typed = parseInt(($speakers && $speakers.value) || '0', 10);
        var k = peopleNames().length;
        if (!(typed >= 2 && typed <= 20) && k >= 2 && k <= 20 && STR.speakers_from_names) {
            el.textContent = STR.speakers_from_names.replace('{n}', k);
        } else {
            el.textContent = STR.speakers_count_hint || el.textContent;
        }
    }
    if ($people) $people.addEventListener('input', syncSpeakersHint);
    if ($speakers) $speakers.addEventListener('input', syncSpeakersHint);
    syncSpeakersHint();
    function spkLabel(idx) { return (STR.speaker_label || 'Speaker {n}').replace('{n}', (idx | 0) + 1); }

    /* ── Распознавание ПО КАНАЛАМ ──────────────────────────────────────────
       Многоканальная запись, где в каналах разные говорящие (запись звонка,
       совещание с микрофоном на человека): распознаём каждый канал отдельно,
       потом сливаем по времени и метим говорящих номером канала.

       ⚠️ Все решения ниже ИЗМЕРЕНЫ на корпусе AMI браузерным движком
       (модель base), мерой F1 по словам — не полнотой:

         моно-сведение (как было)      полнота 56.9%  точность 88.4%  F1 69.2%
         по каналам, без обработки     полнота 86.1%  точность 52.6%  F1 65.3%
         по каналам, как здесь         полнота 71.7%  точность 81.6%  F1 76.3%

       ⚠️⚠️ Средняя строка — ловушка, ради которой всё расписано подробно:
       голое разделение даёт +29 п.п. ПОЛНОТЫ и при этом делает выдачу ХУЖЕ.
       Кто померит одну полноту, отгрузит ухудшение, будучи уверен в обратном.

       Почему именно так:
       · пустой канал ОТСЕИВАЕМ по VAD — на тишине Whisper сочиняет связный
         текст (замерено: 226 слов вымысла с одного молчащего канала);
       · тишину ВНУТРИ канала НЕ вырезаем — трим стоит полноты при любом
         пороге (0.15 → F1 68.9, 0.5 → 60.6 против 69.2 без него);
       · межканальные дубли ДАВИМ — 71.5% «лишних» слов оказались не
         галлюцинацией, а той же речью, протёкшей в соседний микрофон;
       · моно-проход в слияние НЕ добавляем — с ним F1 падает до 74.5%. */
    /* → {sec, segments:[{start,end}]} (seconds) or null. The segments are what
       the GigaAM lane needs: without them GigaAM cuts every channel into the
       SAME fixed 20 s windows, and the channel merge then compares window k of
       one speaker with window k of the other as «crosstalk» and drops the
       quieter one (review 2026-10-01: dropped=2 of 4 turns on a 40 s call). */
    function vadSpeech(pcm) {
        /* Тот же воркер, что в /auto-captions. Отказ VAD не должен ронять
           прогон: при ошибке считаем, что речь есть, — потерять канал с
           настоящим разговором хуже, чем пропустить фильтрацию. */
        return new Promise(function (resolve) {
            var w, fin = false;
            var done = function (v) {
                if (fin) return; fin = true;
                try { w && w.terminate(); } catch (_) {}
                resolve(v);
            };
            try {
                w = new Worker(CFG.urls.sileroWorker + '&locale='
                    + encodeURIComponent(window.__LOCALE || 'en'));
            } catch (_) { return resolve(null); }
            var to = setTimeout(function () { done(null); }, 180000);
            w.onmessage = function (ev) {
                var m = ev.data;
                if (m.type === 'result') {
                    clearTimeout(to);
                    done({ sec: +m.totalSpeechSec || 0, segments: Array.isArray(m.segments) ? m.segments : null });
                }
                else if (m.type === 'error') { clearTimeout(to); done(null); }
            };
            /* Handled («speech is there»), so cancelled — and said in telemetry, which
               window.onerror no longer sees. */
            w.onerror = function (ev) {
                if (ev && ev.preventDefault) ev.preventDefault();
                clearTimeout(to);
                aeTranscribe('vad_worker_died', { msg: String((ev && ev.message) || '').slice(0, 120) });
                done(null);
            };
            var copy = new Float32Array(pcm);
            w.postMessage({ type: 'detect', audioBuffer: copy.buffer, options: { threshold: 0.35 } }, [copy.buffer]);
        });
    }

    function whisperOnPcm(pcm, modelSize) {
        var worker = getWhisperWorker();
        return new Promise(function (resolve, reject) {
            worker.onmessage = function (e) {
                var m = e.data;
                if (m.type === 'result') resolve(m.result);
                else if (m.type === 'error') reject(new Error(m.message));
                else if (m.type === 'backend') { activeBackend = m.backend; renderBackendBadge(); }
            };
            worker.onerror = function (err) { if (err && err.preventDefault) err.preventDefault(); reject(new Error(err.message || 'Worker error')); };
            /* Каналы — ССЫЛКИ внутрь AudioBuffer. Передавать их нельзя:
               transfer отцепил бы буфер у самого файла. Копия на канал. */
            var copy = new Float32Array(pcm);
            var payload = {
                type: 'transcribe', audioBuffer: copy.buffer, modelSize: whisperModelOf(modelSize),
                mediaSec: Math.round(copy.length / 16000),
            };
            var wl = getWhisperLang();
            if (wl) payload.language = wl;
            if ($translateChk && $translateChk.checked) payload.task = 'translate';
            var gl = promptWithPeople();
            if (gl) payload.initialPrompt = gl.slice(0, 600);
            worker.postMessage(payload, [copy.buffer]);
        });
    }

    async function transcribeByChannels(channels, file, modelSize, stillWanted) {
        var S = window.AsrChannelSplit;
        var t0 = Date.now();
        var parts = [], kept = [], skipped = 0, c, k;

        updateProgress(STR.split_checking || STR.processing_file, 12);
        for (c = 0; c < channels.length; c++) {
            var vad = await vadSpeech(channels[c]);
            if (stillWanted && !stillWanted()) return;
            var sec = vad ? vad.sec : null;
            if (sec !== null && !S.keepChannel(sec)) { skipped++; continue; }
            kept.push({ ch: c, speechSec: sec, segments: vad ? vad.segments : null });
        }
        aeTranscribe('chansplit_channels', { total: channels.length, kept: kept.length, skipped: skipped });

        if (!kept.length) {
            showError(STR.error_no_speech || STR.error_decode);
            $progress.classList.add('hidden');
            return;
        }

        transcriptSegments = [];
        for (k = 0; k < kept.length; k++) {
            var idx = kept[k].ch;
            updateProgress((STR.split_progress || 'Channel {i} of {n}')
                .replace('{i}', k + 1).replace('{n}', kept.length),
                15 + Math.round((k / kept.length) * 75));
            var res = modelSize === 'gigaam-ru'
                ? await runGigaamLane(channels[idx], channels[idx].length / 16000, kept[k].segments)
                : await whisperOnPcm(channels[idx], modelSize);
            if (stillWanted && !stillWanted()) return;
            var segs = [];
            if (res && res.chunks && res.chunks.length) {
                for (var ci = 0; ci < res.chunks.length; ci++) {
                    var chk = res.chunks[ci], t = String(chk.text || '').trim();
                    if (!t) continue;
                    segs.push({
                        start: (chk.timestamp && chk.timestamp[0]) || 0,
                        end: (chk.timestamp && typeof chk.timestamp[1] === 'number') ? chk.timestamp[1] : null,
                        text: t,
                    });
                }
            } else if (res && res.text) {
                segs.push({ start: 0, end: null, text: String(res.text).trim() });
            }
            parts.push({ ch: idx, pcm: channels[idx], segments: segs });
        }

        updateProgress(STR.split_merging || STR.done, 92);
        var merged = S.merge(parts, { sampleRate: 16000, label: spkLabel });
        for (var mi = 0; mi < merged.segments.length; mi++) {
            var sg = merged.segments[mi];
            transcriptSegments.push({
                text: sg.text, timestamp: sg.start, end: sg.end,
                speaker: sg.speaker, isFinal: true,
            });
        }

        applyNonSpeechFilter('browser');
        finalTranscript = transcriptSegments.map(function (x) { return x.text; }).join(' ');
        renderFileTranscript();
        updateStats();
        generateWordCloud(true);
        saveToHistory();
        /* Кап списывается ОДИН раз на файл, а не по каналу: единица работы —
           файл. Иначе стерео-звонок стоил бы вдвое, а совещание вчетверо. */
        if (mode === 'file') sttLimitRecord(currentFile);
        discardCheckpoint();
        aeTranscribe('chansplit_done', {
            ms: Date.now() - t0, channels: kept.length,
            segs: merged.total, dropped: merged.dropped,
            words: finalTranscript.split(/\s+/).filter(Boolean).length,
            model: modelSize, backend: activeBackend || '',
        });
        stopProgressTimer();
        clearETAHint();
        updateProgress(STR.done, 100);
        setTimeout(function () { $progress.classList.add('hidden'); }, 2000);
        showCompletionToast(STR.done);
        revealAiButtons();
        try { window.__aeToolComplete(); } catch (_) {}
    }
    async function runDiarization() {
        if (!diarPcm || !window.SpeakerDiarization || transcriptSegments.length < 2) { diarPcm = null; return; }
        _diarizing = true;
        /* Метки — этого документа: если человек открыл другую запись или пошёл
           следующий файл очереди, ставить их некуда. */
        var diarDoc = docEntryId, diarSegs = transcriptSegments;
        try {
            $progress.classList.remove('hidden');
            updateProgress(STR.diarize_progress || 'Identifying speakers…', 92);
            var res = await window.SpeakerDiarization.diarize(diarPcm, transcriptSegments, {
                sampleRate: 16000,
                /* То же число, что уходит серверу: до 19.10.2026 браузерный лейн
                   поле «Сколько человек говорит» показывал, но не читал. */
                numSpeakers: speakersWanted(),
                onProgress: function (f) { updateProgress(STR.diarize_progress || 'Identifying speakers…', Math.min(99, 90 + Math.round(f * 9))); },
            });
            if (res && res.labels && transcriptSegments === diarSegs && docEntryId === diarDoc) {
                for (var i = 0; i < transcriptSegments.length; i++) {
                    transcriptSegments[i].speaker = (res.speakers > 1) ? spkLabel(res.labels[i]) : null;
                }
                renderFileTranscript();
                updateStats();
                /* Запись истории сохранялась ДО разметки — без этого в ней
                   оставался текст без говорящих. */
                saveToHistory();
                aeTranscribe('diarized', { speakers: res.speakers, segs: transcriptSegments.length });
            }
        } catch (e) {
            console.warn('[diar] failed:', e && e.message);
            aeTranscribe('diarize_failed', { msg: (e && e.message || '').slice(0, 80) });
        } finally {
            diarPcm = null; _diarizing = false;
            updateProgress(STR.done, 100);
            setTimeout(function () { $progress.classList.add('hidden'); }, 1200);
        }
    }

    function getWhisperLang() {
        var langMap = {
            'en':'english','ru':'russian','ko':'korean','ar':'arabic','id':'indonesian',
            'es':'spanish','fr':'french','de':'german','pt':'portuguese','it':'italian',
            'ja':'japanese','zh':'chinese','hi':'hindi','tr':'turkish','pl':'polish',
            'nl':'dutch','sv':'swedish','uk':'ukrainian','cs':'czech','th':'thai',
            'vi':'vietnamese','ro':'romanian','el':'greek','fi':'finnish','da':'danish',
            'nb':'norwegian','he':'hebrew','ms':'malay','hu':'hungarian','bg':'bulgarian',
            'hr':'croatian','sk':'slovak','ca':'catalan'
        };
        var base = ($lang.value || 'en-US').split('-')[0].toLowerCase();
        return langMap[base] || null;
    }

    var progressTimer = null;
    var progressStartTime = 0, progressStartActive = 0;
    /* After the tab comes back the line waits for the server's word before it
       counts again — see the visibility handler next to pollServerJob. */
    var elapsedHeld = false;
    function activeMs() { return (typeof window.__activeNow === 'function') ? window.__activeNow() : Date.now(); }
    function unitText(unit, n, display) {
        try {
            return new Intl.NumberFormat((window.__LOCALE || 'en') + '-u-nu-latn',
                { style: 'unit', unit: unit, unitDisplay: display || 'short' }).format(n);
        } catch (_) { return n + ' ' + ({ second: 's', minute: 'min', hour: 'h' })[unit]; }
    }
    /* «42 с», «7:05», «7:25:12» — h:mm:ss past the hour; it read «445:12». */
    function clockText(sec) {
        sec = Math.max(0, Math.floor(sec));
        var h = Math.floor(sec / 3600), m = Math.floor((sec % 3600) / 60), s = sec % 60;
        if (!h && !m) return unitText('second', s, 'narrow');
        var two = function (x) { return (x < 10 ? '0' : '') + x; };
        return h ? h + ':' + two(m) + ':' + two(s) : m + ':' + two(s);
    }
    /* «27 мин», «1 ч 5 мин» — how long the server worked on a recording. */
    function durationText(sec) {
        sec = Math.max(1, Math.round(sec));
        if (sec < 60) return unitText('second', sec);
        var min = Math.round(sec / 60);
        if (min < 60) return unitText('minute', min);
        var h = Math.floor(min / 60), m = min % 60;
        return unitText('hour', h) + (m ? ' ' + unitText('minute', m) : '');
    }

    function startProgressTimer() {
        progressStartTime = Date.now();
        progressStartActive = activeMs();
        elapsedHeld = false;
        $progressFill.classList.add('active');
        clearInterval(progressTimer);
        progressTimer = setInterval(function() {
            if (elapsedHeld) return;
            /* ⚠️ Это ПРОШЕДШЕЕ время, и подписать его надо явно. Раньше строка
               выглядела как «56:22s» — неотличимо от обратного отсчёта, и
               человек читал её как «осталось 56 минут», хотя число росло.
               Живой случай 2026-08-11 (Екатерина): на трёх скриншотах подряд
               2:55s → 31:40s → 56:22s, и рядом висело «≈12 мин». Часы, которые
               идут вперёд там, где ждут обратного отсчёта, хуже отсутствия
               часов: они сообщают неправду уверенным тоном.
               Which clock: the server works while the phone sleeps — wall time;
               the browser lane stops with a frozen tab — active time, or a night
               in a drawer reads as a seven-hour run. */
            var onServer = runState && runState.lane === 'server';
            var elapsed = onServer ? (Date.now() - progressStartTime) / 1000 : (activeMs() - progressStartActive) / 1000;
            $progressTime.textContent = (STR.elapsed_prefix || 'идёт') + ' ' + clockText(elapsed);
        }, 1000);
    }

    function stopProgressTimer() {
        clearInterval(progressTimer);
        progressTimer = null;
        $progressFill.classList.remove('active');
        $progressTime.textContent = '';
    }

    function updateProgress(text, pct) {
        /* Every caller is a transcription lane (browser, channel-split,
           diarization, GigaAM, server, FFmpeg extraction). Once the user has
           taken the surface back, that progress describes work they are no
           longer looking at — painting it over a live recording is how a
           detached job announced itself as the current job. */
        if (!jobOwnsSurface()) return;
        $progressText.textContent = text;
        $progressFill.style.width = Math.min(100, pct) + '%';
    }

    window.addEventListener('ffmpeg-status', function(ev){
        if(ev.detail.phase === 'downloading' && !$progress.classList.contains('hidden')){
            $progressText.textContent = STR.ffmpeg_downloading;
        } else if(ev.detail.phase === 'ready' && !$progress.classList.contains('hidden')){
            $progressText.textContent = STR.processing;
        }
    });

    function updateFileUI() {
        $transcribeBtn.disabled = isTranscribing;
        if (isTranscribing) {
            $transcribeBtn.innerHTML = '&#8987; ' + STR.transcribing + '...';
        } else {
            $transcribeBtn.innerHTML = '&#127919; ' + STR.transcribe;
        }
    }

    /* Whisper-on-recorded-audio entry point. Bridges mic-mode → file-mode
       transcription pipeline: builds a File from the MediaRecorder chunks
       and reuses `transcribeFile()`. Two callers:
         1. Manual refinement — user clicks "Refine with Whisper" in the
            playback panel after a recording finishes. Web Speech transcript
            (if any) gets REPLACED with Whisper output (typically more
            accurate, especially in noisy / accented speech).
         2. Auto-fallback — whisperTakeover() triggers this when Web Speech
            is unrecoverable (network / backend rejected / restart cap hit).
            User keeps the audio they already spoke instead of having to
            re-record from scratch.
       Emits `feature_use:whisper_refine_clicked` / `whisper_auto_fallback_fired`
       so dashboards can measure adoption + rescue rate. */
    async function transcribeRecordedAudio(opts) {
        opts = opts || {};
        if (!recordedChunks.length) {
            showToast(STR.transcript_placeholder || 'Nothing recorded', 'warning');
            return;
        }
        var recMime = (mediaRecorder && mediaRecorder.mimeType) || 'audio/webm';
        var blob = new Blob(recordedChunks, { type: recMime });
        var file = new File([blob], 'recording.webm', { type: recMime, lastModified: Date.now() });
        /* Whisper REPLACES Web Speech output — clear segments so the chunk
           append in transcribeFile doesn't double the transcript.
           ⚠️ What is being replaced is the user's work: whatever Web Speech
           delivered before it died, INCLUDING any edit they typed into the
           contenteditable sheet. Until 2026-09-18 that copy was destroyed
           outright the moment the rescue started — measured 1431 auto-rescues
           in 60 d, every one of them a silent delete. It goes to history
           first; the sheet keeps showing it until the rescue has text of its
           own (see transcribeFile). */
        try { saveToHistory(); } catch (_) {}
        transcriptSegments = [];
        finalTranscript = '';
        updateInterimText('');
        try {
            window.__ae && window.__ae('feature_use', {
                slug: TOOL_SLUG,
                f: opts.auto ? 'whisper_auto_fallback_fired' : 'whisper_refine_clicked',
                sizeKb: Math.round(blob.size / 1024),
            });
        } catch (_) {}
        return transcribeFile(file, { auto: !!opts.auto });
    }

    function handleFile(file) {
        if (!file) return;
        /* «Подключить файл записи»: текст уже есть, нужен только звук к нему. */
        if (attachOnly) { attachOnly = false; attachAudio(file); return; }
        if (!window.__validateFileSize(file, 'audio')) { showError(STR.error_file_too_large); return; }
        restorePlayerHome();
        hideMusicDoor();

        /* Имя документа здесь НЕ меняется: на экране может стоять текст
           прошлого файла, и выбранный файл — ещё не его имя (adoptDocument —
           при старте прогона). Длина — тоже от нового файла, а не от прошлого:
           до прихода метаданных гейты сервера мерили ту запись. */
        currentFile = file;
        serverAudioDur = 0;

        /* Hide dropzone, show file info */
        $dropzone.classList.add('hidden');
        $fileInfo.classList.remove('hidden');
        $fileName.textContent = file.name;
        $fileMeta.textContent = formatFileSize(file.size);

        /* Audio player */
        var audioUrl = URL.createObjectURL(file);
        $audioPlayer.src = audioUrl;
        playerSrcName = file.name || '';
        $audioPlayer.classList.remove('hidden');
        try { maybeShowDemo(); } catch (_) {}
        try { syncFileSettings(true); } catch (_) {}

        /* Show transcribe button */
        $transcribeBtn.classList.remove('hidden');

        /* На телефоне только что показанная кнопка лежит на 3.7–4.9 экрана НИЖЕ
           вьюпорта (замерено 2026-08-05: iPhone 13 → top 2457 при vh 664;
           SE → 4.9 экрана) — человек выбрал файл и не видит ничего нажимаемого.
           Телеметрия 30 дней: 422 мобильных ухода на стадии «файл выбран», и у
           мобильных НЕТ ни одной стадии wasm_load — до кнопки просто не
           доходили. block:'nearest' — разрешённая форма: двигает страницу
           ТОЛЬКО если кнопка вне экрана (десктоп, где она видна, не шелохнётся). */
        try { $transcribeBtn.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (_) {}

        /* Warm the browser model NOW, while the user reviews the file and reaches
           for Transcribe — the ~75-600 MB model download overlaps their think
           time instead of adding to it (telemetry: the #sttTranscribeBtn "clicked
           with no visible response" rage-clicks are model-still-loading). Browser
           path only (the Pro server path uses no local model); skip when SIMD is
           missing (WASM would fail) or a job is already running. The worker caches
           by model key, so this is free if the user then hits Transcribe. */
        /* GigaAM is not a Whisper model and is fetched only through its consent
           door — warming Whisper with its name asked HF for a repo that does not
           exist (401). */
        var preloadModel = ($model && $model.value) || 'tiny';
        if (mode === 'file' && procMode !== 'server' && !browserLaneBlocker() && !isTranscribing
            && WHISPER_SIZES[preloadModel]) {
            try {
                getWhisperWorker().postMessage({ type: 'preload', modelSize: preloadModel });
                aeTranscribe('model_preload_started', { model: preloadModel });
            } catch (_) {}
        }

        /* A fresh file picked → any restore banner from init is stale. If this
           exact file has an unfinished checkpoint, offer to resume the tail. */
        resumeFromSec = 0; pendingCkpt = null;
        hideCkptBanner();
        maybeOfferResume(file);
    }

    function removeFile() {
        currentFile = null;
        hideMusicDoor();
        try { syncFileSettings(false); } catch (_) {}
        $dropzone.classList.remove('hidden');
        $fileInfo.classList.add('hidden');
        $audioPlayer.classList.add('hidden');
        $audioPlayer.removeAttribute('src');
        $audioPlayer.load();
        playerSrcName = '';
        $transcribeBtn.classList.add('hidden');
        resumeFromSec = 0; pendingCkpt = null;
        hideCkptBanner();
        if ($dropzone.__uploaderReset) $dropzone.__uploaderReset();
    }

    /* =====================================================
       Section 11: Export functions
       ===================================================== */
    /* ── Имя выдаваемого файла ────────────────────────────────────────────────
       Все семь экспортов звали файл `transcription.*`. Замер 06.09.2026: 41 из
       69 владельцев держат ≥2 расшифровки (20 — ≥5), 16 % сессий экспортируют
       ≥2 файла подряд — то есть штатно получают «transcription (1).docx». У
       пользовательницы, после жалобы которой это писалось, 16 записей
       консультаций, и в папке загрузок телефона они назывались одинаково.
       Правило и потолок в БАЙТАХ — общим примитивом (__transcriptFile поверх
       __outputName), тем же, которым называет файл серверная библиотека. */
    function outName(fmt, source) {
        var TF = window.__transcriptFile;
        var word = STR.file_word || 'transcript';
        var src = (source === undefined || source === null) ? exportSourceName : source;
        /* Запасная ветка (модуль не загрузился) тоже НЕСЁТ МАТЕРИАЛ: константа
           здесь вернула бы ровно ту поломку, ради которой всё делалось. */
        if (!TF) {
            var base = String(src || '').replace(/\.[A-Za-z0-9]{1,8}$/, '').replace(/[\\/:*?"<>|]+/g, '_').trim();
            return (base ? base + ' - ' : '') + word + '.' + fmt;
        }
        return TF.name(src, fmt, { word: word });
    }
    /* Один формат — одно событие. До сегодня инструментирован был ТОЛЬКО docx,
       и «162 экспорта, все docx» за 30 дней читалось как факт о людях, хотя
       было фактом о замере: у остальных шести форматов события не было вовсе. */
    function aeExport(fmt, ok, err) {
        try {
            window.__ae && window.__ae('feature_use', {
                slug: TOOL_SLUG, f: 'export_' + fmt, ok: ok ? 1 : 0,
                chars: (finalTranscript || '').length,
                src: exportSourceName ? 'file' : 'mic',
                err: err ? String(err).slice(0, 40) : undefined,
            });
        } catch (_) {}
    }
    /* Экспорт экрана — тот же путь, что у записей истории и очереди
       (buildDocFile): одна сборка на формат, расходиться нечему. Имя и
       заголовок документа — у документа (adoptDocument), а не у файла,
       выбранного позже. */
    async function exportCurrent(fmt) {
        var d = currentDoc();
        if (!d.text) return;
        try {
            var f = await buildDocFile(fmt, d);
            if (!f) { showToast(STR.bulk_no_times || '', 'info'); return; }
            if (f.pdf && window.__savePdf) window.__savePdf(f.pdf, f.name);
            else downloadFile(f.blob, f.name, f.blob.type);
            aeExport(fmt, 1);
        } catch (e) {
            aeExport(fmt, 0, e && e.message);
            /* JSZip blocked / offline: the legacy Word-HTML still leaves the
               person with a file — and says what they are getting. */
            if (fmt === 'docx') { exportWordHtml(d); return; }
            if (window.__handleError) window.__handleError(e, 'stt_export_' + fmt, { say: STR.export_failed || '' });
        }
    }

    function formatSRTTime(seconds) {
        /* Whole ms first: rounding the fraction on its own wrote 3.9996 s as
           "00:00:03,1000", a timing players drop together with its cue. */
        var total = Math.max(0, Math.round(seconds * 1000));
        var h = Math.floor(total / 3600000);
        var m = Math.floor(total % 3600000 / 60000);
        var s = Math.floor(total % 60000 / 1000);
        var ms = total % 1000;
        return pad2(h) + ':' + pad2(m) + ':' + pad2(s) + ',' + pad3(ms);
    }

    function pad3(n) { return n < 10 ? '00' + n : n < 100 ? '0' + n : '' + n; }

    function downloadFile(content, filename, type) {
        var blob = (content instanceof Blob) ? content : new Blob([content], { type: type });
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }

    function copyTranscript() {
        var text = getPlainTranscript();
        if (!text) return;
        /* Emit a real event so the silent_click instrumentation doesn't flag
           this click as inert — top silent_click target in 30d (38 events)
           was the copy button, because the copy worked but no telemetry
           followed. */
        try { window.__ae && window.__ae('feature_use', { slug: TOOL_SLUG, f: 'copy_transcript', chars: text.length }); } catch(_) {}

        navigator.clipboard.writeText(text).then(function() {
            $copyBtn.innerHTML = '&#10003; ' + STR.copied;
            $copyBtn.classList.add('success');
            setTimeout(function() {
                $copyBtn.innerHTML = '&#128203; ' + STR.copy;
                $copyBtn.classList.remove('success');
            }, 2000);
        }).catch(function() {
            /* Fallback for older browsers */
            var ta = document.createElement('textarea');
            ta.value = text;
            ta.style.position = 'fixed';
            ta.style.left = '-9999px';
            document.body.appendChild(ta);
            ta.select();
            try { document.execCommand('copy'); } catch(e) {}
            document.body.removeChild(ta);
            $copyBtn.innerHTML = '&#10003; ' + STR.copied;
            $copyBtn.classList.add('success');
            setTimeout(function() {
                $copyBtn.innerHTML = '&#128203; ' + STR.copy;
                $copyBtn.classList.remove('success');
            }, 2000);
        });
    }

    // Floating copy button — visible when transcript has content
    var _copyFloat = document.getElementById('sttCopyFloat');
    if (_copyFloat) {
        _copyFloat.addEventListener('click', function(){
            copyTranscript();
            _copyFloat.textContent = '✓ ' + STR.copied;
            _copyFloat.classList.add('copied');
            setTimeout(function(){ _copyFloat.textContent = '📋 ' + STR.copy; _copyFloat.classList.remove('copied'); }, 2000);
        });
        // Show/hide based on transcript content
        new MutationObserver(function(){
            var hasText = $transcript.textContent.trim().length > 0 && !$transcript.querySelector('.stt-placeholder');
            _copyFloat.classList.toggle('hidden', !hasText);
        }).observe($transcript, { childList: true, subtree: true, characterData: true });
    }

    /* =====================================================
       Section 11b: MediaRecorder (save recording)
       ===================================================== */
    function startMediaRecorder(stream) {
        recordedChunks = [];
        var opts = { audioBitsPerSecond: getMicPreset().bps };
        if (typeof MediaRecorder !== 'undefined') {
            // Gate on canPlayType — the saved recording is played back as a preview
            // (playbackAudio = new Audio(rawBlob)). iOS records webm but can't play it →
            // silent preview. __pickPlayableRecMime → audio/mp4 on iOS. See timbrica-core.js.
            // (Transcription itself is server-side FormData, unaffected either way.)
            var recMime = window.__pickPlayableRecMime
                ? window.__pickPlayableRecMime(['audio/webm;codecs=opus','audio/webm','audio/mp4'])
                : (MediaRecorder.isTypeSupported('audio/webm;codecs=opus') ? 'audio/webm;codecs=opus'
                   : MediaRecorder.isTypeSupported('audio/webm') ? 'audio/webm' : '');
            if (recMime) opts.mimeType = recMime;
            try {
                mediaRecorder = new MediaRecorder(stream, opts);
                mediaRecorder.ondataavailable = function(e) {
                    if (!e.data || !e.data.size) return;
                    recordedChunks.push(e.data);
                    /* If takeover engaged, persist the running buffer to
                       IndexedDB so the recording survives a tab close. */
                    if (webSpeechFailed) persistRecoveryChunks();
                };
                mediaRecorder.start(1000);
            } catch(mrErr) { mediaRecorder = null; }
        }
    }

    /* stopMediaRecorder accepts an optional onStopped callback. mediaRecorder.stop()
       fires `dataavailable` (one final chunk) and then `stop` — chaining off the
       `stop` event guarantees recordedChunks is complete by the time onStopped
       runs. Eliminates the previous 300 ms setTimeout race where a Chrome 147
       user could click Play inside the gap and hit playbackAudio=null
       (rage_click on #sttPlayBtn 2026-05-02 20:13:18, session 85ceff50). */
    function stopMediaRecorder(onStopped) {
        if (mediaRecorder && mediaRecorder.state !== 'inactive') {
            if (onStopped) {
                mediaRecorder.addEventListener('stop', onStopped, { once: true });
            }
            try { mediaRecorder.stop(); } catch(e) {
                /* If stop throws (rare — only when state is invalid), still
                   call the callback so the UI doesn't get stuck. */
                if (onStopped) try { onStopped(); } catch(_) {}
            }
        } else if (onStopped) {
            /* No active recorder — nothing to wait for. */
            onStopped();
        }
    }

    var audioDownloadFormat = 'webm';

    function loadScript(url, integrity) {
        return new Promise(function(resolve, reject) {
            if (document.querySelector('script[src="' + url + '"]')) { resolve(); return; }
            var s = document.createElement('script'); s.src = url;
            if (integrity) { s.integrity = integrity; s.crossOrigin = 'anonymous'; }
            s.onload = resolve; s.onerror = reject; document.head.appendChild(s);
        });
    }

    function ensureLamejs() {
        return typeof lamejs !== 'undefined' ? Promise.resolve() :
            loadScript(CFG.urls.lamejs);
    }

    function audioBufferToWav(buffer) {
        var numCh = buffer.numberOfChannels, sr = buffer.sampleRate, bps = 16;
        var ba = numCh * (bps / 8);
        var length = buffer.getChannelData(0).length;
        var dl = length * numCh * (bps / 8);
        var ab = new ArrayBuffer(44 + dl);
        var v = new DataView(ab);
        function ws(o, s) { for (var i = 0; i < s.length; i++) v.setUint8(o + i, s.charCodeAt(i)); }
        ws(0, 'RIFF'); v.setUint32(4, 36 + dl, true); ws(8, 'WAVE'); ws(12, 'fmt ');
        v.setUint32(16, 16, true); v.setUint16(20, 1, true); v.setUint16(22, numCh, true);
        v.setUint32(24, sr, true); v.setUint32(28, sr * ba, true); v.setUint16(32, ba, true);
        v.setUint16(34, bps, true); ws(36, 'data'); v.setUint32(40, dl, true);
        var channels = [];
        for (var ch = 0; ch < numCh; ch++) channels.push(buffer.getChannelData(ch));
        var off = 44;
        for (var i = 0; i < length; i++) {
            for (var ch = 0; ch < numCh; ch++) {
                var s = Math.max(-1, Math.min(1, channels[ch][i]));
                v.setInt16(off, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
                off += 2;
            }
        }
        return new Blob([ab], { type: 'audio/wav' });
    }

    function encodeMP3(audioBuffer, bitrate) {
        var sampleRate = audioBuffer.sampleRate;
        var numCh = audioBuffer.numberOfChannels;
        var samplesL = audioBuffer.getChannelData(0);
        var samplesR = numCh > 1 ? audioBuffer.getChannelData(1) : null;
        var encoder = new lamejs.Mp3Encoder(numCh, sampleRate, bitrate || 192);
        var mp3Data = [];
        var blockSize = 1152;
        for (var i = 0; i < samplesL.length; i += blockSize) {
            var len = Math.min(blockSize, samplesL.length - i);
            var chunkL = new Int16Array(len);
            for (var j = 0; j < len; j++) {
                var sv = Math.max(-1, Math.min(1, samplesL[i + j]));
                chunkL[j] = sv < 0 ? sv * 0x8000 : sv * 0x7FFF;
            }
            var buf;
            if (samplesR) {
                var chunkR = new Int16Array(len);
                for (var j = 0; j < len; j++) {
                    var sv = Math.max(-1, Math.min(1, samplesR[i + j]));
                    chunkR[j] = sv < 0 ? sv * 0x8000 : sv * 0x7FFF;
                }
                buf = encoder.encodeBuffer(chunkL, chunkR);
            } else {
                buf = encoder.encodeBuffer(chunkL);
            }
            if (buf.length > 0) mp3Data.push(new Int8Array(buf));
        }
        var end = encoder.flush();
        if (end.length > 0) mp3Data.push(new Int8Array(end));
        return new Blob(mp3Data, { type: 'audio/mp3' });
    }

    async function downloadAudio() {
        if (!recordedChunks.length) return;
        var fmt = audioDownloadFormat;
        var recMime = (mediaRecorder && mediaRecorder.mimeType) || 'audio/webm';
        var rawBlob = new Blob(recordedChunks, { type: recMime });

        if (fmt === 'webm') {
            downloadFile(rawBlob, 'recording.webm', recMime);
            return;
        }

        /* Decode to AudioBuffer for WAV/MP3 */
        $audioDlBtn.textContent = STR.processing + '..';
        $audioDlBtn.disabled = true;
        try {
            var arrayBuf = await readFileBuffer(rawBlob);
            var ACtor = window.AudioContext || window.webkitAudioContext;
            var ctx = new ACtor();
            var audioBuffer = await ctx.decodeAudioData(arrayBuf);
            ctx.close();

            if (fmt === 'wav') {
                downloadFile(audioBufferToWav(audioBuffer), 'recording.wav', 'audio/wav');
            } else if (fmt.startsWith('mp3')) {
                var bitrate = parseInt(fmt.split('-')[1]) || 192;
                await ensureLamejs();
                downloadFile(encodeMP3(audioBuffer, bitrate), 'recording.mp3', 'audio/mp3');
            }
        } catch(e) {
            showError(e.message || 'Encoding failed');
        } finally {
            $audioDlBtn.innerHTML = audioDlBtnOrigHTML;
            $audioDlBtn.disabled = false;
        }
    }

    /* =====================================================
       Section 11c: Word-HTML fallback (when the .docx writer cannot load)
       ===================================================== */
    /* Real OOXML .docx is built by buildDocFile through the shared writer.
       Until 2026-08-01 the tool shipped an HTML string named ".doc" with mime
       application/msword — Android/iOS Word, Google Docs and WPS mostly refuse
       it. It survives only as the fallback for a blocked JSZip. */
    function exportWordHtml(d) {
        var stamp = new Date().toLocaleString(window.__LOCALE);
        var paragraphs = docBlocks(d);
        var html = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:w="urn:schemas-microsoft-com:office:word" xmlns="http://www.w3.org/TR/REC-html40">';
        html += '<head><meta charset="utf-8"><style>body{font-family:Calibri,sans-serif;font-size:11pt;line-height:1.5}h1{font-size:16pt}</style></head><body>';
        html += '<h1>' + escHtml(docHeading(d)) + '</h1><p style="color:#888">' + escHtml(docSubtitle(d, stamp)) + '</p>';
        for (var pi = 0; pi < paragraphs.length; pi++) {
            /* Абзац бывает объектом {text, bold…} (структурный путь): отдать его
               в escHtml целиком значило написать «[object Object]». */
            var pText = (paragraphs[pi] && typeof paragraphs[pi] === 'object') ? (paragraphs[pi].text || '') : paragraphs[pi];
            html += '<p>' + escHtml(pText).replace(/\n/g, '<br>') + '</p>';
        }
        html += '</body></html>';
        downloadFile(new Blob(['\ufeff' + html], { type: 'application/msword' }), outName('doc', d.src || ''), 'application/msword');
    }

    /* =====================================================
       Section 11e: Word Cloud
       ===================================================== */
    var _cloudTimer = null;
    function scheduleWordCloud() {
        clearTimeout(_cloudTimer);
        _cloudTimer = setTimeout(function() { generateWordCloud(true); }, 1500);
    }

    function clearWordCloud() {
        var canvas = $wordCloudCanvas;
        var ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        $wordCloudEmpty.classList.remove('hidden');
        declarePanelContent('sttWordCloudSection', false);
    }

    function generateWordCloud(silent) {
        var text = getPlainTranscript();
        if (!text || text.length < 10) {
            if (!silent) showToast(STR.word_cloud_empty, '');
            clearWordCloud();
            return;
        }

        var words = text.toLowerCase().replace(/[^\w\u0400-\u04FF\u0600-\u06FF\uAC00-\uD7AF\s]/g, '').split(/\s+/);
        var stopWords = new Set(['the','a','an','is','are','was','were','be','been','have','has','had','do','does','did','will','would','shall','should','can','could','may','might','must','and','but','or','nor','not','no','so','if','then','than','that','this','these','those','it','its','i','me','my','we','our','you','your','he','him','his','she','her','they','them','their','to','of','in','for','on','with','at','by','from','as','into','about','up','down','out','off','over','under','again','once','here','there','when','where','all','each','both','few','more','most','some','such','only','very','just','also','too','well','back','been','being','what','which','who','how','its','your']);

        var freq = {};
        for (var wi = 0; wi < words.length; wi++) {
            var w = words[wi];
            if (w.length >= 3 && !stopWords.has(w)) freq[w] = (freq[w] || 0) + 1;
        }
        var sorted = Object.entries(freq).sort(function(a, b) { return b[1] - a[1]; }).slice(0, 60);
        if (!sorted.length) return;

        var canvas = $wordCloudCanvas;
        var ctx = canvas.getContext('2d');
        var dpr = window.devicePixelRatio || 1;
        var W = canvas.clientWidth * dpr, H = canvas.clientHeight * dpr;
        canvas.width = W; canvas.height = H;
        ctx.clearRect(0, 0, W, H);

        var maxFreq = sorted[0][1];
        var minSize = 14 * dpr, maxSize = 52 * dpr;
        var colors = ['#6366f1','#8b5cf6','#a78bfa','#c084fc','#e879f9','#f472b6','#fb7185','#60a5fa','#34d399','#fbbf24'];
        var placed = [];

        for (var si = 0; si < sorted.length; si++) {
            var word = sorted[si][0], count = sorted[si][1];
            var size = minSize + (count / maxFreq) * (maxSize - minSize);
            ctx.font = 'bold ' + Math.round(size) + 'px Inter, system-ui, sans-serif';
            var metrics = ctx.measureText(word);
            var wW = metrics.width, wH = size * 1.2;
            var ok = false;
            for (var angle = 0; angle < 200 && !ok; angle += 0.3) {
                var r = angle * 2.5;
                var x = W / 2 + r * Math.cos(angle) - wW / 2;
                var y = H / 2 + r * Math.sin(angle) - wH / 2;
                if (x < 4 || y < 4 || x + wW > W - 4 || y + wH > H - 4) continue;
                var overlap = false;
                for (var j = 0; j < placed.length; j++) {
                    var p = placed[j];
                    if (x < p.x + p.w + 4 && x + wW + 4 > p.x && y < p.y + p.h + 2 && y + wH + 2 > p.y) { overlap = true; break; }
                }
                if (!overlap) {
                    ctx.fillStyle = colors[si % colors.length];
                    ctx.fillText(word, x, y + wH * 0.78);
                    placed.push({ x: x, y: y, w: wW, h: wH });
                    ok = true;
                }
            }
        }
        $wordCloudEmpty.classList.add('hidden');
        declarePanelContent('sttWordCloudSection', true);
    }

    /* =====================================================
       Section 11f: Bookmarks
       ===================================================== */
    function addBookmark() {
        if (!isRecording) return;
        var text = getPlainTranscript();
        bookmarks.push({
            time: timerSeconds,
            preview: text.slice(-60).trim() || '...',
            date: Date.now()
        });
        renderBookmarks();
    }

    function renderBookmarks() {
        declarePanelContent('sttBookmarksSection', bookmarks.length > 0);
        if (!bookmarks.length) {
            $bookmarksList.innerHTML = '<div style="text-align:center;padding:16px;color:var(--text-muted);font-size:13px;">' + STR.bookmarks_empty + '</div>';
            return;
        }
        var html = '';
        for (var bi = 0; bi < bookmarks.length; bi++) {
            var bm = bookmarks[bi];
            html += '<div class="stt-bookmark-item">';
            html += '<span class="stt-timestamp">[' + formatTime(bm.time) + ']</span>';
            html += '<span class="stt-bookmark-preview">' + escHtml(bm.preview) + '</span>';
            html += '<button type="button" class="stt-bookmark-remove" data-bm-remove="' + bi + '" aria-label="Close">&times;</button>';
            html += '</div>';
        }
        $bookmarksList.innerHTML = html;

        $bookmarksList.querySelectorAll('[data-bm-remove]').forEach(function(el) {
            el.addEventListener('click', function() {
                bookmarks.splice(parseInt(el.dataset.bmRemove), 1);
                renderBookmarks();
            });
        });
    }

    /* =====================================================
       Section 11g: Dictation Mode (Focus Mode)
       ===================================================== */
    function enterDictation() {
        isDictationMode = true;
        /* Focus mode is a FOURTH writer to the same text: it snapshots the
           sheet on entry, takes live results itself, and writes the whole
           thing back on exit. Without a claim, a Whisper job running behind
           the overlay would paint into the sheet and then be silently
           overwritten by that write-back — the same collision as the record
           button, one surface further in. Claiming makes the job detach and
           file into history instead.
           Until today this mode emitted NO telemetry at all, so how often it
           is opened — let alone opened over a running job — was unknowable. */
        claimTranscript();
        if (isTranscribing) detachRunningJob();
        try {
            window.__ae && window.__ae('feature_use', {
                slug: TOOL_SLUG, f: 'dictation_mode_open',
                chars: getPlainTranscript().length, rec: isRecording ? 1 : 0,
            });
        } catch (_) {}
        $dictation.classList.add('active');
        $dictationText.textContent = getPlainTranscript();
        $dictationText.focus();
        try {
            var sel = window.getSelection();
            sel.selectAllChildren($dictationText);
            sel.collapseToEnd();
        } catch(e) {}
        if (isRecording) {
            $dictationStatus.textContent = STR.recording + '...';
        }
    }

    function exitDictation() {
        isDictationMode = false;
        $dictation.classList.remove('active');
        var text = $dictationText.textContent.trim();
        if (text) {
            $transcript.textContent = text;
            userHasEdited = true;
            updateStats();
        }
    }

    /* =====================================================
       Section 11h: Audio-Text Sync (file mode)
       ===================================================== */
    /* Панель «Кто говорит» живёт ровно столько же, сколько сам текст, поэтому
       перерисовывается вместе с ним — а не в тринадцати местах, где текст
       обновляется. Обёртка: настоящая отрисовка ниже под прежним именем. */
    function renderFileTranscript() {
        renderFileTranscriptInner();
        /* Сначала — похоже ли на заседание: от ответа зависит, покажет ли
           панель голосов роли одним нажатием. */
        try { courtCheck(); } catch (_) {}
        try { renderRoster(); } catch (_) {}
        try { syncAttachRow(); } catch (_) {}
    }
    function renderFileTranscriptInner() {
        if (!transcriptSegments.length) {
            $transcript.innerHTML = '<div class="stt-placeholder">' + escHtml(STR.transcript_placeholder) + '</div>';
            syncSpeakersToggle();
            return;
        }
        var paras = buildParagraphs(transcriptSegments);
        var showTs = !!($timestamps && $timestamps.checked), showSpk = showSpeakersOn();
        /* Colour by order of first appearance — stable for renamed speakers too. */
        var colour = {}, nextColour = 0, prevSpk = null, html = '';
        var menuTitle = escHtml(STR.para_menu || '');
        lastParas = paras; lastColour = colour;
        for (var p = 0; p < paras.length; p++) {
            var para = paras[p];
            if (para.speaker && colour[para.speaker] === undefined) colour[para.speaker] = (nextColour++) % 8;
            html += '<div class="stt-para" data-p="' + p + '" data-start="' + (para.start || 0) + '">';
            var head = '';
            /* Время реплики — ещё и дверь в её меню (кто говорит, слушать отсюда,
               цитата): метка говорящего стоит только там, где он меняется, а
               время есть у каждого абзаца. */
            if (showTs) head += '<span class="stt-timestamp stt-timestamp--menu" contenteditable="false" role="button" tabindex="0" title="' + menuTitle + '">[' + formatTime(Math.round(para.start || 0)) + ']</span>';
            if (showSpk && para.speaker && para.speaker !== prevSpk) {
                head += '<button type="button" class="stt-speaker" contenteditable="false" data-spk="' + colour[para.speaker]
                      + '" data-speaker="' + escHtml(para.speaker) + '" title="' + escHtml(STR.rename_speaker || 'Rename') + '">'
                      + escHtml(para.speaker) + '</button>';
            }
            if (para.speaker) prevSpk = para.speaker;
            if (head) html += '<span class="stt-para-head" contenteditable="false">' + head + '</span> ';
            for (var i = 0; i < para.segs.length; i++) {
                var seg = para.segs[i];
                var startT = seg.timestamp || 0;
                /* Real segment end when the engine gave it; else clamp to the next
                   segment's start (or +5s for the last) so the highlight doesn't
                   linger through a silence gap. */
                var next = para.segs[i + 1];
                var endT = (typeof seg.end === 'number') ? seg.end : (next ? (next.timestamp || startT + 5) : startT + 5);
                html += '<span class="stt-segment" data-start="' + startT + '" data-end="' + endT + '">' + escHtml(seg.text) + '</span> ';
            }
            html += '</div>';
        }
        $transcript.innerHTML = html;
        syncSpeakersToggle();
    }

    /* =====================================================
       Section 12: Find & Replace
       ===================================================== */
    function openFindPanel() {
        $findPanel.classList.remove('hidden');
        $findInput.focus();
    }

    function closeFindPanel() {
        $findPanel.classList.add('hidden');
        clearHighlights();
        $matchCount.textContent = '';
        $findInput.value = '';
        $replaceInput.value = '';
        currentFindIndex = -1;
        findMatches = [];
    }

    function doFind() {
        var query = $findInput.value;
        if (!query) { clearHighlights(); $matchCount.textContent = ''; return; }

        var text = getPlainTranscript();
        var regex = new RegExp(escRegex(query), 'gi');
        var matches = [];
        var m;
        while ((m = regex.exec(text)) !== null) {
            matches.push({ index: m.index, length: m[0].length });
        }

        findMatches = matches;
        $matchCount.textContent = matches.length > 0
            ? matches.length + ' ' + STR.matches_found
            : STR.no_matches;

        highlightMatches(query);

        if (matches.length > 0) {
            currentFindIndex = 0;
            scrollToMatch(0);
        } else {
            currentFindIndex = -1;
        }
    }

    function highlightMatches(query) {
        if (!transcriptSegments.length || !query) { renderTranscript(); return; }

        var showTs = $timestamps.checked;
        var fullText = '';
        var parts = [];

        for (var i = 0; i < transcriptSegments.length; i++) {
            var seg = transcriptSegments[i];
            var tsHtml = '';
            if (showTs && (i === 0 || seg.timestamp - transcriptSegments[i - 1].timestamp > 5)) {
                tsHtml = '<span class="stt-timestamp">[' + formatTime(seg.timestamp) + ']</span> ';
            }
            parts.push({ ts: tsHtml, text: seg.text });
        }

        var combined = parts.map(function(p) { return p.text; }).join(' ');
        var regex = new RegExp('(' + escRegex(query) + ')', 'gi');
        var highlighted = escHtml(combined).replace(
            new RegExp('(' + escRegex(escHtml(query)) + ')', 'gi'),
            '<span class="stt-highlight">$1</span>'
        );

        /* Rebuild with timestamps */
        var html = '';
        var pos = 0;
        for (var j = 0; j < parts.length; j++) {
            html += parts[j].ts;
            var segLen = escHtml(parts[j].text).length;
            html += highlighted.substring(pos, pos + segLen) + ' ';
            pos += segLen + 1; /* +1 for space */
        }

        $transcript.innerHTML = html;
    }

    function scrollToMatch(index) {
        var highlights = $transcript.querySelectorAll('.stt-highlight');
        highlights.forEach(function(h, i) {
            h.classList.toggle('current', i === index);
        });
        if (highlights[index]) {
            highlights[index].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
    }

    function findNext() {
        if (findMatches.length === 0) return;
        currentFindIndex = (currentFindIndex + 1) % findMatches.length;
        scrollToMatch(currentFindIndex);
    }

    function findPrevious() {
        if (findMatches.length === 0) return;
        currentFindIndex = (currentFindIndex - 1 + findMatches.length) % findMatches.length;
        scrollToMatch(currentFindIndex);
    }

    function doReplace() {
        var query = $findInput.value;
        var replacement = $replaceInput.value;
        if (!query || currentFindIndex < 0) return;

        /* Replace first occurrence in current segment */
        var regex = new RegExp(escRegex(query), 'i');
        for (var i = 0; i < transcriptSegments.length; i++) {
            if (regex.test(transcriptSegments[i].text)) {
                transcriptSegments[i].text = transcriptSegments[i].text.replace(regex, replacement);
                break;
            }
        }
        finalTranscript = transcriptSegments.map(function(s) { return s.text; }).join(' ');
        doFind(); /* re-highlight */
        updateStats();
    }

    function doReplaceAll() {
        var query = $findInput.value;
        var replacement = $replaceInput.value;
        if (!query) return;

        var regex = new RegExp(escRegex(query), 'gi');
        for (var i = 0; i < transcriptSegments.length; i++) {
            transcriptSegments[i].text = transcriptSegments[i].text.replace(regex, replacement);
        }
        finalTranscript = transcriptSegments.map(function(s) { return s.text; }).join(' ');
        renderTranscript();
        updateStats();
        $matchCount.textContent = '';
        findMatches = [];
        currentFindIndex = -1;
    }

    function clearHighlights() {
        renderTranscript();
    }

    /* =====================================================
       Section 13: Statistics
       ===================================================== */
    function updateStats() {
        var text = getPlainTranscript();
        var words = text ? text.split(/\s+/).filter(function(w) { return w.length > 0; }).length : 0;
        var chars = text.length;
        var sentences = text ? (text.match(/[.!?]+/g) || []).length : 0;
        if (text.length > 0 && sentences === 0) sentences = 1;
        var readMin = Math.max(1, Math.ceil(words / 200));

        _$('sttWordCount').textContent = words + ' ' + STR.words;
        _$('sttCharCount').textContent = chars + ' ' + STR.characters;
        _$('sttSentCount').textContent = sentences + ' ' + STR.sentences;
        _$('sttReadTime').textContent = readMin + ' ' + STR.min_read;

        syncPanelSections(words > 0);
    }

    /* Show the after-the-fact panels only once there IS an after.
       Before this, a first-time visitor met four boxes that all said the same
       thing in different words — «Расшифровок пока нет», «Сначала выполните
       транскрипцию», «Закладок пока нет» — filling roughly half the panel with
       explanations of emptiness. The rule the rest of the site already follows
       (app.css `.workspace:not(.active) > *`) is exactly this; this tool never
       adopted it because it predates the convention.

       A section still appears while empty if it holds real history from an
       earlier visit: the point is to hide what has nothing to say, not to hide
       the feature. */
    /* The how-to-transcribe controls belong to a file. Model, language hint,
       glossary, speaker labels, noisy-audio advice — none of it can be decided
       before there is one, and all of it used to sit above an empty drop zone.
       Mic mode is exempt: there the settings apply to the recording you are
       about to make, so they have to be reachable first. */
    /* Decided once at startup too — otherwise mic mode would inherit the
       markup's `hidden` and lose its settings entirely. */
    function syncFileSettings(hasFile) {
        var box = _$('sttFileSettings');
        if (!box) return;
        /* 2026-09-04: the setup grid (language · quality · speakers) stays
           visible BEFORE a file is chosen too. The count of speakers is the one
           thing the engine cannot work out itself and is named up front — and
           the person who came back from the "ready" e-mail has a result but no
           file, so a grid that only opens with a file was invisible exactly
           where he looked for it. The grid is three compact fields now, not the
           screenful of widgets that the 08-10 pass was hiding. */
        box.hidden = false;
        void hasFile;
    }

    /* Что лежит в «после-фактных» панелях СЕЙЧАС — говорит тот, кто их рисует.
       Раньше это ВЫВОДИЛОСЬ из видимости заглушки, и вывод был неверен у всех
       трёх панелей сразу, каждый раз по своей причине:

         · история — renderHistory() гасит заглушку КЛАССОМ (`classList`), а
           проверка читала АТРИБУТ (`el.hidden`); два механизма не встречались;
         · закладки — renderBookmarks() перезаписывает innerHTML списка и свою
           заглушку попросту уничтожает, а на файловой странице её и в разметке
           нет: `_$()` отдаёт открепленный дубль, у него offsetParent === null,
           и «пусто» читалось как «есть содержимое»;
         · облако слов — заглушка в паре была объявлена как null, то есть
           сигнала не было вовсе.

       Цена была не косметическая: панель истории показывается ТОЛЬКО отсюда, а
       позвать эту функцию мог лишь updateStats(), то есть появление текста.
       Человек, вернувшийся за вчерашними расшифровками, видел пустую страницу —
       записи лежали в localStorage и рисовались в DOM, но секция оставалась
       hidden, пока он не надиктует новое. Сторож stt-history-restore.mjs
       падал на этом и указывал ровно сюда. */
    var panelHasOwn = {
        sttHistorySection: false,
        sttWordCloudSection: false,
        sttBookmarksSection: false,
    };

    /** Панель сообщает, есть ли у неё СОБСТВЕННОЕ содержимое (без расшифровки). */
    function declarePanelContent(sectionId, hasOwn) {
        panelHasOwn[sectionId] = !!hasOwn;
        syncPanelSections();
    }

    function syncPanelSections(hasTranscript) {
        /* Без аргумента — вывести самим: так функцию может позвать любая
           панель в момент отрисовки, а не только updateStats(), которая
           считает слова и передаёт готовый ответ (на потоковом прогоне она
           зовётся на каждый кусок, и второй разбор текста там лишний). */
        if (hasTranscript === undefined) {
            hasTranscript = !!getPlainTranscript();
        }

        /* The result panel is part of the same rule. Before a transcript exists
           it is an empty box captioned «Распознанный текст появится здесь» over
           a row of zeros — a screenful spent describing the absence of a result.
           It reveals itself the moment the first words land, because
           renderTranscript() calls updateStats() on every chunk, so a streaming
           run still shows text appearing live. */
        var tsec = _$('sttTranscriptSection');
        if (tsec) tsec.hidden = !hasTranscript;

        Object.keys(panelHasOwn).forEach(function (sectionId) {
            var sec = _$(sectionId);
            if (!sec) return;
            sec.hidden = !(hasTranscript || panelHasOwn[sectionId]);
        });
    }

    /* ── Чей текст на экране (22.10.2026) ──────────────────────────────────
       Имя документа, его длительность, библиотечная копия и запись истории
       раньше жили порознь и менялись в разные моменты: имя — при ВЫБОРЕ файла,
       копия — только при новом серверном результате. Поэтому «Загрузить в
       редактор» отдавал Word с именем и заголовком последнего выбранного файла,
       переименование говорящих в открытой из истории записи уезжало в
       библиотечную копию другой записи, а каждое переименование добавляло в
       историю ещё одну копию того же текста. Обращение 21.10 (Премиум, очередь
       из четырёх записей): «распознаются, но не понятно, как их сохранить» —
       и за октябрь 210+ минут нормы на повторные прогоны уже готовых файлов.
       Теперь всё это — свойства ДОКУМЕНТА и меняются вместе, одной функцией,
       в момент, когда на экран встаёт другой текст. */
    function adoptDocument(m) {
        m = m || {};
        exportSourceName = m.src || '';
        exportDurationSec = Math.round(m.dur || 0);
        libraryTranscriptId = m.lib || null;
        docEntryId = m.id || null;
        docSize = m.size || 0;
        try { syncAttachRow(); } catch (_) {}
    }
    /* Звук в плеере — от другой записи, чем текст: слушать с реплики нечем. */
    function playerIsOtherRecording() {
        if (!playerSrcName || !exportSourceName) return false;
        var base = function (s) { return String(s).replace(/\.[A-Za-z0-9]{1,8}$/, '').trim(); };
        return base(playerSrcName) !== base(exportSourceName);
    }

    /* =====================================================
       Section 14: History (localStorage)
       ===================================================== */
    var HIST_KEY = 'stt_history';
    var HIST_MAX = 20;
    var HIST_BUDGET = 2 * 1024 * 1024;

    function loadHistory() {
        try { return JSON.parse(localStorage.getItem(HIST_KEY) || '[]'); }
        catch(e) { return []; }
    }

    /* История хранила ОДИН плоский текст. Это делало её тупиком: вернуть
       запись в редактор было можно, а разобрать диалог или собрать саммари —
       нет, потому что таймкоды (а с ними и кликабельные цитаты) терялись при
       сохранении. Живой случай 2026-08-05 (Екатерина): «улетело в историю и я
       не могу там ничего сделать кроме как скопировать или перенести в
       редактор». Поэтому храним сегменты — они и есть расшифровка, а плоский
       текст лишь её представление. */
    function historySegments() {
        /* Правки в редакторе не переносятся на сегменты, поэтому после них
           истина — плоский текст, и сегменты сохранять НЕЛЬЗЯ: разбор
           процитировал бы то, чего в тексте уже нет. */
        if (userHasEdited) return null;
        var out = [];
        for (var i = 0; i < transcriptSegments.length; i++) {
            var s = transcriptSegments[i];
            if (!s) continue;
            var seg = { text: String(s.text || '') };
            if (typeof s.timestamp === 'number') seg.timestamp = Math.round(s.timestamp * 100) / 100;
            if (typeof s.end === 'number') seg.end = Math.round(s.end * 100) / 100;   /* paragraph gaps need real ends */
            if (s.speaker) seg.speaker = s.speaker;
            if (s.isParagraph) seg.isParagraph = 1;
            out.push(seg);
        }
        return out.length ? out : null;
    }

    /* localStorage — это ~5 МБ на весь origin, и трёхчасовая расшифровка с
       сегментами весит сотни килобайт. Прежний код клал всё одним setItem и
       глотал ошибку — при переполнении молча терялась и САМАЯ СВЕЖАЯ запись.
       Ужимаем осознанно: сперва снимаем сегменты со старых записей (их текст
       остаётся читаемым), и только потом жертвуем самими старыми записями. */
    function persistHistory(hist) {
        var list = hist.slice(0, HIST_MAX);
        var size = list.map(function (e) { return JSON.stringify(e).length + 1; });
        var total = function () {
            var s = 2;
            for (var i = 0; i < size.length; i++) s += size[i];
            return s;
        };
        for (var i = list.length - 1; i > 0 && total() > HIST_BUDGET; i--) {
            if (!list[i].segments) continue;
            delete list[i].segments;
            size[i] = JSON.stringify(list[i]).length + 1;
        }
        while (list.length > 1 && total() > HIST_BUDGET) { list.pop(); size.pop(); }
        try {
            localStorage.setItem(HIST_KEY, JSON.stringify(list));
        } catch (e) {
            /* Реальная квота меньше нашего бюджета — её делит весь сайт.
               Свежая запись важнее всей остальной истории. */
            try { localStorage.setItem(HIST_KEY, JSON.stringify(list.slice(0, 1))); list = list.slice(0, 1); }
            catch (e2) { list = []; }
        }
        return list;
    }

    /* One way into history, for both producers. The live surface is not the
       only thing worth keeping: a detached job's text never reaches the
       surface at all, and text the rescue is about to replace was on screen a
       moment ago — both go through here so budget, pruning and rendering stay
       in one place. */
    /* `extra` — документ, который НЕ на экране (результат отцепленной работы):
       тогда его имя, длина и id передаются явно, а личность экрана не трогается. */
    function pushHistoryEntry(text, segs, extra) {
        text = (text || '').trim();
        if (text.length < 10) return false;
        extra = extra || {};
        var own = !extra.detached;
        var hist = loadHistory();
        var id = own ? docEntryId : null;
        var entry = {
            id: id || ('h' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7)),
            text: text,
            preview: text.substring(0, 200),
            lang: $lang.value,
            date: Date.now(),
            mode: extra.mode || mode,
            /* Имя записи — чтобы скачивание ИЗ истории тоже называлось по материалу,
               а не «transcription.txt» для всех двадцати записей подряд. */
            src: (extra.src !== undefined) ? extra.src : (own ? (exportSourceName || '') : ''),
            dur: Math.round((extra.dur !== undefined) ? extra.dur : (own ? transcriptLengthSec() : 0)) || 0,
            wordCount: text.split(/\s+/).filter(function(w) { return w.length > 0; }).length
        };
        var lib = (extra.lib !== undefined) ? extra.lib : (own ? libraryTranscriptId : null);
        if (lib) entry.lib = lib;
        var size = (extra.size !== undefined) ? extra.size : (own ? docSize : 0);
        if (size) entry.size = size;
        if (segs) entry.segments = segs;
        /* Один документ — одна запись: переименование говорящего или «Отменить»
           обновляют свою запись, а не добавляют копию (раньше пять переименований
           вытесняли из двадцати мест пять других расшифровок). */
        if (id) hist = hist.filter(function (h) { return h && h.id !== id; });
        hist.unshift(entry);
        persistHistory(hist);
        if (own) docEntryId = entry.id;
        renderHistory();
        try { document.dispatchEvent(new CustomEvent('stt:entry', { detail: entry })); } catch (_) {}
        return true;
    }

    function saveToHistory() {
        return pushHistoryEntry(getPlainTranscript(), historySegments());
    }

    /* A worker result as plain text, without going through the surface. */
    function resultPlainText(result) {
        if (!result) return '';
        if (result.chunks && result.chunks.length) {
            return result.chunks.map(function (c) { return String((c && c.text) || '').trim(); })
                                .filter(Boolean).join(' ');
        }
        return String(result.text || '').trim();
    }

    /* The job finished, but the user has moved on to something else on the
       sheet. Three things must be true here and none of them were before:
       the text is not thrown away, it does not land on top of live work, and
       the user is told where it went. History is the right home — it already
       persists, survives reload and restores into the editor. */
    function deliverDetachedResult(result, headSegs, run) {
        var head = [];
        if (headSegs && headSegs.length) {
            for (var h = 0; h < headSegs.length; h++) {
                var ht = String((headSegs[h] && headSegs[h].text) || '').trim();
                if (ht) head.push({ text: ht, timestamp: headSegs[h].timestamp || 0 });
            }
        }
        var text = head.map(function (s) { return s.text; }).concat(resultPlainText(result) || []).join(' ').trim();
        var segs = null;
        if (result && result.chunks && result.chunks.length) {
            segs = head.slice();
            for (var i = 0; i < result.chunks.length; i++) {
                var c = result.chunks[i];
                var t = String((c && c.text) || '').trim();
                if (!t) continue;
                var seg = { text: t };
                if (c.timestamp && typeof c.timestamp[0] === 'number') seg.timestamp = Math.round(c.timestamp[0] * 100) / 100;
                if (c.timestamp && typeof c.timestamp[1] === 'number') seg.end = Math.round(c.timestamp[1] * 100) / 100;
                segs.push(seg);
            }
            if (!segs.length) segs = null;
        }
        /* Mode is not overridden: each page has exactly one (this page mic,
           /audio-to-text file), so the current value is the honest label. */
        var kept = pushHistoryEntry(text, segs, { detached: true, src: (run && run.src) || '', dur: (run && run.dur) || 0, size: (run && run.size) || 0 });
        if (kept) {
            showResultNote(escHtml(STR.detached_result_ready
                || 'The transcription of your previous recording is ready — it is saved in History below.'));
        }
        try {
            window.__ae && window.__ae('feature_use', {
                slug: TOOL_SLUG, f: 'detached_result_filed',
                chars: text.length, kept: kept ? 1 : 0, model: ($model && $model.value) || '',
            });
        } catch (_) {}
    }

    function renderHistory() {
        var hist = loadHistory();

        /* История — единственная из трёх панелей, у которой содержимое есть БЕЗ
           расшифровки: она лежит в localStorage и переживает перезагрузку.
           Ради этого случая объявление и заведено. */
        declarePanelContent('sttHistorySection', hist.length > 0);

        if (!hist.length) {
            $historyList.innerHTML = '';
            $historyEmpty.classList.remove('hidden');
            $historyList.appendChild($historyEmpty);
            $historyFooter.classList.add('hidden');
            return;
        }

        $historyEmpty.classList.add('hidden');
        $historyFooter.classList.remove('hidden');

        /* ⚠️ Заголовок записи — ИМЯ ФАЙЛА. До 22.10.2026 карточки подписывались
           только «N минут назад · File»: после очереди из четырёх записей
           человек видел четыре одинаковые карточки и не знал, какая из них
           какая (обращение 21.10: «не понятно, как их сохранить»). */
        var fmt = currentBulkFormat();
        var html = '';
        for (var i = 0; i < hist.length; i++) {
            var item = hist[i];
            var relTime = getRelativeTime(item.date);
            var modeLabel = item.mode === 'mic' ? '&#127908;' : '&#128193;';
            var fullText = item.text || item.preview || '';
            var len = entryLength(item);
            html += '<div class="stt-history-item" data-index="' + i + '">';
            html += '<div class="stt-history-head"><span class="stt-history-badge" aria-hidden="true">' + modeLabel + '</span>'
                  + '<strong class="stt-history-title">' + escHtml(entryTitle(item)) + '</strong></div>';
            html += '<div class="stt-history-meta">';
            html += '<span>' + relTime + '</span>';
            if (len) html += '<span>' + escHtml(len) + '</span>';
            html += '<span>' + item.wordCount + ' ' + STR.words + (item.lang ? ' &middot; ' + escHtml(item.lang) : '') + '</span>';
            html += '</div>';
            html += '<div class="stt-history-text">' + escHtml(fullText) + '</div>';
            html += '<div class="stt-history-actions">';
            html += '<button class="stt-hist-btn primary" type="button" data-action="load" data-index="' + i + '">' + STR.history_load + '</button>';
            html += '<button class="stt-hist-btn" type="button" data-action="copy" data-index="' + i + '">' + STR.copy + '</button>';
            html += '<button class="stt-hist-btn" type="button" data-action="download" data-index="' + i + '">&#11015; ' + escHtml(formatLabel(fmt)) + '</button>';
            html += '<button class="stt-hist-btn danger" type="button" data-action="delete" data-index="' + i + '">&times; ' + STR.history_delete + '</button>';
            html += '</div>';
            html += '</div>';
        }

        $historyList.innerHTML = html;
        $historyList.appendChild($historyEmpty);
        $historyEmpty.classList.add('hidden');
        renderHistoryBulk(hist.length);

        /* Toggle expand on click */
        $historyList.querySelectorAll('.stt-history-item').forEach(function(el) {
            el.addEventListener('click', function(e) {
                if (e.target.closest('.stt-hist-btn')) return;
                el.classList.toggle('expanded');
            });
        });

        /* Action buttons */
        $historyList.querySelectorAll('.stt-hist-btn').forEach(function(btn) {
            btn.addEventListener('click', function(e) {
                e.stopPropagation();
                var idx = parseInt(btn.dataset.index, 10);
                var h = loadHistory();
                var item = h[idx];
                if (!item) return;
                var action = btn.dataset.action;

                if (action === 'load') {
                    /* Записи до 22.10.2026 без id: получают его при открытии,
                       чтобы правки обновляли их, а не плодили копию. */
                    if (!item.id) {
                        item.id = newEntryId();
                        persistHistory(h);
                    }
                    openEntry(item);
                    try { aeTranscribe('history_open', { segs: (item.segments || []).length, named: item.src ? 1 : 0 }); } catch (_) {}
                } else if (action === 'copy') {
                    navigator.clipboard.writeText(item.text).catch(function(){});
                } else if (action === 'download') {
                    deliverEntry(item, currentBulkFormat(), 'history');
                } else if (action === 'delete') {
                    h.splice(idx, 1);
                    persistHistory(h);
                    renderHistory();
                }
            });
        });
    }

    function newEntryId() {
        return 'h' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
    }
    /* Подпись записи: имя файла без расширения; у диктовки — дата. */
    function entryTitle(e) {
        var TF = window.__transcriptFile;
        var src = String((e && e.src) || '').trim();
        if (src) return TF ? TF.heading(src) : src.replace(/\.[A-Za-z0-9]{1,8}$/, '');
        try {
            return new Date(e.date).toLocaleString(window.__intlLocale ? window.__intlLocale() : undefined,
                { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
        } catch (_) { return STR.transcription_title || ''; }
    }
    function entryLength(e) {
        var TF = window.__transcriptFile;
        var sec = (e && e.dur) || 0;
        if (!sec && e && e.segments && e.segments.length) {
            var last = e.segments[e.segments.length - 1] || {};
            sec = (typeof last.end === 'number' ? last.end : last.timestamp) || 0;
        }
        if (!TF || sec < 1) return '';
        return TF.humanLength(sec, { h: STR.len_h || '{h} h {m} min', m: STR.len_m || '{m} min' });
    }

    /* Открыть запись истории (или результат очереди) на экране. `file` — сама
       запись, если она у страницы есть: тогда реплики слушаются с места. */
    function openEntry(item, file) {
        if (!item) return;
        if (item.segments && item.segments.length) {
            transcriptSegments = item.segments.map(function (s) {
                var seg = {
                    text: String(s.text || ''),
                    timestamp: typeof s.timestamp === 'number' ? s.timestamp : 0,
                    isFinal: true
                };
                if (typeof s.end === 'number') seg.end = s.end;
                if (s.speaker) seg.speaker = s.speaker;
                if (s.isParagraph) seg.isParagraph = true;
                return seg;
            });
        } else {
            /* Записи, сохранённые до появления сегментов, и записи
               после ручной правки: таймкодов нет, но текст жив. */
            transcriptSegments = [{ text: item.text, timestamp: 0, isFinal: true }];
        }
        finalTranscript = item.text;
        userHasEdited = false;
        hideResultNote();
        adoptDocument({ src: item.src || '', dur: item.dur || 0, lib: item.lib || null, id: item.id || null, size: item.size || 0 });
        if (file && mode === 'file') {
            /* Рейка показывает ту же запись, что и текст: иначе «Расшифровать»
               и плеер говорили бы о другом файле. */
            currentFile = file;
            try { $fileName.textContent = file.name; $fileMeta.textContent = formatFileSize(file.size); } catch (_) {}
            attachAudio(file);
        }
        /* File mode renders paragraphs + speaker chips; the mic
           renderer would flatten a restored dialogue into one run. */
        if (item.segments && item.segments.length) { if (mode === 'file') renderFileTranscript(); else renderTranscript(); }
        else $transcript.textContent = item.text;
        updateStats();
        generateWordCloud(true);
        syncAttachRow();
        var sec = _$('sttTranscriptSection'); if (sec) sec.hidden = false;
        /* Без этого история оставалась тупиком: текст возвращался в
           редактор, а «Разобрать диалог» и саммари не появлялись.
           Условия видимости решает сама функция — здесь мы только
           перестаём её не звать. */
        revealAiButtons();
    }

    /* ── Файл из ЛЮБОЙ записи, а не только из той, что на экране ────────────
       Семь форматов собирались из глобального состояния экрана, поэтому
       запись истории скачивалась только TXT, а «скачать все» не было вовсе.
       Документ — значение {text, segs, src, dur, lang}; экран — лишь один из
       документов, и путь сборки у всех один (buildDocFile). */
    var BULK_FORMATS = ['docx', 'pdf', 'txt', 'md', 'srt', 'vtt', 'json'];
    function formatLabel(fmt) {
        return ({ docx: 'Word', pdf: 'PDF', txt: 'TXT', md: 'Markdown', srt: 'SRT', vtt: 'VTT', json: 'JSON' })[fmt] || String(fmt).toUpperCase();
    }
    function currentBulkFormat() {
        var v = 'docx';
        try { if (window.__toolSettings) v = String(window.__toolSettings.load(TOOL_SLUG, 'bulk_fmt', 'docx')); } catch (_) {}
        return BULK_FORMATS.indexOf(v) >= 0 ? v : 'docx';
    }
    function setBulkFormat(fmt) {
        if (BULK_FORMATS.indexOf(fmt) < 0) return;
        try { window.__toolSettings && window.__toolSettings.save(TOOL_SLUG, 'bulk_fmt', fmt); } catch (_) {}
        renderHistory();
        try { document.dispatchEvent(new CustomEvent('stt:bulk-format', { detail: { fmt: fmt } })); } catch (_) {}
    }
    function entryDoc(e) {
        var segs = (e && e.segments && e.segments.length) ? e.segments : null;
        return { text: String((e && e.text) || ''), segs: segs, src: (e && e.src) || '', dur: (e && e.dur) || 0,
                 lang: (e && e.lang) || '' };
    }
    /* Документ экрана — тем же значением: правка руками, переименования и
       удалённые реплики уже в нём (getPlainTranscript синхронизирует DOM). */
    function currentDoc() {
        var text = getPlainTranscript();
        return { text: text || '', segs: (!userHasEdited && transcriptSegments.length) ? transcriptSegments : null,
                 src: exportSourceName || '', dur: exportDurationSec || transcriptLengthSec(),
                 lang: ($lang && $lang.value) || '' };
    }
    function hasTimesIn(segs) {
        if (!segs) return false;
        for (var i = 0; i < segs.length; i++) if ((segs[i] && segs[i].timestamp) > 0) return true;
        return false;
    }
    function docOpts() {
        return { speakers: showSpeakersOn(), timestamps: !!($timestamps && $timestamps.checked) };
    }
    function docText(d) {
        if (!d.segs) return d.text.trim();
        return paragraphsToText(buildParagraphs(d.segs), docOpts());
    }
    /* Абзацы для Word: СТРУКТУРОЙ, пока структура жива.
       ⚠️⚠️ Данные в файле были и раньше — не было ВИДА. Метка «Говорящий 2:»
       уходила в тело абзаца обычным шрифтом, и Word показывал прозу там, где на
       экране цветные пилюли: «в окошке текст с разделением на говорящих, при
       скачивании сплошной» (Премиум-пользовательница, 06.09.2026). Имя —
       отдельной жирной строкой без нижнего отступа, время — серым. Если
       человек переписал текст руками, структуры нет — абзацы из текста. */
    function docBlocks(d) {
        var TF = window.__transcriptFile;
        if (TF && d.segs) {
            var blocks = TF.blocks(d.segs, docOpts());
            if (blocks.length) {
                var out = [];
                for (var i = 0; i < blocks.length; i++) {
                    var b = blocks[i];
                    var head = [b.time ? '[' + b.time + ']' : '', b.speaker || ''].filter(Boolean).join(' ');
                    if (head) out.push({ text: head, bold: !!b.speaker, size: b.speaker ? 22 : 18,
                                         color: b.speaker ? null : '808080', spaceAfter: false });
                    out.push({ text: b.text });
                }
                return out;
            }
        }
        return docText(d).split(/\n\n+/).filter(function (p) { return p.trim() !== ''; });
    }
    function docCues(d) {
        var cues = [], segs = d.segs || [];
        for (var i = 0; i < segs.length; i++) {
            var seg = segs[i];
            if (!seg || seg.isParagraph || !seg.text) continue;
            cues.push({ start: seg.timestamp || 0, end: (typeof seg.end === 'number') ? seg.end : null,
                        text: seg.text, speaker: seg.speaker });
        }
        return cues;
    }
    function docHeading(d, fallback) {
        var TF = window.__transcriptFile;
        return TF ? TF.heading(d.src, { fallback: fallback || STR.transcription_title }) : (d.src || fallback || STR.transcription_title);
    }
    function docSubtitle(d, stamp) {
        var TF = window.__transcriptFile;
        return TF ? TF.subtitle({
            word: STR.transcription_title,
            durationSec: d.dur || 0,
            lenTpl: { h: STR.len_h || '{h} h {m} min', m: STR.len_m || '{m} min' },
            date: stamp,
        }) : stamp;
    }
    async function ensurePdfLibs() {
        var load = function (src) {
            return new Promise(function (resolve, reject) {
                var s = document.createElement('script');
                s.src = src; s.onload = resolve; s.onerror = reject;
                document.head.appendChild(s);
            });
        };
        if (!window.html2canvas) await load(CFG.urls.html2canvas);
        if (!window.jspdf) await load(CFG.urls.jspdf);
        if (!window.pdfExport) await load(CFG.urls.pdfExport);
        return !!(window.html2canvas && window.jspdf && window.pdfExport);
    }
    /* Документ → {blob, name}; null — у документа нет того, что просит формат
       (субтитры без таймкодов, пустой текст). Бросает на сбое сборки. */
    async function buildDocFile(fmt, d) {
        var name = outName(fmt, d.src || '');
        var text = docText(d);
        if (!text) return null;
        if (fmt === 'txt') return { blob: new Blob([text], { type: 'text/plain;charset=utf-8' }), name: name };
        if (fmt === 'md') {
            /* Markdown: те же абзацы, имя говорящего жирным, время — кодом. */
            var md = text.split(/\n\n+/).map(function (p) {
                return p.replace(/^(\[(?:\d+:)?\d\d:\d\d\])\s*/, '`$1` ')
                        .replace(/^((?:`[^`]*`\s*)?)([^:\n`]{1,40}):\s/, function (m, ts, nm) { return ts + '**' + nm + ':** '; });
            }).join('\n\n');
            return { blob: new Blob([md], { type: 'text/markdown;charset=utf-8' }), name: name };
        }
        if (fmt === 'srt' || fmt === 'vtt') {
            if (!d.segs || !hasTimesIn(d.segs)) return null;
            var S = window.SubtitleSerializer;
            var cues = docCues(d);
            var spk = cues.some(function (c) { return !!c.speaker; });
            var sub = S ? (fmt === 'srt' ? S.toSrt(cues, { speakers: spk }) : S.toVtt(cues, { speakers: spk }))
                        : (fmt === 'vtt' ? 'WEBVTT\n\n' : '') + legacySrtFrom(d.segs);
            return { blob: new Blob([sub.trim()], { type: 'text/plain;charset=utf-8' }), name: name };
        }
        if (fmt === 'json') {
            var data = { text: text, segments: d.segs || [], language: d.lang || '', date: new Date().toISOString() };
            return { blob: new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' }), name: name };
        }
        var stamp = new Date().toLocaleString(window.__LOCALE);
        if (fmt === 'docx') {
            var blob = await window.DocxWriter.build({ title: docHeading(d), subtitle: docSubtitle(d, stamp), paragraphs: docBlocks(d) });
            return { blob: blob, name: name };
        }
        if (fmt === 'pdf') {
            if (!(await ensurePdfLibs())) throw new Error('pdf_libs_missing');
            var el = document.createElement('div');
            el.style.cssText = 'font-family:Arial,sans-serif;font-size:12pt;line-height:1.6;padding:20px;color:#222;background:#fff;width:700px;position:absolute;left:-9999px;top:0;';
            var html = '<h1 style="font-size:18pt;margin-bottom:8px;color:#222;">' + escHtml(docHeading(d)) + '</h1>'
                     + '<p style="color:#888;font-size:10pt;">' + escHtml(docSubtitle(d, stamp)) + '</p><hr style="margin:10px 0;border-color:#ddd;">';
            text.split(/\n\n+/).forEach(function (p) {
                if (p.trim()) html += '<p style="margin:8px 0;color:#222;">' + escHtml(p).replace(/\n/g, '<br>') + '</p>';
            });
            el.innerHTML = html;
            document.body.appendChild(el);
            void el.offsetHeight;
            try {
                /* captureToPdf режет высокий холст на страницы (pdf-export.js):
                   одним снимком 90-минутная расшифровка давала пустой PDF. */
                var pdf = await window.pdfExport.captureToPdf(el, { scale: 2, margin: 15, overlap: 12 });
                return { blob: pdf.output('blob'), name: name, pdf: pdf };
            } finally { try { document.body.removeChild(el); } catch (_) {} }
        }
        return null;
    }
    function legacySrtFrom(segs) {
        var out = '', n = 0;
        for (var i = 0; i < segs.length; i++) {
            var seg = segs[i];
            if (!seg || seg.isParagraph || !seg.text) continue;
            var startT = seg.timestamp || 0;
            var endT = (typeof seg.end === 'number') ? seg.end : (segs[i + 1] ? (segs[i + 1].timestamp || startT + 5) : startT + 5);
            out += (++n) + '\n' + formatSRTTime(startT) + ' --> ' + formatSRTTime(endT) + '\n' + seg.text + '\n\n';
        }
        return out;
    }
    /* Одна запись → один файл, тем же путём выдачи, что и экспорт экрана. */
    async function deliverEntry(entry, fmt, where) {
        var d = entryDoc(entry);
        try {
            var f = await buildDocFile(fmt, d);
            if (!f) { showToast(STR.bulk_no_times || '', 'info'); return false; }
            if (f.pdf && window.__savePdf) window.__savePdf(f.pdf, f.name);
            else downloadFile(f.blob, f.name, f.blob.type);
            try { aeTranscribe('entry_export', { fmt: fmt, where: where || '', named: d.src ? 1 : 0 }); } catch (_) {}
            return true;
        } catch (e) {
            if (window.__handleError) window.__handleError(e, 'stt_entry_export', { say: STR.export_failed || '' });
            try { aeTranscribe('entry_export', { fmt: fmt, where: where || '', ok: 0 }); } catch (_) {}
            return false;
        }
    }
    function bulkName(fmt, n) {
        var TF = window.__transcriptFile;
        return TF ? TF.name('', fmt, { word: STR.file_word || 'transcript', suffix: '(' + n + ')' }) : 'transcripts.' + fmt;
    }
    /* Много записей: архивом (каждая — свой файл, имена различны) или одним
       документом подряд, с именем записи заголовком. Субтитры, JSON и PDF
       одним файлом не бывают: у каждой записи своя шкала времени и страницы. */
    async function deliverEntries(entries, fmt, opts) {
        opts = opts || {};
        entries = (entries || []).filter(Boolean);
        if (!entries.length) return { ok: false, n: 0 };
        if (opts.combined && (fmt === 'docx' || fmt === 'txt' || fmt === 'md')) {
            var docs = entries.map(entryDoc);
            var n = docs.length, blob;
            if (fmt === 'docx') {
                var paras = [];
                docs.forEach(function (d, i) {
                    if (i) paras.push({ text: '' });
                    paras.push({ text: docHeading(d, entryTitle(entries[i])), bold: true, size: 28, spaceAfter: false });
                    var sub = docSubtitle(d, '');
                    if (sub) paras.push({ text: sub, size: 18, color: '808080' });
                    paras = paras.concat(docBlocks(d));
                });
                blob = await window.DocxWriter.build({
                    title: (STR.bulk_combined_title || 'Transcripts ({n})').replace('{n}', n),
                    subtitle: new Date().toLocaleString(window.__LOCALE),
                    paragraphs: paras,
                });
            } else {
                var parts = docs.map(function (d, i) {
                    var head = docHeading(d, entryTitle(entries[i]));
                    return (fmt === 'md' ? '## ' + head : head + '\n' + new Array(Math.min(60, head.length) + 1).join('='))
                        + '\n\n' + docText(d);
                });
                blob = new Blob([parts.join('\n\n\n')], { type: fmt === 'md' ? 'text/markdown;charset=utf-8' : 'text/plain;charset=utf-8' });
            }
            downloadFile(blob, bulkName(fmt, n), blob.type);
            try { aeTranscribe('bulk_export', { fmt: fmt, n: n, combined: 1, where: opts.where || '' }); } catch (_) {}
            return { ok: true, n: n, via: 'combined' };
        }
        var items = [], skipped = 0;
        for (var i = 0; i < entries.length; i++) {
            var f = await buildDocFile(fmt, entryDoc(entries[i]));
            if (f) items.push({ name: f.name, blob: f.blob }); else skipped++;
        }
        if (!items.length) { showToast(STR.bulk_no_times || '', 'info'); return { ok: false, n: 0, skipped: skipped }; }
        var res = { via: 'single' };
        if (items.length === 1) downloadFile(items[0].blob, items[0].name, items[0].blob.type);
        else {
            var BD = window.__batchDeliver || (window.__ensureBatchDeliver ? await window.__ensureBatchDeliver() : null);
            if (!BD) throw new Error('batch_deliver_missing');
            res = await BD.deliver(items, { zipName: bulkName('zip', items.length), slug: TOOL_SLUG, archiveOnly: true });
        }
        if (skipped && STR.bulk_skipped) showToast(STR.bulk_skipped.replace('{n}', skipped), 'info');
        try { aeTranscribe('bulk_export', { fmt: fmt, n: items.length, skipped: skipped, combined: 0, via: (res && res.via) || '', where: opts.where || '' }); } catch (_) {}
        return { ok: true, n: items.length, skipped: skipped, via: res && res.via };
    }
    /* Низ истории: формат, «Скачать все», «Одним файлом». Строится здесь, а не
       в блейде: история у двух страниц одна. */
    function renderHistoryBulk(n) {
        if (!$historyFooter) return;
        var box = _$('sttHistoryBulk');
        if (!box) {
            box = document.createElement('div');
            box.id = 'sttHistoryBulk';
            box.className = 'stt-bulk';
            var lab = document.createElement('label');
            lab.className = 'stt-bulk-fmt';
            var cap = document.createElement('span');
            cap.textContent = STR.bulk_format || 'Format';
            var sel = document.createElement('select');
            BULK_FORMATS.forEach(function (f) { var o = document.createElement('option'); o.value = f; o.textContent = formatLabel(f); sel.appendChild(o); });
            sel.addEventListener('change', function () { setBulkFormat(sel.value); });
            lab.append(cap, sel);
            var zip = document.createElement('button');
            zip.type = 'button'; zip.className = 'stt-hist-btn primary'; zip.dataset.bulk = 'zip';
            var one = document.createElement('button');
            one.type = 'button'; one.className = 'stt-hist-btn'; one.dataset.bulk = 'one';
            var run = function (btn, combined) {
                btn.disabled = true;
                deliverEntries(loadHistory(), currentBulkFormat(), { combined: combined, where: 'history' })
                    .catch(function (e) { if (window.__handleError) window.__handleError(e, 'stt_bulk_export', { say: STR.export_failed || '' }); })
                    .then(function () { btn.disabled = false; });
            };
            zip.addEventListener('click', function () { run(zip, false); });
            one.addEventListener('click', function () { run(one, true); });
            box.append(lab, zip, one);
            $historyFooter.insertBefore(box, $historyFooter.firstChild);
        }
        var fmt = currentBulkFormat();
        box.querySelector('select').value = fmt;
        var zipBtn = box.querySelector('[data-bulk=zip]');
        zipBtn.textContent = '\u2B07 ' + (STR.bulk_all || 'Download all ({n})').replace('{n}', n);
        zipBtn.hidden = n < 2;
        var oneBtn = box.querySelector('[data-bulk=one]');
        oneBtn.textContent = STR.bulk_one_file || 'One file';
        oneBtn.hidden = n < 2 || !(fmt === 'docx' || fmt === 'txt' || fmt === 'md');
    }

    function clearHistory() {
        if (!confirm(STR.history_clear_confirm)) return;
        try { localStorage.removeItem(HIST_KEY); } catch(e) {}
        renderHistory();
    }

    function getRelativeTime(timestamp) {
        var diff = Date.now() - timestamp;
        var mins = Math.floor(diff / 60000);
        var hours = Math.floor(diff / 3600000);
        var days = Math.floor(diff / 86400000);

        if (mins < 1) return STR.just_now;
        if (mins < 60) return mins + ' ' + STR.minutes_ago;
        if (hours < 24) return hours + ' ' + STR.hours_ago;
        return days + ' ' + STR.days_ago;
    }

    /* =====================================================
       Section 15: Keyboard shortcuts
       ===================================================== */
    document.addEventListener('keydown', function(e) {
        var kl = window.__keyLetter ? window.__keyLetter(e) : String(e.key || '').toLowerCase();
        /* Ctrl+Shift+R — Start/Stop recording */
        if (e.ctrlKey && e.shiftKey && kl === 'r') {
            e.preventDefault();
            if (mode !== 'mic') return;
            isRecording ? stopRecording() : startRecording();
            return;
        }
        /* Ctrl+Shift+P — Pause/Resume */
        if (e.ctrlKey && e.shiftKey && kl === 'p') {
            e.preventDefault();
            if (mode !== 'mic' || !isRecording) return;
            isPaused ? resumeRecording() : pauseRecording();
            return;
        }
        /* Ctrl+Shift+C — Copy transcript */
        if (e.ctrlKey && e.shiftKey && kl === 'c') {
            e.preventDefault();
            copyTranscript();
            return;
        }
        /* Ctrl+S — Save as TXT */
        if (e.ctrlKey && !e.shiftKey && kl === 's') {
            e.preventDefault();
            exportCurrent('txt');
            return;
        }
        /* Ctrl+F — Find */
        if (e.ctrlKey && !e.shiftKey && kl === 'f') {
            e.preventDefault();
            if ($findPanel.classList.contains('hidden')) {
                openFindPanel();
            } else {
                closeFindPanel();
            }
            return;
        }
        /* Ctrl+Shift+B — Add bookmark */
        if (e.ctrlKey && e.shiftKey && kl === 'b') {
            e.preventDefault();
            addBookmark();
            return;
        }
        /* Ctrl+Shift+D — Toggle dictation mode */
        if (e.ctrlKey && e.shiftKey && kl === 'd') {
            e.preventDefault();
            isDictationMode ? exitDictation() : enterDictation();
            return;
        }
        /* Escape — Close panels */
        if (e.key === 'Escape') {
            if (isDictationMode) { exitDictation(); return; }
            if (!$findPanel.classList.contains('hidden')) closeFindPanel();
            if ($exportMenu.classList.contains('show')) $exportMenu.classList.remove('show');
        }
        /* Enter in find input */
        if (e.key === 'Enter' && document.activeElement === $findInput) {
            e.preventDefault();
            if (e.shiftKey) findPrevious();
            else findNext();
        }
    });

    /* =====================================================
       Section 16: Mode toggle, UI, drag-drop, init
       ===================================================== */

    /* ── Режим определяется URL: /speech-to-text против /audio-to-text ──
       Переключатель — это ссылки между двумя страницами, JS тут не нужен.
       ⚠️ Здесь стояла строка, прятавшая чекбокс «непрерывный режим» на
       файловой странице. После разведения блейдов (08.09.2026) файловая
       страница его вовсе не рендерит, а `closest('label')` у открепленного
       запасного узла возвращает null — то есть строка перестала быть нужной
       ровно тогда, когда начала падать. */

    /* ── Record button ── */
    $recordBtn.addEventListener('click', function() {
        isRecording ? stopRecording() : startRecording();
    });

    /* "Record again" CTA inside the playback panel — direct affordance for users
       whose actual record button has scrolled out of view after a recording.
       Telemetry: emitted alongside startRecording so we can measure adoption. */
    if ($recordAgainBtn) {
        $recordAgainBtn.addEventListener('click', function() {
            try { window.__ae && window.__ae('feature_use', { slug: TOOL_SLUG, f: 'record_again_click' }); } catch(e) {}
            startRecording();
        });
    }

    /* Whisper-refine click — hands the captured audio to the offline Whisper
       pipeline. Disables itself during transcription to prevent double-fire
       (transcribeFile flips isTranscribing and updates UI). Telemetry +
       graceful no-op when no recording exists. */
    if ($whisperRefineBtn) {
        $whisperRefineBtn.addEventListener('click', function () {
            if (isTranscribing || !recordedChunks.length) return;
            $whisperRefineBtn.disabled = true;
            Promise.resolve(transcribeRecordedAudio({ auto: false })).finally(function () {
                $whisperRefineBtn.disabled = false;
            });
        });
    }

    /* Warning Try-again — closes the rage-click loop where users tapped the
       inert warning text expecting a button. Resets the no-speech counters
       so the 10 s "no result" timer re-arms; if the recording was still
       active, we coax recognition back to life. */
    if ($warnRetryBtn) {
        $warnRetryBtn.addEventListener('click', function() {
            try { window.__ae && window.__ae('feature_use', { slug: TOOL_SLUG, f: 'warning_try_again' }); } catch(e) {}
            hideWarning();
            noSpeechCount = 0;
            hasGotResult = false;
            /* Coax recognition back to life — rebuild the session fresh.
               Skipped once Web Speech has handed off to Whisper-takeover. */
            if (isRecording && !isPaused && !webSpeechFailed) {
                restartVoiceSession();
            }
        });
    }
    if ($warnFileLink) {
        $warnFileLink.addEventListener('click', function() {
            try { window.__ae && window.__ae('feature_use', { slug: TOOL_SLUG, f: 'warning_switch_to_file' }); } catch(e) {}
            /* Default <a> navigation handles the rest. */
        });
    }

    $pauseBtn.addEventListener('click', function() {
        isPaused ? resumeRecording() : pauseRecording();
    });

    $stopBtn.addEventListener('click', function() {
        stopRecording();
    });

    /* ── Playback controls ── */
    $playBtn.addEventListener('click', togglePlayback);
    $playbackWrap.addEventListener('click', seekPlayback);

    /* ── Settings toggle ── */
    $settingsBtn.addEventListener('click', function() {
        $advSettings.classList.toggle('hidden');
    });

    /* ── Language change ── */
    $lang.addEventListener('change', function() {
        savePrefs();
        /* If recording, rebuild the recognition session with the new
           language (Web Speech can't change lang on a live session). */
        if (isRecording && !isPaused && !webSpeechFailed) {
            restartVoiceSession();
        }
    });

    /* ── Checkbox changes ── */
    $continuous.addEventListener('change', savePrefs);
    $timestamps.addEventListener('change', function() {
        savePrefs();
        /* File mode renders paragraphs/speakers; the mic renderer would flatten
           them (it knows nothing about turns). */
        if (mode === 'file') renderFileTranscript(); else renderTranscript();
    });
    if ($showSpeakers) $showSpeakers.addEventListener('change', function () {
        try { window.__toolSettings && window.__toolSettings.save(TOOL_SLUG, 'show_speakers', $showSpeakers.checked ? 1 : 0); } catch (_) {}
        renderFileTranscript();
        try { aeTranscribe('speakers_toggle', { on: $showSpeakers.checked ? 1 : 0 }); } catch (_) {}
    });
    $autoScroll.addEventListener('change', savePrefs);
    $autoPunct.addEventListener('change', savePrefs);
    $voiceCommands.addEventListener('change', savePrefs);
    $autoParagraphs.addEventListener('change', savePrefs);

    /* ── Upload — component owns drag/drop/click/keyboard ──
       Через __bindUploaderFile, а не голым addEventListener: на медленной сети
       файл бывает выбран РАНЬШЕ, чем этот модуль подключился, и событие
       уезжает в пустоту — тул стоит мёртвый, пока человек не выберет файл
       второй раз. Помощник доигрывает такой выбор задним числом (окно 30 с) и
       не задваивает, когда гонки не было. Голый слушатель остаётся запасным
       путём на случай, если tool-uploader.js ещё не выполнился. */
    if (typeof window.__bindUploaderFile === 'function') {
        window.__bindUploaderFile($dropzone, handleFile);
    } else {
        $dropzone.addEventListener('tool-uploader:file', function(e) {
            var f = e.detail && (e.detail.file || (e.detail.files && e.detail.files[0]));
            if (f) handleFile(f);
        });
    }
    function reopenPicker(){
        if ($dropzone.__uploaderReset) $dropzone.__uploaderReset();
        if ($dropzone.__uploaderOpen)  $dropzone.__uploaderOpen();
    }

    /* ── File remove ── */
    $fileRemove.addEventListener('click', function(e) {
        e.stopPropagation();
        try { window.__ae && window.__ae('feature_use', { slug: TOOL_SLUG, f: 'file_remove' }); } catch(_) {}
        removeFile();
    });

    /* The names note follows what is typed, not only what is saved. */
    if ($glossary) $glossary.addEventListener('input', updateNamesNote);
    if ($people) $people.addEventListener('input', updateNamesNote);

    /* Persist the glossary across sessions (proper nouns stay set). */
    if ($glossary) $glossary.addEventListener('change', function () {
        savePrefs();
        try { if (this.value.trim()) window.__ae && window.__ae('feature_use', { slug: TOOL_SLUG, f: 'glossary_set', len: this.value.trim().length }); } catch (_) {}
    });

    /* ── «Эта запись уже расшифрована» (22.10.2026) ────────────────────────
       RU, 60 дней: 192 из 1103 серверных расшифровок (17 %, 2 619 минут) —
       повтор файла, который тот же человек уже расшифровывал; 139 дали тот же
       текст. Человек не находил готовое и запускал снова — минуты нормы, токены
       и полчаса ожидания. Теперь перед прогоном: та же запись (имя без
       расширения и длина) уже есть в истории или в «Моих генерациях» →
       «Открыть готовую» или «Расшифровать заново». Решает человек: повтор с
       другими настройками законен. */
    var existingAsk = false;
    function sameRecordingName(a, b) {
        var base = function (x) { return String(x || '').replace(/\.[A-Za-z0-9]{1,8}$/, '').trim(); };
        return !!a && base(a) === base(b);
    }
    function historyMatch(file, dur) {
        if (!dur) return null;
        var hist = loadHistory(), tol = Math.max(1.5, dur * 0.005);
        for (var i = 0; i < hist.length; i++) {
            var h = hist[i];
            if (!h || h.mode === 'mic' || !sameRecordingName(h.src, file.name)) continue;
            /* Имя и длина у разных записей совпадают чаще, чем кажется
               («test.wav», «Новая запись.m4a» по полминуты): запись, знающая
               размер файла, опознаётся по имени И байтам (22.10.2026). */
            if (h.size && file.size) { if (h.size === file.size) return h; continue; }
            if (h.dur) { if (Math.abs(h.dur - dur) <= tol) return h; continue; }
            /* Записи до 22.10.2026 длины не хранят: конец последней реплики
               стоит не дальше длины записи и не сильно раньше её. */
            var last = h.segments && h.segments.length ? h.segments[h.segments.length - 1] : null;
            var end = last ? ((typeof last.end === 'number' ? last.end : last.timestamp) || 0) : 0;
            if (end > 0 && end <= dur + tol && end >= dur - Math.max(30, dur * 0.05)) return h;
        }
        return null;
    }
    function lookupExisting(file, dur) {
        if (!file || mode !== 'file') return Promise.resolve(null);
        dur = Math.round(dur || 0);
        if (file.__sttExisting && file.__sttExisting.dur === dur) return file.__sttExisting.p;
        var h = historyMatch(file, dur), p;
        if (h) p = Promise.resolve({ where: 'history', entry: h, at: h.date || 0 });
        else if (dur > 0 && CFG.urls.transcribeExisting && typeof __serverAsr !== 'undefined' && asrServerAllowed()) {
            p = fetch(CFG.urls.transcribeExisting + '?name=' + encodeURIComponent(file.name || '') + '&dur=' + dur, {
                credentials: 'same-origin', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            }).then(function (r) { return r.ok ? r.json() : null; })
              .then(function (d) { return (d && d.match) ? { where: 'library', match: d.match, at: Date.parse(d.match.at) || 0 } : null; })
              .catch(function () { return null; });
        } else p = Promise.resolve(null);
        var rec = { dur: dur, p: p, done: false, value: undefined };
        p.then(function (v) { rec.done = true; rec.value = v; });
        file.__sttExisting = rec;
        return p;
    }
    /* Длина выбранного файла: из метаданных плеера, если они уже пришли;
       иначе ждём их не дольше `ms` (0 — длины нет, проверка не нужна). */
    function playerDurationOf(file) {
        var d = $audioPlayer ? $audioPlayer.duration : 0;
        return (playerSrcName === (file.name || '') && isFinite(d) && d > 0) ? d : 0;
    }
    function whenDuration(file, ms) {
        if (playerDurationOf(file)) return Promise.resolve(playerDurationOf(file));
        return new Promise(function (resolve) {
            var done = false;
            var finish = function () {
                if (done) return; done = true;
                $audioPlayer.removeEventListener('loadedmetadata', onMeta);
                resolve(playerDurationOf(file));
            };
            var onMeta = function () { setTimeout(finish, 0); };
            $audioPlayer.addEventListener('loadedmetadata', onMeta);
            setTimeout(finish, ms);
        });
    }
    /* Готова ли уже эта запись — спросить, как только у плеера есть длина:
       к нажатию «Расшифровать» ответ уже здесь. Свой слушатель, а не в
       initServerAsr(): та выходит, когда серверного лейна нет, а история
       браузерного лейна тоже бывает «уже готовым». */
    if ($audioPlayer) $audioPlayer.addEventListener('loadedmetadata', function () {
        if (mode !== 'file' || !currentFile) return;
        var d = playerDurationOf(currentFile);
        if (d) { try { lookupExisting(currentFile, d); } catch (_) {} }
    });
    function existingWhen(ms) {
        if (!ms) return '';
        try {
            return new Date(ms).toLocaleString(window.__intlLocale ? window.__intlLocale() : undefined,
                { day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit' });
        } catch (_) { return ''; }
    }
    function serverModelName(key) {
        var q = (typeof QUALITY_LABELS !== 'undefined') ? QUALITY_LABELS[key] : null;
        try { return (q && q.name) ? q.name() : ''; } catch (_) { return ''; }
    }
    /* → 'open' | 'run' | 'cancel' */
    async function askExisting(file, m) {
        var TF = window.__transcriptFile;
        var name = TF ? TF.heading(file.name) : file.name;
        var bits = [existingWhen(m.at)];
        if (m.where === 'library') {
            var mn = serverModelName(m.match.model);
            if (mn) bits.push(mn);
            if (m.match.diarized && m.match.speakers > 1) bits.push((STR.existing_speakers || '{n}').replace('{n}', m.match.speakers));
        }
        var where = m.where === 'library'
            ? (STR.existing_in_library || '').replace('{date}', existingWhen(Date.parse(m.match.kept_until) || 0) || '—')
            : (STR.existing_in_history || '');
        var html = escHtml((STR.existing_body || '{name} — {details}.').replace('{name}', name).replace('{details}', bits.filter(Boolean).join(', ')))
                 + (where ? '<br><br>' + escHtml(where) : '');
        var ageH = m.at ? Math.round((Date.now() - m.at) / 36e5) : -1;
        aeTranscribe('existing_offer', { where: m.where, ageH: ageH, min: Math.round(playerDurationOf(file) / 60) });
        var r = await showConfirmModal({
            title: STR.existing_title || '',
            html: html,
            confirmLabel: STR.existing_open || STR.history_load,
            altLabel: STR.existing_rerun || STR.transcribe,
            cancelLabel: STR.cancel,
        });
        if (r === true) {
            var ok = await openExisting(file, m);
            aeTranscribe('existing_open', { where: m.where, ok: ok ? 1 : 0, ageH: ageH });
            if (ok) return 'open';
            /* Копия успела истечь: честно сказать и не прятать запуск. */
            showToast(STR.library_expired || '', 'info');
            return 'cancel';
        }
        if (r === 'alt') { file.__sttRerun = true; aeTranscribe('existing_rerun', { where: m.where, ageH: ageH }); return 'run'; }
        aeTranscribe('existing_cancel', { where: m.where });
        return 'cancel';
    }
    async function openExisting(file, m) {
        if (m.where === 'history') {
            var h = loadHistory(), e = null;
            for (var i = 0; i < h.length; i++) if (h[i] === m.entry || (h[i] && m.entry && h[i].id && h[i].id === m.entry.id)
                                                    || (h[i] && h[i].date === m.entry.date && h[i].src === m.entry.src)) { e = h[i]; break; }
            e = e || m.entry;
            if (!e.id) { e.id = newEntryId(); persistHistory(h); }
            openEntry(e, file);
            announceEntry(e);
            return true;
        }
        var lib = await fetchLibraryEntry(m.match.id);
        if (lib.error) return false;
        lib.src = file.name || lib.src;
        lib.size = file.size || 0;
        openEntry(lib, file);
        /* В историю — тем же документом (id, имя, длина, библиотечная копия):
           отсюда его подхватят очередь и «Скачать все». */
        saveToHistory();
        return true;
    }
    function announceEntry(e) {
        try { document.dispatchEvent(new CustomEvent('stt:entry', { detail: e })); } catch (_) {}
    }

    /* Интерфейс для очереди файлов (фасад в блейде /audio-to-text) и тестов.
       Очередь не читает DOM движка: занят ли он, что получилось и как отдать —
       только отсюда и из событий `stt:run` / `stt:entry`. */
    window.__sttWorkspace = {
        busy: function () { return !!(isTranscribing || _diarizing || existingAsk); },
        openEntry: openEntry,
        deliverEntry: deliverEntry,
        deliverEntries: deliverEntries,
        format: currentBulkFormat,
        setFormat: setBulkFormat,
        formats: function () { return BULK_FORMATS.map(function (f) { return { key: f, label: formatLabel(f) }; }); },
        combinable: function (fmt) { return fmt === 'docx' || fmt === 'txt' || fmt === 'md'; },
        title: entryTitle,
        libraryUrl: CFG.urls.myGenerations || '',
        serverLane: function () { return procMode === 'server' && typeof __serverAsr !== 'undefined' && asrServerAllowed(); },
    };

    /* ── Transcribe button ── */
    $transcribeBtn.addEventListener('click', function () {
        if (!currentFile || existingAsk || isTranscribing) return;
        var file = currentFile;
        var rec = file.__sttExisting;
        if (mode !== 'file' || file.__sttRerun || (rec && rec.done && !rec.value)) { startTranscription(); return; }
        existingAsk = true;
        /* Ответ библиотеки обычно уже здесь (спросили на метаданных); если сеть
           медленная — ждём не дольше 2,5 с и запускаем как раньше. */
        var wait = rec ? rec.p : whenDuration(file, 1500).then(function (d) { return lookupExisting(file, d); });
        Promise.race([wait, new Promise(function (r) { setTimeout(function () { r(null); }, 2500); })])
            .then(function (m) { return m ? askExisting(file, m) : 'run'; })
            .catch(function () { return 'run'; })
            .then(function (what) {
                existingAsk = false;
                if (what === 'run' && currentFile === file && !isTranscribing) startTranscription();
            });
    });
    function startTranscription() {
        if (!currentFile) return;
        /* Server lane FIRST, and deliberately BEFORE the daily-run gate.
           The two meters are orthogonal (2026-08-01): the free daily counter
           belongs to the BROWSER lane, the server lane is metered in minutes and
           tokens. Running both would wall a user who just paid — buy an hour of
           transcription, get stopped by the free "10 a day" counter. That is the
           exact failure ToolDailyCapMirrorTest's mixed free+paid allowlist exists
           to prevent, and the reason this branch must not fall through to it. */
        if (procMode === 'server' && typeof __serverAsr !== 'undefined' && asrServerAllowed()) {
            transcribeOnServer(currentFile);
            return;
        }
        /* Browser lane — the free one, on the user's own CPU. THIS is what the
           daily counter meters. Recorded only on a completed transcription. */
        /* Per-tier length ceiling (guests: 30 min). Checked BEFORE the daily
           counter so a refused file never burns the one run a guest has.
           Fails open when the duration is unknown — a metadata-less container
           must not be blocked by a limit we cannot actually evaluate. */
        var _durMinCap = (typeof __serverAsr !== 'undefined' ? (__serverAsr.maxDurMin | 0) : 0);
        var _durNow = ($audioPlayer && isFinite($audioPlayer.duration)) ? $audioPlayer.duration : 0;
        if (_durMinCap > 0 && _durNow > _durMinCap * 60) {
            showError((STR.error_too_long_tier || '')
                .replace('{min}', Math.round(_durNow / 60)).replace('{cap}', _durMinCap));
            aeTranscribe('tier_too_long', { min: Math.round(_durNow / 60), cap: _durMinCap });
            return;
        }
        if (sttLimitBlocked(currentFile)) return;
        var laneBlocker = browserLaneBlocker();
        if (laneBlocker) {
            /* Browser path is doomed without WASM-SIMD (old iOS Safari, Win7
               Chrome) — ort would download 30 MB then crash with "no available
               backend" — and without module workers (Firefox < 114, Safari < 15:
               no import() inside a worker, see browserLaneBlocker). Route Pro
               users to their reliable server perk; give everyone else an
               honest, actionable message. */
            handleNoSimd(currentFile, laneBlocker);
        } else {
            transcribeFile(currentFile);
        }
    }

    /* ── Cancel button ── */
    $cancelBtn.addEventListener('click', function() {
        /* Server job: stop watching (the server job finishes on its own, but the
           user asked to stop — drop the resume pointer so it doesn't re-surface). */
        if (serverPollTimer || serverJobId) {
            clearTimeout(serverPollTimer); serverPollTimer = null; serverJobId = null;
            try { localStorage.removeItem(SERVER_JOB_LS_KEY); } catch (_) {}
            aeTranscribe('server_transcribe_canceled');
            /* Исход прогона пишется и здесь: без него прогон считался живым до
               ухода со страницы (`run_ended left_page` на отменённом). */
            reportRunOutcome('canceled', { lane: 'server' });
            isTranscribing = false; stopProgressTimer(); $progress.classList.add('hidden'); updateFileUI();
            return;
        }
        if (whisperWorker) {
            whisperWorker.terminate();   /* hard-kill — the awaited Promise never settles, so we clean up here */
            whisperWorker = null;
            activeBackend = null;
        }
        transcribeCanceled = true;
        cancelGen++;
        /* An open GigaAM download question belongs to the cancelled run —
           answering it later would do nothing. */
        try { document.querySelectorAll('.wmp-gate').forEach(function (g) { g.hidden = true; }); } catch (_) {}
        stopProgressTimer();
        stopWatchdog();
        releaseWakeLock();
        reportRunOutcome('canceled', { chunks: ckptStreamSegs.length });
        aeTranscribe('transcription_canceled', { chunksDone: ckptStreamSegs.length });
        /* Don't throw away what was already transcribed — commit the streamed
           partial into the transcript so the user keeps it, and persist it so
           the recovery banner can offer a resume next time. */
        if (ckptStreamSegs.length) {
            saveCheckpoint('in_progress', true);
            transcriptSegments = ckptStreamSegs.map(function (txt, i) {
                return { text: txt, timestamp: chunkStartSec(i + 1), isFinal: true };
            });
            finalTranscript = ckptStreamSegs.join(' ').trim();
            renderFileTranscript();
            updateStats();
        }
        ckptPartial = '';
        isTranscribing = false;
        updateFileUI();
        $progress.classList.add('hidden');
        clearETAHint();
        renderBackendBadge();
    });

    /* ── Model change ── */
    $model.addEventListener('change', function() {
        userChangedModel = true;
        savePrefs();
        /* Terminate worker so next transcription creates a fresh one with the new model */
        if (whisperWorker) {
            whisperWorker.terminate();
            whisperWorker = null;
            activeBackend = null;
        }
        renderBackendBadge();
        /* Model changed → the fingerprint changes, so any pending resume offer
           is stale. Re-evaluate against the new model for the current file. */
        /* …but not while a run is going: a declined GigaAM door changes the
           select mid-run, and offering «Продолжить» then would set
           resumeFromSec under the running job, which adds it to every
           timestamp it delivers (review 2026-10-01). */
        if (!isTranscribing) {
            resumeFromSec = 0; pendingCkpt = null;
            hideCkptBanner();
            if (currentFile && mode === 'file') maybeOfferResume(currentFile);
        }
        /* The shared whisper-model-picker component owns the warning
           visibility + large_model_selected telemetry — its own change
           listener runs alongside this one. (Literal x-tag avoided in
           this comment — Blade compiles x-tags inside JS comments too.) */
    });

    /* ── Copy ── */
    $copyBtn.addEventListener('click', copyTranscript);

    /* ── Export dropdown ── */
    $exportBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        $exportMenu.classList.toggle('show');
    });

    document.addEventListener('click', function() {
        $exportMenu.classList.remove('show');
    });

    $exportMenu.querySelectorAll('button').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
            e.stopPropagation();
            var fmt = btn.dataset.format;
            if (btn.dataset.doc === 'court') openCourtPanel();
            else if (BULK_FORMATS.indexOf(fmt) >= 0) exportCurrent(fmt);
            $exportMenu.classList.remove('show');
        });
    });

    /* ── Find & Replace ── */
    $findBtn.addEventListener('click', function() {
        if ($findPanel.classList.contains('hidden')) openFindPanel();
        else closeFindPanel();
    });
    $findClose.addEventListener('click', closeFindPanel);
    $findInput.addEventListener('input', doFind);
    $findNext.addEventListener('click', findNext);
    $findPrev.addEventListener('click', findPrevious);
    $replaceBtn.addEventListener('click', doReplace);
    $replaceAllBtn.addEventListener('click', doReplaceAll);

    /* ── Bookmark button ── */
    $bookmarkBtn.addEventListener('click', addBookmark);

    /* ── Save recording button ── */
    /* Audio download button — click toggles format menu */
    $audioDlBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        $audioDlMenu.classList.toggle('open');
    });
    $audioDlMenu.addEventListener('click', function(e) {
        e.stopPropagation();
        var btn = e.target.closest('[data-fmt]');
        if (!btn) return;
        audioDownloadFormat = btn.dataset.fmt;
        $audioDlMenu.querySelectorAll('[data-fmt]').forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');
        $audioDlMenu.classList.remove('open');
        downloadAudio().catch(function(err){ window.__handleError && window.__handleError(err,'downloadAudio') });
    });
    document.addEventListener('click', function() { $audioDlMenu.classList.remove('open'); });

    /* ── Word cloud ── */
    $genCloud.addEventListener('click', function() { generateWordCloud(); });

    /* ── Dictation mode ── */
    $dictationBtn.addEventListener('click', enterDictation);
    $exitDictation.addEventListener('click', exitDictation);
    $dictationRecordBtn.addEventListener('click', function() {
        isRecording ? stopRecording() : startRecording();
    });

    /* ── Transcript editable input listener ── */
    var _editSyncTimer = null;
    $transcript.addEventListener('input', function() {
        userHasEdited = true;   /* immediate: copy/TXT read the live DOM until the sync fires */
        /* «Отменить» возвращает снимок расшифровки целиком. После правки текста
           руками он вернул бы и прежние слова — поэтому снимки с этого места
           недействительны. */
        if (spkUndo.length) { spkUndo = []; syncSpkUndo(); }
        updateStats();
        /* Debounced: rebuild the segment array from the DOM so timestamped
           exports (SRT/VTT) and playback-highlight follow the edit. */
        clearTimeout(_editSyncTimer);
        _editSyncTimer = setTimeout(syncSegmentsFromDom, 450);
    });

    /* ── Audio-text sync (file mode) ── */
    $audioPlayer.addEventListener('timeupdate', function() {
        if (mode !== 'file') return;
        var t = $audioPlayer.currentTime;
        $transcript.querySelectorAll('.stt-segment').forEach(function(el) {
            var s = parseFloat(el.dataset.start || 0);
            var e = parseFloat(el.dataset.end || Infinity);
            el.classList.toggle('active', t >= s && t < e);
        });
    });

    $transcript.addEventListener('click', function(e) {
        /* Speaker chip → inline rename. The chip is a button inside a
           contenteditable box, so the click must not fall through to the
           editor or to the seek-on-click below. */
        var chip = e.target.closest('.stt-speaker');
        if (chip && mode === 'file') {
            e.preventDefault(); e.stopPropagation();
            if (chip.querySelector('input')) return;
            var chipPara = chip.closest('.stt-para');
            startSpeakerRename(chip);
            /* Рядом с переименованием «везде» — то, чего не было: отдать ЭТУ
               реплику другому говорящему. */
            openParaMenu(chipPara ? parseInt(chipPara.dataset.p, 10) : -1, chip);
            return;
        }
        var stamp = e.target.closest('.stt-timestamp--menu');
        if (stamp && mode === 'file') {
            e.preventDefault(); e.stopPropagation();
            var stampPara = stamp.closest('.stt-para');
            var stampIdx = stampPara ? parseInt(stampPara.dataset.p, 10) : -1;
            if ($paraMenu && !$paraMenu.hidden && paraMenuIdx === stampIdx) { closeParaMenu(); return; }
            openParaMenu(stampIdx, stamp);
            return;
        }
        var seg = e.target.closest('.stt-segment');
        if (seg && seg.dataset.start && mode === 'file' && $audioPlayer.src && !playerIsOtherRecording()) {
            $audioPlayer.currentTime = parseFloat(seg.dataset.start);
            $audioPlayer.play();
        }
    });
    /* Выделенный текст должен дожить до меню: по нему строится цитата. Без
       этого нажатие на время снимало бы выделение раньше, чем его прочтут. */
    $transcript.addEventListener('mousedown', function (e) {
        if (mode === 'file' && e.target.closest && e.target.closest('.stt-timestamp--menu')) e.preventDefault();
    });
    $transcript.addEventListener('keydown', function (e) {
        if ((e.key === 'Enter' || e.key === ' ') && e.target.classList && e.target.classList.contains('stt-timestamp--menu')) {
            e.preventDefault(); e.target.click();
        }
    });
    function startSpeakerRename(chip) {
        if (chip.querySelector('input')) return;
        var oldName = chip.dataset.speaker || chip.textContent.trim();
        var input = document.createElement('input');
        input.type = 'text'; input.value = oldName; input.maxLength = 40;
        input.className = 'stt-speaker-input'; input.setAttribute('aria-label', STR.rename_speaker || 'Rename');
        input.size = Math.max(6, Math.min(24, oldName.length + 2));
        chip.textContent = ''; chip.appendChild(input);
        input.focus(); input.select();
        var done = false;
        function finish(commit) {
            if (done) return; done = true;
            /* Меню реплики открывается вместе с полем имени и уходит вместе с
               ним: Escape в поле до документа не доходит (поле гасит всплытие). */
            closeParaMenu();
            var v = input.value;
            if (commit && renameSpeaker(oldName, v)) return;   /* re-rendered */
            renderFileTranscript();
        }
        input.addEventListener('keydown', function (ev) {
            if (ev.key === 'Enter') { ev.preventDefault(); finish(true); }
            else if (ev.key === 'Escape') { ev.preventDefault(); finish(false); }
            ev.stopPropagation();
        });
        input.addEventListener('blur', function () { finish(true); });
        input.addEventListener('click', function (ev) { ev.stopPropagation(); });
    }

    /* ══ Правка говорящих · меню реплики · запись к готовому тексту (07.10.2026) ══
       До этой правки с метками можно было сделать одно — переименовать голос
       везде. Поправить ОДНУ реплику, отданную не тому человеку, было нечем, а
       попытка (вписать в метку имя другого говорящего) молча сливала двоих во
       всём тексте. Ошибается же разметка часто: за 30 дней до правки она нашла
       восемь и больше «говорящих» в 23 прогонах из 105. Операции над сегментами —
       в public/js/transcript-speakers.js, здесь только страница. Разбор и
       замеры — docs/court-transcript.md. */
    var $paraMenu = _$('sttParaMenu'), $spkUndoBtn = _$('sttSpkUndo'), $spkAsk = _$('sttSpkAsk');
    var $attach = _$('sttAttach'), $attachBtn = _$('sttAttachBtn');

    /* Правка текста руками доезжает до сегментов через 450 мс. Действие с
       метками ждать не может — забираем её сейчас, иначе перерисовка её сотрёт. */
    function flushEdits() {
        if (!userHasEdited) return false;
        clearTimeout(_editSyncTimer);
        syncSegmentsFromDom();
        return true;
    }
    function spkRemember() {
        if (!SPK) return;
        spkUndo.push(SPK.snapshot(transcriptSegments));
        if (spkUndo.length > 30) spkUndo.shift();
    }
    function spkForget() { if (spkUndo.length) spkUndo.pop(); }
    function syncSpkUndo() { if ($spkUndoBtn) $spkUndoBtn.hidden = !spkUndo.length; }
    function spkCommit(ev, data) {
        closeParaMenu(); closeSpkAsk();
        renderFileTranscript(); saveToHistory(); persistSpeakerNames(); syncSpkUndo();
        try { aeTranscribe(ev, data || {}); } catch (_) {}
    }
    if ($spkUndoBtn) $spkUndoBtn.addEventListener('click', function () {
        if (!SPK || !spkUndo.length) return;
        flushEdits();
        var snap = spkUndo.pop();
        /* Текст с тех пор переписали так, что сегментов стало другое число —
           старые метки приложить не к чему. Честнее сказать, чем угадать. */
        if (!SPK.restore(transcriptSegments, snap)) { spkUndo = []; syncSpkUndo(); return; }
        closeParaMenu(); closeSpkAsk();
        renderFileTranscript(); saveToHistory(); persistSpeakerNames(); syncSpkUndo();
        showToast(STR.speaker_undone || '', 'info');
        try { aeTranscribe('speaker_undo', { left: spkUndo.length }); } catch (_) {}
    });

    /* ── Вопрос о слиянии двух голосов ── */
    function closeSpkAsk() { if ($spkAsk && !$spkAsk.hidden) { $spkAsk.hidden = true; $spkAsk.innerHTML = ''; } }
    function askMerge(from, into) {
        if (!$spkAsk || !SPK) return;
        $spkAsk.innerHTML = '';
        var q = document.createElement('span');
        q.className = 'stt-roster-ask-q';
        q.textContent = (STR.speaker_merge_ask || '').replace('{name}', function () { return into; });
        var yes = document.createElement('button'), no = document.createElement('button');
        yes.type = no.type = 'button';
        yes.className = 'stt-tool-btn stt-roster-ask-yes'; no.className = 'stt-tool-btn stt-roster-ask-no';
        yes.textContent = STR.speaker_merge_yes || 'Merge';
        no.textContent = STR.speaker_merge_no || 'Keep separate';
        yes.addEventListener('click', function () {
            flushEdits();
            spkRemember();
            var n = SPK.merge(transcriptSegments, from, into);
            if (!n) { spkForget(); closeSpkAsk(); renderFileTranscript(); return; }
            spkCommit('speaker_merged', { segs: n });
        });
        no.addEventListener('click', function () {
            closeSpkAsk();
            renderFileTranscript();   /* поле имени возвращается к прежнему значению */
            try { aeTranscribe('speaker_merge_declined', {}); } catch (_) {}
        });
        $spkAsk.appendChild(q); $spkAsk.appendChild(yes); $spkAsk.appendChild(no);
        $spkAsk.hidden = false;
        try { $spkAsk.scrollIntoView({ block: 'nearest' }); } catch (_) {}
        try { yes.focus({ preventScroll: true }); } catch (_) {}
        try { aeTranscribe('speaker_merge_asked', {}); } catch (_) {}
    }

    /* ── Меню реплики ── */
    function closeParaMenu() {
        if ($paraMenu && !$paraMenu.hidden) { $paraMenu.hidden = true; $paraMenu.innerHTML = ''; }
        paraMenuIdx = -1; paraMenuPick = null;
    }
    function pmButton(cls, text) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = cls; b.textContent = text;
        return b;
    }
    /* Что выделено внутри абзаца — на случай цитаты одной фразы, а не всей реплики. */
    function pickedIn(paraEl) {
        try {
            var sel = window.getSelection && window.getSelection();
            if (!sel || sel.isCollapsed || !sel.rangeCount) return null;
            if (!paraEl.contains(sel.anchorNode) || !paraEl.contains(sel.focusNode)) return null;
            var text = sel.toString().replace(/\s+/g, ' ').trim();
            if (text.length < 3) return null;
            var rng = sel.getRangeAt(0);
            /* Какие сегменты абзаца задеты и где в них края выделения: по этим
               местам часть реплики можно отдать другому говорящему. */
            var segEls = paraEl.querySelectorAll('.stt-segment'), j0 = -1, j1 = -1;
            for (var j = 0; j < segEls.length; j++) {
                if (!rng.intersectsNode(segEls[j])) continue;
                if (j0 < 0) j0 = j;
                j1 = j;
            }
            if (j0 < 0) return null;
            var offsetIn = function (segEl, node, off) {
                var r = document.createRange();
                r.selectNodeContents(segEl);
                try { r.setEnd(node, off); } catch (_) { return -1; }
                return r.toString().length;
            };
            var off0 = segEls[j0].contains(rng.startContainer) ? offsetIn(segEls[j0], rng.startContainer, rng.startOffset) : 0;
            var off1 = segEls[j1].contains(rng.endContainer) ? offsetIn(segEls[j1], rng.endContainer, rng.endOffset) : (segEls[j1].textContent || '').length;
            var at = parseFloat(segEls[j0].dataset.start);
            return { text: text, start: isFinite(at) ? at : null,
                     range: (off0 >= 0 && off1 >= 0) ? { j0: j0, off0: off0, j1: j1, off1: off1 } : null };
        } catch (_) { return null; }
    }
    function openParaMenu(idx, anchor) {
        if (!$paraMenu || mode !== 'file' || !(idx >= 0)) return;
        var paraEl = anchor && anchor.closest ? anchor.closest('.stt-para') : null;
        var pick = paraEl ? pickedIn(paraEl) : null;
        /* Абзацы помнят объекты сегментов последней отрисовки. После правки
           текста руками сегменты уже другие — перерисовываем и берём абзац заново. */
        if (flushEdits() || !lastParas[idx] || transcriptSegments.indexOf(lastParas[idx].segs[0]) < 0) {
            renderFileTranscriptInner();
            paraEl = $transcript.querySelector('.stt-para[data-p="' + idx + '"]');
            anchor = paraEl ? (paraEl.querySelector('.stt-timestamp--menu') || paraEl.querySelector('.stt-speaker') || paraEl) : null;
        }
        var para = lastParas[idx];
        if (!para || !anchor) return;
        paraMenuIdx = idx; paraMenuPick = pick;
        $paraMenu.innerHTML = '';

        if (SPK) {
            var who = document.createElement('div');
            who.className = 'stt-pmenu-sec';
            var wl = document.createElement('div');
            wl.className = 'stt-pmenu-l';
            wl.textContent = (pick && pick.range ? STR.para_who_picked : STR.para_who) || '';
            who.appendChild(wl);
            var names = SPK.names(transcriptSegments);
            names.forEach(function (name) {
                if (name === para.speaker) return;
                var b = pmButton('stt-pmenu-btn stt-pmenu-spk', name);
                var dot = document.createElement('i');
                dot.className = 'stt-roster-dot'; dot.dataset.spk = String(lastColour[name] === undefined ? 0 : lastColour[name]);
                b.insertBefore(dot, b.firstChild);
                b.addEventListener('click', function () { assignPara(idx, name, false); });
                who.appendChild(b);
            });
            var fresh = pmButton('stt-pmenu-btn stt-pmenu-new', '+ ' + (STR.para_new_speaker || 'New speaker'));
            fresh.addEventListener('click', function () {
                assignPara(idx, SPK.freeName(transcriptSegments, STR.speaker_label || 'Speaker {n}'), true);
            });
            who.appendChild(fresh);
            if (!(pick && pick.range) && STR.para_pick_hint) {
                var ph = document.createElement('div');
                ph.className = 'stt-pmenu-hint'; ph.textContent = STR.para_pick_hint;
                who.appendChild(ph);
            }
            $paraMenu.appendChild(who);
        }
        var act = document.createElement('div');
        act.className = 'stt-pmenu-sec';
        var listen = pmButton('stt-pmenu-btn', '▶ ' + (STR.para_listen || 'Listen from here'));
        listen.addEventListener('click', function () {
            var at = (paraMenuPick && paraMenuPick.start != null) ? paraMenuPick.start : (para.start || 0);
            var ok = seekTo(at);
            closeParaMenu();
            try { aeTranscribe('para_listen', { ok: ok ? 1 : 0 }); } catch (_) {}
        });
        var quote = pmButton('stt-pmenu-btn', '❝ ' + (STR.para_copy_quote || 'Copy quote'));
        quote.addEventListener('click', function () { copyQuote(para, paraMenuPick); });
        act.appendChild(listen);
        if ($audioPlayer && $audioPlayer.src && !$audioPlayer.paused) {
            var stop = pmButton('stt-pmenu-btn', '⏸ ' + (STR.pause || 'Pause'));
            stop.addEventListener('click', function () { try { $audioPlayer.pause(); } catch (_) {} closeParaMenu(); });
            act.appendChild(stop);
        }
        act.appendChild(quote);
        $paraMenu.appendChild(act);

        /* Место — под временем или меткой, в координатах блока расшифровки: меню
           стоит ВНЕ редактируемого поля, иначе его слова попали бы в текст. */
        var host = $paraMenu.parentNode;
        $paraMenu.hidden = false;
        var hr = host.getBoundingClientRect(), ar = anchor.getBoundingClientRect();
        var w = Math.max(200, Math.min(300, hr.width - 16));
        $paraMenu.style.width = w + 'px';
        $paraMenu.style.top = Math.round(ar.bottom - hr.top + 6) + 'px';
        $paraMenu.style.left = Math.round(Math.max(8, Math.min(ar.left - hr.left, hr.width - w - 8))) + 'px';
        try { aeTranscribe('para_menu_open', { via: anchor.classList.contains('stt-speaker') ? 'chip' : 'time' }); } catch (_) {}
    }
    function assignPara(idx, name, isNew) {
        var para = lastParas[idx];
        if (!para || !SPK) { closeParaMenu(); return; }
        var span = SPK.span(transcriptSegments, para.segs);
        if (!span) { closeParaMenu(); return; }
        var rg = paraMenuPick && paraMenuPick.range, part = false, n = 0;
        spkRemember();
        if (rg && para.segs[rg.j0] && para.segs[rg.j1]) {
            /* Выделена часть реплики: отдаём только её, разрезая сегменты по
               краям выделения. Так чинится «Нет, отводов нет. Ответчик?» —
               ответ одного и вопрос другого, распознанные одним куском. */
            var i0 = transcriptSegments.indexOf(para.segs[rg.j0]), i1 = transcriptSegments.indexOf(para.segs[rg.j1]);
            if (i0 >= 0 && i1 >= i0) { n = SPK.assignText(transcriptSegments, i0, rg.off0, i1, rg.off1, name); part = true; }
        }
        if (!part) n = SPK.assign(transcriptSegments, span[0], span[1], name);
        if (!n) { spkForget(); closeParaMenu(); renderFileTranscript(); return; }
        spkCommit('speaker_reassigned', { segs: n, fresh: isNew ? 1 : 0, part: part ? 1 : 0 });
    }
    if ($paraMenu) {
        /* Нажатие на пункт не должно уводить фокус из поля имени раньше клика:
           иначе уход с поля перерисует текст под рукой. */
        $paraMenu.addEventListener('mousedown', function (e) { e.preventDefault(); });
        document.addEventListener('pointerdown', function (e) {
            if ($paraMenu.hidden) return;
            var t = e.target;
            if ($paraMenu.contains(t)) return;
            if (t.closest && t.closest('.stt-timestamp--menu, .stt-speaker')) return;
            closeParaMenu();
        }, true);
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !$paraMenu.hidden) closeParaMenu(); });
        $transcript.addEventListener('scroll', closeParaMenu);
    }

    /* ── Слушать с места и цитата с отметкой времени ── */
    function seekTo(sec) {
        /* В плеере может стоять файл, выбранный ПОСЛЕ этого текста (очередь,
           запись из истории): перемотка в чужую запись хуже, чем никакой. */
        if (!$audioPlayer || !$audioPlayer.src || playerIsOtherRecording()) { nudgeAttach(); return false; }
        try {
            $audioPlayer.currentTime = Math.max(0, sec || 0);
            var p = $audioPlayer.play();
            if (p && p.catch) p.catch(function () {});
        } catch (_) {}
        /* Страницу НЕ двигаем: человек читает реплику, и плеер наверху ему
           сейчас не нужен — нужен звук. Остановить можно из того же меню. */
        return true;
    }
    function quoteClock(sec) {
        var C = window.__transcriptCourt;
        return C ? C.clock(sec) : formatTime(sec);
    }
    function quoteText(para, pick) {
        var text = (pick && pick.text) || para.segs.map(function (s) { return s.text; }).join(' ').replace(/\s+/g, ' ').trim();
        var at = (pick && pick.start != null) ? pick.start : (para.start || 0);
        var who = showSpeakersOn() ? (para.speaker || '') : '';
        var tpl = who ? (STR.quote_named || '[{time}] {who}: "{text}"') : (STR.quote_plain || '[{time}] "{text}"');
        return tpl.replace('{time}', function () { return quoteClock(at); })
                  .replace('{who}', function () { return who; })
                  .replace('{text}', function () { return text; });
    }
    function copyText(text, done) {
        var ok = function () { if (done) done(); };
        var legacy = function () {
            var ta = document.createElement('textarea');
            ta.value = text; ta.style.position = 'fixed'; ta.style.left = '-9999px';
            document.body.appendChild(ta); ta.select();
            try { document.execCommand('copy'); } catch (_) {}
            document.body.removeChild(ta);
            ok();
        };
        try {
            if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(ok).catch(legacy);
            else legacy();
        } catch (_) { legacy(); }
    }
    function copyQuote(para, pick) {
        var q = quoteText(para, pick);
        closeParaMenu();
        copyText(q, function () { showToast(STR.quote_copied || STR.copied || '', 'success'); });
        try { aeTranscribe('quote_copied', { chars: q.length, picked: pick ? 1 : 0 }); } catch (_) {}
    }

    /* ── Запись к готовому тексту ─────────────────────────────────────────────
       Текст, вернувшийся по ссылке из письма, из «Моих генераций» или из
       истории, приходит без звука: файл остался на устройстве. Слушать реплики
       и переходить по времени тогда нечем — а длинная запись, ради которой и
       есть серверная расшифровка, заканчивается именно так. Файл подключается
       с устройства, никуда не отправляется и новой расшифровки не запускает. */
    function hasTimes() {
        for (var i = 0; i < transcriptSegments.length; i++) if ((transcriptSegments[i].timestamp || 0) > 0) return true;
        return false;
    }
    function syncAttachRow() {
        if (!$attach) return;
        $attach.hidden = !(mode === 'file' && !isTranscribing && transcriptSegments.length > 0 && hasTimes()
            && (!($audioPlayer && $audioPlayer.src) || playerIsOtherRecording()));
    }
    function nudgeAttach() {
        syncAttachRow();
        if ($attach && !$attach.hidden) {
            try { $attach.scrollIntoView({ block: 'nearest' }); } catch (_) {}
            $attach.classList.add('is-nudged');
            setTimeout(function () { $attach.classList.remove('is-nudged'); }, 1800);
        }
        showToast(STR.attach_audio_note || '', 'info');
    }
    function restorePlayerHome() {
        if (!playerHome || !$audioPlayer) return;
        try { playerHome.parent.insertBefore($audioPlayer, playerHome.next); } catch (_) {}
        playerHome = null;
    }
    function transcriptLengthSec() {
        var last = 0;
        for (var i = transcriptSegments.length - 1; i >= 0 && !last; i--) {
            var s = transcriptSegments[i];
            if (s && !s.isParagraph) last = (typeof s.end === 'number' ? s.end : s.timestamp) || 0;
        }
        return Math.max(exportDurationSec || 0, last);
    }
    function attachAudio(file) {
        if (!file || !$audioPlayer) return;
        try { $audioPlayer.src = URL.createObjectURL(file); } catch (_) { return; }
        $audioPlayer.classList.remove('hidden');
        /* Человек сам сказал «это запись к этому тексту» — имя файла может быть
           другим (видео, переименованная копия), но звук теперь — его. */
        playerSrcName = exportSourceName || file.name || '';
        /* В режиме чтения рейка с плеером сложена — ставим плеер к тексту. */
        if ($attach && $attach.parentNode && !playerHome && !$audioPlayer.offsetParent) {
            playerHome = { parent: $audioPlayer.parentNode, next: $audioPlayer.nextSibling };
            $attach.parentNode.insertBefore($audioPlayer, $attach);
        }
        if (!exportSourceName) exportSourceName = file.name || '';
        var want = transcriptLengthSec();
        var onMeta = function () {
            $audioPlayer.removeEventListener('loadedmetadata', onMeta);
            var got = $audioPlayer.duration;
            var off = (isFinite(got) && got > 0 && want > 0) ? Math.abs(got - want) > Math.max(20, want * 0.05) : false;
            if (off) {
                showToast((STR.attach_audio_mismatch || '')
                    .replace('{file}', function () { return quoteClock(got); })
                    .replace('{text}', function () { return quoteClock(want); }), 'error');
            } else {
                showToast(STR.attach_audio_done || '', 'success');
            }
            try { aeTranscribe('audio_attached', { mismatch: off ? 1 : 0 }); } catch (_) {}
        };
        $audioPlayer.addEventListener('loadedmetadata', onMeta);
        syncAttachRow();
    }
    if ($attachBtn) $attachBtn.addEventListener('click', function () {
        attachOnly = true;
        try {
            if ($dropzone.__uploaderReset) $dropzone.__uploaderReset();
            if ($dropzone.__uploaderOpen) $dropzone.__uploaderOpen();
            else { var inp = _$('sttDropzone-input'); if (inp) inp.click(); }
        } catch (_) { attachOnly = false; }
        /* Человек закрыл окно выбора, ничего не выбрав: следующий файл, брошенный
           в зону, — уже новая расшифровка, а не запись к этому тексту. */
        setTimeout(function () { attachOnly = false; }, 120000);
        try { aeTranscribe('audio_attach_click', {}); } catch (_) {}
    });

    /* ══ Расшифровка для суда (русская страница) ═════════════════════════════
       Роли предлагаются, когда текст похож на заседание; документ собирается из
       меню «Скачать». Слова — resources/lang/ru/court-transcript.php. */
    var COURT = CFG.court || null;
    var $courtOffer = _$('sttCourtOffer'), $courtPanel = _$('sttCourt'), $courtDoc = _$('sttCourtDoc');
    var courtProposal = null;

    function courtSignature() {
        var names = SPK ? SPK.names(transcriptSegments).join('|') : '';
        return transcriptSegments.length + '#' + names;
    }
    function courtCheck() {
        if (!COURT || !$courtOffer || !window.__transcriptRoles || !SPK) return;
        if (mode !== 'file' || isTranscribing || !transcriptHasSpeakers()) { $courtOffer.hidden = true; return; }
        var sig = courtSignature();
        if (sig === courtState.sig) return;
        courtState.sig = sig;
        var prop = window.__transcriptRoles.propose(transcriptSegments, COURT.roles || {});
        courtState.hearing = !!(prop.hearing && prop.court);
        /* Дверь к разбору уже могла встать со словами про «консультацию». */
        var _dcta = _$('sttDialogueCta'), _dsub = _dcta ? _dcta.querySelector('span') : null;
        if (_dsub && courtState.hearing && COURT.cta_sub) _dsub.textContent = COURT.cta_sub;
        courtProposal = prop.items && prop.items.length ? prop : null;
        /* «Не нужно» относится к этой расшифровке, а не ко всем следующим. */
        if (!courtProposal || courtState.skipLen === transcriptSegments.length) { $courtOffer.hidden = true; return; }
        var list = _$('sttCourtOfferList');
        if (list) {
            list.textContent = courtProposal.items.map(function (it) {
                return it.label + ' ' + (COURT.offer_arrow || '→') + ' ' + it.name;
            }).join('; ') + '.';
            /* Голос с уликами за две роли: его не подписываем, а говорим, что в
               нём двое, и чем это поправить. */
            (prop.mixed || []).forEach(function (m) {
                list.textContent += ' ' + (COURT.offer_mixed || '')
                    .replace(':label', function () { return m.label; })
                    .replace(':roles', function () { return m.roles.join(', ').toLowerCase(); });
            });
        }
        $courtOffer.hidden = false;
        if (!courtState.seen) {
            courtState.seen = true;
            try { aeTranscribe('court_offer_shown', { n: courtProposal.items.length, voices: SPK.names(transcriptSegments).length }); } catch (_) {}
        }
    }
    function applyCourtRoles() {
        if (!courtProposal || !SPK) return;
        flushEdits();
        spkRemember();
        var done = 0;
        courtProposal.items.forEach(function (it) {
            if (!SPK.has(transcriptSegments, it.label)) return;
            /* Два голоса с одной ролью (разметка раздвоила судью) становятся
               одним говорящим — это и есть починка, а не побочный эффект. */
            done += SPK.has(transcriptSegments, it.name)
                ? SPK.merge(transcriptSegments, it.label, it.name)
                : SPK.rename(transcriptSegments, it.label, it.name);
        });
        if (!done) { spkForget(); $courtOffer.hidden = true; return; }
        var n = courtProposal.items.length;
        courtProposal = null; $courtOffer.hidden = true;
        spkCommit('court_roles_applied', { n: n, segs: done });
        showToast(COURT.offer_done || '', 'success');
    }
    if ($courtOffer) {
        var _ca = _$('sttCourtOfferApply'), _cs = _$('sttCourtOfferSkip');
        if (_ca) _ca.addEventListener('click', applyCourtRoles);
        if (_cs) _cs.addEventListener('click', function () {
            courtState.skipLen = transcriptSegments.length; courtProposal = null; $courtOffer.hidden = true;
            try { aeTranscribe('court_offer_skipped', {}); } catch (_) {}
        });
    }
    /* Роли одним нажатием — тем же приёмом, что «Названные вами»: имя уходит в
       поле, которое в фокусе, либо в первое ещё не подписанное. Показываются,
       когда текст похож на заседание или открыта форма документа. */
    function renderCourtRoles(voices) {
        var host = _$('sttRoster');
        if (!host) return;
        var wrap = _$('sttRosterRoles');
        var on = !!(COURT && (courtState.hearing || ($courtPanel && !$courtPanel.hidden)) && voices && voices.length);
        if (!on) { if (wrap) wrap.hidden = true; return; }
        if (!wrap) {
            wrap = document.createElement('div');
            wrap.id = 'sttRosterRoles'; wrap.className = 'stt-roster-sugg';
            var lab = document.createElement('span');
            lab.className = 'stt-roster-sugg-label'; lab.textContent = COURT.roles_label || '';
            var chips = document.createElement('span');
            chips.className = 'stt-roster-sugg-chips'; chips.id = 'sttRosterRoleChips';
            wrap.appendChild(lab); wrap.appendChild(chips);
            host.appendChild(wrap);
        }
        wrap.hidden = false;
        var box = _$('sttRosterRoleChips');
        box.innerHTML = '';
        var taken = {};
        voices.forEach(function (v) { taken[v.name.toLowerCase()] = 1; });
        Object.keys(COURT.roles || {}).forEach(function (key) {
            var name = COURT.roles[key];
            var c = document.createElement('button');
            c.type = 'button';
            c.className = 'stt-roster-chip' + (taken[name.toLowerCase()] ? ' is-used' : '');
            c.textContent = name;
            c.addEventListener('mousedown', function (e) { e.preventDefault(); });   /* фокус остаётся в поле имени */
            c.addEventListener('click', function () {
                var target = document.activeElement;
                if (!target || !target.classList || !target.classList.contains('stt-roster-name')) {
                    var all = Array.prototype.slice.call(document.querySelectorAll('.stt-roster-name'));
                    target = all.filter(function (i) { return /^\D+\s*\d+$/.test(i.value) || /^speaker_\d+$/i.test(i.value); })[0];
                }
                if (!target) return;
                var row = target.closest('.stt-roster-row');
                var was = row && row.dataset.speaker;
                if (!was) return;
                if (renameSpeaker(was, name)) { persistSpeakerNames(); try { aeTranscribe('speaker_renamed', { via: 'role' }); } catch (_) {} }
            });
            box.appendChild(c);
        });
    }

    /* ── Форма документа ── */
    function courtVal(id) { var el = _$(id); return el ? String(el.value || '').trim() : ''; }
    function courtRadio(name) {
        var el = document.querySelector('input[name="' + name + '"]:checked');
        return el ? el.value : '';
    }
    function courtForm() {
        var audioDur = ($audioPlayer && isFinite($audioPlayer.duration)) ? $audioPlayer.duration : 0;
        return {
            kind: courtRadio('sttCourtKind') || 'hearing',
            court: courtVal('sttCourtCourt'), caseNo: courtVal('sttCourtCase'),
            date: courtVal('sttCourtDate'), time: courtVal('sttCourtTime'),
            source: courtRadio('sttCourtSource') || 'own',
            recorder: courtRadio('sttCourtKind') === 'talk' ? courtVal('sttCourtWho') : courtVal('sttCourtRecorder'),
            when: courtVal('sttCourtWhen'), conditions: courtVal('sttCourtHow'),
            author: courtVal('sttCourtAuthor'), authorRole: courtVal('sttCourtRole'),
            fileName: exportSourceName || '',
            durationSec: exportDurationSec || Math.round(serverAudioDur || 0) || Math.round(audioDur) || 0,
            speakers: showSpeakersOn(),
        };
    }
    function courtBuild() {
        var C = window.__transcriptCourt;
        if (!C || !COURT) return null;
        flushEdits();
        return C.build(buildParagraphs(transcriptSegments), courtForm(), COURT.doc || {});
    }
    function courtSyncKind() {
        var kind = courtRadio('sttCourtKind') || 'hearing';
        var own = (courtRadio('sttCourtSource') || 'own') === 'own';
        Array.prototype.forEach.call($courtPanel.querySelectorAll('[data-for]'), function (el) {
            el.hidden = el.dataset.for !== kind;
        });
        var rec = _$('sttCourtRecorderRow');
        if (rec) rec.hidden = !(kind === 'hearing' && own);
        var hint = _$('sttCourtDateHint');
        if (hint && kind !== 'hearing') hint.hidden = true;
    }
    function courtPreview() {
        if (!$courtDoc) return;
        var doc = courtBuild();
        if (!doc) { $courtDoc.textContent = ''; return; }
        var html = '', shown = 0, LIMIT = 6;
        doc.blocks.forEach(function (b) {
            if (b.k === 'head') html += '<div class="stt-court-doc-head">' + b.lines.map(function (l) { return '<div>' + escHtml(l) + '</div>'; }).join('') + '</div>';
            else if (b.k === 'title') html += '<p class="stt-court-doc-title"><b>' + escHtml(b.text) + '</b></p>';
            else if (b.k === 'sub') html += '<p class="stt-court-doc-title">' + escHtml(b.text) + '</p>';
            else if (b.k === 'gap') html += '<p class="stt-court-doc-gap"></p>';
            else if (b.k === 'turn') {
                shown++;
                if (shown <= LIMIT) html += '<p class="stt-court-doc-turn"><span>[' + escHtml(b.time) + ']</span> ' + (b.who ? '<b>' + escHtml(b.who) + ':</b> ' : '') + escHtml(b.text) + '</p>';
                else if (shown === LIMIT + 1) html += '<p class="stt-court-doc-more">' + escHtml((COURT.preview_more || '').replace(':n', function () { return String(doc.turns); })) + '</p>';
            }
            else if (b.k === 'note') html += '<p class="stt-court-doc-note">' + escHtml(b.text) + '</p>';
            else html += '<p class="stt-court-doc-p">' + escHtml(b.text) + '</p>';
        });
        $courtDoc.innerHTML = html;
    }
    function openCourtPanel() {
        if (!$courtPanel || !COURT || !transcriptSegments.length) return;
        $courtPanel.hidden = false;
        /* Суд называет файл записи датой и временем заседания — берём их оттуда,
           но только в пустые поля и говорим об этом рядом. */
        var C = window.__transcriptCourt, d = _$('sttCourtDate'), t = _$('sttCourtTime'), hint = _$('sttCourtDateHint');
        var m = C ? C.fileMoment(exportSourceName) : null;
        if (m && d && !d.value) {
            d.value = m.date;
            if (t && !t.value) t.value = m.time;
            if (hint) hint.hidden = false;
            var src = document.querySelector('input[name="sttCourtSource"][value="court"]');
            if (src) src.checked = true;
        }
        /* Кто готовил и в каком положении — одно и то же от записи к записи. */
        if (window.__toolSettings) {
            ['Author', 'Role'].forEach(function (k) {
                var el = _$('sttCourt' + k);
                try { if (el && !el.value) el.value = String(window.__toolSettings.load(TOOL_SLUG, 'court_' + k.toLowerCase(), '') || ''); } catch (_) {}
            });
        }
        courtSyncKind();
        courtPreview();
        try { renderRoster(); } catch (_) {}
        try { $courtPanel.scrollIntoView({ block: 'nearest' }); } catch (_) {}
        try { aeTranscribe('court_panel_open', { hearing: courtState.hearing ? 1 : 0, dated: m ? 1 : 0 }); } catch (_) {}
    }
    if ($courtPanel && COURT) {
        $courtPanel.addEventListener('input', function () { courtSyncKind(); courtPreview(); });
        $courtPanel.addEventListener('change', function () { courtSyncKind(); courtPreview(); });
        var _cc = _$('sttCourtClose');
        if (_cc) _cc.addEventListener('click', function () { $courtPanel.hidden = true; try { renderRoster(); } catch (_) {} });
        ['Author', 'Role'].forEach(function (k) {
            var el = _$('sttCourt' + k);
            if (el) el.addEventListener('change', function () {
                try { if (window.__toolSettings) window.__toolSettings.save(TOOL_SLUG, 'court_' + k.toLowerCase(), el.value.trim()); } catch (_) {}
            });
        });
        var _cd = _$('sttCourtDocx'), _cp = _$('sttCourtCopy');
        if (_cp) _cp.addEventListener('click', function () {
            var doc = courtBuild();
            if (!doc) return;
            copyText(window.__transcriptCourt.toPlain(doc.blocks), function () { showToast(COURT.copied || STR.copied || '', 'success'); });
            try { aeTranscribe('export_court', { ok: 1, as: 'text', kind: courtForm().kind }); } catch (_) {}
        });
        if (_cd) _cd.addEventListener('click', function () {
            var doc = courtBuild();
            if (!doc || !window.DocxWriter) { showError(COURT.failed || ''); return; }
            var f = courtForm(), was = _cd.innerHTML;
            _cd.disabled = true; _cd.textContent = COURT.building || '';
            var TF = window.__transcriptFile;
            var name = TF ? TF.name(exportSourceName, 'docx', { word: COURT.file_word || STR.file_word || 'transcript' }) : 'transcript.docx';
            var filled = ['court', 'caseNo', 'date', 'author'].filter(function (k) { return !!f[k]; }).length;
            window.DocxWriter.build({
                docTitle: (COURT.doc && (f.kind === 'talk' ? COURT.doc.title_talk : COURT.doc.title_hearing)) || '',
                font: 'Times New Roman', size: 24, line: 276, lang: 'ru-RU',
                blocks: window.__transcriptCourt.toDocx(doc.blocks),
            }).then(function (blob) {
                var save = window.__downloadFile ? window.__downloadFile(blob, name) : (downloadFile(blob, name, window.DocxWriter.MIME), true);
                return Promise.resolve(save);
            }).then(function (saved) {
                try { aeTranscribe('export_court', { ok: saved === false ? 0 : 1, as: 'docx', kind: f.kind, filled: filled, turns: doc.turns }); } catch (_) {}
            }).catch(function (e) {
                showError(COURT.failed || '');
                try { aeTranscribe('export_court', { ok: 0, as: 'docx', err: String(e && e.message || e).slice(0, 40) }); } catch (_) {}
            }).then(function () { _cd.disabled = false; _cd.innerHTML = was; });
        });
    }

    /* ── Font size ── */
    document.querySelectorAll('.stt-font-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
            setFontSize(btn.dataset.size);
            savePrefs();
        });
    });

    function setFontSize(size) {
        currentFontSize = size;
        $transcript.classList.remove('font-small', 'font-large');
        if (size === 'small') $transcript.classList.add('font-small');
        else if (size === 'large') $transcript.classList.add('font-large');

        document.querySelectorAll('.stt-font-btn').forEach(function(b) {
            b.classList.toggle('active', b.dataset.size === size);
        });
    }

    /* ── Clear transcript ── */
    $clearBtn.addEventListener('click', function() {
        if (!transcriptSegments.length) return;
        var beforeChars = getPlainTranscript().length;
        if (!confirm(STR.clear_confirm)) {
            try { window.__ae && window.__ae('feature_use', { slug: TOOL_SLUG, f: 'clear_transcript_canceled', chars: beforeChars }); } catch(_) {}
            return;
        }
        transcriptSegments = [];
        finalTranscript = '';
        userHasEdited = false;
        bookmarks = [];
        renderTranscript();
        renderBookmarks();
        updateStats();
        clearWordCloud();
        try { localStorage.removeItem('stt_autosave'); } catch(e) {}
        try { window.__ae && window.__ae('feature_use', { slug: TOOL_SLUG, f: 'clear_transcript', chars: beforeChars }); } catch(_) {}
    });

    /* ── History clear ── */
    $historyClear.addEventListener('click', clearHistory);

    /* ── Populate languages ── */
    /* Имя языка НА ЯЗЫКЕ ИНТЕРФЕЙСА. Раньше дропдаун (и производная от него
       языковая подсказка качества) показывал жёсткий английский список —
       «Russian» в русском интерфейсе, «Korean» в корейском (замерено свипом по
       9 локалям 2026-08-05). Intl.DisplayNames локализует все 37 названий без
       единой строки перевода; английское имя остаётся запасным. */
    var _langDN = null;
    try { _langDN = new Intl.DisplayNames([(window.__LOCALE || 'en')], { type: 'language' }); } catch (e) {}
    function langDisplayName(code, fallback) {
        try {
            var n = _langDN && _langDN.of(code);
            if (n && n !== code) return n.charAt(0).toUpperCase() + n.slice(1);
        } catch (e) {}
        return fallback;
    }

    function populateLanguages() {
        /* Auto-detect FIRST + default (file mode): Whisper detects the spoken
           language itself, which is the accuracy-correct default — a forced
           browser-language on other-language audio silently produced a worse
           transcript (anatomy gap #4). getWhisperLang() already maps 'auto' → null
           → the worker auto-detects. Mic mode keeps a concrete language (Web
           Speech needs one), so Auto is offered only where Whisper runs. */
        var html = '';
        if (mode === 'file') {
            html += '<option value="auto">🌐 ' + (STR.auto_detect || 'Auto-detect') + '</option>';
        }
        for (var i = 0; i < LANGUAGES.length; i++) {
            var lang = LANGUAGES[i];
            html += '<option value="' + lang.code + '">' + langDisplayName(lang.code, lang.name) + '</option>';
        }
        $lang.innerHTML = html;

        if (mode === 'file') {
            /* Locale-informed default (comment #864): 'auto' let weak models
               misdetect the language and decode Spanish audio as English
               tokens — the "the the the" wall the user quoted. People
               overwhelmingly transcribe their OWN language, so preselect the
               page locale's language VISIBLY in the picker (auto stays one
               click away; restorePrefs still overrides with a saved choice;
               mic mode has matched the browser language since day one). */
            var locBase = (window.__LOCALE || 'en').split('-')[0].toLowerCase();
            var locOpt = $lang.querySelector('option[value^="' + locBase + '"]');
            $lang.value = locOpt ? locOpt.value : 'auto';
            return;
        }
        /* Mic mode: match the browser language (Web Speech needs a concrete one). */
        var browserLang = navigator.language || navigator.languages[0] || 'en-US';
        var exact = $lang.querySelector('option[value="' + browserLang + '"]');
        if (exact) {
            $lang.value = browserLang;
        } else {
            var base = browserLang.split('-')[0];
            var partial = $lang.querySelector('option[value^="' + base + '"]');
            if (partial) $lang.value = partial.value;
        }
    }

    /* ── Waveform resize ── */
    function resizeWaveform() {
        var canvas = $waveform;
        var dpr = window.devicePixelRatio || 1;
        var rect = canvas.getBoundingClientRect();
        canvas.width = rect.width * dpr;
        canvas.height = rect.height * dpr;
    }

    var resizeTimeout;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(resizeWaveform, 150);
    });

    /* ── Toast notifications ── */
    function showToast(msg, type) {
        $toast.textContent = msg;
        $toast.className = 'stt-toast ' + (type || '') + ' show';
        clearTimeout(toastTimer);
        toastTimer = setTimeout(function() {
            $toast.classList.remove('show');
        }, 3000);
    }

    function showError(msg) {
        showToast(msg, 'error');
    }

    /* showWarning surfaces an inline banner. `opts.canRetry` shows the
       Try-again button (re-arm recognition); `opts.showFileLink` shows the
       Switch-to-file-mode link. Both default to true — call sites pass
       `canRetry:false` for unrecoverable cases like browser-not-supported. */
    function showWarning(msg, opts) {
        /* Suppress the warning panel entirely once Web Speech has handed off
           to Whisper-takeover. The panel's "Switch to file mode" link would
           navigate away and abandon the in-progress MediaRecorder recording
           that whisperTakeover is keeping alive specifically so Whisper can
           rescue it on stop. The takeover toast is the source of truth from
           this point on. */
        if (webSpeechFailed) return;
        opts = opts || {};
        $warning.classList.remove('hidden');
        $warningText.textContent = msg;
        $warnRetryBtn.classList.toggle('hidden', opts.canRetry === false);
        $warnFileLink.classList.toggle('hidden', opts.showFileLink === false);
    }
    function hideWarning() { $warning.classList.add('hidden'); }

    /* ── Utility functions ── */
    function escHtml(s) {
        var div = document.createElement('div');
        div.textContent = s;
        return div.innerHTML;
    }

    function escRegex(s) {
        return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    function formatFileSize(bytes) {
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / 1048576).toFixed(1) + ' MB';
    }

    /* =====================================================
       INIT
       ===================================================== */
    populateLanguages();
    restorePrefs();
    /* Async capability detection — switches default model + badges
       once we know whether WebGPU adapter is reachable. */
    detectCaps();
    /* Sync panel visibility to initial mode */
    $micPanel.classList.toggle('hidden', mode !== 'mic');
    $filePanel.classList.toggle('hidden', mode !== 'file');
    /* Speaker-labels toggle: file mode only, and only where the diarization
       model can run (needs the transformers stack + AudioContext). */
    /* Метки говорящих есть у ДВУХ лейнов: браузерного (нужна модель эмбеддингов
       и AudioContext) и серверного (sherpa на боксе). До 2026-09-04 показ
       галочки зависел только от браузерного условия — там, где серверный лейн
       есть, а браузерный диаризатор недоступен, Премиум оставался без самой
       кнопки. */
    var _browserDiar = !!(window.SpeakerDiarization && window.SpeakerDiarization.isSupported());
    var _serverDiar  = !!(typeof __serverAsr !== 'undefined' && __serverAsr && __serverAsr.enabled && __serverAsr.diarize);
    if ($diarizeRow && mode === 'file' && (_browserDiar || _serverDiar)) {
        $diarizeRow.hidden = false;
        if ($diarize) $diarize.addEventListener('change', savePrefs);
        syncDiarizeAvailability();
    }
    /* loadAutoSave() removed — history section serves this purpose */
    renderHistory();
    resizeWaveform();
    /* Check IndexedDB for an unfinished Whisper-takeover recording from
       a previous session and surface the recovery banner if found. */
    initRecoveryPanel();
    /* File-mode: surface a recovered partial transcript from a prior crashed
       / closed session (bug-report 38fdd911). */
    initFileRecovery();
    /* Возврат СОХРАНЁННОЙ расшифровки из «Моих генераций» (?transcript=N).
       ⚠️ ВНЕ initServerAsr(): там он и стоял сперва, а эта функция выходит
       сразу, если серверный лейн выключен или не предлагается на локали —
       то есть у всех, кроме Премиума. Своя сохранённая расшифровка к
       серверному лейну отношения не имеет: она уже принадлежит человеку.
       Поймано сквозным прогоном по настоящей ссылке из библиотеки. */
    initLibraryRestore();
    initDiskLink();
    (function () {
        var b = _$('sttNewRun');
        if (!b) return;
        b.addEventListener('click', function () {
            var app = document.querySelector('.stt--library');
            if (app) app.classList.remove('stt--library');
            try { aeTranscribe('library_newrun_opened', {}); } catch (_) {}
        });
    })();
    /* Pro server-side transcription option (variant A) — reveal the processing
       switch, wire the upgrade offer, resume any tab-survived server job. */
    try { syncFileSettings(!!currentFile); } catch (_) {}
    initServerAsr();
    initTranscriptAi();

    /* Browser capability check — Try-again is meaningless when the API isn't
       there at all; only the Switch-to-file-mode link helps. */
    if (!window.SpeechRecognition && !window.webkitSpeechRecognition) {
        showWarning(STR.error_speech_not_supported, { canRetry: false });
    }

    /* Counter the project-wide broken-banner anxiety on mic mode. STT is one
       of the rare tools where the mic flow needs zero WASM — we shouldn't
       leave users wondering if everything is broken. Listens for the
       wasm-team's warmup_failed feature_use; reveals the inline teal hint
       once. Idempotent: re-firing the event won't double-show or animate. */
    var _wasmHintEl = _$('sttWasmHint');
    if (_wasmHintEl) {
        var _origAeForHint = window.__ae;
        if (_origAeForHint) {
            window.__ae = function(type, payload) {
                if (type === 'feature_use'
                    && payload && payload.f === 'warmup_failed'
                    && _wasmHintEl.classList.contains('hidden')) {
                    _wasmHintEl.classList.remove('hidden');
                }
                return _origAeForHint.apply(this, arguments);
            };
        }
        /* Late page-load case — warmup may have failed before our wrap was
           in place. window.__hasRealFFmpeg is the project's discriminator
           between the queue-stub and the real impl; if FFmpeg isn't loadable
           after 5 s we surface the hint anyway. */
        setTimeout(function () {
            if (window.__hasRealFFmpeg && !window.__hasRealFFmpeg()
                && _wasmHintEl.classList.contains('hidden')) {
                /* Don't show on file mode — banner is the right alarm there. */
                if (mode === 'mic') _wasmHintEl.classList.remove('hidden');
            }
        }, 5000);
    }

})();
